webpackJsonp([1],{

/***/ "+B6H":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 7c719d91f347978c05f47c4893cd4a22
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SegmentListItem_DeleteSegment_MutationVariables = {|
  input: {
    tripId?: ?string;
    segmentId?: ?string;
    clientMutationId?: ?string;
  };
|};

export type SegmentListItem_DeleteSegment_MutationResponse = {|
  +deleteSegment: ?{|
    +trip: ?{|
      +numSegments: ?number;
      +segments: ?$ReadOnlyArray<?{|
        +id: string;
      |}>;
    |};
  |};
|};
*/

/*
mutation SegmentListItem_DeleteSegment_Mutation(
  $input: DeleteSegmentInput!
) {
  deleteSegment(input: $input) {
    trip {
      numSegments
      segments {
        id
      }
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "DeleteSegmentInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "SegmentListItem_DeleteSegment_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "DeleteSegmentInput!"
      }],
      "concreteType": "DeleteSegmentPayload",
      "name": "deleteSegment",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "numSegments",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Segment",
          "name": "segments",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "SegmentListItem_DeleteSegment_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "DeleteSegmentInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "SegmentListItem_DeleteSegment_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "DeleteSegmentInput!"
      }],
      "concreteType": "DeleteSegmentPayload",
      "name": "deleteSegment",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "numSegments",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Segment",
          "name": "segments",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation SegmentListItem_DeleteSegment_Mutation(\n  $input: DeleteSegmentInput!\n) {\n  deleteSegment(input: $input) {\n    trip {\n      numSegments\n      segments {\n        id\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "+Rwz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 4081f9248844b267103406b1c5c035c2
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type AddNote_AddNoteToTrip_MutationVariables = {|
  input: {
    tripId?: ?string;
    note?: ?string;
    clientMutationId?: ?string;
  };
|};

export type AddNote_AddNoteToTrip_MutationResponse = {|
  +addNote: ?{|
    +trip: ?{|
      +history: ?$ReadOnlyArray<?{|
        +id: string;
      |}>;
      +notes: ?$ReadOnlyArray<?{|
        +owner: {|
          +firstName: string;
        |};
        +content: string;
        +created: any;
      |}>;
    |};
  |};
|};
*/

/*
mutation AddNote_AddNoteToTrip_Mutation(
  $input: AddNoteInput!
) {
  addNote(input: $input) {
    trip {
      history {
        id
      }
      notes {
        owner {
          firstName
          id
        }
        content
        created
        id
      }
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "AddNoteInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddNote_AddNoteToTrip_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "AddNoteInput!"
      }],
      "concreteType": "AddNotePayload",
      "name": "addNote",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Revision",
          "name": "history",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Note",
          "name": "notes",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "owner",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "firstName",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "content",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "created",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "AddNote_AddNoteToTrip_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "AddNoteInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "AddNote_AddNoteToTrip_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "AddNoteInput!"
      }],
      "concreteType": "AddNotePayload",
      "name": "addNote",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Revision",
          "name": "history",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Note",
          "name": "notes",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "owner",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "firstName",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "content",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "created",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation AddNote_AddNoteToTrip_Mutation(\n  $input: AddNoteInput!\n) {\n  addNote(input: $input) {\n    trip {\n      history {\n        id\n      }\n      notes {\n        owner {\n          firstName\n          id\n        }\n        content\n        created\n        id\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "+oc7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("F8kA");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__("IQwA");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Vendor = function (_React$Component) {
  _inherits(Vendor, _React$Component);

  function Vendor() {
    _classCallCheck(this, Vendor);

    return _possibleConstructorReturn(this, (Vendor.__proto__ || Object.getPrototypeOf(Vendor)).apply(this, arguments));
  }

  _createClass(Vendor, [{
    key: 'render',
    // eslint-disable-line
    value: function render() {
      var _props = this.props,
          _props$vendor = _props.vendor,
          id = _props$vendor.id,
          name = _props$vendor.name,
          active = _props.active;


      return _react2.default.createElement(
        _reactRouterDom.Link,
        {
          to: '/vendors/' + id + '/',
          className: active ? _styles2.default.active : null
        },
        _react2.default.createElement(
          'div',
          { className: _styles2.default.tripListItem },
          name
        )
      );
    }
  }]);

  return Vendor;
}(_react2.default.Component);

exports.default = Vendor;


Vendor.propTypes = {
  vendor: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    name: _propTypes2.default.string
  }).isRequired,
  active: _propTypes2.default.bool.isRequired
};

/***/ }),

/***/ "/7px":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\nquery TripAssignments_Owners_Query {\n  allUsers {\n    edges {\n      node {\n        id,\n        firstName,\n        lastName,\n        assignments,\n      }\n    }\n  }\n}\n'], ['\nquery TripAssignments_Owners_Query {\n  allUsers {\n    edges {\n      node {\n        id,\n        firstName,\n        lastName,\n        assignments,\n      }\n    }\n  }\n}\n']);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__("Q4lS");

var _reactRouterDom = __webpack_require__("F8kA");

var _reactApollo = __webpack_require__("3zLD");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TripAssignmentsQuery = (0, _reactApollo.gql)(_templateObject);

var TripAssignments = function TripAssignments(_ref) {
  var data = _ref.data,
      className = _ref.className;

  if (data.loading) {
    return _react2.default.createElement(
      'div',
      { style: styles.cardStyles },
      _react2.default.createElement(
        _materialUi.Card,
        { style: styles.progressContainer },
        _react2.default.createElement(_materialUi.CardHeader, { title: 'Trip Assignments' }),
        _react2.default.createElement(_materialUi.CircularProgress, { style: styles.progressIndicator })
      )
    );
  }

  var users = data.allUsers.edges;


  return _react2.default.createElement(
    _materialUi.Card,
    { className: className },
    _react2.default.createElement(_materialUi.CardHeader, {
      title: 'Trip Assignments'
    }),
    _react2.default.createElement(
      _materialUi.CardText,
      null,
      _react2.default.createElement(
        'ul',
        null,
        users.map(function (_ref2) {
          var _ref2$node = _ref2.node,
              id = _ref2$node.id,
              firstName = _ref2$node.firstName,
              lastName = _ref2$node.lastName,
              assignments = _ref2$node.assignments;

          if (assignments === 0) {
            return null;
          }
          return _react2.default.createElement(
            'li',
            { style: styles.ListItemStyles, key: id },
            _react2.default.createElement(
              _reactRouterDom.Link,
              { to: '/trips/?user=' + id },
              firstName,
              ' ',
              lastName[0],
              '.'
            ),
            _react2.default.createElement(
              'span',
              null,
              assignments
            )
          );
        })
      )
    )
  );
};

TripAssignments.propTypes = {
  data: _propTypes2.default.shape().isRequired,
  className: _propTypes2.default.string
};

TripAssignments.defaultProps = {
  className: ''
};

exports.default = (0, _reactApollo.graphql)(TripAssignmentsQuery)(TripAssignments);


var styles = {
  ListItemStyles: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: 16,
    marginTop: 16,
    marginBottom: 16
  },
  progressContainer: {
    margin: 10,
    position: 'relative'
  },
  progressIndicator: {
    marginLeft: '50%',
    left: -20
  }
};

/***/ }),

/***/ "/Zpr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2, _class2, _temp3, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRelay = __webpack_require__("Tc9k");

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _fuzzy = __webpack_require__("Pv+r");

var _fuzzy2 = _interopRequireDefault(_fuzzy);

var _aphrodite = __webpack_require__("BK4P");

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _ResponseListFilters = __webpack_require__("XwAW");

var _ResponseListFilters2 = _interopRequireDefault(_ResponseListFilters);

var _Response = __webpack_require__("YcI5");

var _Response2 = _interopRequireDefault(_Response);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RenderedResponses = (_temp2 = _class = function (_React$Component) {
  _inherits(RenderedResponses, _React$Component);

  function RenderedResponses() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RenderedResponses);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RenderedResponses.__proto__ || Object.getPrototypeOf(RenderedResponses)).call.apply(_ref, [this].concat(args))), _this), _this.scrollToResponse = function () {
      var node = _reactDom2.default.findDOMNode(_this.refs.activeVendor); // eslint-disable-line
      if (node) {
        node.scrollIntoView({ behavior: "instant", block: "start" });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RenderedResponses, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollToResponse();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.scrollToResponse();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          responses = _props.responses,
          activeResponse = _props.activeResponse;


      return _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styles.listItems) },
        responses.map(function (response) {
          var responseId = response.id;

          var active = responseId === activeResponse;
          var ref = active ? 'activeResponse' : null;

          return _react2.default.createElement(_Response2.default, { key: responseId, response: response, active: active, ref: ref });
        })
      );
    }
  }]);

  return RenderedResponses;
}(_react2.default.Component), _class.propTypes = {
  responses: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  activeResponse: _propTypes2.default.string
}, _class.defaultProps = {
  activeResponse: ''
}, _temp2);
var ResponseListRenderer = (_temp3 = _class2 = function (_React$Component2) {
  _inherits(ResponseListRenderer, _React$Component2);

  // eslint-disable-line
  function ResponseListRenderer(props) {
    _classCallCheck(this, ResponseListRenderer);

    var _this2 = _possibleConstructorReturn(this, (ResponseListRenderer.__proto__ || Object.getPrototypeOf(ResponseListRenderer)).call(this, props));

    _this2.updateFilter = function (e) {
      var newFilter = e.target.value;

      _this2.setState({ filter: newFilter });
    };

    _this2.state = {
      filter: props.filter
    };
    return _this2;
  }

  _createClass(ResponseListRenderer, [{
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          loadingEl = _props2.loadingEl,
          activeResponse = _props2.activeResponse;
      var filter = this.state.filter;


      return _react2.default.createElement(_reactRelay.QueryRenderer, {
        environment: _environment2.default, query: _graphql || (_graphql = function _graphql() {
          return __webpack_require__("JDU+");
        }), render: function render(_ref2) {
          var error = _ref2.error,
              props = _ref2.props;

          if (error) {
            return _react2.default.createElement(
              'div',
              null,
              error.message
            );
          } else if (props) {
            var responses = props.allResponses.edges;


            var filteredResponses = responses.map(function (_ref3) {
              var node = _ref3.node;
              return node;
            });
            if (filter) {
              filteredResponses = _fuzzy2.default.filter(filter, responses.map(function (_ref4) {
                var node = _ref4.node;
                return node;
              }), {
                extract: function extract(response) {
                  return response.display;
                }
              }).map(function (filteredResponse) {
                return filteredResponse.original;
              });
            }

            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_ResponseListFilters2.default, {
                numTotal: responses.length,
                numFiltered: filteredResponses.length,
                updateFilter: _this3.updateFilter,
                filter: filter
              }),
              _react2.default.createElement(RenderedResponses, { responses: filteredResponses, activeResponse: activeResponse })
            );
          }
          return loadingEl;
        }
      });
    }
  }]);

  return ResponseListRenderer;
}(_react2.default.Component), _class2.propTypes = {
  loadingEl: _propTypes2.default.shape().isRequired,
  filter: _propTypes2.default.string,
  activeResponse: _propTypes2.default.string
}, _class2.defaultProps = {
  filter: '',
  activeResponse: null
}, _temp3);
exports.default = ResponseListRenderer;


var styles = _aphrodite.StyleSheet.create({
  listItems: {
    height: 'calc(100vh - 161px)',
    overflow: 'auto',
    position: 'relative',
    top: '90px'
  }
});

/***/ }),

/***/ "/rVg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class, _class2, _temp;

var _templateObject = _taggedTemplateLiteral(['\nquery TripDetailsQuery {\n  allUsers(groups_Name: "Team") {\n    edges {\n      node {\n        id,\n        firstName,\n        username\n      }\n    }\n  },\n  tripCategories {\n    edges {\n      node {\n        id,\n        name\n      }\n    }\n  }\n}\n'], ['\nquery TripDetailsQuery {\n  allUsers(groups_Name: "Team") {\n    edges {\n      node {\n        id,\n        firstName,\n        username\n      }\n    }\n  },\n  tripCategories {\n    edges {\n      node {\n        id,\n        name\n      }\n    }\n  }\n}\n']);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("RH2O");

var _materialUi = __webpack_require__("Q4lS");

var _reactApollo = __webpack_require__("3zLD");

var _aphrodite = __webpack_require__("BK4P");

var _InquiryActions = __webpack_require__("EJRV");

var InquiryActions = _interopRequireWildcard(_InquiryActions);

var _DateRangeComponent = __webpack_require__("JW7h");

var _DateRangeComponent2 = _interopRequireDefault(_DateRangeComponent);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TripDetailsQuery = (0, _reactApollo.gql)(_templateObject);

var TripDetails = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    inquiry: state.Inquiry.get('inquiry').toJS(),
    loggedInUser: state.Auth.get('username')
  };
}), _dec2 = (0, _reactApollo.graphql)(TripDetailsQuery), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(TripDetails, _React$Component);

  function TripDetails(props) {
    _classCallCheck(this, TripDetails);

    var _this = _possibleConstructorReturn(this, (TripDetails.__proto__ || Object.getPrototypeOf(TripDetails)).call(this, props));

    _this.toggleCheckbox = function (name) {
      return function (e, checked) {
        _this.props.dispatch(InquiryActions.updateField(['inquiry', 'tripDetails', name], checked));
      };
    };

    _this.updateTextfield = function (name) {
      return function (e) {
        var value = e.target.value;

        _this.props.dispatch(InquiryActions.updateField(['inquiry', 'tripDetails', name], value));
      };
    };

    _this.updateQuillNotes = function (field) {
      return function (value) {
        _this.props.dispatch(InquiryActions.updateField(['inquiry', 'tripDetails', field], value));
      };
    };

    _this.updateSelect = function (name) {
      return function (e, index, value) {
        _this.props.dispatch(InquiryActions.updateField(['inquiry', 'tripDetails', name], value));
      };
    };

    _this.updateTravelDates = function (value) {
      var startDate = value.startDate,
          endDate = value.endDate;

      _this.props.dispatch(InquiryActions.updateField(['inquiry', 'tripDetails', 'travelStartDate'], startDate));
      _this.props.dispatch(InquiryActions.updateField(['inquiry', 'tripDetails', 'travelEndDate'], endDate));
    };

    _this.toggleSpecificDates = function (e) {
      var checked = e.target.checked;

      _this.props.dispatch(InquiryActions.updateField(['inquiry', 'tripDetails', 'specificDates'], checked));
    };

    if (typeof window !== 'undefined') {
      _this.ReactQuill = __webpack_require__("TWqO"); // eslint-disable-line global-require
    }
    return _this;
  }

  _createClass(TripDetails, [{
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var _props = this.props,
          data = _props.data,
          loggedInUser = _props.loggedInUser,
          selectedUser = _props.inquiry.tripDetails.selectedUser;


      if (!selectedUser) {
        var users = [];
        if (!data.loading) {
          users = data.allUsers.edges.map(function (_ref) {
            var node = _ref.node;
            return node;
          });
          if (users.map(function (_ref2) {
            var username = _ref2.username;
            return username;
          }).indexOf(loggedInUser) >= 0) {
            this.updateSelect('selectedUser')(null, null, loggedInUser);
          }
        }
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _props2$inquiry$tripD = _props2.inquiry.tripDetails,
          inbox = _props2$inquiry$tripD.inbox,
          selectedUser = _props2$inquiry$tripD.selectedUser,
          category = _props2$inquiry$tripD.category,
          specificDates = _props2$inquiry$tripD.specificDates,
          travelStartDate = _props2$inquiry$tripD.travelStartDate,
          travelEndDate = _props2$inquiry$tripD.travelEndDate,
          timeframe = _props2$inquiry$tripD.timeframe,
          notes = _props2$inquiry$tripD.notes,
          vipNotes = _props2$inquiry$tripD.vipNotes,
          destination = _props2$inquiry$tripD.destination,
          data = _props2.data;


      var users = [];
      var categories = [];
      if (!data.loading) {
        users = data.allUsers.edges.map(function (_ref3) {
          var node = _ref3.node;
          return node;
        });
        categories = data.tripCategories.edges.map(function (_ref4) {
          var node = _ref4.node;
          return node;
        });
      }

      return _react2.default.createElement(
        _materialUi.Paper,
        { className: (0, _aphrodite.css)(styles.container) },
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.formRow) },
          _react2.default.createElement(
            _materialUi.SelectField,
            {
              floatingLabelText: 'Inbox:',
              value: inbox,
              onChange: this.updateSelect('inbox')
            },
            ['team@', 'insidecircle@', 'david@', 'jessica@'].map(function (option, index) {
              return _react2.default.createElement(_materialUi.MenuItem, { key: index, value: option, primaryText: option });
            })
          ),
          _react2.default.createElement(
            _materialUi.SelectField,
            {
              floatingLabelText: 'Assign trip to:',
              value: selectedUser,
              onChange: this.updateSelect('selectedUser')
            },
            users.map(function (_ref5) {
              var id = _ref5.id,
                  username = _ref5.username,
                  firstName = _ref5.firstName;
              return _react2.default.createElement(_materialUi.MenuItem, { key: id, value: username, primaryText: firstName });
            })
          ),
          _react2.default.createElement(
            _materialUi.SelectField,
            {
              floatingLabelText: 'Trip Category:',
              value: category,
              onChange: this.updateSelect('category')
            },
            categories.map(function (_ref6) {
              var id = _ref6.id,
                  name = _ref6.name;
              return _react2.default.createElement(_materialUi.MenuItem, { key: id, value: id, primaryText: name });
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.formRow) },
          _react2.default.createElement(
            'div',
            { style: { flexGrow: 1 } },
            _react2.default.createElement(_materialUi.TextField, {
              value: destination,
              floatingLabelText: 'Destination',
              onChange: this.updateTextfield('destination')
            })
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _aphrodite.css)(styles.dateRangeContainer) },
            specificDates ? _react2.default.createElement(_DateRangeComponent2.default, {
              className: (0, _aphrodite.css)(styles.dateRange),
              fieldClass: (0, _aphrodite.css)(styles.dateRangeField),
              startValue: travelStartDate,
              endValue: travelEndDate,
              startLabel: 'Travel Start Date',
              endLabel: 'Travel End Date',
              onChange: this.updateTravelDates
            }) : _react2.default.createElement(_materialUi.TextField, {
              floatingLabelText: 'Timeframe',
              value: timeframe,
              onChange: this.updateTextfield('timeframe')
            }),
            _react2.default.createElement(_materialUi.Toggle, {
              checked: specificDates,
              onClick: this.toggleSpecificDates,
              label: 'Specific Dates',
              labelPosition: 'right'
            })
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _aphrodite.css)(styles.formRow) },
            _react2.default.createElement(
              'div',
              { className: (0, _aphrodite.css)(styles.notes) },
              _react2.default.createElement(
                'h2',
                null,
                'Trip Notes'
              ),
              _react2.default.createElement(this.ReactQuill, {
                value: notes,
                onChange: this.updateQuillNotes('notes')
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _aphrodite.css)(styles.formRow) },
            _react2.default.createElement(
              'div',
              { className: (0, _aphrodite.css)(styles.notes) },
              _react2.default.createElement(
                'h2',
                null,
                'VIP Notes'
              ),
              _react2.default.createElement(this.ReactQuill, {
                value: vipNotes,
                onChange: this.updateQuillNotes('vipNotes')
              })
            )
          )
        )
      );
    }
  }]);

  return TripDetails;
}(_react2.default.Component), _class2.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  inquiry: _propTypes2.default.shape().isRequired,
  data: _propTypes2.default.shape().isRequired,
  loggedInUser: _propTypes2.default.string.isRequired
}, _temp)) || _class) || _class);


var styles = _aphrodite.StyleSheet.create({
  container: {
    maxWidth: 839,
    display: 'flex',
    flexDirection: 'column',
    padding: 15,
    marginLeft: 15
  },
  formRow: {
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    flexWrap: 'wrap',
    alignItems: 'flex-start'
  },
  notes: {
    flexGrow: 1,
    marginTop: 10
  },
  dateRangeContainer: {
    flexGrow: 2
  },
  dateRange: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between'
  },
  dateRangeField: {
    marginBottom: 20
  }
});

exports.default = TripDetails;

/***/ }),

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__("j1ja");
module.exports = __webpack_require__("EAxn");


/***/ }),

/***/ "3Jva":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 382f62870c5db7af1e958fa015fb2c73
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type TaskListItem_VoidTask_MutationVariables = {|
  input: {
    taskId?: ?string;
    action?: ?string;
    value?: ?boolean;
    clientMutationId?: ?string;
  };
|};

export type TaskListItem_VoidTask_MutationResponse = {|
  +taskAction: ?{|
    +task: ?{|
      +completed: boolean;
      +voided: boolean;
      +history: ?$ReadOnlyArray<?{|
        +name: ?string;
        +action: ?string;
        +timestamp: ?string;
      |}>;
      +trip: ?{|
        +id: string;
        +welcomeHome: ?boolean;
      |};
    |};
  |};
|};
*/

/*
mutation TaskListItem_VoidTask_Mutation(
  $input: TaskActionInput!
) {
  taskAction(input: $input) {
    task {
      completed
      voided
      history {
        name
        action
        timestamp
      }
      trip {
        id
        welcomeHome
      }
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "TaskActionInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskListItem_VoidTask_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "TaskActionInput!"
      }],
      "concreteType": "TaskActionPayload",
      "name": "taskAction",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "name": "task",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "completed",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "voided",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "TaskHistoryObject",
          "name": "history",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "action",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "timestamp",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Trip",
          "name": "trip",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "welcomeHome",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "TaskListItem_VoidTask_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "TaskActionInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "TaskListItem_VoidTask_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "TaskActionInput!"
      }],
      "concreteType": "TaskActionPayload",
      "name": "taskAction",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "name": "task",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "completed",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "voided",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "TaskHistoryObject",
          "name": "history",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "action",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "timestamp",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Trip",
          "name": "trip",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "welcomeHome",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation TaskListItem_VoidTask_Mutation(\n  $input: TaskActionInput!\n) {\n  taskAction(input: $input) {\n    task {\n      completed\n      voided\n      history {\n        name\n        action\n        timestamp\n      }\n      trip {\n        id\n        welcomeHome\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "3dDk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2, _graphql, _graphql2;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _aphrodite = __webpack_require__("BK4P");

var _materialUi = __webpack_require__("Q4lS");

var _reactRelay = __webpack_require__("Tc9k");

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TaskListItem = (_temp2 = _class = function (_React$Component) {
  _inherits(TaskListItem, _React$Component);

  function TaskListItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TaskListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TaskListItem.__proto__ || Object.getPrototypeOf(TaskListItem)).call.apply(_ref, [this].concat(args))), _this), _this.completeTask = function (e, checked) {
      var taskId = _this.props.task.id;


      (0, _reactRelay.commitMutation)(_environment2.default, {
        mutation: _graphql || (_graphql = function _graphql() {
          return __webpack_require__("7p1K");
        }),
        variables: { input: { taskId: taskId, action: "complete", value: checked } },
        onError: function onError(err) {
          return alert(err);
        }
      });
    }, _this.voidTask = function () {
      var taskId = _this.props.task.id;


      (0, _reactRelay.commitMutation)(_environment2.default, {
        mutation: _graphql2 || (_graphql2 = function _graphql2() {
          return __webpack_require__("3Jva");
        }),
        variables: { input: { taskId: taskId, action: "void", value: true } },
        onError: function onError(err) {
          return alert(err);
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TaskListItem, [{
    key: "render",
    value: function render() {
      var _props$task = this.props.task,
          description = _props$task.description,
          completed = _props$task.completed,
          dueDate = _props$task.dueDate,
          voided = _props$task.voided,
          voidDate = _props$task.voidDate,
          history = _props$task.history;


      return _react2.default.createElement(
        "li",
        { className: (0, _aphrodite.css)(styles.taskListItem) },
        _react2.default.createElement(_materialUi.Checkbox, {
          className: (0, _aphrodite.css)(styles.checkbox),
          labelStyle: voided ? { textDecoration: "line-through" } : null,
          label: description,
          labelPosition: "right",
          checked: completed,
          disabled: completed || voided,
          onCheck: this.completeTask
        }),
        completed || voided ? null : _react2.default.createElement(_materialUi.FlatButton, {
          label: "void",
          disabled: completed || voided,
          secondary: true,
          onTouchTap: this.voidTask
        })
      );
    }
  }]);

  return TaskListItem;
}(_react2.default.Component), _class.propTypes = {
  task: _propTypes2.default.shape().isRequired
}, _temp2);
exports.default = TaskListItem;


var styles = _aphrodite.StyleSheet.create({
  taskListItem: {
    display: "flex",
    marginBottom: 5,
    ":nth-child(even)": {
      background: _ourismanTravelTheme2.default.palette.primary3Color
    }
  },
  checkbox: {
    paddingTop: 5
  }
});

/***/ }),

/***/ "44Vo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__("Q4lS");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _aphrodite = __webpack_require__("BK4P");

var _NewInquiryButton = __webpack_require__("pzu2");

var _NewInquiryButton2 = _interopRequireDefault(_NewInquiryButton);

var _GlobalSearchBox = __webpack_require__("GQCW");

var _GlobalSearchBox2 = _interopRequireDefault(_GlobalSearchBox);

var _LogoutButton = __webpack_require__("W63S");

var _LogoutButton2 = _interopRequireDefault(_LogoutButton);

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Header = (_temp = _class = function (_React$Component) {
  _inherits(Header, _React$Component);

  function Header() {
    _classCallCheck(this, Header);

    return _possibleConstructorReturn(this, (Header.__proto__ || Object.getPrototypeOf(Header)).apply(this, arguments));
  }

  _createClass(Header, [{
    key: 'render',
    value: function render() {
      var history = this.props.history;


      return _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styles.headerStyles) },
        _react2.default.createElement(
          _materialUi.AppBar,
          { showMenuIconButton: false },
          _react2.default.createElement(
            'div',
            { className: (0, _aphrodite.css)(styles.headerContentStyles) },
            _react2.default.createElement(
              'div',
              { className: (0, _aphrodite.css)(styles.headerNameStyles) },
              _react2.default.createElement('img', { src: '/OT_Logo_Mark_Gold.png', height: '64', alt: 'Ourisman Travel' }),
              _react2.default.createElement(
                'h1',
                { className: (0, _aphrodite.css)(styles.headerTitleStyles) },
                'Ourisman Travel'
              )
            ),
            _react2.default.createElement(
              'div',
              { className: (0, _aphrodite.css)(styles.headerActionStyles) },
              _react2.default.createElement(_GlobalSearchBox2.default, { history: history }),
              _react2.default.createElement(_NewInquiryButton2.default, { history: history }),
              _react2.default.createElement(_LogoutButton2.default, null)
            )
          )
        ),
        this.props.children
      );
    }
  }]);

  return Header;
}(_react2.default.Component), _class.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
  history: _propTypes2.default.shape({
    push: _propTypes2.default.func
  }).isRequired
}, _class.defaultProps = {
  children: []
}, _temp);
exports.default = Header;


var styles = _aphrodite.StyleSheet.create({
  headerStyles: {
    position: 'fixed',
    width: '100%',
    zIndex: 1000
  },
  headerActionStyles: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center'
  },
  headerContentStyles: {
    display: 'flex',
    justifyContent: 'space-between',
    width: '100%',
    position: 'relative',
    left: -16,
    boxSizing: 'content-box'
  },
  headerNameStyles: {
    alignItems: 'center',
    display: 'flex',
    color: _ourismanTravelTheme2.default.palette.alternateTextColor
  },
  headerTitleStyles: {
    margin: 0,
    color: _ourismanTravelTheme2.default.palette.alternateTextColor,
    boxSizing: 'content-box',
    fontFamily: 'Noto Sans,sans-serif',
    fontSize: '2em',
    lineHeight: 'inherit',
    '@media (max-width: 925px)': {
      display: 'none'
    }
  }
});

/***/ }),

/***/ "5Dr9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _relayRuntime = __webpack_require__("NGV3");

var _isomorphicFetch = __webpack_require__("j9g7");

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _network = __webpack_require__("Zg14");

var _network2 = _interopRequireDefault(_network);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var source = new _relayRuntime.RecordSource();
var store = new _relayRuntime.Store(source);
var NODE_ENV = "production";


function fetchQuery(operation, variables) {
  var graphqlURL = NODE_ENV === "development" ? _network2.default : "";
  return (0, _isomorphicFetch2.default)(graphqlURL + "/graphql/", {
    method: "POST",
    headers: {
      authorization: "Bearer " + localStorage.getItem("PPJWT"),
      "content-type": "application/json"
    },
    credentials: "same-origin",
    body: JSON.stringify({
      query: operation.text,
      variables: variables
    })
  }).then(function (response) {
    return response.json();
  });
}

var network = _relayRuntime.Network.create(fetchQuery);

var environment = new _relayRuntime.Environment({ network: network, store: store });

exports.default = environment;

/***/ }),

/***/ "5EsW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 035a7dc7832ae75aac0965d5ccc16756
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type VoidTrip_CancelTrip_MutationVariables = {|
  input: {
    tripId?: ?string;
    notes?: ?string;
    clientMutationId?: ?string;
  };
|};

export type VoidTrip_CancelTrip_MutationResponse = {|
  +cancelTrip: ?{|
    +trip: ?{|
      +cancelled: boolean;
      +tripName: ?string;
      +welcomeHome: ?boolean;
      +tasks: ?$ReadOnlyArray<?{|
        +taskType: "DRAFT_WH" | "CANCEL_WH" | "OTHER";
        +description: string;
        +completed: boolean;
        +voided: boolean;
        +history: ?$ReadOnlyArray<?{|
          +name: ?string;
          +action: ?string;
          +timestamp: ?string;
        |}>;
      |}>;
    |};
  |};
|};
*/

/*
mutation VoidTrip_CancelTrip_Mutation(
  $input: CancelTripInput!
) {
  cancelTrip(input: $input) {
    trip {
      cancelled
      tripName
      welcomeHome
      tasks {
        taskType
        description
        completed
        voided
        history {
          name
          action
          timestamp
        }
        id
      }
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "CancelTripInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "VoidTrip_CancelTrip_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CancelTripInput!"
      }],
      "concreteType": "CancelTripPayload",
      "name": "cancelTrip",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancelled",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tripName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "welcomeHome",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "name": "tasks",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "taskType",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "description",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "completed",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "voided",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TaskHistoryObject",
            "name": "history",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "action",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "timestamp",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "VoidTrip_CancelTrip_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "CancelTripInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "VoidTrip_CancelTrip_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "CancelTripInput!"
      }],
      "concreteType": "CancelTripPayload",
      "name": "cancelTrip",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancelled",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tripName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "welcomeHome",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "name": "tasks",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "taskType",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "description",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "completed",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "voided",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TaskHistoryObject",
            "name": "history",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "action",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "timestamp",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation VoidTrip_CancelTrip_Mutation(\n  $input: CancelTripInput!\n) {\n  cancelTrip(input: $input) {\n    trip {\n      cancelled\n      tripName\n      welcomeHome\n      tasks {\n        taskType\n        description\n        completed\n        voided\n        history {\n          name\n          action\n          timestamp\n        }\n        id\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "5d3T":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 033ce065163af11e85242a5966098c64
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type EditTrip_UpdateTrip_MutationVariables = {|
  input: {
    tripId?: ?string;
    inbox?: ?string;
    ownerId?: ?string;
    categoryId?: ?string;
    destination?: ?string;
    specificDates?: ?boolean;
    timeFrame?: ?string;
    startDate?: ?string;
    endDate?: ?string;
    needsVetting?: ?boolean;
    prospect?: ?boolean;
    clientMutationId?: ?string;
  };
|};

export type EditTrip_UpdateTrip_MutationResponse = {|
  +updateTrip: ?{|
    +trip: ?{|
      +inbox: ?string;
      +tripName: ?string;
      +ownerId: ?string;
      +ownerName: ?string;
      +owner: ?{|
        +id: string;
      |};
      +category: ?{|
        +id: string;
        +name: string;
      |};
      +destination: string;
      +specificDates: boolean;
      +timeFrame: ?string;
      +startDate: ?string;
      +endDate: ?string;
      +dateString: ?string;
      +needsVetting: boolean;
      +prospect: boolean;
      +welcomeHome: ?boolean;
      +tasks: ?$ReadOnlyArray<?{|
        +taskType: "DRAFT_WH" | "CANCEL_WH" | "OTHER";
        +description: string;
        +completed: boolean;
        +voided: boolean;
        +history: ?$ReadOnlyArray<?{|
          +name: ?string;
          +action: ?string;
          +timestamp: ?string;
        |}>;
      |}>;
    |};
  |};
|};
*/

/*
mutation EditTrip_UpdateTrip_Mutation(
  $input: UpdateTripInput!
) {
  updateTrip(input: $input) {
    trip {
      timeFrame
      inbox
      ownerId
      ownerName
      owner {
        id
      }
      category {
        id
        name
      }
      destination
      specificDates
      tripName
      startDate
      endDate
      dateString
      needsVetting
      prospect
      welcomeHome
      tasks {
        taskType
        description
        completed
        voided
        history {
          name
          action
          timestamp
        }
        id
      }
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "UpdateTripInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditTrip_UpdateTrip_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "UpdateTripInput!"
      }],
      "concreteType": "UpdateTripPayload",
      "name": "updateTrip",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "timeFrame",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "inbox",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "ownerId",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "ownerName",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "User",
          "name": "owner",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "TripCategory",
          "name": "category",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "destination",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "specificDates",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tripName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "startDate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "endDate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dateString",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "needsVetting",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "prospect",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "welcomeHome",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "name": "tasks",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "taskType",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "description",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "completed",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "voided",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TaskHistoryObject",
            "name": "history",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "action",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "timestamp",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "EditTrip_UpdateTrip_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "UpdateTripInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "EditTrip_UpdateTrip_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "UpdateTripInput!"
      }],
      "concreteType": "UpdateTripPayload",
      "name": "updateTrip",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tripName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "timeFrame",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "ownerId",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "ownerName",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "User",
          "name": "owner",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "TripCategory",
          "name": "category",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "destination",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "specificDates",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "inbox",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "startDate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "endDate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dateString",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "needsVetting",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "prospect",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "welcomeHome",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "name": "tasks",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "taskType",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "description",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "completed",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "voided",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TaskHistoryObject",
            "name": "history",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "action",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "timestamp",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation EditTrip_UpdateTrip_Mutation(\n  $input: UpdateTripInput!\n) {\n  updateTrip(input: $input) {\n    trip {\n      timeFrame\n      inbox\n      ownerId\n      ownerName\n      owner {\n        id\n      }\n      category {\n        id\n        name\n      }\n      destination\n      specificDates\n      tripName\n      startDate\n      endDate\n      dateString\n      needsVetting\n      prospect\n      welcomeHome\n      tasks {\n        taskType\n        description\n        completed\n        voided\n        history {\n          name\n          action\n          timestamp\n        }\n        id\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "5fJs":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseDate = parseDate;
exports.dateString = dateString;

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _momentRange = __webpack_require__("l5j/");

var _momentParseformat = __webpack_require__("m0Xp");

var _momentParseformat2 = _interopRequireDefault(_momentParseformat);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var moment = (0, _momentRange.extendMoment)(_moment2.default);

function parseDate(date) {
  return moment(date, (0, _momentParseformat2.default)(date));
}

function dateString(startDate, endDate) {
  var parseDates = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

  var dateString = '';
  if (startDate) {
    var momentStartDate = void 0;
    if (moment.isMoment(startDate)) {
      momentStartDate = startDate;
    } else {
      momentStartDate = parseDate(startDate);
    }

    if (parseDates && momentStartDate.isValid()) {
      dateString = '' + momentStartDate.format('DDMMM').toUpperCase();
    } else {
      dateString = startDate;
    }

    if (endDate) {
      var momentEndDate = void 0;
      if (moment.isMoment(endDate)) {
        momentEndDate = endDate;
      } else {
        momentEndDate = parseDate(endDate);
      }

      if (parseDates && momentStartDate.isValid() && momentEndDate.isValid()) {
        var duration = moment.range(momentStartDate, momentEndDate).diff('days');

        dateString = dateString + '-' + duration + 'NT';
      } else {
        dateString = dateString + '-' + endDate;
      }
    }
  }

  return dateString;
}

/***/ }),

/***/ "6Gex":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp2;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__("Q4lS");

var _reactRedux = __webpack_require__("RH2O");

var _TripsActions = __webpack_require__("FMZb");

var _styles = __webpack_require__("IoNl");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TripListFilter = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    filter: state.Trips.get("filter"),
    selectedUser: state.Trips.get("selectedUser")
  };
}), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(TripListFilter, _React$Component);

  function TripListFilter() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TripListFilter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TripListFilter.__proto__ || Object.getPrototypeOf(TripListFilter)).call.apply(_ref, [this].concat(args))), _this), _this.updateFilter = function (e, index, value) {
      return _this.props.dispatch((0, _TripsActions.setValue)("filter", value));
    }, _this.selectUser = function (e, index, value) {
      return _this.props.dispatch((0, _TripsActions.setValue)("selectedUser", value));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TripListFilter, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          users = _props.users,
          numFiltered = _props.numFiltered,
          numTrips = _props.numTrips,
          filterNeed = _props.filter,
          selectedUser = _props.selectedUser;


      return _react2.default.createElement(
        "div",
        { className: _styles2.default.listFilter },
        _react2.default.createElement(
          "div",
          { className: _styles2.default.tripListFilters },
          _react2.default.createElement(
            "div",
            { className: _styles2.default.filter },
            _react2.default.createElement(
              "span",
              null,
              "Assigned to:"
            ),
            _react2.default.createElement(
              _materialUi.DropDownMenu,
              { value: selectedUser, onChange: this.selectUser },
              _react2.default.createElement(_materialUi.MenuItem, { value: "all", primaryText: "All" }),
              _lodash2.default.values(users).map(function (user) {
                var id = user.id,
                    name = user.name;


                return _react2.default.createElement(_materialUi.MenuItem, { key: id, value: id, primaryText: name });
              })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: _styles2.default.filter },
            _react2.default.createElement(
              "span",
              null,
              "Filter by:"
            ),
            _react2.default.createElement(
              _materialUi.DropDownMenu,
              { value: filterNeed, onChange: this.updateFilter },
              _react2.default.createElement(_materialUi.MenuItem, { value: "all", primaryText: "------" }),
              _react2.default.createElement(_materialUi.MenuItem, { value: "prospect", primaryText: "prospect" }),
              _react2.default.createElement(_materialUi.MenuItem, { value: "insideCircle", primaryText: "Inside Circle" }),
              _react2.default.createElement(_materialUi.MenuItem, { value: "highPriority", primaryText: "BMOC" }),
              _react2.default.createElement(_materialUi.MenuItem, { value: "book", primaryText: "needs booking" }),
              _react2.default.createElement(_materialUi.MenuItem, { value: "filing", primaryText: "needs filing" }),
              _react2.default.createElement(_materialUi.MenuItem, { value: "invoice", primaryText: "needs invoicing" }),
              _react2.default.createElement(_materialUi.MenuItem, {
                value: "actionableInvoice",
                primaryText: "has actionable invoice"
              }),
              _react2.default.createElement(_materialUi.MenuItem, { value: "vip", primaryText: "needs VIP" }),
              _react2.default.createElement(_materialUi.MenuItem, { value: "welcomeHome", primaryText: "needs Welcome Home" }),
              _react2.default.createElement(_materialUi.MenuItem, { value: "training", primaryText: "needs training" }),
              _react2.default.createElement(_materialUi.MenuItem, { value: "vetting", primaryText: "needs vetting" }),
              _react2.default.createElement(_materialUi.MenuItem, { value: "cancellation", primaryText: "has cancellation" })
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { className: _styles2.default.infoLine },
          numFiltered,
          " (of ",
          numTrips,
          ") trips displayed"
        )
      );
    }
  }]);

  return TripListFilter;
}(_react2.default.Component), _class2.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  users: _propTypes2.default.shape(),
  numFiltered: _propTypes2.default.number.isRequired,
  numTrips: _propTypes2.default.number.isRequired,
  filter: _propTypes2.default.string.isRequired,
  selectedUser: _propTypes2.default.string.isRequired
}, _class2.defaultProps = {
  users: {}
}, _temp2)) || _class);
exports.default = TripListFilter;

/***/ }),

/***/ "6pLH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _exenv = __webpack_require__("u4m+");

var _exenv2 = _interopRequireDefault(_exenv);

var _materialUi = __webpack_require__("Q4lS");

var _VendorDetailsRenderer = __webpack_require__("VnsJ");

var _VendorDetailsRenderer2 = _interopRequireDefault(_VendorDetailsRenderer);

var _VendorListRenderer = __webpack_require__("HMW4");

var _VendorListRenderer2 = _interopRequireDefault(_VendorListRenderer);

var _styles = __webpack_require__("IQwA");

var _styles2 = _interopRequireDefault(_styles);

var _VendorListFilters = __webpack_require__("TZ1C");

var _VendorListFilters2 = _interopRequireDefault(_VendorListFilters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Vendors = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    viewport: state.Responsive.get('viewport'),
    windowHeight: state.Responsive.get('windowHeight')
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(Vendors, _React$Component);

  function Vendors(props) {
    _classCallCheck(this, Vendors);

    var _this = _possibleConstructorReturn(this, (Vendors.__proto__ || Object.getPrototypeOf(Vendors)).call(this, props));

    _this.state = {
      onClient: false
    };
    return _this;
  }

  _createClass(Vendors, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ onClient: _exenv2.default.canUseDom });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ onClient: true }); // eslint-disable-line
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          viewport = _props.viewport,
          activeVendor = _props.match.params.vendorId,
          windowHeight = _props.windowHeight;
      var onClient = this.state.onClient;

      var top = (windowHeight - 161) / 2 + 161;

      var ActiveVendor = _react2.default.createElement(_VendorDetailsRenderer2.default, { activeVendor: activeVendor });

      if (viewport !== 'desktop' && activeVendor) {
        return ActiveVendor;
      }

      var loadingEl = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_VendorListFilters2.default, { updateFilter: function updateFilter() {
            return null;
          } }),
        _react2.default.createElement(_materialUi.RefreshIndicator, { top: top, left: 277, status: 'loading' })
      );

      return _react2.default.createElement(
        'div',
        { className: _styles2.default.container },
        _react2.default.createElement(
          'div',
          { className: _styles2.default.list },
          onClient ? _react2.default.createElement(_VendorListRenderer2.default, {
            activeVendor: activeVendor,
            loadingEl: loadingEl
          }) : loadingEl
        ),
        _react2.default.createElement(
          'div',
          { className: _styles2.default.detail },
          activeVendor ? ActiveVendor : null
        )
      );
    }
  }]);

  return Vendors;
}(_react2.default.Component), _class2.propTypes = {
  viewport: _propTypes2.default.string.isRequired,
  match: _propTypes2.default.shape({
    params: _propTypes2.default.object
  }).isRequired,
  windowHeight: _propTypes2.default.number.isRequired
}, _temp)) || _class);
exports.default = Vendors;

/***/ }),

/***/ "78Lb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TripListFilters = exports.Trip = exports.Trips = undefined;

var _Trips2 = __webpack_require__("Aki7");

var _Trips3 = _interopRequireDefault(_Trips2);

var _Trip2 = __webpack_require__("UCvn");

var _Trip3 = _interopRequireDefault(_Trip2);

var _TripListFilters2 = __webpack_require__("6Gex");

var _TripListFilters3 = _interopRequireDefault(_TripListFilters2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Trips = _Trips3.default;
exports.Trip = _Trip3.default;
exports.TripListFilters = _TripListFilters3.default;

/***/ }),

/***/ "7YgM":
/***/ (function(module, exports) {

module.exports = {"license":"private","name":"ping-pong","repository":"https://github.com/ping-pong-travel-technology/ot-pingpong","author":"Josh Ourisman <josh@pingpong.travel>","private":true,"version":"4.1.0","dependencies":{"@sentry/browser":"5.0.8","@sentry/node":"5.0.8","aphrodite":"^1.2.3","babel-preset-kyt-react":"0.2.0","compression":"1.6.2","event-stream":"3.3.5","exenv":"^1.2.2","express":"^4.15.3","firebase":"^6.1.0","fuzzy":"^0.1.3","graphql":"^0.11.3","immutable":"^3.8.1","isomorphic-fetch":"^2.2.1","keymirror":"^0.1.1","kyt":"0.6.0","lodash":"^4.17.4","material-ui":"^0.18.3","moment":"^2.18.1","moment-parseformat":"^2.2.0","moment-range":"^3.0.3","prop-types":"^15.5.10","react":"^15.6.1","react-apollo":"1.4.16","react-date-range":"^0.9.4","react-dom":"^15.6.1","react-google-login":"^2.9.2","react-helmet":"^5.1.3","react-jsonschema-form":"^0.49.0","react-quill":"^1.3.5","react-redux":"^5.0.5","react-relay":"1.1.0","react-router-dom":"^4.1.1","react-tap-event-plugin":"^2.0.1","redux":"^3.6.0","redux-devtools":"^3.4.0","redux-devtools-dock-monitor":"^1.1.2","redux-devtools-log-monitor":"^1.3.0","redux-devtools-themes":"^1.0.0","redux-form":"^5.2.3","redux-thunk":"^2.2.0","victory":"^0.25.6"},"scripts":{"test-watch":"kyt test -- --watch","relay":"relay-compiler --src ./src --schema src/schema.json","proto":"kyt proto","lint-script":"kyt lint-script","lint":"npm run lint-script && npm run lint-style","lint-style":"kyt lint-style","dev":"kyt dev","start":"node build/server/main.js","test-coverage":"kyt test -- --coverage","build":"kyt build","kyt:help":"kyt --help","test":"kyt test"},"devDependencies":{"babel-plugin-relay":"1.1.0","babel-plugin-transform-decorators-legacy":"^1.3.4","babel-preset-stage-0":"^6.24.1","enzyme":"^2.8.2","eslint-config-prettier":"^4.1.0","react-addons-test-utils":"^15.6.0","relay-compiler":"1.1.0","sass-lint":"^1.10.2"},"description":"Ping Pong"}

/***/ }),

/***/ "7p1K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash a9cc1865d9378e94c4bc2889ec9668fa
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type TaskListItem_CompleteTask_MutationVariables = {|
  input: {
    taskId?: ?string;
    action?: ?string;
    value?: ?boolean;
    clientMutationId?: ?string;
  };
|};

export type TaskListItem_CompleteTask_MutationResponse = {|
  +taskAction: ?{|
    +task: ?{|
      +completed: boolean;
      +voided: boolean;
      +history: ?$ReadOnlyArray<?{|
        +name: ?string;
        +action: ?string;
        +timestamp: ?string;
      |}>;
      +trip: ?{|
        +id: string;
        +welcomeHome: ?boolean;
      |};
    |};
  |};
|};
*/

/*
mutation TaskListItem_CompleteTask_Mutation(
  $input: TaskActionInput!
) {
  taskAction(input: $input) {
    task {
      completed
      voided
      history {
        name
        action
        timestamp
      }
      trip {
        id
        welcomeHome
      }
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "TaskActionInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "TaskListItem_CompleteTask_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "TaskActionInput!"
      }],
      "concreteType": "TaskActionPayload",
      "name": "taskAction",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "name": "task",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "completed",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "voided",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "TaskHistoryObject",
          "name": "history",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "action",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "timestamp",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Trip",
          "name": "trip",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "welcomeHome",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "TaskListItem_CompleteTask_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "TaskActionInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "TaskListItem_CompleteTask_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "TaskActionInput!"
      }],
      "concreteType": "TaskActionPayload",
      "name": "taskAction",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "name": "task",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "completed",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "voided",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "TaskHistoryObject",
          "name": "history",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "action",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "timestamp",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Trip",
          "name": "trip",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "welcomeHome",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation TaskListItem_CompleteTask_Mutation(\n  $input: TaskActionInput!\n) {\n  taskAction(input: $input) {\n    task {\n      completed\n      voided\n      history {\n        name\n        action\n        timestamp\n      }\n      trip {\n        id\n        welcomeHome\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "81cR":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"styles-container--3JL7A","list":"styles-list--2gETu","detail":"styles-detail--2e1uW","listFilter":"styles-listFilter--3kJqu","listItems":"styles-listItems--RRW1x","active":"styles-active--3Ko7W","report":"styles-report--3NatH","summaryContainer":"styles-summaryContainer--1up8J","summaryBox":"styles-summaryBox--3mEYP","futureTravelContainer":"styles-futureTravelContainer--35xDt","futureTravelBox":"styles-futureTravelBox--1Llpa","settings":"styles-settings--3K4Ba","splitList":"styles-splitList--3tRF6"};

/***/ }),

/***/ "85Hc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__("Q4lS");

var _reactRelay = __webpack_require__("Tc9k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _reactRouterDom = __webpack_require__("F8kA");

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _DateRangeComponent = __webpack_require__("JW7h");

var _DateRangeComponent2 = _interopRequireDefault(_DateRangeComponent);

var _DateFieldComponent = __webpack_require__("kg8o");

var _DateFieldComponent2 = _interopRequireDefault(_DateFieldComponent);

var _DailyRates = __webpack_require__("WexP");

var _DailyRates2 = _interopRequireDefault(_DailyRates);

var _rest = __webpack_require__("i4WM");

var _rest2 = _interopRequireDefault(_rest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditSegment = (_temp = _class = function (_React$Component) {
  _inherits(EditSegment, _React$Component);

  function EditSegment(props) {
    _classCallCheck(this, EditSegment);

    var _this = _possibleConstructorReturn(this, (EditSegment.__proto__ || Object.getPrototypeOf(EditSegment)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props$segment = _this.props.segment,
        category = _this$props$segment.category,
        smokingRoom = _this$props$segment.smokingRoom,
        numAdults = _this$props$segment.numAdults,
        numChildren = _this$props$segment.numChildren,
        startDate = _this$props$segment.startDate,
        endDate = _this$props$segment.endDate,
        cancellationDeadline = _this$props$segment.cancellationDeadline,
        sabreLocator = _this$props$segment.sabreLocator,
        confirmationNumber = _this$props$segment.confirmationNumber,
        cancellationNumber = _this$props$segment.cancellationNumber,
        rates = _this$props$segment.rates,
        currency = _this$props$segment.currency,
        averageDailyRate = _this$props$segment.averageDailyRate,
        bedType = _this$props$segment.bedType,
        amenityProgram = _this$props$segment.amenityProgram,
        vendor = _this$props$segment.vendor;


    _this.state = {
      vendorId: vendor ? vendor.id : "",
      vendorName: vendor ? vendor.name : "",
      category: category,
      smokingRoom: smokingRoom,
      numAdults: numAdults,
      numChildren: numChildren,
      startDate: startDate,
      endDate: endDate,
      cancellationDeadline: cancellationDeadline,
      sabreLocator: sabreLocator,
      confirmationNumber: confirmationNumber,
      cancellationNumber: cancellationNumber,
      rates: rates,
      currency: currency,
      averageDailyRate: averageDailyRate,
      note: "",
      bedType: bedType,
      amenityProgram: amenityProgram,
      segmentAutocompleteData: [],
      saving: false
    };

    if (typeof window !== "undefined") {
      _this.ReactQuill = __webpack_require__("TWqO"); // eslint-disable-line global-require
    }
    return _this;
  }

  _createClass(EditSegment, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          onComplete = _props.onComplete,
          vendor = _props.segment.vendor;
      var _state = this.state,
          category = _state.category,
          smokingRoom = _state.smokingRoom,
          numAdults = _state.numAdults,
          numChildren = _state.numChildren,
          startDate = _state.startDate,
          endDate = _state.endDate,
          cancellationDeadline = _state.cancellationDeadline,
          sabreLocator = _state.sabreLocator,
          confirmationNumber = _state.confirmationNumber,
          cancellationNumber = _state.cancellationNumber,
          rates = _state.rates,
          currency = _state.currency,
          averageDailyRate = _state.averageDailyRate,
          note = _state.note,
          bedType = _state.bedType,
          amenityProgram = _state.amenityProgram,
          segmentAutocompleteData = _state.segmentAutocompleteData,
          vendorName = _state.vendorName,
          saving = _state.saving;


      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(_reactRouterDom.Prompt, { message: "A segment is still being editing, leaving now will discard any changes made." }),
        _react2.default.createElement(
          "div",
          { style: styles.editFields },
          _react2.default.createElement(_materialUi.AutoComplete, {
            searchText: vendorName,
            style: styles.formFieldStyle,
            menuStyle: { width: 500 },
            listStyle: { width: 500 },
            floatingLabelText: "Vendor",
            dataSource: segmentAutocompleteData,
            onUpdateInput: this.handleUpdateSegmentAutocomplete,
            onNewRequest: this.vendorSelected,
            filter: function filter() {
              return true;
            },
            fullWidth: true
          }),
          _react2.default.createElement(_materialUi.TextField, {
            floatingLabelText: "Room Category",
            value: category,
            onChange: this.updateTextField("category")
          }),
          _react2.default.createElement(_materialUi.TextField, {
            floatingLabelText: "Bedding",
            value: bedType,
            onChange: this.updateTextField("bedType")
          }),
          _react2.default.createElement(_materialUi.AutoComplete, {
            floatingLabelText: "Amenity Program",
            menuStyle: { width: 500 },
            listStyle: { width: 500 },
            dataSource: vendor ? vendor.amenityPrograms : [],
            onUpdateInput: this.amenityOnUpdateInput,
            onNewRequest: this.amenityOnNewRequest,
            searchText: amenityProgram,
            filter: this.autoCompleteFilter
          }),
          _react2.default.createElement(_materialUi.Checkbox, {
            label: "Smoking",
            checked: smokingRoom,
            onCheck: this.updateSmoking
          }),
          _react2.default.createElement(_materialUi.TextField, {
            floatingLabelText: "Number of Adults",
            value: numAdults,
            type: "number",
            onChange: this.updateTextField("numAdults")
          }),
          _react2.default.createElement(_materialUi.TextField, {
            floatingLabelText: "Number of Children",
            value: numChildren,
            type: "number",
            onChange: this.updateTextField("numChildren")
          }),
          _react2.default.createElement(_DateRangeComponent2.default, {
            startValue: startDate,
            endValue: endDate,
            startLabel: "Check-in Date",
            endLabel: "Check-out Date",
            onChange: this.updateDates
          }),
          _react2.default.createElement(_DateFieldComponent2.default, {
            floatingLabelText: "Cancellation Deadline",
            value: cancellationDeadline || "",
            onChange: this.updateTextField("cancellationDeadline")
          }),
          _react2.default.createElement(_materialUi.TextField, {
            floatingLabelText: "SABRE Locator",
            value: sabreLocator,
            onChange: this.updateTextField("sabreLocator")
          }),
          _react2.default.createElement(_materialUi.TextField, {
            floatingLabelText: "Confirmation Number",
            value: confirmationNumber,
            onChange: this.updateTextField("confirmationNumber")
          }),
          _react2.default.createElement(_materialUi.TextField, {
            floatingLabelText: "Cancellation Number",
            value: cancellationNumber,
            onChange: this.updateTextField("cancellationNumber"),
            disabled: confirmationNumber === ""
          })
        ),
        _react2.default.createElement(_materialUi.Toggle, {
          checked: averageDailyRate,
          onClick: this.toggleAverageDailyRate,
          label: averageDailyRate ? "Average Daily Rate" : "Daily Rates",
          labelPosition: "right"
        }),
        _react2.default.createElement(_DailyRates2.default, {
          editing: true,
          startDate: startDate,
          endDate: endDate,
          rates: rates,
          currency: currency,
          average: averageDailyRate,
          onChange: this.updateRates
        }),
        _react2.default.createElement(this.ReactQuill, { value: note, onChange: this.updateNote }),
        _react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", secondary: true, onTouchTap: onComplete }),
        _react2.default.createElement(_materialUi.FlatButton, {
          label: "Save",
          primary: true,
          onTouchTap: this.save,
          disabled: saving
        })
      );
    }
  }]);

  return EditSegment;
}(_react2.default.Component), _class.propTypes = {
  segment: _propTypes2.default.shape().isRequired,
  onComplete: _propTypes2.default.func.isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.updateTextField = function (field) {
    return function (e) {
      var value = e.target.value;


      var newState = {};
      newState[field] = value;
      _this2.setState(newState);
    };
  };

  this.updateNote = function (note) {
    _this2.setState({ note: note });
  };

  this.updateSmoking = function (e, checked) {
    _this2.setState({ smokingRoom: checked });
  };

  this.updateDates = function (e) {
    var startDate = e.startDate,
        endDate = e.endDate;


    _this2.setState({ startDate: startDate, endDate: endDate });
  };

  this.updateRates = function (rates, currency) {
    _this2.setState({ rates: rates, currency: currency });
  };

  this.amenityOnNewRequest = function (chosenRequest) {
    _this2.setState({
      amenityProgram: chosenRequest
    });
  };

  this.amenityOnUpdateInput = function (searchText) {
    _this2.setState({
      amenityProgram: searchText
    });
  };

  this.autoCompleteFilter = function (searchText, key) {
    var normalKey = key.toLowerCase();
    var normalText = searchText.toLowerCase();
    return searchText !== "" && normalKey.indexOf(normalText) !== -1;
  };

  this.handleUpdateSegmentAutocomplete = function (value) {
    (0, _rest2.default)("auto/vendor", value).then(function (response) {
      var objects = response.objects;

      _this2.setState({
        vendor: value,
        segmentAutocompleteData: objects.map(function (object) {
          return {
            text: object.name,
            value: object.relayId,
            name: object.name,
            score: object.score
          };
        })
      });
    }).catch(function (response) {
      console.log(response);
    });
  };

  this.vendorSelected = function (selected, index) {
    if (index !== -1) {
      var vendorId = selected.value,
          vendorName = selected.name;


      _this2.setState({ vendorId: vendorId, vendorName: vendorName });
    }
  };

  this.save = function () {
    _this2.setState({ saving: true });

    var _props2 = _this2.props,
        segmentId = _props2.segment.id,
        onComplete = _props2.onComplete;
    var _state2 = _this2.state,
        category = _state2.category,
        smokingRoom = _state2.smokingRoom,
        numAdults = _state2.numAdults,
        numChildren = _state2.numChildren,
        cancellationDeadline = _state2.cancellationDeadline,
        sabreLocator = _state2.sabreLocator,
        confirmationNumber = _state2.confirmationNumber,
        cancellationNumber = _state2.cancellationNumber,
        rates = _state2.rates,
        averageDailyRate = _state2.averageDailyRate,
        note = _state2.note,
        bedType = _state2.bedType,
        amenityProgram = _state2.amenityProgram,
        vendorId = _state2.vendorId;
    var _state3 = _this2.state,
        startDate = _state3.startDate,
        endDate = _state3.endDate,
        currency = _state3.currency;


    if (_moment2.default.isMoment(startDate)) {
      startDate = startDate.format("YYYY-MM-DDTHH:mm:ssZZ");
    }
    if (_moment2.default.isMoment(endDate)) {
      endDate = endDate.format("YYYY-MM-DDTHH:mm:ssZZ");
    }

    if (confirmationNumber && !currency) {
      var setUSD = confirm("You have not set a currency for this segment, do you want to default to USD?");

      if (setUSD) {
        currency = "USD";
      } else {
        _this2.setState({ saving: false });
        return;
      }
    }

    (0, _reactRelay.commitMutation)(_environment2.default, {
      mutation: _graphql || (_graphql = function _graphql() {
        return __webpack_require__("BhTv");
      }),
      variables: {
        input: {
          segmentId: segmentId,
          vendorId: vendorId,
          category: category,
          smokingRoom: smokingRoom,
          numAdults: numAdults,
          numChildren: numChildren,
          startDate: startDate,
          endDate: endDate,
          cancellationDeadline: cancellationDeadline,
          sabreLocator: sabreLocator,
          confirmationNumber: confirmationNumber,
          cancellationNumber: cancellationNumber,
          rates: rates,
          currency: currency,
          averageDailyRate: averageDailyRate,
          note: note,
          bedType: bedType,
          amenityProgram: amenityProgram
        }
      },
      onCompleted: function onCompleted() {
        return onComplete();
      },
      onError: function onError(err) {
        alert(err);
        _this2.setState({ saving: false });
      }
    });
  };

  this.toggleAverageDailyRate = function (e) {
    var checked = e.target.checked;

    _this2.setState({ averageDailyRate: checked });
  };
}, _temp);
exports.default = EditSegment;


var styles = {
  editFields: {
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between"
  }
};

/***/ }),

/***/ "8fRm":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  query SalesReportRenderer_Trips_Query {\n    rawTrips {\n      edges {\n        node {\n          id\n          created\n          cancelled\n          prospect\n          specificDates\n          segments {\n            booked\n            cancelled\n            bookedTimestamp\n            cancelledTimestamp\n          }\n          cancelledTimestamp\n          inbox\n          travelStartDate\n          tripName\n          ownerName\n        }\n      }\n    }\n  }\n"], ["\n  query SalesReportRenderer_Trips_Query {\n    rawTrips {\n      edges {\n        node {\n          id\n          created\n          cancelled\n          prospect\n          specificDates\n          segments {\n            booked\n            cancelled\n            bookedTimestamp\n            cancelledTimestamp\n          }\n          cancelledTimestamp\n          inbox\n          travelStartDate\n          tripName\n          ownerName\n        }\n      }\n    }\n  }\n"]);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__("Q4lS");

var _reactApollo = __webpack_require__("3zLD");

var _SalesReport = __webpack_require__("yCYw");

var _SalesReport2 = _interopRequireDefault(_SalesReport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SalesReportQuery = (0, _reactApollo.gql)(_templateObject);

var SalesReportRenderer = function SalesReportRenderer(_ref) {
  var data = _ref.data;

  if (data.loading) {
    return _react2.default.createElement(
      "div",
      { style: styles.progressContainer },
      _react2.default.createElement(_materialUi.CardHeader, { title: "Sales Report Loading" }),
      _react2.default.createElement(_materialUi.CircularProgress, { style: styles.progressIndicator })
    );
  }

  var trips = data.rawTrips.edges;


  return _react2.default.createElement(_SalesReport2.default, { trips: trips.map(function (_ref2) {
      var node = _ref2.node;
      return node;
    }) });
};

SalesReportRenderer.propTypes = {
  data: _propTypes2.default.shape().isRequired
};

exports.default = (0, _reactApollo.graphql)(SalesReportQuery)(SalesReportRenderer);


var styles = {
  progressContainer: {
    margin: 10,
    position: "relative"
  },
  progressIndicator: {
    marginLeft: "50%",
    left: -20
  }
};

/***/ }),

/***/ "99iq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SalesReportRenderer = __webpack_require__("8fRm");

var _SalesReportRenderer2 = _interopRequireDefault(_SalesReportRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _SalesReportRenderer2.default;

/***/ }),

/***/ "9FEW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 5ce58e468dadb168d5beefec16c8ace8
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SegmentListItem_DuplicateSegment_MutationVariables = {|
  input: {
    segmentId?: ?string;
    clientMutationId?: ?string;
  };
|};

export type SegmentListItem_DuplicateSegment_MutationResponse = {|
  +duplicateSegment: ?{|
    +trip: ?{|
      +segments: ?$ReadOnlyArray<?{|
        +id: string;
        +vendor: ?{|
          +id: string;
          +name: string;
          +amenityPrograms: ?$ReadOnlyArray<?string>;
        |};
        +trip: ?{|
          +id: string;
          +searchId: ?string;
          +numSegments: ?number;
          +dropbox: ?boolean;
          +invoice: ?boolean;
          +draftVip: ?boolean;
          +book: ?boolean;
          +cancel: ?boolean;
        |};
        +name: ?string;
        +dateString: ?string;
        +startDate: ?string;
        +endDate: ?string;
        +category: ?string;
        +bedType: ?string;
        +amenityProgram: ?string;
        +numAdults: ?number;
        +numChildren: ?number;
        +smokingRoom: ?boolean;
        +rates: ?$ReadOnlyArray<?number>;
        +currency: string;
        +averageDailyRate: boolean;
        +cancellationDeadline: ?any;
        +dropbox: boolean;
        +invoiced: boolean;
        +vipDrafted: boolean;
        +booked: boolean;
        +cancelled: boolean;
        +sabreLocator: string;
        +confirmationNumber: string;
        +cancellationNumber: string;
        +vipLetter: string;
        +notes: ?$ReadOnlyArray<?{|
          +id: string;
          +owner: {|
            +id: string;
            +firstName: string;
          |};
          +content: string;
          +created: any;
        |}>;
      |}>;
    |};
  |};
|};
*/

/*
mutation SegmentListItem_DuplicateSegment_Mutation(
  $input: DuplicateSegmentInput!
) {
  duplicateSegment(input: $input) {
    trip {
      segments {
        rates
        id
        trip {
          id
          searchId
          numSegments
          dropbox
          invoice
          draftVip
          book
          cancel
        }
        name
        dateString
        startDate
        endDate
        category
        bedType
        amenityProgram
        numAdults
        numChildren
        smokingRoom
        vendor {
          id
          name
          amenityPrograms
        }
        currency
        averageDailyRate
        cancellationDeadline
        dropbox
        invoiced
        vipDrafted
        booked
        cancelled
        sabreLocator
        confirmationNumber
        cancellationNumber
        vipLetter
        notes {
          id
          owner {
            id
            firstName
          }
          content
          created
        }
      }
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "DuplicateSegmentInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "SegmentListItem_DuplicateSegment_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "DuplicateSegmentInput!"
      }],
      "concreteType": "DuplicateSegmentPayload",
      "name": "duplicateSegment",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Segment",
          "name": "segments",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "rates",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Trip",
            "name": "trip",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "searchId",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "numSegments",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "dropbox",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "invoice",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "draftVip",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "book",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "cancel",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dateString",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "startDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "endDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "category",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "bedType",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "amenityProgram",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "numAdults",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "numChildren",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "smokingRoom",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Vendor",
            "name": "vendor",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "amenityPrograms",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "currency",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "averageDailyRate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancellationDeadline",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dropbox",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "invoiced",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "vipDrafted",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "booked",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancelled",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "sabreLocator",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "confirmationNumber",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancellationNumber",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "vipLetter",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "name": "notes",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "User",
              "name": "owner",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "firstName",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "content",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "created",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "SegmentListItem_DuplicateSegment_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "DuplicateSegmentInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "SegmentListItem_DuplicateSegment_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "DuplicateSegmentInput!"
      }],
      "concreteType": "DuplicateSegmentPayload",
      "name": "duplicateSegment",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Segment",
          "name": "segments",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Vendor",
            "name": "vendor",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "amenityPrograms",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "rates",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Trip",
            "name": "trip",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "searchId",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "numSegments",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "dropbox",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "invoice",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "draftVip",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "book",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "cancel",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dateString",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "startDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "endDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "category",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "bedType",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "amenityProgram",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "numAdults",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "numChildren",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "smokingRoom",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "currency",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "averageDailyRate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancellationDeadline",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dropbox",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "invoiced",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "vipDrafted",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "booked",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancelled",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "sabreLocator",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "confirmationNumber",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancellationNumber",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "vipLetter",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "name": "notes",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "User",
              "name": "owner",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "firstName",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "content",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "created",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation SegmentListItem_DuplicateSegment_Mutation(\n  $input: DuplicateSegmentInput!\n) {\n  duplicateSegment(input: $input) {\n    trip {\n      segments {\n        rates\n        id\n        trip {\n          id\n          searchId\n          numSegments\n          dropbox\n          invoice\n          draftVip\n          book\n          cancel\n        }\n        name\n        dateString\n        startDate\n        endDate\n        category\n        bedType\n        amenityProgram\n        numAdults\n        numChildren\n        smokingRoom\n        vendor {\n          id\n          name\n          amenityPrograms\n        }\n        currency\n        averageDailyRate\n        cancellationDeadline\n        dropbox\n        invoiced\n        vipDrafted\n        booked\n        cancelled\n        sabreLocator\n        confirmationNumber\n        cancellationNumber\n        vipLetter\n        notes {\n          id\n          owner {\n            id\n            firstName\n          }\n          content\n          created\n        }\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "9jke":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2, _dec, _class2, _class3, _temp4, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("Tc9k");

var _reactRedux = __webpack_require__("RH2O");

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _Trip = __webpack_require__("UCvn");

var _Trip2 = _interopRequireDefault(_Trip);

var _TripListFilters = __webpack_require__("6Gex");

var _TripListFilters2 = _interopRequireDefault(_TripListFilters);

var _styles = __webpack_require__("IoNl");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RenderedTrips = (_temp2 = _class = function (_React$Component) {
  _inherits(RenderedTrips, _React$Component);

  function RenderedTrips() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RenderedTrips);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RenderedTrips.__proto__ || Object.getPrototypeOf(RenderedTrips)).call.apply(_ref, [this].concat(args))), _this), _this.scrollToTrip = function () {
      var node = _reactDom2.default.findDOMNode(_this.refs.activeTrip); // eslint-disable-line
      if (node) {
        node.scrollIntoView({ behavior: "instant", block: "start" });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RenderedTrips, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.scrollToTrip();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.scrollToTrip();
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          trips = _props.trips,
          activeTrip = _props.activeTrip;


      return _react2.default.createElement(
        "div",
        { className: _styles2.default.listItems },
        trips.map(function (trip) {
          var tripId = trip.id;

          var active = tripId === activeTrip;
          var ref = active ? "activeTrip" : null;

          return _react2.default.createElement(_Trip2.default, { key: tripId, trip: trip, active: active, ref: ref });
        })
      );
    }
  }]);

  return RenderedTrips;
}(_react2.default.Component), _class.propTypes = {
  trips: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  activeTrip: _propTypes2.default.string
}, _class.defaultProps = {
  activeTrip: ""
}, _temp2);
var Renderer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    windowHeight: state.Responsive.get("windowHeight"),
    filter: state.Trips.get("filter"),
    selectedUser: state.Trips.get("selectedUser")
  };
}), _dec(_class2 = (_temp4 = _class3 = function (_React$Component2) {
  _inherits(Renderer, _React$Component2);

  function Renderer() {
    var _ref2;

    var _temp3, _this2, _ret2;

    _classCallCheck(this, Renderer);

    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return _ret2 = (_temp3 = (_this2 = _possibleConstructorReturn(this, (_ref2 = Renderer.__proto__ || Object.getPrototypeOf(Renderer)).call.apply(_ref2, [this].concat(args))), _this2), _this2.tripNeeds = function (trip, need) {
      var book = trip.book,
          dropbox = trip.dropbox,
          invoice = trip.invoice,
          actionableInvoice = trip.actionableInvoice,
          draftVip = trip.draftVip,
          needsTraining = trip.needsTraining,
          needsVetting = trip.needsVetting,
          insideCircle = trip.insideCircle,
          cancel = trip.cancel,
          prospect = trip.prospect,
          specificDates = trip.specificDates,
          highPriority = trip.highPriority,
          welcomeHome = trip.welcomeHome;


      if (need === null) {
        return true;
      } else if (need === "book") {
        return book;
      } else if (need === "filing") {
        return dropbox;
      } else if (need === "invoice") {
        return invoice;
      } else if (need === "actionableInvoice") {
        return actionableInvoice;
      } else if (need === "vip") {
        return draftVip;
      } else if (need === "training") {
        return needsTraining;
      } else if (need === "vetting") {
        return needsVetting;
      } else if (need === "insideCircle") {
        return insideCircle;
      } else if (need === "cancellation") {
        return cancel;
      } else if (need === "prospect") {
        return prospect && !specificDates;
      } else if (need === "highPriority") {
        return highPriority;
      } else if (need === "welcomeHome") {
        return welcomeHome;
      }

      return true;
    }, _temp3), _possibleConstructorReturn(_this2, _ret2);
  }
  // eslint-disable-line


  _createClass(Renderer, [{
    key: "render",
    value: function render() {
      var _this3 = this;

      var _props2 = this.props,
          filterNeed = _props2.filter,
          activeTrip = _props2.activeTrip,
          selectedUser = _props2.selectedUser,
          loadingEl = _props2.loadingEl;


      return _react2.default.createElement(_reactRelay.QueryRenderer, {
        environment: _environment2.default,
        query: _graphql || (_graphql = function _graphql() {
          return __webpack_require__("hO6s");
        }),
        render: function render(_ref3) {
          var error = _ref3.error,
              props = _ref3.props;

          if (error) {
            return _react2.default.createElement(
              "div",
              null,
              error.message
            );
          } else if (props) {
            var trips = props.allTrips.edges;


            var users = {};
            var filteredTrips = trips.filter(function (_ref4) {
              var trip = _ref4.node;
              var ownerId = trip.ownerId,
                  ownerName = trip.ownerName;

              users[ownerId] = { id: ownerId, name: ownerName };

              var match = (selectedUser === "all" || ownerId === selectedUser) && (filterNeed === "all" || _this3.tripNeeds(trip, filterNeed));

              return match;
            }).map(function (_ref5) {
              var trip = _ref5.node;
              return trip;
            });

            return _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(_TripListFilters2.default, {
                filter: filterNeed,
                users: users,
                numFiltered: filteredTrips.length,
                numTrips: trips.length
              }),
              _react2.default.createElement(RenderedTrips, { trips: filteredTrips, activeTrip: activeTrip })
            );
          }

          return loadingEl;
        }
      });
    }
  }]);

  return Renderer;
}(_react2.default.Component), _class3.propTypes = {
  filter: _propTypes2.default.string.isRequired,
  activeTrip: _propTypes2.default.string,
  selectedUser: _propTypes2.default.string.isRequired,
  loadingEl: _propTypes2.default.element.isRequired
}, _class3.defaultProps = {
  activeTrip: ""
}, _temp4)) || _class2);
exports.default = Renderer;

/***/ }),

/***/ "9tc1":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("RH2O");

var _home = __webpack_require__("S5U3");

var _home2 = _interopRequireDefault(_home);

var _flight = __webpack_require__("d7hA");

var _flight2 = _interopRequireDefault(_flight);

var _people = __webpack_require__("5LaU");

var _people2 = _interopRequireDefault(_people);

var _reactRouterDom = __webpack_require__("F8kA");

var _hotel = __webpack_require__("yCHS");

var _hotel2 = _interopRequireDefault(_hotel);

var _trendingUp = __webpack_require__("duF4");

var _trendingUp2 = _interopRequireDefault(_trendingUp);

var _questionAnswer = __webpack_require__("HwUN");

var _questionAnswer2 = _interopRequireDefault(_questionAnswer);

var _receipt = __webpack_require__("UzsU");

var _receipt2 = _interopRequireDefault(_receipt);

var _aphrodite = __webpack_require__("BK4P");

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NavBar = function NavBar(props) {
  var version = props.version;


  return _react2.default.createElement(
    'div',
    { className: (0, _aphrodite.css)(styleSheet.container) },
    _react2.default.createElement(
      _reactRouterDom.Link,
      { to: '/' },
      _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styleSheet.iconContainer) },
        _react2.default.createElement(_home2.default, { className: (0, _aphrodite.css)(styleSheet.icon) }),
        _react2.default.createElement(
          'span',
          { className: (0, _aphrodite.css)(styleSheet.label) },
          'Home'
        )
      )
    ),
    _react2.default.createElement(
      _reactRouterDom.Link,
      { to: '/trips/' },
      _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styleSheet.iconContainer) },
        _react2.default.createElement(_flight2.default, { className: (0, _aphrodite.css)(styleSheet.icon) }),
        _react2.default.createElement(
          'span',
          { className: (0, _aphrodite.css)(styleSheet.label) },
          'Trips'
        )
      )
    ),
    _react2.default.createElement(
      _reactRouterDom.Link,
      { to: '/quote/' },
      _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styleSheet.iconContainer) },
        _react2.default.createElement(_receipt2.default, { className: (0, _aphrodite.css)(styleSheet.icon) }),
        _react2.default.createElement(
          'span',
          { className: (0, _aphrodite.css)(styleSheet.label) },
          'Rate Quote'
        )
      )
    ),
    _react2.default.createElement(
      _reactRouterDom.Link,
      { to: '/clients/' },
      _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styleSheet.iconContainer) },
        _react2.default.createElement(_people2.default, { className: (0, _aphrodite.css)(styleSheet.icon) }),
        _react2.default.createElement(
          'span',
          { className: (0, _aphrodite.css)(styleSheet.label) },
          'Clients'
        )
      )
    ),
    _react2.default.createElement(
      _reactRouterDom.Link,
      { to: '/vendors/' },
      _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styleSheet.iconContainer) },
        _react2.default.createElement(_hotel2.default, { className: (0, _aphrodite.css)(styleSheet.icon) }),
        _react2.default.createElement(
          'span',
          { className: (0, _aphrodite.css)(styleSheet.label) },
          'Vendors'
        )
      )
    ),
    _react2.default.createElement(
      _reactRouterDom.Link,
      { to: '/forms/responses/' },
      _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styleSheet.iconContainer) },
        _react2.default.createElement(_questionAnswer2.default, { className: (0, _aphrodite.css)(styleSheet.icon) }),
        _react2.default.createElement(
          'span',
          { className: (0, _aphrodite.css)(styleSheet.label) },
          'Form Responses'
        )
      )
    ),
    _react2.default.createElement(
      _reactRouterDom.Link,
      { to: '/reports/' },
      _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styleSheet.iconContainer) },
        _react2.default.createElement(_trendingUp2.default, { className: (0, _aphrodite.css)(styleSheet.icon) }),
        _react2.default.createElement(
          'span',
          { className: (0, _aphrodite.css)(styleSheet.label) },
          'Reports'
        )
      )
    ),
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styleSheet.version) },
      'Ping Pong v',
      version
    )
  );
};

NavBar.propTypes = {
  version: _propTypes2.default.string.isRequired
};

exports.default = (0, _reactRedux.connect)(function (state) {
  return { version: state.Auth.get('version') };
})(NavBar);


var styleSheet = _aphrodite.StyleSheet.create({
  container: {
    background: _ourismanTravelTheme2.default.palette.primary3Color,
    boxSizing: 'content-box',
    display: 'flex',
    position: 'fixed',
    '@media (max-width: 800px)': {
      borderTop: '2px solid ' + _ourismanTravelTheme2.default.palette.borderColor,
      bottom: 0,
      justifyContent: 'space-around',
      paddingBottom: 5,
      paddingTop: 5,
      width: '100%',
      zIndex: 1000
    },
    '@media (min-width: 800px)': {
      alignItems: 'center',
      borderRight: '2px solid ' + _ourismanTravelTheme2.default.palette.borderColor,
      flexDirection: 'column',
      height: 'calc(100vh - 64px)',
      paddingRight: 10,
      top: 64,
      width: 70
    }
  },
  icon: {
    width: 50,
    height: 50
  },
  iconContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    '@media (min-width: 800px)': {
      marginTop: 10,
      marginLeft: 10
    }
  },
  label: {
    '@media (max-width: 800px)': {
      display: 'none'
    },
    '@media (min-width: 800px)': {
      textAlign: 'center',
      fontSize: 15,
      color: _ourismanTravelTheme2.default.palette.textColor
    }
  },
  activeLinkStyle: {},
  version: {
    '@media (max-width: 800px)': {
      display: 'none'
    },
    '@media (min-width: 800px)': {
      fontSize: 9,
      fontWeight: 'bold',
      marginTop: 'auto'
    }
  }
});

/***/ }),

/***/ "AA0U":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = createReducer;

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function createReducer(initialState, handlers) {
  return function () {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    if (!_immutable.Map.isMap(state) && !_immutable.List.isList(state)) {
      state = _immutable2.default.fromJS(state);
    }

    var handler = handlers[action.type];

    if (!handler) {
      return state;
    }

    state = handler(state, action);

    if (!_immutable.Map.isMap(state) && !_immutable.List.isList(state)) {
      throw new TypeError('Reducers must return Immutable objects.');
    }

    return state;
  };
}

/***/ }),

/***/ "AMVQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("F8kA");

var _reactRedux = __webpack_require__("RH2O");

var _redux = __webpack_require__("2KeS");

var _reduxThunk = __webpack_require__("bEzl");

var _reduxThunk2 = _interopRequireDefault(_reduxThunk);

var _reactApollo = __webpack_require__("3zLD");

var _browser = __webpack_require__("AHhf");

var Sentry = _interopRequireWildcard(_browser);

var _App = __webpack_require__("I5fo");

var _App2 = _interopRequireDefault(_App);

var _reducers = __webpack_require__("La8e");

var reducers = _interopRequireWildcard(_reducers);

var _apollo = __webpack_require__("zPxQ");

var _apollo2 = _interopRequireDefault(_apollo);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

if (true) {
  Sentry.init({
    dsn: "https://2d8124fc671c45caa52e34d93454a611@sentry.io/170129"
  });
}

var store = (0, _redux.createStore)((0, _redux.combineReducers)(reducers), window.SERVER_STATE, (0, _redux.compose)((0, _redux.applyMiddleware)(_apollo2.default.middleware(), _reduxThunk2.default)));

// We need a Root component for React Hot Loading.

exports.default = function () {
  return _react2.default.createElement(
    _reactRouterDom.BrowserRouter,
    null,
    _react2.default.createElement(
      _reactApollo.ApolloProvider,
      { store: store, client: _apollo2.default },
      _react2.default.createElement(_App2.default, null)
    )
  );
};

/***/ }),

/***/ "AVJT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 39a547dc218435aaec8530b1092f91b3
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SegmentDetails_SetCheckbox_MutationVariables = {|
  input: {
    segmentId?: ?string;
    checkbox?: ?string;
    value?: ?boolean;
    clientMutationId?: ?string;
  };
|};

export type SegmentDetails_SetCheckbox_MutationResponse = {|
  +setCheckbox: ?{|
    +segment: ?{|
      +id: string;
      +dropbox: boolean;
      +invoiced: boolean;
      +vipDrafted: boolean;
      +booked: boolean;
      +cancelled: boolean;
      +trip: ?{|
        +dropbox: ?boolean;
        +invoice: ?boolean;
        +draftVip: ?boolean;
        +book: ?boolean;
        +cancel: ?boolean;
        +actionableInvoice: ?boolean;
      |};
    |};
  |};
|};
*/

/*
mutation SegmentDetails_SetCheckbox_Mutation(
  $input: SetCheckboxInput!
) {
  setCheckbox(input: $input) {
    segment {
      id
      dropbox
      invoiced
      vipDrafted
      booked
      cancelled
      trip {
        dropbox
        invoice
        draftVip
        book
        cancel
        actionableInvoice
        id
      }
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "SetCheckboxInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "SegmentDetails_SetCheckbox_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "SetCheckboxInput!"
      }],
      "concreteType": "SetCheckboxPayload",
      "name": "setCheckbox",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Segment",
        "name": "segment",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dropbox",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "invoiced",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "vipDrafted",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "booked",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancelled",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Trip",
          "name": "trip",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dropbox",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "invoice",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "draftVip",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "book",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancel",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "actionableInvoice",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "SegmentDetails_SetCheckbox_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "SetCheckboxInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "SegmentDetails_SetCheckbox_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "SetCheckboxInput!"
      }],
      "concreteType": "SetCheckboxPayload",
      "name": "setCheckbox",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Segment",
        "name": "segment",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dropbox",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "invoiced",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "vipDrafted",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "booked",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancelled",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Trip",
          "name": "trip",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dropbox",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "invoice",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "draftVip",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "book",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancel",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "actionableInvoice",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation SegmentDetails_SetCheckbox_Mutation(\n  $input: SetCheckboxInput!\n) {\n  setCheckbox(input: $input) {\n    segment {\n      id\n      dropbox\n      invoiced\n      vipDrafted\n      booked\n      cancelled\n      trip {\n        dropbox\n        invoice\n        draftVip\n        book\n        cancel\n        actionableInvoice\n        id\n      }\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "Aki7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _materialUi = __webpack_require__("Q4lS");

var _exenv = __webpack_require__("u4m+");

var _exenv2 = _interopRequireDefault(_exenv);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _TripListRenderer = __webpack_require__("9jke");

var _TripListRenderer2 = _interopRequireDefault(_TripListRenderer);

var _TripListFilters = __webpack_require__("6Gex");

var _TripListFilters2 = _interopRequireDefault(_TripListFilters);

var _TripsActions = __webpack_require__("FMZb");

var _styles = __webpack_require__("IoNl");

var _styles2 = _interopRequireDefault(_styles);

var _TripDetailsRenderer = __webpack_require__("gl9Z");

var _TripDetailsRenderer2 = _interopRequireDefault(_TripDetailsRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Trips = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    viewport: state.Responsive.get('viewport'),
    windowHeight: state.Responsive.get('windowHeight'),
    filterNeed: state.Trips.get('filter')
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(Trips, _React$Component);

  function Trips(props) {
    _classCallCheck(this, Trips);

    var _this = _possibleConstructorReturn(this, (Trips.__proto__ || Object.getPrototypeOf(Trips)).call(this, props));

    _this.setSelectedUser = function () {
      var userRE = /\?user=([\w=]+)/;
      var match = userRE.exec(location.search);
      var selectedUser = match ? match[1] : 'all';

      _this.props.dispatch((0, _TripsActions.setValue)('selectedUser', selectedUser));
    };

    _this.state = {
      onClient: false
    };
    return _this;
  }

  _createClass(Trips, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ onClient: _exenv2.default.canUseDom });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ onClient: true }); // eslint-disable-line
      this.setSelectedUser();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          viewport = _props.viewport,
          activeTrip = _props.match.params.tripId,
          windowHeight = _props.windowHeight,
          filterNeed = _props.filterNeed;
      var onClient = this.state.onClient;

      var top = (windowHeight - 161) / 2 + 161;

      var ActiveTrip = _react2.default.createElement(_TripDetailsRenderer2.default, { activeTrip: activeTrip });

      if (viewport !== 'desktop' && activeTrip) {
        return ActiveTrip;
      }

      var loadingEl = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_TripListFilters2.default, { filter: filterNeed, numFiltered: 0, numTrips: 0 }),
        _react2.default.createElement(_materialUi.RefreshIndicator, { top: top, left: 277, status: 'loading' })
      );

      return _react2.default.createElement(
        'div',
        { className: _styles2.default.container },
        _react2.default.createElement(
          'div',
          { className: _styles2.default.list },
          onClient ? _react2.default.createElement(_TripListRenderer2.default, {
            activeTrip: activeTrip,
            loadingEl: loadingEl
          }) : loadingEl
        ),
        _react2.default.createElement(
          'div',
          { className: _styles2.default.detail },
          activeTrip ? ActiveTrip : null
        )
      );
    }
  }]);

  return Trips;
}(_react2.default.Component), _class2.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  viewport: _propTypes2.default.string.isRequired,
  match: _propTypes2.default.shape({
    params: _propTypes2.default.object
  }).isRequired,
  windowHeight: _propTypes2.default.number.isRequired,
  filterNeed: _propTypes2.default.string.isRequired
}, _temp)) || _class);
exports.default = Trips;

/***/ }),

/***/ "BVsG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2, _dec, _class2, _class3, _temp3, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("Tc9k");

var _reactRedux = __webpack_require__("RH2O");

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fuzzy = __webpack_require__("Pv+r");

var _fuzzy2 = _interopRequireDefault(_fuzzy);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _Client = __webpack_require__("YpiJ");

var _Client2 = _interopRequireDefault(_Client);

var _styles = __webpack_require__("DsNi");

var _styles2 = _interopRequireDefault(_styles);

var _ClientListFilters = __webpack_require__("mcCO");

var _ClientListFilters2 = _interopRequireDefault(_ClientListFilters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RenderedClients = (_temp2 = _class = function (_React$Component) {
  _inherits(RenderedClients, _React$Component);

  function RenderedClients() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RenderedClients);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RenderedClients.__proto__ || Object.getPrototypeOf(RenderedClients)).call.apply(_ref, [this].concat(args))), _this), _this.scrollToClient = function () {
      var node = _reactDom2.default.findDOMNode(_this.refs.activeClient); // eslint-disable-line
      if (node) {
        node.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RenderedClients, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollToClient();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.scrollToClient();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          clients = _props.clients,
          activeClient = _props.activeClient;


      return _react2.default.createElement(
        'div',
        { className: _styles2.default.listItems },
        clients.map(function (client) {
          var clientId = client.id;

          var active = clientId === activeClient;
          var ref = active ? 'activeClient' : null;

          return _react2.default.createElement(_Client2.default, {
            key: clientId,
            client: client,
            active: active,
            ref: ref
          });
        })
      );
    }
  }]);

  return RenderedClients;
}(_react2.default.Component), _class.propTypes = {
  clients: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  activeClient: _propTypes2.default.string
}, _class.defaultProps = {
  activeClient: ''
}, _temp2);
var Renderer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    windowHeight: state.Responsive.get('windowHeight')
  };
}), _dec(_class2 = (_temp3 = _class3 = function (_React$Component2) {
  _inherits(Renderer, _React$Component2);

  // eslint-disable-line
  function Renderer(props) {
    _classCallCheck(this, Renderer);

    var _this2 = _possibleConstructorReturn(this, (Renderer.__proto__ || Object.getPrototypeOf(Renderer)).call(this, props));

    _this2.updateClientFilter = function (e) {
      var clientFilter = e.target.value;

      _this2.setState({ clientFilter: clientFilter });
    };

    _this2.state = {
      clientFilter: ''
    };
    return _this2;
  }

  _createClass(Renderer, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          activeClient = _props2.activeClient,
          loadingEl = _props2.loadingEl;
      var clientFilter = this.state.clientFilter;

      var updateClientFilter = this.updateClientFilter;

      return _react2.default.createElement(_reactRelay.QueryRenderer, {
        environment: _environment2.default,
        query: _graphql || (_graphql = function _graphql() {
          return __webpack_require__("RtMB");
        }),
        render: function render(_ref2) {
          var error = _ref2.error,
              props = _ref2.props;

          if (error) {
            return _react2.default.createElement(
              'div',
              null,
              error.message
            );
          } else if (props) {
            var clients = props.allTravelers.edges;


            var filteredClients = clients.map(function (_ref3) {
              var node = _ref3.node;
              return node;
            });
            if (clientFilter) {
              filteredClients = _fuzzy2.default.filter(clientFilter, clients.map(function (_ref4) {
                var node = _ref4.node;
                return node;
              }), {
                extract: function extract(_ref5) {
                  var displayName = _ref5.displayName,
                      fullName = _ref5.fullName,
                      isPrimaryTraveler = _ref5.isPrimaryTraveler,
                      primaryTraveler = _ref5.primaryTraveler;

                  if (isPrimaryTraveler || primaryTraveler === null) {
                    return fullName + ' ' + displayName;
                  }

                  return fullName + ' ' + displayName + ' ' + primaryTraveler.fullName + ' ' + primaryTraveler.displayName;
                }
              }).map(function (filteredClient) {
                return filteredClient.original;
              });
            }

            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_ClientListFilters2.default, {
                numClients: clients.length,
                numFiltered: filteredClients.length,
                updateFilter: updateClientFilter,
                filter: clientFilter
              }),
              _react2.default.createElement(RenderedClients, {
                clients: filteredClients,
                activeClient: activeClient
              })
            );
          }

          return loadingEl;
        }
      });
    }
  }]);

  return Renderer;
}(_react2.default.Component), _class3.propTypes = {
  activeClient: _propTypes2.default.string,
  loadingEl: _propTypes2.default.element.isRequired
}, _class3.defaultProps = {
  activeClient: ''
}, _temp3)) || _class2);
exports.default = Renderer;

/***/ }),

/***/ "BhTv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash d572bedecd4c8dc6045fe72d40559937
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type EditSegment_EditSegment_MutationVariables = {|
  input: {
    segmentId?: ?string;
    vendorId?: ?string;
    category?: ?string;
    bedType?: ?string;
    amenityProgram?: ?string;
    smokingRoom?: ?boolean;
    numAdults?: ?number;
    numChildren?: ?number;
    startDate?: ?string;
    endDate?: ?string;
    cancellationDeadline?: ?string;
    sabreLocator?: ?string;
    confirmationNumber?: ?string;
    cancellationNumber?: ?string;
    averageDailyRate?: ?boolean;
    rates?: ?$ReadOnlyArray<?number>;
    currency?: ?string;
    note?: ?string;
    clientMutationId?: ?string;
  };
|};

export type EditSegment_EditSegment_MutationResponse = {|
  +editSegment: ?{|
    +segment: ?{|
      +id: string;
      +vendor: ?{|
        +id: string;
        +name: string;
        +amenityPrograms: ?$ReadOnlyArray<?string>;
      |};
      +trip: ?{|
        +id: string;
        +searchId: ?string;
        +dateString: ?string;
        +startDate: ?string;
        +endDate: ?string;
        +dropbox: ?boolean;
        +invoice: ?boolean;
        +draftVip: ?boolean;
        +book: ?boolean;
        +cancel: ?boolean;
        +welcomeHome: ?boolean;
        +tasks: ?$ReadOnlyArray<?{|
          +taskType: "DRAFT_WH" | "CANCEL_WH" | "OTHER";
          +description: string;
          +completed: boolean;
          +voided: boolean;
          +history: ?$ReadOnlyArray<?{|
            +name: ?string;
            +action: ?string;
            +timestamp: ?string;
          |}>;
        |}>;
      |};
      +name: ?string;
      +dateString: ?string;
      +startDate: ?string;
      +endDate: ?string;
      +category: ?string;
      +bedType: ?string;
      +amenityProgram: ?string;
      +numAdults: ?number;
      +numChildren: ?number;
      +smokingRoom: ?boolean;
      +rates: ?$ReadOnlyArray<?number>;
      +currency: string;
      +averageDailyRate: boolean;
      +cancellationDeadline: ?any;
      +dropbox: boolean;
      +invoiced: boolean;
      +vipDrafted: boolean;
      +vipSent: boolean;
      +booked: boolean;
      +cancelled: boolean;
      +sabreLocator: string;
      +confirmationNumber: string;
      +cancellationNumber: string;
      +vipLetter: string;
      +notes: ?$ReadOnlyArray<?{|
        +id: string;
        +owner: {|
          +id: string;
          +firstName: string;
        |};
        +content: string;
        +created: any;
      |}>;
    |};
  |};
|};
*/

/*
mutation EditSegment_EditSegment_Mutation(
  $input: EditSegmentInput!
) {
  editSegment(input: $input) {
    segment {
      currency
      id
      trip {
        invoice
        id
        dateString
        startDate
        endDate
        dropbox
        searchId
        draftVip
        book
        cancel
        welcomeHome
        tasks {
          taskType
          description
          completed
          voided
          history {
            name
            action
            timestamp
          }
          id
        }
      }
      name
      dateString
      startDate
      endDate
      category
      bedType
      amenityProgram
      numAdults
      numChildren
      smokingRoom
      rates
      vendor {
        id
        name
        amenityPrograms
      }
      averageDailyRate
      cancellationDeadline
      dropbox
      invoiced
      vipDrafted
      vipSent
      booked
      cancelled
      sabreLocator
      confirmationNumber
      cancellationNumber
      vipLetter
      notes {
        id
        owner {
          id
          firstName
        }
        content
        created
      }
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "EditSegmentInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "EditSegment_EditSegment_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "EditSegmentInput!"
      }],
      "concreteType": "EditSegmentPayload",
      "name": "editSegment",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Segment",
        "name": "segment",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "currency",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Trip",
          "name": "trip",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "invoice",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dateString",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "startDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "endDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dropbox",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "searchId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "draftVip",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "book",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancel",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "welcomeHome",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "name": "tasks",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "taskType",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "description",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "completed",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "voided",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "TaskHistoryObject",
              "name": "history",
              "plural": true,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "action",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "timestamp",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dateString",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "startDate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "endDate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "category",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "bedType",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "amenityProgram",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "numAdults",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "numChildren",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "smokingRoom",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "rates",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Vendor",
          "name": "vendor",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "amenityPrograms",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "averageDailyRate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancellationDeadline",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dropbox",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "invoiced",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "vipDrafted",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "vipSent",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "booked",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancelled",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "sabreLocator",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "confirmationNumber",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancellationNumber",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "vipLetter",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Note",
          "name": "notes",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "owner",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "firstName",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "content",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "created",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "EditSegment_EditSegment_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "EditSegmentInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "EditSegment_EditSegment_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "EditSegmentInput!"
      }],
      "concreteType": "EditSegmentPayload",
      "name": "editSegment",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Segment",
        "name": "segment",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Vendor",
          "name": "vendor",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "amenityPrograms",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "currency",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Trip",
          "name": "trip",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "searchId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "invoice",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dateString",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "startDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "endDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dropbox",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "draftVip",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "book",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancel",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "welcomeHome",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Task",
            "name": "tasks",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "taskType",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "description",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "completed",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "voided",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "TaskHistoryObject",
              "name": "history",
              "plural": true,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "name",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "action",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "timestamp",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dateString",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "startDate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "endDate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "category",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "bedType",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "amenityProgram",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "numAdults",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "numChildren",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "smokingRoom",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "rates",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "averageDailyRate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancellationDeadline",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dropbox",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "invoiced",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "vipDrafted",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "vipSent",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "booked",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancelled",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "sabreLocator",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "confirmationNumber",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancellationNumber",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "vipLetter",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Note",
          "name": "notes",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "owner",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "firstName",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "content",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "created",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation EditSegment_EditSegment_Mutation(\n  $input: EditSegmentInput!\n) {\n  editSegment(input: $input) {\n    segment {\n      currency\n      id\n      trip {\n        invoice\n        id\n        dateString\n        startDate\n        endDate\n        dropbox\n        searchId\n        draftVip\n        book\n        cancel\n        welcomeHome\n        tasks {\n          taskType\n          description\n          completed\n          voided\n          history {\n            name\n            action\n            timestamp\n          }\n          id\n        }\n      }\n      name\n      dateString\n      startDate\n      endDate\n      category\n      bedType\n      amenityProgram\n      numAdults\n      numChildren\n      smokingRoom\n      rates\n      vendor {\n        id\n        name\n        amenityPrograms\n      }\n      averageDailyRate\n      cancellationDeadline\n      dropbox\n      invoiced\n      vipDrafted\n      vipSent\n      booked\n      cancelled\n      sabreLocator\n      confirmationNumber\n      cancellationNumber\n      vipLetter\n      notes {\n        id\n        owner {\n          id\n          firstName\n        }\n        content\n        created\n      }\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "Cqxy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactJsonschemaForm = __webpack_require__("Nrtq");

var _reactJsonschemaForm2 = _interopRequireDefault(_reactJsonschemaForm);

var _aphrodite = __webpack_require__("BK4P");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DisplayFieldTemplate = function DisplayFieldTemplate(_ref) {
  var children = _ref.children;
  return children;
};
DisplayFieldTemplate.propTypes = {
  children: _propTypes2.default.node.isRequired
};

var StringField = function StringField(_ref2) {
  var _ref2$schema = _ref2.schema,
      title = _ref2$schema.title,
      format = _ref2$schema.format,
      formData = _ref2.formData;

  var data = format === 'date' ? (0, _moment2.default)(formData).format('MMM. D, YYYY') : formData;

  return _react2.default.createElement(
    'div',
    { className: (0, _aphrodite.css)(styles.field) },
    _react2.default.createElement(
      'span',
      { className: (0, _aphrodite.css)(styles.question) },
      title
    ),
    _react2.default.createElement(
      'span',
      { className: (0, _aphrodite.css)(styles.answer) },
      data
    )
  );
};
StringField.propTypes = {
  schema: _propTypes2.default.shape().isRequired,
  formData: _propTypes2.default.string
};
StringField.defaultProps = {
  formData: ''
};

var ArrayFieldTemplate = function ArrayFieldTemplate(props) {
  return _react2.default.createElement(
    'div',
    null,
    props.title,
    props.items.map(function (item) {
      return _react2.default.createElement(
        'div',
        { key: item.index },
        item.children
      );
    })
  );
};
ArrayFieldTemplate.propTypes = {
  title: _propTypes2.default.string.isRequired,
  items: _propTypes2.default.arrayOf().isRequired
};

var BooleanField = function BooleanField(_ref3) {
  var schema = _ref3.schema,
      formData = _ref3.formData;

  var enumNames = schema.enumNames || ['yes', 'no'];
  return _react2.default.createElement(
    'div',
    { className: (0, _aphrodite.css)(styles.field) },
    _react2.default.createElement(
      'span',
      { className: (0, _aphrodite.css)(styles.question) },
      schema.title
    ),
    _react2.default.createElement(
      'span',
      { className: (0, _aphrodite.css)(styles.answer) },
      formData ? enumNames[0] : enumNames[1]
    )
  );
};
BooleanField.propTypes = {
  schema: _propTypes2.default.shape().isRequired,
  formData: _propTypes2.default.bool.isRequired
};

var ResponseDetail = function ResponseDetail(_ref4) {
  var response = _ref4.response;

  var formProps = {
    schema: JSON.parse(response.savedSchema),
    uiSchema: JSON.parse(response.savedUiSchema),
    formData: JSON.parse(response.response)
  };
  formProps.uiSchema['ui:readonly'] = true;

  return _react2.default.createElement(
    'div',
    { className: (0, _aphrodite.css)(styles.container) },
    _react2.default.createElement(
      _reactJsonschemaForm2.default,
      _extends({}, formProps, {
        fields: { StringField: StringField, BooleanField: BooleanField },
        FieldTemplate: DisplayFieldTemplate,
        ArrayFieldTemplate: ArrayFieldTemplate
      }),
      _react2.default.createElement('div', null)
    )
  );
};

ResponseDetail.propTypes = {
  response: _propTypes2.default.shape({
    savedSchema: _propTypes2.default.string.isRequired,
    savedUiSchema: _propTypes2.default.string.isRequired,
    response: _propTypes2.default.string.isRequired
  }).isRequired
};

exports.default = ResponseDetail;


var styles = _aphrodite.StyleSheet.create({
  container: {
    margin: 5
  },
  question: {
    fontWeight: 'bold',
    width: '25%'
  },
  answer: {
    width: '75%',
    marginLeft: 5
  },
  field: {
    display: 'flex',
    ':nth-child(odd)': {
      background: _ourismanTravelTheme2.default.palette.primary3Color
    }
  }
});

/***/ }),

/***/ "DaVp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp2, _graphql, _graphql2, _graphql3;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _materialUi = __webpack_require__("Q4lS");

var _reactRouterDom = __webpack_require__("F8kA");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRelay = __webpack_require__("Tc9k");

var _aphrodite = __webpack_require__("BK4P");

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

var _NotesComponent = __webpack_require__("WsVO");

var _NotesComponent2 = _interopRequireDefault(_NotesComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TripList = function TripList(_ref) {
  var trips = _ref.trips;
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h3",
      null,
      "Trips (",
      trips.length,
      ")"
    ),
    _react2.default.createElement(
      "ul",
      null,
      trips.map(function (_ref2) {
        var id = _ref2.id,
            tripName = _ref2.tripName,
            firstName = _ref2.owner.firstName;
        return _react2.default.createElement(
          "li",
          { key: id },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: "/trips/" + id + "/" },
            tripName,
            " (",
            firstName,
            ")"
          )
        );
      })
    )
  );
};

TripList.propTypes = {
  trips: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
};

var ResponseList = function ResponseList(_ref3) {
  var responses = _ref3.responses;
  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h3",
      null,
      "Form Responses (",
      responses.length,
      ")"
    ),
    _react2.default.createElement(
      "ul",
      null,
      responses.map(function (_ref4) {
        var _ref4$node = _ref4.node,
            id = _ref4$node.id,
            display = _ref4$node.display;
        return _react2.default.createElement(
          "li",
          { key: id },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: "/forms/responses/" + id + "/" },
            display
          )
        );
      })
    )
  );
};

ResponseList.propTypes = {
  responses: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
};

var ClientDetail = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    viewport: state.Responsive.get("viewport")
  };
}), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(ClientDetail, _React$Component);

  function ClientDetail() {
    var _ref5;

    var _temp, _this, _ret;

    _classCallCheck(this, ClientDetail);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref5 = ClientDetail.__proto__ || Object.getPrototypeOf(ClientDetail)).call.apply(_ref5, [this].concat(args))), _this), _this.setCheckbox = function (checkbox) {
      return function (e, checked) {
        var travelerId = _this.props.client.id;

        var input = { travelerId: travelerId, checkbox: checkbox, value: checked };

        (0, _reactRelay.commitMutation)(_environment2.default, {
          mutation: _graphql || (_graphql = function _graphql() {
            return __webpack_require__("fqvC");
          }),
          variables: { input: input },
          onError: function onError(err) {
            return alert(err);
          }
        });
      };
    }, _this.triggerWelcomeCampaign = function () {
      var travelerId = _this.props.client.id;

      var input = { travelerId: travelerId };

      (0, _reactRelay.commitMutation)(_environment2.default, {
        mutation: _graphql2 || (_graphql2 = function _graphql2() {
          return __webpack_require__("tNoA");
        }),
        variables: { input: input },
        onError: function onError(err) {
          return alert(err);
        }
      });
    }, _this.triggerWelcomeBack = function () {
      var travelerId = _this.props.client.id;

      var input = { travelerId: travelerId };

      (0, _reactRelay.commitMutation)(_environment2.default, {
        mutation: _graphql3 || (_graphql3 = function _graphql3() {
          return __webpack_require__("YjfQ");
        }),
        variables: { input: input },
        onError: function onError(err) {
          return alert(err);
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ClientDetail, [{
    key: "render",
    value: function render() {
      var _props$client = this.props.client,
          id = _props$client.id,
          fullName = _props$client.fullName,
          primaryTraveler = _props$client.primaryTraveler,
          firstName = _props$client.firstName,
          middleName = _props$client.middleName,
          lastName = _props$client.lastName,
          birthdate = _props$client.birthdate,
          currentTier = _props$client.currentTier,
          email = _props$client.email,
          insideCircle = _props$client.insideCircle,
          lowPriority = _props$client.lowPriority,
          highPriority = _props$client.highPriority,
          needsTraining = _props$client.needsTraining,
          needsVetting = _props$client.needsVetting,
          fired = _props$client.fired,
          trips = _props$client.trips,
          prospect = _props$client.prospect,
          displayName = _props$client.displayName,
          responses = _props$client.responseSet.edges,
          acceptPolicies = _props$client.acceptPolicies,
          acceptPoliciesTimestamp = _props$client.acceptPoliciesTimestamp,
          profile = _props$client.profile,
          welcomeCampaign = _props$client.welcomeCampaign,
          welcomeBack = _props$client.welcomeBack,
          vipNotes = _props$client.vipNotes,
          profileNotes = _props$client.profileNotes,
          travelers = _props$client.travelers;


      var tripList = trips.edges.map(function (edge) {
        return edge.node;
      });
      var primaryTravelerLink = primaryTraveler ? _react2.default.createElement(
        _reactRouterDom.Link,
        { to: "/clients/" + primaryTraveler.id + "/" },
        primaryTraveler.fullName
      ) : "(primary traveler)";

      var momentBirthdate = (0, _moment2.default)(birthdate);
      var age = _moment2.default.duration((0, _moment2.default)().diff(momentBirthdate)).years();
      var format = "MMMM Do YYYY";
      var formattedBirthdate = momentBirthdate.format(format) + " (" + age + " years)";
      var display = displayName || fullName;
      var profileData = JSON.parse(profile);

      var hasEmail = email && email.length > 0;

      var travelerList = travelers.edges.map(function (edge) {
        return edge.node;
      });

      return _react2.default.createElement(
        "div",
        { className: (0, _aphrodite.css)(styles.clientContainer) },
        _react2.default.createElement(
          "div",
          { className: (0, _aphrodite.css)(styles.header) },
          _react2.default.createElement(
            "h1",
            { className: (0, _aphrodite.css)(styles.headerName) },
            display,
            " ",
            acceptPolicies ? _react2.default.createElement(
              "small",
              null,
              "(accepted booking policies",
              " ",
              (0, _moment2.default)(acceptPoliciesTimestamp).fromNow(),
              ")"
            ) : null
          ),
          _react2.default.createElement(
            "span",
            { className: (0, _aphrodite.css)(styles.headerPrimaryTraveler) },
            primaryTravelerLink
          ),
          currentTier ? _react2.default.createElement(
            "span",
            { className: (0, _aphrodite.css)(styles.headerTier) },
            "Tier ",
            currentTier
          ) : null
        ),
        _react2.default.createElement(
          "div",
          { className: (0, _aphrodite.css)(styles.clientFlagContainer) },
          _react2.default.createElement(
            "span",
            { className: (0, _aphrodite.css)(styles.clientFlag) },
            _react2.default.createElement(_materialUi.Checkbox, {
              label: "Inside Circle",
              checked: insideCircle,
              onCheck: this.setCheckbox("insideCircle")
            })
          ),
          _react2.default.createElement(
            "span",
            { className: (0, _aphrodite.css)(styles.clientFlag) },
            _react2.default.createElement(_materialUi.Checkbox, {
              label: "BMOC",
              checked: highPriority,
              onCheck: this.setCheckbox("highPriority")
            })
          ),
          _react2.default.createElement(
            "span",
            { className: (0, _aphrodite.css)(styles.clientFlag) },
            _react2.default.createElement(_materialUi.Checkbox, {
              label: "Low Priority",
              checked: lowPriority,
              onCheck: this.setCheckbox("lowPriority")
            })
          ),
          _react2.default.createElement(
            "span",
            { className: (0, _aphrodite.css)(styles.clientFlag) },
            _react2.default.createElement(_materialUi.Checkbox, {
              label: "Needs Training",
              checked: needsTraining,
              onCheck: this.setCheckbox("needsTraining")
            })
          ),
          _react2.default.createElement(
            "span",
            { className: (0, _aphrodite.css)(styles.clientFlag) },
            _react2.default.createElement(_materialUi.Checkbox, {
              label: "Needs Vetting",
              checked: needsVetting,
              onCheck: this.setCheckbox("needsVetting")
            })
          ),
          _react2.default.createElement(
            "span",
            { className: (0, _aphrodite.css)(styles.clientFlag) },
            _react2.default.createElement(_materialUi.Checkbox, {
              label: "Fired",
              checked: fired,
              onCheck: this.setCheckbox("fired")
            })
          ),
          _react2.default.createElement(
            "span",
            { className: (0, _aphrodite.css)(styles.clientFlag) },
            _react2.default.createElement(_materialUi.Checkbox, {
              label: "Prospect",
              checked: prospect,
              onCheck: this.setCheckbox("prospect")
            })
          ),
          _react2.default.createElement(
            "span",
            { className: (0, _aphrodite.css)(styles.clientFlag) },
            _react2.default.createElement(_materialUi.Checkbox, {
              label: "Accepted Booking Policies",
              checked: acceptPolicies,
              onCheck: this.setCheckbox("acceptPolicies")
            })
          ),
          !insideCircle ? _react2.default.createElement(
            "span",
            { className: (0, _aphrodite.css)(styles.clientFlag) },
            _react2.default.createElement(_materialUi.Checkbox, {
              label: "Welcome Campaign",
              checked: welcomeCampaign,
              disabled: welcomeCampaign || !hasEmail,
              onCheck: this.triggerWelcomeCampaign
            })
          ) : null,
          !insideCircle ? _react2.default.createElement(
            "span",
            { className: (0, _aphrodite.css)(styles.clientFlag) },
            _react2.default.createElement(_materialUi.Checkbox, {
              label: "Welcome Back Campaign",
              checked: welcomeBack,
              disabled: welcomeBack || !hasEmail,
              onCheck: this.triggerWelcomeBack
            })
          ) : null
        ),
        _react2.default.createElement(
          "div",
          { className: (0, _aphrodite.css)(styles.dataTable) },
          _react2.default.createElement(
            "div",
            { className: (0, _aphrodite.css)(styles.dataRow) },
            _react2.default.createElement(
              "span",
              { className: (0, _aphrodite.css)(styles.dataLabel) },
              "First name:"
            ),
            _react2.default.createElement(
              "span",
              { className: (0, _aphrodite.css)(styles.dataContent) },
              firstName
            )
          ),
          _react2.default.createElement(
            "div",
            { className: (0, _aphrodite.css)(styles.dataRow) },
            _react2.default.createElement(
              "span",
              { className: (0, _aphrodite.css)(styles.dataLabel) },
              "Middle name:"
            ),
            _react2.default.createElement(
              "span",
              { className: (0, _aphrodite.css)(styles.dataContent) },
              middleName
            )
          ),
          _react2.default.createElement(
            "div",
            { className: (0, _aphrodite.css)(styles.dataRow) },
            _react2.default.createElement(
              "span",
              { className: (0, _aphrodite.css)(styles.dataLabel) },
              "Last name:"
            ),
            _react2.default.createElement(
              "span",
              { className: (0, _aphrodite.css)(styles.dataContent) },
              lastName
            )
          ),
          _react2.default.createElement(
            "div",
            { className: (0, _aphrodite.css)(styles.dataRow) },
            _react2.default.createElement(
              "span",
              { className: (0, _aphrodite.css)(styles.dataLabel) },
              "Display name:"
            ),
            _react2.default.createElement(
              "span",
              { className: (0, _aphrodite.css)(styles.dataContent) },
              display
            )
          ),
          _react2.default.createElement(
            "div",
            { className: (0, _aphrodite.css)(styles.dataRow) },
            _react2.default.createElement(
              "span",
              { className: (0, _aphrodite.css)(styles.dataLabel) },
              "Birthdate:"
            ),
            _react2.default.createElement(
              "span",
              { className: (0, _aphrodite.css)(styles.dataContent) },
              formattedBirthdate
            )
          ),
          email.map(function (address, index) {
            return _react2.default.createElement(
              "div",
              { className: (0, _aphrodite.css)(styles.dataRow), key: index },
              _react2.default.createElement(
                "span",
                { className: (0, _aphrodite.css)(styles.dataLabel) },
                "Email ",
                index + 1,
                ":"
              ),
              _react2.default.createElement(
                "span",
                { className: (0, _aphrodite.css)(styles.dataContent) },
                address
              )
            );
          })
        ),
        _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(
            "h3",
            null,
            "Traveler Profile"
          ),
          _react2.default.createElement(
            "div",
            { className: (0, _aphrodite.css)(styles.dataTable) },
            _react2.default.createElement(
              "div",
              { className: (0, _aphrodite.css)(styles.dataRow) },
              _react2.default.createElement(
                "span",
                { className: (0, _aphrodite.css)(styles.dataLabel) },
                "Smoking:"
              ),
              _react2.default.createElement(
                "span",
                { className: (0, _aphrodite.css)(styles.dataContent) },
                profileData.smoking ? "smoking" : "non-smoking"
              )
            ),
            _react2.default.createElement(
              "div",
              { className: (0, _aphrodite.css)(styles.dataRow) },
              _react2.default.createElement(
                "span",
                { className: (0, _aphrodite.css)(styles.dataLabel) },
                "Bedding:"
              ),
              _react2.default.createElement(
                "span",
                { className: (0, _aphrodite.css)(styles.dataContent) },
                profileData.bedding
              )
            ),
            _react2.default.createElement(
              "div",
              { className: (0, _aphrodite.css)(styles.dataRow) },
              _react2.default.createElement(
                "span",
                { className: (0, _aphrodite.css)(styles.dataLabel) },
                "Standard Requests:"
              ),
              _react2.default.createElement(
                "span",
                { className: (0, _aphrodite.css)(styles.dataContent) },
                profileData.standardRequests
              )
            ),
            _react2.default.createElement(
              "div",
              { className: (0, _aphrodite.css)(styles.dataRow) },
              _react2.default.createElement(
                "span",
                { className: (0, _aphrodite.css)(styles.dataLabel) },
                "Favorite Things:"
              ),
              _react2.default.createElement(
                "span",
                { className: (0, _aphrodite.css)(styles.dataContent) },
                profileData.favoriteThings
              )
            ),
            _react2.default.createElement(
              "div",
              { className: (0, _aphrodite.css)(styles.dataRow) },
              _react2.default.createElement(
                "span",
                { className: (0, _aphrodite.css)(styles.dataLabel) },
                "Need to Know:"
              ),
              _react2.default.createElement(
                "span",
                { className: (0, _aphrodite.css)(styles.dataContent) },
                profileData.needToKnow
              )
            ),
            _react2.default.createElement(
              "div",
              { className: (0, _aphrodite.css)(styles.dataRow) },
              _react2.default.createElement(
                "span",
                { className: (0, _aphrodite.css)(styles.dataLabel) },
                "Referred By:"
              ),
              _react2.default.createElement(
                "span",
                { className: (0, _aphrodite.css)(styles.dataContent) },
                profileData.referral,
                profileData.other ? ": " + profileData.other : null
              )
            ),
            _react2.default.createElement(
              "div",
              { className: (0, _aphrodite.css)(styles.dataRow) },
              _react2.default.createElement(
                "span",
                { className: (0, _aphrodite.css)(styles.dataLabel) },
                "Other travelers:"
              ),
              _react2.default.createElement(
                "span",
                { className: (0, _aphrodite.css)(styles.dataContent) },
                travelerList.length > 0 ? travelerList.length : "n/a"
              )
            )
          )
        ),
        _react2.default.createElement(
          _materialUi.Card,
          { className: (0, _aphrodite.css)(styles.notes) },
          _react2.default.createElement(_materialUi.CardHeader, {
            title: "VIP Notes",
            subtitle: "Exactly as will appear in VIP letters."
          }),
          _react2.default.createElement(
            _materialUi.CardText,
            null,
            _react2.default.createElement(_NotesComponent2.default, { id: id, fieldName: "vipNotes", value: vipNotes }),
            travelerList.length > 0 ? _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                "div",
                null,
                "VIP Notes for other travelers:"
              ),
              _react2.default.createElement(
                "div",
                { className: (0, _aphrodite.css)(styles.dataTable) },
                travelerList.map(function (traveler) {
                  return _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.dataRow) },
                    _react2.default.createElement(
                      "span",
                      { className: (0, _aphrodite.css)(styles.dataLabel) },
                      _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: "/clients/" + traveler.id + "/" },
                        traveler.displayName || traveler.fullName
                      )
                    ),
                    _react2.default.createElement("div", {
                      className: "ql-editor",
                      dangerouslySetInnerHTML: { __html: traveler.vipNotes }
                    })
                  );
                })
              )
            ) : null
          )
        ),
        _react2.default.createElement(
          _materialUi.Card,
          { className: (0, _aphrodite.css)(styles.notes) },
          _react2.default.createElement(_materialUi.CardHeader, { title: "Profile Notes" }),
          _react2.default.createElement(
            _materialUi.CardText,
            null,
            _react2.default.createElement(_NotesComponent2.default, { id: id, fieldName: "profileNotes", value: profileNotes })
          )
        ),
        responses.length > 0 ? _react2.default.createElement(ResponseList, { responses: responses }) : null,
        tripList.length > 0 ? _react2.default.createElement(TripList, { trips: tripList }) : null
      );
    }
  }], [{
    key: "primaryTravelerInfo",
    value: function primaryTravelerInfo(primaryTraveler) {
      if (!primaryTraveler) {
        return _react2.default.createElement(
          "h4",
          null,
          "primary traveler"
        );
      }
      var id = primaryTraveler.id,
          fullName = primaryTraveler.fullName;


      return _react2.default.createElement(
        "h4",
        null,
        _react2.default.createElement(
          "i",
          null,
          "primary traveler"
        ),
        ": ",
        _react2.default.createElement(
          _reactRouterDom.Link,
          { to: "/clients/" + id + "/" },
          fullName
        )
      );
    }
  }]);

  return ClientDetail;
}(_react2.default.Component), _class2.propTypes = {
  client: _propTypes2.default.shape().isRequired
}, _temp2)) || _class);


var styles = _aphrodite.StyleSheet.create({
  clientContainer: {
    paddingLeft: 5,
    paddingRight: 5
  },
  header: {
    display: "flex",
    flexDirection: "column",
    marginBottom: 15
  },
  headerName: {
    fontSize: 24,
    fontWeight: "bold",
    marginBottom: 5
  },
  headerPrimaryTraveler: {
    marginLeft: 15,
    fontSize: 12
  },
  headerTier: {},
  clientFlagContainer: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap"
  },
  clientFlag: {
    flex: "0 1 20%"
  },
  dataTable: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginBottom: 10
  },
  dataRow: {
    ":nth-child(even)": {
      background: _ourismanTravelTheme2.default.palette.borderColor
    },
    display: "flex",
    alignItems: "flex-start"
  },
  dataLabel: {
    fontSize: 12,
    width: "15%"
  },
  dataContent: {
    width: "85%"
  },
  notes: {
    marginBottom: 5
  }
});

exports.default = ClientDetail;

/***/ }),

/***/ "DqTz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AdminReportControls = __webpack_require__("hO+Y");

var _AdminReportControls2 = _interopRequireDefault(_AdminReportControls);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _AdminReportControls2.default;

/***/ }),

/***/ "DsNi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"styles-container--gJ116","list":"styles-list--2yziz","detail":"styles-detail--1xjSU","listFilter":"styles-listFilter--2ThDC","listItems":"styles-listItems--3KRoi","active":"styles-active--3JIMi","clientListItem":"styles-clientListItem--ZPcqy","primaryTravelerName":"styles-primaryTravelerName--r-ozn"};

/***/ }),

/***/ "EAxn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__("O27J");

var _reactHotLoader = __webpack_require__("rGbO");

var _reactTapEventPlugin = __webpack_require__("S33B");

var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);

var _aphrodite = __webpack_require__("BK4P");

var _Root = __webpack_require__("AMVQ");

var _Root2 = _interopRequireDefault(_Root);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _reactTapEventPlugin2.default)();

var root = document.querySelector('#root');

_aphrodite.StyleSheet.rehydrate(window.renderedClassNames);
var mount = function mount(RootComponent) {
  (0, _reactDom.render)(_react2.default.createElement(
    _reactHotLoader.AppContainer,
    null,
    _react2.default.createElement(RootComponent, null)
  ), root);
};

if (false) {
  module.hot.accept('./Root', function () {
    // eslint-disable-next-line global-require,import/newline-after-import
    var RootComponent = require('./Root').default;
    mount(RootComponent);
  });
}

mount(_Root2.default);

/***/ }),

/***/ "EJRV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toggleNewTraveler = toggleNewTraveler;
exports.addTraveler = addTraveler;
exports.moveTraveler = moveTraveler;
exports.removeTraveler = removeTraveler;
exports.removeSegment = removeSegment;
exports.updateField = updateField;
exports.addSegment = addSegment;
exports.resetInquiryForm = resetInquiryForm;

var _ActionTypes = __webpack_require__("zLtr");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toggleNewTraveler(value) {
  return {
    type: _ActionTypes2.default.Inquiry.toggleNewTraveler,
    value: value
  };
}

function addTraveler(traveler) {
  return {
    type: _ActionTypes2.default.Inquiry.addTraveler,
    traveler: traveler
  };
}

function moveTraveler(start, end) {
  return {
    type: _ActionTypes2.default.Inquiry.moveTraveler,
    start: start,
    end: end
  };
}

function removeTraveler(index) {
  return {
    type: _ActionTypes2.default.Inquiry.removeTraveler,
    index: index
  };
}

function removeSegment(index) {
  return {
    type: _ActionTypes2.default.Inquiry.removeSegment,
    index: index
  };
}

function updateField(field, value) {
  return {
    type: _ActionTypes2.default.Inquiry.updateField,
    field: field,
    value: value
  };
}

function addSegment(segment) {
  return {
    type: _ActionTypes2.default.Inquiry.addSegment,
    segment: segment
  };
}

function resetInquiryForm() {
  return {
    type: _ActionTypes2.default.Inquiry.resetInquiryForm
  };
}

/***/ }),

/***/ "Et58":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp, _initialiseProps, _graphql, _graphql2;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("F8kA");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _materialUi = __webpack_require__("Q4lS");

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRedux = __webpack_require__("RH2O");

var _check = __webpack_require__("Ak9Z");

var _check2 = _interopRequireDefault(_check);

var _add = __webpack_require__("XPiC");

var _add2 = _interopRequireDefault(_add);

var _cancel = __webpack_require__("IRMx");

var _cancel2 = _interopRequireDefault(_cancel);

var _email = __webpack_require__("LWqx");

var _email2 = _interopRequireDefault(_email);

var _confirmationNumber = __webpack_require__("Y4+6");

var _confirmationNumber2 = _interopRequireDefault(_confirmationNumber);

var _block = __webpack_require__("gj6W");

var _block2 = _interopRequireDefault(_block);

var _arrowDropDown = __webpack_require__("Pvnv");

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _arrowDropUp = __webpack_require__("Bly6");

var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRelay = __webpack_require__("Tc9k");

var _aphrodite = __webpack_require__("BK4P");

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

var _VIPLetter = __webpack_require__("zL3R");

var _VIPLetter2 = _interopRequireDefault(_VIPLetter);

var _NoteListItem = __webpack_require__("abLE");

var _NoteListItem2 = _interopRequireDefault(_NoteListItem);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultTransfersMessages = {
  known: "The guests will be managing their own transfers; " + "for your reference, their flight details are:",
  unknown: "Unfortunately, we do not have the guests' travel details " + "available; we will be sure to forward you any information that comes " + "our way!"
};

var SegmentListItem = function SegmentListItem(_ref) {
  var segment = _ref.segment,
      segmentId = _ref.segmentId,
      tripId = _ref.tripId;

  if (segment.cancelled) {
    return _react2.default.createElement(
      "span",
      { style: styles.cancelledSegment },
      segment.name
    );
  } else if (segment.id === segmentId) {
    return _react2.default.createElement(
      "b",
      null,
      segment.name
    );
  }

  return _react2.default.createElement(
    _reactRouterDom.Link,
    { to: "/trips/" + tripId + "/segments/" + segment.id + "/" },
    segment.name
  );
};

SegmentListItem.propTypes = {
  segment: _propTypes2.default.shape().isRequired,
  segmentId: _propTypes2.default.string.isRequired,
  tripId: _propTypes2.default.string.isRequired
};

var SegmentDetail = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    viewport: state.Responsive.get("viewport"),
    windowWidth: state.Responsive.get("windowWidth"),
    windowHeight: state.Responsive.get("windowHeight")
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(SegmentDetail, _React$Component);

  function SegmentDetail(props) {
    _classCallCheck(this, SegmentDetail);

    var _this = _possibleConstructorReturn(this, (SegmentDetail.__proto__ || Object.getPrototypeOf(SegmentDetail)).call(this, props));

    _initialiseProps.call(_this);

    _this.state = _this.getInitialState(props);
    return _this;
  }

  _createClass(SegmentDetail, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var oldId = this.props.segment.id;
      var newId = nextProps.segment.id;


      if (oldId !== newId) {
        this.setState(this.getInitialState(nextProps));
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("beforeunload", this.handleUnload);
      window.addEventListener("resize", this.handleResize);

      this.setRightColumnWidth();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("beforeunload", this.handleUnload);
      window.removeEventListener("resize", this.handleResize);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var newLetterOffset = this.getLetterOffset();
      if (newLetterOffset !== prevState.letterOffset) {
        this.setLetterOffset();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _props$segment = this.props.segment,
          _props$segment$trip = _props$segment.trip,
          tripNotes = _props$segment$trip.notes,
          primaryTravelerName = _props$segment$trip.primaryTravelerName,
          destination = _props$segment$trip.destination,
          tripId = _props$segment$trip.id,
          segments = _props$segment$trip.segments,
          inbox = _props$segment$trip.inbox,
          tripDateString = _props$segment$trip.dateString,
          tripVipNotes = _props$segment$trip.vipNotes,
          segmentName = _props$segment.name,
          segmentNotes = _props$segment.notes,
          startDate = _props$segment.startDate,
          endDate = _props$segment.endDate,
          category = _props$segment.category,
          confirmationNumber = _props$segment.confirmationNumber,
          _props$segment$vendor = _props$segment.vendor,
          vendorName = _props$segment$vendor.name,
          amenityPrograms = _props$segment$vendor.amenityPrograms,
          segmentId = _props$segment.id,
          vipDrafted = _props$segment.vipDrafted,
          dateString = _props$segment.dateString,
          bedType = _props$segment.bedType;
      var _state = this.state,
          primaryContactName = _state.primaryContactName,
          primaryContactEmail = _state.primaryContactEmail,
          primaryContactPosition = _state.primaryContactPosition,
          additionalContactEmails = _state.additionalContactEmails,
          specialRequests = _state.specialRequests,
          transferArrangements = _state.transferArrangements,
          arrivalDetails = _state.arrivalDetails,
          departureDetails = _state.departureDetails,
          bookingIATA = _state.bookingIATA,
          segmentTravelers = _state.segmentTravelers,
          isDirty = _state.isDirty,
          rightColumnWidth = _state.rightColumnWidth,
          formExpanded = _state.formExpanded,
          letterOffset = _state.letterOffset,
          letterHeight = _state.letterHeight,
          newRequest = _state.newRequest,
          knownTransfers = _state.knownTransfers,
          from = _state.from,
          insideCircle = _state.insideCircle,
          primaryContactDisplayName = _state.primaryContactDisplayName;

      var displayEmailList = additionalContactEmails.join(", ");
      var amenityProgram = this.state.amenityProgram === "(no program)" ? "VIP" : this.state.amenityProgram;

      var users = this.props.users.edges.map(function (edge) {
        return edge.node.firstName;
      });
      var autocompleteNames = [].concat(_toConsumableArray(users), [this.getDefaultFrom(insideCircle)]).sort();

      var iatas = {
        Brownell: "01739080",
        Tzell: "01575781"
      };
      var iata = iatas[bookingIATA];

      var dateFormat = "dddd, MMMM Do";
      var displayStartDate = (0, _moment2.default)(startDate).format(dateFormat);
      var displayEndDate = (0, _moment2.default)(endDate).format(dateFormat);

      var travelers = _lodash2.default.values(segmentTravelers).filter(function (traveler) {
        return traveler.traveling;
      });
      var travelerNames = travelers.map(function (_ref2, index) {
        var firstName = _ref2.firstName,
            lastName = _ref2.lastName,
            birthdate = _ref2.birthdate,
            adult = _ref2.adult;

        var age = void 0;
        if (adult) {
          age = "";
        } else if (birthdate) {
          age = " (" + (0, _moment2.default)().diff((0, _moment2.default)(birthdate), "years") + ")";
        } else {
          age = " (child)";
        }

        var extra = "";
        if (travelers.length < 2) {
          extra = "";
        } else if (travelers.length === 2 && index !== 1) {
          extra = " and ";
        } else if (index + 2 !== travelers.length && index + 1 !== travelers.length) {
          extra = ", ";
        } else if (index === travelers.length - 2) {
          extra = ", and ";
        }
        var travelerName = firstName + " " + lastName + (age || "") + extra;

        return _react2.default.createElement(
          "span",
          { key: index },
          _react2.default.createElement(
            "span",
            { style: styles.travelerName },
            travelerName
          )
        );
      });
      var rightColumnStyles = _extends({}, styles.rightColumn, {
        width: rightColumnWidth
      });
      var formStyles = _extends({}, styles.form, {
        width: rightColumnWidth
      });
      var renderedLetterStyles = _extends({}, styles.renderedLetter, {
        width: rightColumnWidth,
        top: letterOffset,
        maxHeight: letterHeight
      });

      var numTravelers = _lodash2.default.values(segmentTravelers).filter(function (traveler) {
        return traveler.traveling;
      }).length;

      var exampleArrival = "XXX (airport code) at 2:15 pm on " + (displayStartDate + " via American Airlines Flight #12345");

      var exampleDeparture = "XXX (airport code) at 2:15 pm on " + (displayEndDate + " via American Airlines Flight #12345");

      var cancelledIconColor = _ourismanTravelTheme2.default.palette.accent1Color;

      var vipLetterProps = {
        primaryContactDisplayName: primaryContactDisplayName,
        amenityProgram: amenityProgram,
        vendorName: vendorName,
        from: from,
        travelerNames: travelerNames,
        displayStartDate: displayStartDate,
        displayEndDate: displayEndDate,
        category: category,
        bedType: bedType,
        confirmationNumber: confirmationNumber,
        specialRequests: specialRequests,
        transferArrangements: transferArrangements,
        arrivalDetails: arrivalDetails,
        departureDetails: departureDetails,
        insideCircle: insideCircle,
        iata: iata
      };

      var to = primaryContactName + " <" + primaryContactEmail + ">";
      var cc = displayEmailList;
      var subjectLine = (amenityProgram + " Client Arrival " + dateString + " " + vendorName).trim();

      var fromInbox = inbox === "insidecircle@" ? "insidecircle@" : "team@";
      var gmailLink = "https://mail.google.com/mail/u/" + (fromInbox + "metaphortravel.com/?view=cm&fs=1&su=" + subjectLine) + ("&to=" + to + "&cc=" + cc);

      return _react2.default.createElement(
        "div",
        { style: styles.container },
        _react2.default.createElement(
          "div",
          { style: styles.leftColumn },
          _react2.default.createElement(
            "div",
            { style: styles.tripDetails },
            _react2.default.createElement(
              "h2",
              null,
              segmentName
            ),
            _react2.default.createElement(
              _reactRouterDom.Link,
              { to: "/trips/" + tripId + "/" },
              _react2.default.createElement(
                "h3",
                null,
                primaryTravelerName,
                " ",
                destination,
                " ",
                tripDateString
              )
            ),
            _react2.default.createElement(
              "ol",
              null,
              segments.map(function (segment) {
                return _react2.default.createElement(
                  "li",
                  { key: segment.id, style: styles.segmentListItem },
                  _react2.default.createElement(SegmentListItem, {
                    segment: segment,
                    segmentId: segmentId,
                    tripId: tripId
                  }),
                  _react2.default.createElement(
                    "div",
                    { style: styles.segmentIconStyle },
                    _react2.default.createElement(
                      "div",
                      { style: styles.indicatorGroupStyle },
                      _react2.default.createElement(
                        "div",
                        { style: styles.indicatorStyle },
                        segment.cancelled && _react2.default.createElement(_block2.default, {
                          color: segment.cancelled ? cancelledIconColor : null
                        }) || !segment.booked && _react2.default.createElement(_confirmationNumber2.default, null) || null,
                        _react2.default.createElement(
                          "span",
                          null,
                          segment.cancelled ? "cancelled" : "book"
                        )
                      ),
                      _react2.default.createElement(
                        "div",
                        { style: styles.indicatorStyle },
                        !segment.vipDrafted && !segment.cancelled ? _react2.default.createElement(_email2.default, {
                          color: segment.cancelled ? cancelledIconColor : null
                        }) : null,
                        _react2.default.createElement(
                          "span",
                          null,
                          "draft"
                        )
                      )
                    )
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            "div",
            { style: styles.notesContainer },
            _react2.default.createElement(
              "h4",
              null,
              "VIP Notes for Trip"
            ),
            _react2.default.createElement(
              _materialUi.Card,
              { className: newCss(aphroditeStyles.vipNotes) },
              _react2.default.createElement(
                _materialUi.CardText,
                null,
                _react2.default.createElement("div", {
                  className: newCss(aphroditeStyles.display),
                  dangerouslySetInnerHTML: { __html: tripVipNotes }
                })
              )
            ),
            _react2.default.createElement(
              "h4",
              null,
              "VIP Notes for Travelers"
            ),
            travelers.map(function (traveler) {
              return _react2.default.createElement(
                _materialUi.Card,
                {
                  key: traveler.id,
                  className: newCss(aphroditeStyles.vipNotes)
                },
                _react2.default.createElement(
                  _materialUi.CardText,
                  null,
                  _react2.default.createElement(
                    _reactRouterDom.Link,
                    { to: "/clients/" + traveler.id + "/", target: "_blank" },
                    _react2.default.createElement(
                      "h5",
                      null,
                      traveler.fullName
                    )
                  ),
                  _react2.default.createElement("div", {
                    className: newCss(aphroditeStyles.display),
                    dangerouslySetInnerHTML: { __html: traveler.vipNotes }
                  })
                )
              );
            }),
            _react2.default.createElement(
              "h4",
              null,
              "Trip Notes"
            ),
            tripNotes.map(function (note, index) {
              return _react2.default.createElement(_NoteListItem2.default, { key: index, index: index, note: note });
            }),
            _react2.default.createElement(
              "h4",
              null,
              "Segment Notes"
            ),
            segmentNotes.map(function (note, index) {
              return _react2.default.createElement(_NoteListItem2.default, { key: index, index: index, note: note });
            })
          )
        ),
        _react2.default.createElement(
          "div",
          { style: rightColumnStyles },
          _react2.default.createElement(
            _materialUi.Card,
            {
              style: formStyles,
              id: "form",
              expanded: formExpanded,
              onExpandChange: this.handleExpandChange
            },
            _react2.default.createElement(_materialUi.CardHeader, {
              title: "VIP Letter Form",
              actAsExpander: true,
              showExpandableButton: true
            }),
            _react2.default.createElement(
              _materialUi.CardText,
              { expandable: true },
              _react2.default.createElement(
                "div",
                { style: styles.formRow },
                _react2.default.createElement(_materialUi.AutoComplete, {
                  floatingLabelText: "Amenity Program",
                  menuStyle: { width: 500 },
                  listStyle: { width: 500 },
                  dataSource: amenityPrograms,
                  onUpdateInput: this.amenityOnUpdateInput,
                  onNewRequest: this.amenityOnNewRequest,
                  searchText: amenityProgram,
                  filter: this.autoCompleteFilter
                }),
                _react2.default.createElement(
                  _materialUi.SelectField,
                  {
                    floatingLabelText: "Booking IATA",
                    value: bookingIATA,
                    onChange: this.selectIATA
                  },
                  _lodash2.default.toPairs(iatas).map(function (pair) {
                    return _react2.default.createElement(_materialUi.MenuItem, {
                      key: pair[1],
                      value: pair[0],
                      primaryText: pair[0] + " #" + pair[1]
                    });
                  })
                ),
                _react2.default.createElement(_materialUi.AutoComplete, {
                  floatingLabelText: "Email From",
                  menuStyle: { width: 500 },
                  listStyle: { width: 500 },
                  dataSource: autocompleteNames,
                  onUpdateInput: this.fromOnUpdateInput,
                  onNewRequest: this.fromOnNewRequest,
                  searchText: from,
                  filter: this.autoCompleteFilter
                }),
                _react2.default.createElement(_materialUi.Toggle, {
                  toggled: insideCircle,
                  label: "Inside Circle",
                  labelPosition: "right",
                  onClick: this.toggleInsideCircle
                })
              ),
              _react2.default.createElement(
                "div",
                { style: styles.formRow },
                _react2.default.createElement(_materialUi.TextField, {
                  floatingLabelText: "Primary Contact Email",
                  value: primaryContactEmail,
                  onChange: this.updateTextField("primaryContactEmail")
                }),
                _react2.default.createElement(_materialUi.TextField, {
                  floatingLabelText: "Primary Contact Name",
                  value: primaryContactName,
                  onChange: this.updateTextField("primaryContactName")
                }),
                _react2.default.createElement(_materialUi.TextField, {
                  floatingLabelText: "Primary Contact Display Name",
                  value: primaryContactDisplayName,
                  onChange: this.updateTextField("primaryContactDisplayName")
                }),
                _react2.default.createElement(_materialUi.TextField, {
                  floatingLabelText: "Primary Contact Position",
                  value: primaryContactPosition,
                  onChange: this.updateTextField("primaryContactPosition")
                })
              ),
              _react2.default.createElement(
                "div",
                { style: styles.formRow },
                _react2.default.createElement(_materialUi.TextField, {
                  floatingLabelText: "Additional Contact Emails (comma-separated list)",
                  value: displayEmailList,
                  onChange: this.updateEmailList,
                  fullWidth: true
                })
              ),
              _react2.default.createElement(
                "div",
                { style: styles.travelerRow },
                _react2.default.createElement(
                  "h4",
                  null,
                  "Travelers for Segment (",
                  numTravelers,
                  " selected)"
                ),
                _react2.default.createElement(
                  "div",
                  { style: styles.travelerChips },
                  _lodash2.default.values(segmentTravelers).map(function (_ref3) {
                    var id = _ref3.id,
                        fullName = _ref3.fullName,
                        traveling = _ref3.traveling,
                        birthdate = _ref3.birthdate,
                        adult = _ref3.adult;

                    var age = birthdate && (0, _moment2.default)().diff((0, _moment2.default)(birthdate), "years") || adult && "18+" || "child";

                    return _react2.default.createElement(
                      _materialUi.Chip,
                      {
                        key: id,
                        style: styles.chip,
                        onTouchTap: _this2.toggleTraveler(id),
                        onRequestDelete: traveling ? _this2.toggleTraveler(id) : null
                      },
                      traveling ? _react2.default.createElement(_materialUi.Avatar, { color: "#444", icon: _react2.default.createElement(_check2.default, null) }) : null,
                      fullName,
                      " (",
                      age,
                      ")"
                    );
                  })
                )
              ),
              _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "h4",
                  null,
                  "Special Requests or Occasions"
                ),
                _react2.default.createElement(
                  "ul",
                  null,
                  specialRequests.map(function (request, index) {
                    return _react2.default.createElement(
                      "li",
                      { key: index, style: styles.formRequest },
                      _react2.default.createElement(_materialUi.TextField, {
                        id: "" + index,
                        value: request,
                        fullWidth: true,
                        onChange: _this2.updateRequest(index)
                      }),
                      _react2.default.createElement(
                        _materialUi.IconButton,
                        {
                          style: styles.buttonStyle,
                          onTouchTap: _this2.moveUp(index),
                          disabled: index < 1
                        },
                        _react2.default.createElement(_arrowDropUp2.default, null)
                      ),
                      _react2.default.createElement(
                        _materialUi.IconButton,
                        {
                          style: styles.buttonStyle,
                          onTouchTap: _this2.moveDown(index),
                          disabled: index >= specialRequests.length - 1
                        },
                        _react2.default.createElement(_arrowDropDown2.default, null)
                      ),
                      _react2.default.createElement(
                        _materialUi.IconButton,
                        null,
                        _react2.default.createElement(_cancel2.default, { onClick: _this2.removeRequest(index) })
                      )
                    );
                  })
                ),
                _react2.default.createElement(
                  "div",
                  { style: styles.newRequest },
                  _react2.default.createElement(_materialUi.TextField, {
                    hintText: "e.g. The family enjoys fruit and water",
                    fullWidth: true,
                    value: newRequest,
                    onChange: this.updateTextField("newRequest", false),
                    onKeyDown: this.newRequestKeyDown
                  }),
                  _react2.default.createElement(
                    _materialUi.IconButton,
                    null,
                    _react2.default.createElement(_add2.default, { onClick: this.addRequest })
                  )
                )
              ),
              _react2.default.createElement(
                "div",
                null,
                _react2.default.createElement(
                  "h4",
                  null,
                  "Transfer Arrangements"
                ),
                _react2.default.createElement(_materialUi.Toggle, {
                  toggled: knownTransfers,
                  label: knownTransfers ? "Known" : "Unknown",
                  labelPosition: "right",
                  onClick: this.toggleKnownTransfers
                }),
                _react2.default.createElement(_materialUi.TextField, {
                  floatingLabelText: "Transfer Details",
                  value: transferArrangements,
                  onChange: this.updateTextField("transferArrangements"),
                  fullWidth: true
                }),
                _react2.default.createElement(
                  "div",
                  { style: styles.transferDetails },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Arrival:"
                  ),
                  _react2.default.createElement(_materialUi.TextField, {
                    hintText: exampleArrival,
                    value: arrivalDetails,
                    onChange: this.updateTextField("arrivalDetails"),
                    fullWidth: true,
                    disabled: !knownTransfers
                  })
                ),
                _react2.default.createElement(
                  "div",
                  { style: styles.transferDetails },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Departure:"
                  ),
                  _react2.default.createElement(_materialUi.TextField, {
                    hintText: exampleDeparture,
                    value: departureDetails,
                    onChange: this.updateTextField("departureDetails"),
                    fullWidth: true,
                    disabled: !knownTransfers
                  })
                )
              )
            )
          ),
          _react2.default.createElement(
            _materialUi.Card,
            { style: renderedLetterStyles, id: "renderedLetter" },
            _react2.default.createElement(
              _materialUi.CardText,
              null,
              _react2.default.createElement(
                "div",
                { style: styles.letterHeader },
                _react2.default.createElement(
                  "p",
                  null,
                  _react2.default.createElement(
                    "span",
                    { style: styles.headerLabel },
                    vendorName
                  ),
                  _react2.default.createElement("br", null),
                  _react2.default.createElement(
                    "span",
                    { style: styles.headerLabel },
                    "From:"
                  ),
                  "\xA0",
                  _react2.default.createElement(
                    "span",
                    null,
                    inbox
                  ),
                  _react2.default.createElement("br", null),
                  _react2.default.createElement(
                    "span",
                    { style: styles.headerLabel },
                    amenityProgram,
                    " E-mail:"
                  ),
                  "\xA0",
                  _react2.default.createElement(
                    "span",
                    null,
                    primaryContactEmail
                  ),
                  _react2.default.createElement("br", null),
                  _react2.default.createElement(
                    "span",
                    { style: styles.headerLabel },
                    "Primary ",
                    amenityProgram,
                    " Contact:"
                  ),
                  "\xA0",
                  _react2.default.createElement(
                    "span",
                    null,
                    primaryContactName,
                    " (",
                    primaryContactPosition,
                    ")"
                  ),
                  _react2.default.createElement("br", null),
                  _react2.default.createElement(
                    "span",
                    { style: styles.headerLabel },
                    "E-mail:"
                  ),
                  "\xA0",
                  _react2.default.createElement(
                    "span",
                    null,
                    displayEmailList
                  ),
                  _react2.default.createElement("br", null),
                  _react2.default.createElement(
                    "span",
                    { style: styles.headerLabel },
                    "Gmail Link:"
                  ),
                  "\xA0",
                  _react2.default.createElement(
                    "span",
                    null,
                    _react2.default.createElement(
                      "a",
                      {
                        href: gmailLink,
                        target: "_blank",
                        rel: "noopener noreferrer"
                      },
                      "click here"
                    )
                  ),
                  _react2.default.createElement("br", null)
                ),
                _react2.default.createElement(
                  "div",
                  null,
                  _react2.default.createElement(_materialUi.RaisedButton, {
                    label: vipDrafted ? "Mark Undrafted" : "Mark Drafted",
                    onTouchTap: this.setCheckbox,
                    disabled: isDirty,
                    primary: true,
                    style: { marginRight: 15 }
                  }),
                  _react2.default.createElement(_materialUi.RaisedButton, {
                    label: "Save Changes",
                    onTouchTap: this.save,
                    disabled: !isDirty,
                    secondary: true
                  })
                )
              ),
              _react2.default.createElement(
                "p",
                null,
                _react2.default.createElement(
                  "b",
                  null,
                  "Subject: "
                ),
                _react2.default.createElement(
                  "span",
                  null,
                  subjectLine
                )
              ),
              _react2.default.createElement(_VIPLetter2.default, vipLetterProps)
            )
          )
        )
      );
    }
  }]);

  return SegmentDetail;
}(_react2.default.Component), _class2.propTypes = {
  segment: _propTypes2.default.shape().isRequired,
  users: _propTypes2.default.shape().isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.getInitialState = function (props) {
    var _props$segment2 = props.segment,
        vipContext = _props$segment2.vipContext,
        _props$segment2$trip = _props$segment2.trip,
        travelers = _props$segment2$trip.travelers,
        insideCircle = _props$segment2$trip.insideCircle,
        _props$segment2$ameni = _props$segment2.amenityProgram,
        amenityProgram = _props$segment2$ameni === undefined ? "Virtuoso" : _props$segment2$ameni,
        rawContacts = _props$segment2.vendor.contacts;


    var rightColumnWidth = 0;
    var letterOffset = 0;
    var letterHeight = 0;
    if (_this3.state !== undefined) {
      rightColumnWidth = _this3.state.rightColumnWidth;
      letterOffset = _this3.state.letterOffset;
      letterHeight = _this3.state.letterHeight;
    }

    var contacts = JSON.parse(rawContacts);
    var primaryContact = _lodash2.default.find(contacts, function (contact) {
      return contact.primary === true;
    });

    var name = "";
    var email = "";
    var position = "";
    var displayName = "";
    if (primaryContact) {
      name = primaryContact.name;
      email = primaryContact.email;
      position = primaryContact.position;
      displayName = primaryContact.displayName || "";
    }

    var additionalContacts = [];
    if (contacts) {
      additionalContacts = contacts.filter(function (contact) {
        return contact.primary !== true;
      }).map(function (contact) {
        return contact.email;
      });
    }

    var newState = _lodash2.default.assign({
      primaryContactName: name,
      primaryContactDisplayName: displayName,
      primaryContactEmail: email,
      primaryContactPosition: position,
      additionalContactEmails: additionalContacts,
      amenityProgram: amenityProgram,
      specialRequests: [],
      transferArrangements: defaultTransfersMessages.unknown,
      arrivalDetails: "",
      departureDetails: "",
      bookingIATA: "Brownell",
      segmentTravelers: {},
      from: _this3.getDefaultFrom(insideCircle),
      isDirty: false,
      rightColumnWidth: rightColumnWidth,
      letterOffset: letterOffset,
      formExpanded: true,
      letterHeight: letterHeight,
      newRequest: "",
      knownTransfers: false,
      insideCircle: insideCircle
    }, JSON.parse(vipContext));

    travelers.map(function (_ref4) {
      var id = _ref4.id,
          fullName = _ref4.fullName,
          firstName = _ref4.firstName,
          lastName = _ref4.lastName,
          birthdate = _ref4.birthdate,
          adult = _ref4.adult,
          vipNotes = _ref4.vipNotes;

      // eslint-disable-line
      var existing = newState.segmentTravelers[id];

      var travelerObject = {};
      travelerObject[id] = {
        id: id,
        fullName: fullName,
        firstName: firstName,
        lastName: lastName,
        birthdate: birthdate,
        adult: adult,
        traveling: existing === undefined ? true : existing.traveling,
        vipNotes: vipNotes
      };

      newState.segmentTravelers = _lodash2.default.assign(newState.segmentTravelers, travelerObject);
    });

    return newState;
  };

  this.getDefaultFrom = function (insideCircle) {
    return insideCircle ? "Team Ourisman (on behalf of David Ourisman)" : "Team Ourisman";
  };

  this.save = function () {
    var segmentId = _this3.props.segment.id;
    var _state2 = _this3.state,
        primaryContactName = _state2.primaryContactName,
        primaryContactEmail = _state2.primaryContactEmail,
        primaryContactPosition = _state2.primaryContactPosition,
        additionalContactEmails = _state2.additionalContactEmails,
        amenityProgram = _state2.amenityProgram,
        specialRequests = _state2.specialRequests,
        transferArrangements = _state2.transferArrangements,
        arrivalDetails = _state2.arrivalDetails,
        departureDetails = _state2.departureDetails,
        bookingIATA = _state2.bookingIATA,
        segmentTravelers = _state2.segmentTravelers,
        from = _state2.from,
        knownTransfers = _state2.knownTransfers,
        insideCircle = _state2.insideCircle,
        primaryContactDisplayName = _state2.primaryContactDisplayName;

    var vipContext = {
      primaryContactName: primaryContactName,
      primaryContactEmail: primaryContactEmail,
      primaryContactPosition: primaryContactPosition,
      additionalContactEmails: additionalContactEmails,
      amenityProgram: amenityProgram,
      specialRequests: specialRequests,
      transferArrangements: transferArrangements,
      arrivalDetails: arrivalDetails,
      departureDetails: departureDetails,
      bookingIATA: bookingIATA,
      segmentTravelers: segmentTravelers,
      from: from,
      knownTransfers: knownTransfers,
      insideCircle: insideCircle,
      primaryContactDisplayName: primaryContactDisplayName
    };

    var input = { segmentId: segmentId, vipContext: vipContext };

    (0, _reactRelay.commitMutation)(_environment2.default, {
      mutation: _graphql || (_graphql = function _graphql() {
        return __webpack_require__("nPTA");
      }),
      variables: { input: input },
      onCompleted: function onCompleted() {
        _this3.setState({
          isDirty: false,
          formExpanded: false
        });
      },
      onError: function onError(err) {
        return alert(err);
      }
    });
  };

  this.setCheckbox = function () {
    var _props$segment3 = _this3.props.segment,
        segmentId = _props$segment3.id,
        vipDrafted = _props$segment3.vipDrafted;


    var input = {
      segmentId: segmentId,
      checkbox: "vipDrafted",
      value: !vipDrafted
    };

    (0, _reactRelay.commitMutation)(_environment2.default, {
      mutation: _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__("PULU");
      }),
      variables: { input: input },
      onError: function onError(err) {
        return alert(err);
      }
    });
  };

  this.handleResize = function () {
    _this3.setRightColumnWidth();
    _this3.setLetterOffset();
  };

  this.setRightColumnWidth = function () {
    var _window = window,
        innerWidth = _window.innerWidth;

    var rightColumnWidth = innerWidth - 530;
    _this3.setState({ rightColumnWidth: rightColumnWidth });
  };

  this.getLetterOffset = function () {
    var element = document.getElementById("form");
    return element.offsetTop + element.clientHeight + 15;
  };

  this.setLetterOffset = function () {
    var _window2 = window,
        innerHeight = _window2.innerHeight;

    var letterOffset = _this3.getLetterOffset();

    _this3.setState({
      letterOffset: letterOffset,
      letterHeight: innerHeight - letterOffset - 15
    });
  };

  this.handleUnload = function (e) {
    var isDirty = _this3.state.isDirty;

    var event = e || window.event;

    if (!isDirty) {
      return undefined;
    }

    var message = "You have unsaved changes in your VIP letter, " + "leaving without saving will cause them to be lost.";

    event.preventDefault();
    event.returnValue = message;
    return message;
  };

  this.updateTextField = function (field) {
    var dirty = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    return function (e) {
      var value = e.target.value;


      var newState = {
        isDirty: dirty
      };
      newState[field] = value;

      if (field === "primaryContactName") {
        newState.primaryContactDisplayName = value.split(" ")[0];
      }

      _this3.setState(newState);
    };
  };

  this.updateRequest = function (index) {
    return function (_ref5) {
      var value = _ref5.target.value;
      var specialRequests = _this3.state.specialRequests;

      var newSpecialRequests = [].concat(_toConsumableArray(specialRequests));
      newSpecialRequests[index] = value;

      _this3.setState({
        isDirty: true,
        specialRequests: newSpecialRequests
      });
    };
  };

  this.updateEmailList = function (e) {
    var value = e.target.value;

    var emailList = value.split(",").map(function (email) {
      return email.trim();
    });

    _this3.setState({
      isDirty: true,
      additionalContactEmails: emailList
    });
  };

  this.toggleTraveler = function (id) {
    return function () {
      var segmentTravelers = _this3.state.segmentTravelers;

      segmentTravelers[id].traveling = !segmentTravelers[id].traveling;
      _this3.setState({
        isDirty: true,
        segmentTravelers: segmentTravelers
      });
    };
  };

  this.handleExpandChange = function (expanded) {
    _this3.setState({ formExpanded: expanded });
  };

  this.addRequest = function () {
    var _state3 = _this3.state,
        specialRequests = _state3.specialRequests,
        newRequest = _state3.newRequest;

    _this3.setState({
      isDirty: true,
      newRequest: "",
      specialRequests: [].concat(_toConsumableArray(specialRequests), [newRequest])
    });
  };

  this.removeRequest = function (index) {
    return function () {
      var specialRequests = _this3.state.specialRequests;

      specialRequests.splice(index, 1);
      _this3.setState({
        isDirty: true,
        specialRequests: specialRequests
      });
    };
  };

  this.newRequestKeyDown = function (e) {
    var keyCode = e.keyCode;

    if (keyCode === 13) {
      _this3.addRequest();
    }
  };

  this.selectIATA = function (event, index, value) {
    return _this3.setState({ bookingIATA: value });
  };

  this.toggleKnownTransfers = function (_ref6) {
    var checked = _ref6.target.checked;

    _this3.setState({
      isDirty: true,
      knownTransfers: checked,
      transferArrangements: checked ? defaultTransfersMessages.known : defaultTransfersMessages.unknown,
      arrivalDetails: "",
      departureDetails: ""
    });
  };

  this.toggleInsideCircle = function (_ref7) {
    var checked = _ref7.target.checked;

    _this3.setState({
      isDirty: true,
      insideCircle: checked,
      from: _this3.getDefaultFrom(checked)
    });
  };

  this.fromOnNewRequest = function (chosenRequest) {
    _this3.setState({
      isDirty: true,
      from: chosenRequest
    });
  };

  this.fromOnUpdateInput = function (searchText) {
    _this3.setState({
      isDirty: true,
      from: searchText
    });
  };

  this.amenityOnNewRequest = function (chosenRequest) {
    _this3.setState({
      isDirty: true,
      amenityProgram: chosenRequest
    });
  };

  this.amenityOnUpdateInput = function (searchText) {
    _this3.setState({
      isDirty: true,
      amenityProgram: searchText
    });
  };

  this.autoCompleteFilter = function (searchText, key) {
    var normalKey = key.toLowerCase();
    var normalText = searchText.toLowerCase();
    return searchText !== "" && normalKey.indexOf(normalText) !== -1;
  };

  this.moveUp = function (index) {
    return function () {
      if (index > 0) {
        _this3.moveItem(index, index - 1);
      }
    };
  };

  this.moveDown = function (index) {
    return function () {
      if (index < _this3.state.specialRequests.length - 1) {
        _this3.moveItem(index, index + 1);
      }
    };
  };

  this.moveItem = function (oldIndex, newIndex) {
    var specialRequests = _this3.state.specialRequests;

    var newRequests = specialRequests.slice();
    var toMove = specialRequests[oldIndex];
    newRequests.splice(oldIndex, 1);
    newRequests.splice(newIndex, 0, toMove);
    _this3.setState({ specialRequests: newRequests });
  };
}, _temp)) || _class);


var styles = {
  container: {
    display: "flex"
  },
  leftColumn: {
    flex: "0 0 430px",
    marginLeft: 5
  },
  notesContainer: {
    overflow: "auto",
    position: "relative",
    width: 430
  },
  tripDetails: {
    background: "white",
    width: 430,
    zIndex: 10
  },
  rightColumn: {
    marginLeft: 5
  },
  headerLabel: {
    fontWeight: "bold"
  },
  formRow: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between"
  },
  letterHeader: {
    width: "100%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between",
    alignItems: "baseline"
  },
  travelerName: {
    fontWeight: "bold"
  },
  form: {
    position: "fixed",
    maxHeight: "50%",
    overflow: "auto"
  },
  renderedLetter: {
    overflow: "auto",
    position: "fixed"
  },
  travelerRow: {},
  travelerChips: {
    display: "flex",
    flexWrap: "wrap"
  },
  chip: {
    margin: 4
  },
  newRequest: {
    display: "flex"
  },
  formRequest: {
    display: "flex"
  },
  transferDetails: {
    display: "flex",
    alignItems: "baseline"
  },
  segmentIconStyle: {
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline",
    position: "relative",
    top: 5
  },
  indicatorGroupStyle: {
    display: "flex"
  },
  indicatorStyle: {
    // marginRight: 5,
    fontSize: 8,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "flex-end",
    width: 38,
    height: 33
  },
  cancelledIconStyle: {
    color: _ourismanTravelTheme2.default.palette.accent1Color
  },
  segmentListItem: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "baseline",
    fontSize: 12
  },
  cancelledSegment: {
    textDecoration: "line-through",
    color: _ourismanTravelTheme2.default.palette.accent1Color
  },
  buttonStyle: {
    padding: 0,
    width: 20,
    height: 5,
    position: "relative",
    top: 8
  }
};

// eslint-disable-next-line no-shadow
var globalSelectorHandler = function globalSelectorHandler(selector, _, generateSubtreeStyles) {
  if (selector[0] !== "*") {
    return null;
  }

  return generateSubtreeStyles(selector.slice(1));
};
var globalExtension = { selectorHandler: globalSelectorHandler };

var _StyleSheet$extend = _aphrodite.StyleSheet.extend([globalExtension]),
    newStyleSheet = _StyleSheet$extend.StyleSheet,
    newCss = _StyleSheet$extend.css;

var aphroditeStyles = newStyleSheet.create({
  vipNotes: {
    margin: 5
  },
  display: {
    "*ul": {
      listStyleType: "disc",
      listStylePosition: "inside"
    },
    "*ol": {
      listStyleType: "decimal",
      listStylePosition: "inside"
    },
    "*em": {
      fontStyle: "italic"
    }
  }
});

exports.default = SegmentDetail;

/***/ }),

/***/ "FMZb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setValue = setValue;

var _ActionTypes = __webpack_require__("zLtr");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setValue(field, value) {
  // eslint-disable-line
  return {
    type: _ActionTypes2.default.Trips.setValue,
    field: field,
    value: value
  };
}

/***/ }),

/***/ "FjB9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp2;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("RH2O");

var _materialUi = __webpack_require__("Q4lS");

var _aphrodite = __webpack_require__("BK4P");

var _DateEntry = __webpack_require__("VcJq");

var _DateEntry2 = _interopRequireDefault(_DateEntry);

var _RateQuoteActions = __webpack_require__("wRbn");

var RateQuoteActions = _interopRequireWildcard(_RateQuoteActions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RateEntry = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    destination: state.RateQuote.get('destination'),
    vendorName: state.RateQuote.get('vendorName'),
    vendorURL: state.RateQuote.get('vendorURL'),
    amenityType: state.RateQuote.get('amenityType'),
    roomRates: state.RateQuote.get('roomRates'),
    amenities: state.RateQuote.get('amenities'),
    averageRate: state.RateQuote.get('averageRate')
  };
}), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(RateEntry, _React$Component);

  function RateEntry() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RateEntry);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RateEntry.__proto__ || Object.getPrototypeOf(RateEntry)).call.apply(_ref, [this].concat(args))), _this), _this.updateField = function (fieldName) {
      return function (e) {
        _this.props.dispatch(RateQuoteActions.updateString(fieldName, e.target.value));
      };
    }, _this.handleUpdateInput = function (fieldName) {
      return function (value) {
        _this.props.dispatch(RateQuoteActions.updateString(fieldName, value));
      };
    }, _this.toggleAverageRate = function (e) {
      _this.props.dispatch(RateQuoteActions.updateString('averageRate', e.target.checked));
    }, _this.autoCompleteFilter = function (searchText, key) {
      var loweredSearchText = searchText.toLowerCase();
      var loweredKey = key.toLowerCase();

      return searchText !== '' && loweredKey.includes(loweredSearchText);
    }, _this.rateTypes = ['Best Available Rate', 'Virtuoso Best Available Rate', 'Preferred Partner Best Available Rate', 'Diamond Club Best Available Rate', 'Mandarin Oriental Fan Club Best Available Rate', 'Ritz Carlton STARS Best Available Rate', 'Starwood Luxury Privileges Best Available Rate'], _this.cancellationPresets = ['24 hours', '48 hours', '3 days', '7 days', '21 days', '30 days'], _this.depositPresets = ['No deposit required;', 'Deposit required;', 'One night deposit required at time of booking;', 'Two night deposit required at time of booking;', '50% deposit required at time of booking;'], _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RateEntry, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;


      return _react2.default.createElement(
        _materialUi.Card,
        { className: className },
        _react2.default.createElement(_materialUi.CardTitle, { title: 'Enter Rate Information' }),
        _react2.default.createElement(
          _materialUi.CardText,
          null,
          _react2.default.createElement(
            'div',
            { className: (0, _aphrodite.css)(styles.container) },
            _react2.default.createElement(_materialUi.TextField, {
              value: this.props.destination,
              floatingLabelText: 'Destination Name',
              onChange: this.updateField('destination')
            }),
            _react2.default.createElement(_DateEntry2.default, null),
            _react2.default.createElement(
              'div',
              { className: (0, _aphrodite.css)(styles.vendorInfo) },
              _react2.default.createElement(_materialUi.TextField, {
                value: this.props.vendorName,
                floatingLabelText: 'Vendor Name',
                onChange: this.updateField('vendorName')
              }),
              _react2.default.createElement(_materialUi.TextField, {
                value: this.props.vendorURL,
                floatingLabelText: 'Vendor URL',
                onChange: this.updateField('vendorURL')
              })
            ),
            _react2.default.createElement(_materialUi.AutoComplete, {
              floatingLabelText: 'Rate Type',
              dataSource: this.rateTypes,
              onUpdateInput: this.handleUpdateInput('rateType'),
              onNewRequest: this.handleUpdateInput('rateType'),
              fullWidth: true,
              filter: this.autoCompleteFilter
            }),
            _react2.default.createElement(_materialUi.AutoComplete, {
              floatingLabelText: 'Deposit/Guarantee',
              dataSource: this.depositPresets,
              onUpdateInput: this.handleUpdateInput('deposit'),
              onNewRequest: this.handleUpdateInput('deposit'),
              fullWidth: true,
              filter: this.autoCompleteFilter
            }),
            _react2.default.createElement(_materialUi.AutoComplete, {
              floatingLabelText: 'Cancellation Policy',
              dataSource: this.cancellationPresets.map(function (preset) {
                return 'cancel up to ' + preset + ' prior to arrival to avoid penalty.';
              }),
              onUpdateInput: this.handleUpdateInput('cancellation'),
              onNewRequest: this.handleUpdateInput('cancellation'),
              fullWidth: true,
              filter: this.autoCompleteFilter
            }),
            _react2.default.createElement(_materialUi.Toggle, {
              checked: this.props.averageRate,
              onClick: this.toggleAverageRate,
              label: 'Average Nightly Rates'
            }),
            _react2.default.createElement(_materialUi.TextField, {
              floatingLabelText: 'Room Rates',
              multiLine: true,
              fullWidth: true,
              value: this.props.roomRates,
              onChange: this.updateField('roomRates')
            }),
            _react2.default.createElement(_materialUi.TextField, {
              floatingLabelText: 'Amenity Type',
              value: this.props.amenityType,
              onChange: this.updateField('amenityType')
            }),
            _react2.default.createElement(_materialUi.TextField, {
              floatingLabelText: 'Amenities',
              multiLine: true,
              fullWidth: true,
              value: this.props.amenities,
              onChange: this.updateField('amenities')
            })
          )
        )
      );
    }
  }]);

  return RateEntry;
}(_react2.default.Component), _class2.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  className: _propTypes2.default.string.isRequired,
  destination: _propTypes2.default.string,
  vendorName: _propTypes2.default.string,
  vendorURL: _propTypes2.default.string,
  amenityType: _propTypes2.default.string,
  roomRates: _propTypes2.default.string,
  amenities: _propTypes2.default.string,
  averageRate: _propTypes2.default.bool
}, _class2.defaultProps = {
  destination: '',
  vendorName: '',
  vendorURL: '',
  amenityType: '',
  roomRates: '',
  amenities: '',
  averageRate: false
}, _temp2)) || _class);
exports.default = RateEntry;


var styles = _aphrodite.StyleSheet.create({
  container: {
    display: 'flex',
    flexDirection: 'column'
  },
  vendorInfo: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  }
});

/***/ }),

/***/ "Fz6x":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("Tc9k");

var _materialUi = __webpack_require__("Q4lS");

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _ResponseDetail = __webpack_require__("Cqxy");

var _ResponseDetail2 = _interopRequireDefault(_ResponseDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResponseDetailsRenderer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    windowHeight: state.Responsive.get('windowHeight')
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(ResponseDetailsRenderer, _React$Component);

  function ResponseDetailsRenderer() {
    _classCallCheck(this, ResponseDetailsRenderer);

    return _possibleConstructorReturn(this, (ResponseDetailsRenderer.__proto__ || Object.getPrototypeOf(ResponseDetailsRenderer)).apply(this, arguments));
  }

  _createClass(ResponseDetailsRenderer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          windowHeight = _props.windowHeight,
          activeResponse = _props.activeResponse;

      var top = (windowHeight - 161) / 2 + 161;

      var loadingEl = _react2.default.createElement(_materialUi.RefreshIndicator, {
        top: top,
        left: 900,
        status: 'loading'
      });

      return _react2.default.createElement(_reactRelay.QueryRenderer, {
        environment: _environment2.default,
        variables: {
          responseId: activeResponse
        },
        query: _graphql || (_graphql = function _graphql() {
          return __webpack_require__("c8yp");
        }),
        render: function render(_ref) {
          var error = _ref.error,
              props = _ref.props;

          if (error) {
            return _react2.default.createElement(
              'div',
              null,
              error.message
            );
          } else if (props) {
            var response = props.response;


            return _react2.default.createElement(_ResponseDetail2.default, { response: response });
          }

          return loadingEl;
        }
      });
    }
  }]);

  return ResponseDetailsRenderer;
}(_react2.default.Component), _class2.propTypes = {
  windowHeight: _propTypes2.default.number.isRequired,
  activeResponse: _propTypes2.default.string.isRequired
}, _temp)) || _class);
exports.default = ResponseDetailsRenderer;

/***/ }),

/***/ "GQCW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__("Q4lS");

var _search = __webpack_require__("4bvr");

var _search2 = _interopRequireDefault(_search);

var _aphrodite = __webpack_require__("BK4P");

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

var _rest = __webpack_require__("i4WM");

var _rest2 = _interopRequireDefault(_rest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var GlobalSearchBox = (_temp = _class = function (_React$Component) {
  _inherits(GlobalSearchBox, _React$Component);

  function GlobalSearchBox(props) {
    _classCallCheck(this, GlobalSearchBox);

    var _this = _possibleConstructorReturn(this, (GlobalSearchBox.__proto__ || Object.getPrototypeOf(GlobalSearchBox)).call(this, props));

    _this.handleUpdateSearchBox = function (value) {
      (0, _rest2.default)('trip', value).then(function (response) {
        var objects = response.objects;

        _this.setState({
          searchResults: objects.map(function (object) {
            return {
              text: object.tripName,
              value: object.id
            };
          })
        });
      });
    };

    _this.tripSelected = function (selected, index) {
      var value = selected.value;
      var searchResults = _this.state.searchResults;


      if (index === -1) {
        if (searchResults.length === 0) {
          return;
        }
        value = searchResults[0].value;
      }

      _this.props.history.push('/trips/' + value + '/');
    };

    _this.state = {
      searchResults: []
    };
    return _this;
  }

  _createClass(GlobalSearchBox, [{
    key: 'render',
    value: function render() {
      var searchResults = this.state.searchResults;


      return _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styles.searchContainer) },
        _react2.default.createElement(_materialUi.AutoComplete, {
          name: 'global-search',
          dataSource: searchResults,
          className: (0, _aphrodite.css)(styles.searchBoxStyle),
          menuStyle: { width: 500 },
          listStyle: { width: 500 },
          onUpdateInput: this.handleUpdateSearchBox,
          onNewRequest: this.tripSelected,
          filter: function filter() {
            return true;
          }
        }),
        _react2.default.createElement(_search2.default, { className: (0, _aphrodite.css)(styles.largeIconStyle) })
      );
    }
  }]);

  return GlobalSearchBox;
}(_react2.default.Component), _class.propTypes = {
  history: _propTypes2.default.shape({
    push: _propTypes2.default.func
  }).isRequired
}, _temp);
exports.default = GlobalSearchBox;


var styles = _aphrodite.StyleSheet.create({
  largeIconStyle: {
    position: 'relative',
    left: -24,
    top: 7,
    color: _ourismanTravelTheme2.default.palette.alternateTextColor
  },
  largeTextFieldStyle: {
    position: 'relative',
    top: -10,
    color: 'red'
  },
  searchBoxStyle: {
    color: _ourismanTravelTheme2.default.palette.secondaryTextColor,
    WebkitTextFillColor: _ourismanTravelTheme2.default.palette.secondaryTextColor,
    maxWidth: 256
  },
  searchContainer: {
    '@media (max-width: 800px)': {
      display: 'none'
    }
  }
});

/***/ }),

/***/ "GhSK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _apollo = __webpack_require__("zPxQ");

var _apollo2 = _interopRequireDefault(_apollo);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _apollo2.default.reducer();

/***/ }),

/***/ "Gm1F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InquiryForm = undefined;

var _InquiryForm2 = __webpack_require__("xnrt");

var _InquiryForm3 = _interopRequireDefault(_InquiryForm2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.InquiryForm = _InquiryForm3.default;

/***/ }),

/***/ "HMW4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2, _dec, _class2, _class3, _temp3, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("Tc9k");

var _reactRedux = __webpack_require__("RH2O");

var _reactDom = __webpack_require__("O27J");

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _fuzzy = __webpack_require__("Pv+r");

var _fuzzy2 = _interopRequireDefault(_fuzzy);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _Vendor = __webpack_require__("+oc7");

var _Vendor2 = _interopRequireDefault(_Vendor);

var _styles = __webpack_require__("IQwA");

var _styles2 = _interopRequireDefault(_styles);

var _VendorListFilters = __webpack_require__("TZ1C");

var _VendorListFilters2 = _interopRequireDefault(_VendorListFilters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RenderedVendors = (_temp2 = _class = function (_React$Component) {
  _inherits(RenderedVendors, _React$Component);

  function RenderedVendors() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RenderedVendors);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RenderedVendors.__proto__ || Object.getPrototypeOf(RenderedVendors)).call.apply(_ref, [this].concat(args))), _this), _this.scrollToVendor = function () {
      var node = _reactDom2.default.findDOMNode(_this.refs.activeVendor); // eslint-disable-line
      if (node) {
        node.scrollIntoView({ behavior: 'instant', block: 'start' });
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RenderedVendors, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.scrollToVendor();
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.scrollToVendor();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          vendors = _props.vendors,
          activeVendor = _props.activeVendor;


      return _react2.default.createElement(
        'div',
        { className: _styles2.default.listItems },
        vendors.map(function (vendor) {
          var vendorId = vendor.id;

          var active = vendorId === activeVendor;
          var ref = active ? 'activeVendor' : null;

          return _react2.default.createElement(_Vendor2.default, { key: vendorId, vendor: vendor, active: active, ref: ref });
        })
      );
    }
  }]);

  return RenderedVendors;
}(_react2.default.Component), _class.propTypes = {
  vendors: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  activeVendor: _propTypes2.default.string
}, _class.defaultProps = {
  activeVendor: ''
}, _temp2);
var Renderer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    windowHeight: state.Responsive.get('windowHeight')
  };
}), _dec(_class2 = (_temp3 = _class3 = function (_React$Component2) {
  _inherits(Renderer, _React$Component2);

  // eslint-disable-line
  function Renderer(props) {
    _classCallCheck(this, Renderer);

    var _this2 = _possibleConstructorReturn(this, (Renderer.__proto__ || Object.getPrototypeOf(Renderer)).call(this, props));

    _this2.updateVendorFilter = function (e) {
      var vendorFilter = e.target.value;

      _this2.setState({ vendorFilter: vendorFilter });
    };

    _this2.state = {
      vendorFilter: ''
    };
    return _this2;
  }

  _createClass(Renderer, [{
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          activeVendor = _props2.activeVendor,
          loadingEl = _props2.loadingEl;
      var vendorFilter = this.state.vendorFilter;

      var updateVendorFilter = this.updateVendorFilter;

      return _react2.default.createElement(_reactRelay.QueryRenderer, {
        environment: _environment2.default,
        query: _graphql || (_graphql = function _graphql() {
          return __webpack_require__("mL6h");
        }),
        render: function render(_ref2) {
          var error = _ref2.error,
              props = _ref2.props;

          if (error) {
            return _react2.default.createElement(
              'div',
              null,
              error.message
            );
          } else if (props) {
            var vendors = props.allVendors.edges;


            var filteredVendors = vendors.map(function (_ref3) {
              var node = _ref3.node;
              return node;
            });
            if (vendorFilter) {
              filteredVendors = _fuzzy2.default.filter(vendorFilter, vendors.map(function (_ref4) {
                var node = _ref4.node;
                return node;
              }), {
                extract: function extract(vendor) {
                  return vendor.name;
                }
              }).map(function (filteredVendor) {
                return filteredVendor.original;
              });
            }

            return _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_VendorListFilters2.default, {
                numVendors: vendors.length,
                numFiltered: filteredVendors.length,
                updateFilter: updateVendorFilter,
                filter: vendorFilter
              }),
              _react2.default.createElement(RenderedVendors, {
                vendors: filteredVendors,
                activeVendor: activeVendor
              })
            );
          }

          return loadingEl;
        }
      });
    }
  }]);

  return Renderer;
}(_react2.default.Component), _class3.propTypes = {
  activeVendor: _propTypes2.default.string,
  loadingEl: _propTypes2.default.element.isRequired
}, _class3.defaultProps = {
  activeVendor: ''
}, _temp3)) || _class2);
exports.default = Renderer;

/***/ }),

/***/ "HdZY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 928c1b9f6c6595d4005379071ba49a90
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type MergeVendorsRenderer_MergeDetails_QueryResponse = {|
  +allVendors: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string;
        +name: string;
        +sabreCode: string;
        +contacts: ?any;
        +amenityPrograms: ?$ReadOnlyArray<?string>;
      |};
    |}>;
  |};
|};
*/

/*
query MergeVendorsRenderer_MergeDetails_Query(
  $id: String!
) {
  allVendors(id: $id) {
    edges {
      node {
        id
        name
        sabreCode
        contacts
        amenityPrograms
      }
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "id",
      "type": "String!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "MergeVendorsRenderer_MergeDetails_Query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "id",
        "variableName": "id",
        "type": "String"
      }],
      "concreteType": "VendorConnection",
      "name": "allVendors",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "VendorEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Vendor",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "sabreCode",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "contacts",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "amenityPrograms",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "MergeVendorsRenderer_MergeDetails_Query",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "id",
      "type": "String!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "MergeVendorsRenderer_MergeDetails_Query",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "id",
        "variableName": "id",
        "type": "String"
      }],
      "concreteType": "VendorConnection",
      "name": "allVendors",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "VendorEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Vendor",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "sabreCode",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "contacts",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "amenityPrograms",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "query MergeVendorsRenderer_MergeDetails_Query(\n  $id: String!\n) {\n  allVendors(id: $id) {\n    edges {\n      node {\n        id\n        name\n        sabreCode\n        contacts\n        amenityPrograms\n      }\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "I5fo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = __webpack_require__("PIAa");

var _aphrodite = __webpack_require__("BK4P");

var _AppContainer = __webpack_require__("wsBE");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'div',
    { className: newCss(styles.content) },
    _react2.default.createElement(
      _reactHelmet.Helmet,
      null,
      _react2.default.createElement(
        'title',
        null,
        'Ourisman Travel - Ping Pong'
      ),
      _react2.default.createElement('link', {
        href: 'https://fonts.googleapis.com/css?family=Noto+Sans:400,700&subset=cyrillic,cyrillic-ext',
        rel: 'stylesheet',
        type: 'text/css'
      }),
      _react2.default.createElement('link', { rel: 'stylesheet', href: '//cdn.quilljs.com/1.2.6/quill.snow.css' })
    ),
    _react2.default.createElement(_AppContainer.AppContainer, null)
  );
};

var globalSelectorHandler = function globalSelectorHandler(selector, _, generateSubtreeStyles) {
  if (selector[0] !== '*') {
    return null;
  }

  return generateSubtreeStyles(selector.slice(1));
};
var globalExtension = { selectorHandler: globalSelectorHandler };

var _StyleSheet$extend = _aphrodite.StyleSheet.extend([globalExtension]),
    newStyleSheet = _StyleSheet$extend.StyleSheet,
    newCss = _StyleSheet$extend.css;

var styles = newStyleSheet.create({
  content: {
    fontFamily: 'Noto Sans,sans-serif',
    '*a': {
      ':hover': {
        color: 'inherit',
        fontWeight: 'inherit'
      },
      textDecoration: 'none'
    }
  }
});

/***/ }),

/***/ "IQwA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"styles-container--3cIYC","list":"styles-list--3WYqk","detail":"styles-detail--3oNcd","listFilter":"styles-listFilter--jg_IA","listItems":"styles-listItems--3pqYC","active":"styles-active--1Gt7d","tripListItem":"styles-tripListItem--8tHH3"};

/***/ }),

/***/ "InNJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 7f7587addfbc38f83772ff09627e691b
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type TravelerListItem_ReorderTraveler_MutationVariables = {|
  input: {
    tripId?: ?string;
    travelerId?: ?string;
    oldIndex?: ?number;
    newIndex?: ?number;
    clientMutationId?: ?string;
  };
|};

export type TravelerListItem_ReorderTraveler_MutationResponse = {|
  +reorderTraveler: ?{|
    +trip: ?{|
      +tripName: ?string;
      +primaryTravelerName: ?string;
      +travelers: ?$ReadOnlyArray<?{|
        +id: string;
      |}>;
    |};
  |};
|};
*/

/*
mutation TravelerListItem_ReorderTraveler_Mutation(
  $input: ReorderTravelerInput!
) {
  reorderTraveler(input: $input) {
    trip {
      tripName
      primaryTravelerName
      travelers {
        id
      }
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "ReorderTravelerInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "TravelerListItem_ReorderTraveler_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ReorderTravelerInput!"
      }],
      "concreteType": "ReorderTravelerPayload",
      "name": "reorderTraveler",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tripName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "primaryTravelerName",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Traveler",
          "name": "travelers",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "TravelerListItem_ReorderTraveler_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "ReorderTravelerInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "TravelerListItem_ReorderTraveler_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "ReorderTravelerInput!"
      }],
      "concreteType": "ReorderTravelerPayload",
      "name": "reorderTraveler",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tripName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "primaryTravelerName",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Traveler",
          "name": "travelers",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation TravelerListItem_ReorderTraveler_Mutation(\n  $input: ReorderTravelerInput!\n) {\n  reorderTraveler(input: $input) {\n    trip {\n      tripName\n      primaryTravelerName\n      travelers {\n        id\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "IoNl":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"styles-container--29xbz","list":"styles-list--3oFzT","detail":"styles-detail--3OU0z","listFilter":"styles-listFilter--2vpYe","listItems":"styles-listItems--3nedm","active":"styles-active--3qCDI","tripDetails":"styles-tripDetails--1ZoU3","tripTitle":"styles-tripTitle--IYKBw","titlePrimary":"styles-titlePrimary--36iHf","cancelledPrimary":"styles-cancelledPrimary--bRCpG","titleSecondary":"styles-titleSecondary--3uBCm","cancelledSecondary":"styles-cancelledSecondary--2SZ6_","leftBlock":"styles-leftBlock--6RyOp","rightBlock":"styles-rightBlock--3xYXB","button":"styles-button--jFTF6","timestamp":"styles-timestamp--2558W","label":"styles-label--1rKD4","data":"styles-data--27o3E","flags":"styles-flags--1klO5","fired":"styles-fired--34Gy4","insideCircle":"styles-insideCircle--kPWG0","lowPriority":"styles-lowPriority--1uP3n","needsTraining":"styles-needsTraining--35FrN","needsVetting":"styles-needsVetting--2AKQ3","prospect":"styles-prospect--247eW","highPriority":"styles-highPriority--3jyeq","tripListItem":"styles-tripListItem--luvim","primaryDetails":"styles-primaryDetails--2weIM","travelerName":"styles-travelerName--3U8R3","secondaryDetails":"styles-secondaryDetails--2nPLl","indicators":"styles-indicators--1H9U6","icons":"styles-icons--2MV_t","icon":"styles-icon--2Iq0J","tripListFilters":"styles-tripListFilters--35M0p","filter":"styles-filter--1AeBE","infoLine":"styles-infoLine--12nAk"};

/***/ }),

/***/ "JDU+":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 609504dd3a5c98e6d5a842775a14256d
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ResponseListRenderer_ResponseList_QueryResponse = {|
  +allResponses: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string;
        +display: string;
        +created: any;
      |};
    |}>;
  |};
|};
*/

/*
query ResponseListRenderer_ResponseList_Query {
  allResponses {
    edges {
      node {
        id
        display
        created
      }
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ResponseListRenderer_ResponseList_Query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "FormResponseConnection",
      "name": "allResponses",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "FormResponseEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "FormResponse",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "display",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "created",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ResponseListRenderer_ResponseList_Query",
  "query": {
    "argumentDefinitions": [],
    "kind": "Root",
    "name": "ResponseListRenderer_ResponseList_Query",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "FormResponseConnection",
      "name": "allResponses",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "FormResponseEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "FormResponse",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "display",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "created",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "query ResponseListRenderer_ResponseList_Query {\n  allResponses {\n    edges {\n      node {\n        id\n        display\n        created\n      }\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "JW7h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__("Q4lS");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _momentParseformat = __webpack_require__("m0Xp");

var _momentParseformat2 = _interopRequireDefault(_momentParseformat);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _aphrodite = __webpack_require__("BK4P");

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateRange = (_temp = _class = function (_React$Component) {
  _inherits(DateRange, _React$Component);

  function DateRange(props) {
    _classCallCheck(this, DateRange);

    var _this = _possibleConstructorReturn(this, (DateRange.__proto__ || Object.getPrototypeOf(DateRange)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        startValue = _this$props.startValue,
        endValue = _this$props.endValue;

    var _this$processValue = _this.processValue(startValue),
        parsedStart = _this$processValue.parsedValue,
        startError = _this$processValue.errorText;

    var _this$processValue2 = _this.processValue(endValue),
        parsedEnd = _this$processValue2.parsedValue,
        endError = _this$processValue2.errorText;

    _this.state = {
      startInput: startValue,
      endInput: endValue,
      parsedStart: parsedStart,
      parsedEnd: parsedEnd,
      startError: startError,
      endError: endValue ? endError : '',
      singleFieldEntry: false
    };
    return _this;
  }

  _createClass(DateRange, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var nextParseDate = nextProps.parseDate,
          nextValue = nextProps.value;
      var _props = this.props,
          passedOnChange = _props.onChange,
          currentParseDate = _props.parseDate,
          currentValue = _props.value;


      if (currentValue && currentParseDate !== nextParseDate) {
        var nextState = {
          input: nextValue,
          parsedValue: ''
        };
        if (nextParseDate && nextValue) {
          nextState = this.processValue(nextValue);
        }

        if (this.state.parsedValue !== nextState.parsedValue) {
          this.setState(nextState);
          passedOnChange({ target: { value: nextValue } });
        }
      } else {
        this.setState({ input: nextValue });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _state = this.state,
          startInput = _state.startInput,
          endInput = _state.endInput,
          startError = _state.startError,
          endError = _state.endError,
          singleFieldEntry = _state.singleFieldEntry,
          parsedStart = _state.parsedStart,
          parsedEnd = _state.parsedEnd;
      var _props2 = this.props,
          startLabel = _props2.startLabel,
          endLabel = _props2.endLabel,
          className = _props2.className,
          fieldClass = _props2.fieldClass;


      var startErrorStyle = {
        color: parsedStart && (0, _moment2.default)(parsedStart).isValid() ? _ourismanTravelTheme2.default.palette.primary1Color : _ourismanTravelTheme2.default.palette.accent2Color
      };

      var endErrorStyle = {
        color: parsedEnd && (0, _moment2.default)(parsedEnd).isValid() ? _ourismanTravelTheme2.default.palette.primary1Color : _ourismanTravelTheme2.default.palette.accent2Color
      };

      return _react2.default.createElement(
        'div',
        { className: className || (0, _aphrodite.css)(styles.componentStyle) },
        _react2.default.createElement(_materialUi.TextField, {
          className: (0, _aphrodite.css)(styles.fieldStyle),
          floatingLabelText: startLabel,
          value: startInput || '',
          errorText: startError,
          onChange: this.onChangeStart,
          errorStyle: startErrorStyle,
          floatingLabelFocusStyle: startErrorStyle
        }),
        _react2.default.createElement(_materialUi.TextField, {
          className: fieldClass || (0, _aphrodite.css)(styles.fieldStyle),
          floatingLabelText: endLabel,
          value: endInput || '',
          errorText: endError,
          disabled: singleFieldEntry,
          onChange: this.onChangeEnd,
          errorStyle: endErrorStyle,
          floatingLabelFocusStyle: endErrorStyle
        })
      );
    }
  }]);

  return DateRange;
}(_react2.default.Component), _class.propTypes = {
  startValue: _propTypes2.default.shape(),
  endValue: _propTypes2.default.shape(),
  allowPast: _propTypes2.default.bool,
  parseDate: _propTypes2.default.bool,
  onChange: _propTypes2.default.func.isRequired,
  value: _propTypes2.default.string.isRequired,
  startLabel: _propTypes2.default.string.isRequired,
  endLabel: _propTypes2.default.string.isRequired,
  className: _propTypes2.default.string,
  fieldClass: _propTypes2.default.string
}, _class.defaultProps = {
  parseDate: true,
  allowPast: false,
  startValue: {},
  endValue: {},
  className: '',
  fieldClass: ''
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.onChangeStart = function (e) {
    var value = e.target.value;
    var allowPast = _this2.props.allowPast;


    var dateStringRE = /(\d{1,2})(\w{3})[- ](\d+)[Nn][Tt] ?(\d{4})?/;
    var match = dateStringRE.exec(value);

    var _state2 = _this2.state,
        parsedStart = _state2.parsedStart,
        parsedEnd = _state2.parsedEnd;


    if (match) {
      var _match = _slicedToArray(match, 5),
          day = _match[1],
          month = _match[2],
          duration = _match[3],
          _match$ = _match[4],
          year = _match$ === undefined ? (0, _moment2.default)().year() : _match$;

      var startDate = (0, _moment2.default)(day + ' ' + month + ' ' + year, 'DD MMM YYYY');
      if (!allowPast && startDate < (0, _moment2.default)()) {
        startDate = (0, _moment2.default)(day + ' ' + month + ' ' + (year + 1), 'DD MMM YYYY');
      }

      var endDate = (0, _moment2.default)(startDate).add(_moment2.default.duration(parseInt(duration, 10), 'days'));

      var startValues = _this2.processValue(startDate);
      var endValues = _this2.processValue(endDate);

      parsedStart = startValues.parsedValue;
      parsedEnd = endValues.parsedValue;

      _this2.setState({
        startInput: value.toUpperCase(),
        endInput: endValues.errorText,
        parsedStart: parsedStart,
        parsedEnd: parsedEnd,
        startError: startValues.errorText,
        endError: '',
        singleFieldEntry: true
      });
    } else {
      var processedValues = _this2.processValue(value);
      parsedStart = processedValues.parsedValue;

      _this2.setState({
        startInput: processedValues.input,
        parsedStart: parsedStart,
        startError: processedValues.errorText,
        singleFieldEntry: false
      });
    }
    _this2.props.onChange({
      startDate: parsedStart,
      endDate: parsedEnd
    });
  };

  this.onChangeEnd = function (e) {
    var value = e.target.value;
    var parsedStart = _this2.state.parsedStart;
    var parsedEnd = _this2.state.parsedEnd;

    var processedValues = _this2.processValue(value);
    parsedEnd = processedValues.parsedValue;

    _this2.setState({
      endInput: processedValues.input,
      parsedEnd: parsedEnd,
      endError: processedValues.errorText
    });
    _this2.props.onChange({
      startDate: parsedStart,
      endDate: parsedEnd
    });
  };

  this.processValue = function (value) {
    if (value === undefined || value === '') {
      return {
        input: value,
        parsedValue: null,
        errorText: ''
      };
    }

    var format = 'dddd, MMMM Do YYYY';
    var allowPast = _this2.props.allowPast;


    var parsedValue = void 0;
    if (_moment2.default.isMoment(value)) {
      parsedValue = value;
    } else {
      var enteredFormat = value ? (0, _momentParseformat2.default)(value) : format;
      parsedValue = (0, _moment2.default)(value, enteredFormat);
      if (!allowPast && parsedValue < (0, _moment2.default)() && enteredFormat.search('Y') < 0) {
        parsedValue.add(1, 'years');
      }
    }

    return {
      input: value,
      parsedValue: parsedValue && parsedValue.isValid() ? parsedValue : null,
      errorText: parsedValue && parsedValue.isValid() ? parsedValue.format(format) : "can't interpret date"
    };
  };
}, _temp);
exports.default = DateRange;


var styles = _aphrodite.StyleSheet.create({
  componentStyle: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  fieldStyle: {
    width: 256,
    marginRight: 24
  }
});

/***/ }),

/***/ "JhVn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 85b1a0ce6a24bcb354870d736d6a6587
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type MergeVendors_Merge_MutationVariables = {|
  input: {
    toKeep?: ?string;
    toMerge?: ?string;
    name?: ?string;
    sabreCode?: ?string;
    contacts?: ?any;
    amenityPrograms?: ?$ReadOnlyArray<?string>;
    clientMutationId?: ?string;
  };
|};

export type MergeVendors_Merge_MutationResponse = {|
  +mergeVendors: ?{|
    +vendor: ?{|
      +name: string;
      +sabreCode: string;
      +contacts: ?any;
      +amenityPrograms: ?$ReadOnlyArray<?string>;
    |};
  |};
|};
*/

/*
mutation MergeVendors_Merge_Mutation(
  $input: MergeVendorsInput!
) {
  mergeVendors(input: $input) {
    vendor {
      name
      sabreCode
      contacts
      amenityPrograms
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "MergeVendorsInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "MergeVendors_Merge_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "MergeVendorsInput!"
      }],
      "concreteType": "MergeVendorsPayload",
      "name": "mergeVendors",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Vendor",
        "name": "vendor",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "sabreCode",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "contacts",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "amenityPrograms",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "MergeVendors_Merge_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "MergeVendorsInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "MergeVendors_Merge_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "MergeVendorsInput!"
      }],
      "concreteType": "MergeVendorsPayload",
      "name": "mergeVendors",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Vendor",
        "name": "vendor",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "sabreCode",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "contacts",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "amenityPrograms",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation MergeVendors_Merge_Mutation(\n  $input: MergeVendorsInput!\n) {\n  mergeVendors(input: $input) {\n    vendor {\n      name\n      sabreCode\n      contacts\n      amenityPrograms\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "JqB5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__("Q4lS");

var _reactRedux = __webpack_require__("RH2O");

var _reactRelay = __webpack_require__("Tc9k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var EditTrip = (_dec = (0, _reactRedux.connect)(), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(EditTrip, _React$Component);

  function EditTrip(props) {
    _classCallCheck(this, EditTrip);

    var _this = _possibleConstructorReturn(this, (EditTrip.__proto__ || Object.getPrototypeOf(EditTrip)).call(this, props));

    _this.close = function () {
      _this.props.handleSave();
    };

    _this.save = function () {
      var tripId = _this.props.trip.id;
      var reason = _this.state.reason;


      (0, _reactRelay.commitMutation)(_environment2.default, {
        mutation: _graphql || (_graphql = function _graphql() {
          return __webpack_require__("5EsW");
        }),
        variables: { input: { tripId: tripId, notes: reason } },
        onError: function onError(err) {
          return alert(err);
        },
        onCompleted: function onCompleted() {
          return _this.close();
        }
      });
    };

    _this.updateTextField = function (fieldName) {
      return function (e) {
        var value = e.target.value;

        var newState = _this.state;
        newState[fieldName] = value;
        _this.setState(newState);
      };
    };

    _this.state = {
      reason: ""
    };
    return _this;
  }

  _createClass(EditTrip, [{
    key: "render",
    value: function render() {
      var reason = this.state.reason;

      var hasReason = reason && reason !== "";

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          "div",
          { style: styles.fieldsGroup },
          _react2.default.createElement(_materialUi.TextField, {
            style: styles.formField,
            floatingLabelText: "Why is this trip being voided?",
            fullWidth: true,
            value: reason,
            onChange: this.updateTextField("reason")
          })
        ),
        _react2.default.createElement(
          "div",
          { style: styles.formActions },
          _react2.default.createElement(_materialUi.RaisedButton, {
            style: styles.formButton,
            label: "Do Not Void Trip",
            primary: true,
            onTouchTap: this.close
          }),
          _react2.default.createElement(_materialUi.RaisedButton, {
            style: styles.formButton,
            label: "Void Trip",
            secondary: true,
            onTouchTap: this.save,
            disabled: !hasReason
          })
        )
      );
    }
  }]);

  return EditTrip;
}(_react2.default.Component), _class2.propTypes = {
  handleSave: _propTypes2.default.func.isRequired,
  trip: _propTypes2.default.shape().isRequired
}, _temp)) || _class);


var styles = {
  formActions: {
    display: "flex",
    justifyContent: "flex-end"
  },
  formButton: {
    marginRight: 15
  },
  fieldsGroup: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    flexWrap: "wrap"
  },
  formField: {
    marginRight: 25
  },
  specificDates: {
    marginTop: 15
  }
};

exports.default = EditTrip;

/***/ }),

/***/ "KnFw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Responses = undefined;

var _Responses2 = __webpack_require__("jFoS");

var _Responses3 = _interopRequireDefault(_Responses2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Responses = _Responses3.default;

/***/ }),

/***/ "La8e":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Auth = __webpack_require__("pY8a");

Object.defineProperty(exports, 'Auth', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Auth).default;
  }
});

var _RateQuote = __webpack_require__("aDnY");

Object.defineProperty(exports, 'RateQuote', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_RateQuote).default;
  }
});

var _Responsive = __webpack_require__("gtrU");

Object.defineProperty(exports, 'Responsive', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Responsive).default;
  }
});

var _Inquiry = __webpack_require__("RNKu");

Object.defineProperty(exports, 'Inquiry', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Inquiry).default;
  }
});

var _Trips = __webpack_require__("u6o6");

Object.defineProperty(exports, 'Trips', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Trips).default;
  }
});

var _apolloReducer = __webpack_require__("GhSK");

Object.defineProperty(exports, 'apollo', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_apolloReducer).default;
  }
});

var _formReducer = __webpack_require__("r4x5");

Object.defineProperty(exports, 'formReducer', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_formReducer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),

/***/ "Mc/I":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 *  Custom material-ui theme for Ourisman Travel.
 */

exports.default = {
  spacing: {
    iconSize: 24,
    desktopGutter: 24,
    desktopGutterMore: 32,
    desktopGutterLess: 16,
    desktopGutterMini: 8,
    desktopKeylineIncrement: 64,
    desktopDropDownMenuItemHeight: 32,
    desktopDropDownMenuFontSize: 15,
    desktopDrawerMenuItemHeight: 48,
    desktopSubheaderHeight: 48,
    desktopToolbarHeight: 56
  },
  fontFamily: "Noto Sans,sans-serif",
  palette: {
    primary1Color: "#000000",
    primary2Color: "#212121",
    primary3Color: "#DDDDDD",
    accent1Color: "#da2128",
    accent2Color: "#ff5e52",
    accent3Color: "#a00000",
    textColor: "#212121",
    secondaryTextColor: "#dddddd",
    alternateTextColor: "#997e35",
    canvasColor: "#ffffff",
    alternateСanvasColor: "#484848",
    alternate1Color: "rgba(255, 255, 255, 0.54)",
    alternate2Color: "#f5f5f5",
    borderColor: "#bdbdbd",
    disabledColor: "rgba(0,0,0,0.3)",
    pickerHeaderColor: "#00bcd4",
    clockCircleColor: "rgba(0,0,0,0.07)",
    shadowColor: "#484848",
    fired: "#fb4c2f",
    insideCircle: "#4986e7",
    lowPriority: "#DDDDDD",
    needsTraining: "#fbe983",
    needsVetting: "#2da2bb",
    highPriority: "#deadbf"
  }
};

/***/ }),

/***/ "Mjw5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(["\n  query AdminReport($startDate: String!, $endDate: String!) {\n    adminReport(startDate: $startDate, endDate: $endDate) {\n      vipLetters\n    }\n  }\n"], ["\n  query AdminReport($startDate: String!, $endDate: String!) {\n    adminReport(startDate: $startDate, endDate: $endDate) {\n      vipLetters\n    }\n  }\n"]);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__("Q4lS");

var _reactApollo = __webpack_require__("3zLD");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _victory = __webpack_require__("37UR");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var VIPLettersQuery = (0, _reactApollo.gql)(_templateObject);

var VIPLetters = function VIPLetters(_ref) {
  var data = _ref.data,
      className = _ref.className;

  if (data.loading) {
    return _react2.default.createElement(
      "div",
      { style: styles.cardStyles },
      _react2.default.createElement(
        _materialUi.Card,
        { style: styles.progressContainer },
        _react2.default.createElement(_materialUi.CardHeader, { title: "VIP Letters" }),
        _react2.default.createElement(_materialUi.CircularProgress, { style: styles.progressIndicator })
      )
    );
  }

  var vipLetters = data.adminReport.vipLetters;

  var endDate = (0, _moment2.default)().add(14, "days");

  var _JSON$parse = JSON.parse(vipLetters),
      toDraft = _JSON$parse.toDraft,
      toSend = _JSON$parse.toSend,
      total = _JSON$parse.total,
      sent = _JSON$parse.sent;

  return _react2.default.createElement(
    _materialUi.Card,
    { className: className },
    _react2.default.createElement(_materialUi.CardHeader, {
      title: "VIP Letters",
      subtitle: "of " + total + " due by " + endDate.format("DDMMM").toUpperCase()
    }),
    _react2.default.createElement(
      _materialUi.CardText,
      null,
      _react2.default.createElement(
        "ul",
        null,
        _react2.default.createElement(
          "li",
          null,
          _react2.default.createElement(
            "strong",
            null,
            toDraft
          ),
          " letters to draft of",
          " ",
          _react2.default.createElement(
            "strong",
            null,
            total
          )
        )
      ),
      _react2.default.createElement(_victory.VictoryPie, {
        colorScale: "warm",
        data: [{ x: "To Draft", y: toDraft }, { x: "Drafted", y: total }].sort(function (a, b) {
          if (a.y < b.y) {
            return -1;
          }
          if (a.y > b.y) {
            return 1;
          }

          return 0;
        })
      })
    )
  );
};

VIPLetters.propTypes = {
  data: _propTypes2.default.shape().isRequired,
  className: _propTypes2.default.string
};

VIPLetters.defaultProps = {
  className: ""
};

exports.default = (0, _reactApollo.graphql)(VIPLettersQuery, {
  options: {
    variables: {
      startDate: (0, _moment2.default)().format("YYYY-MM-DD"),
      endDate: (0, _moment2.default)().add(14, "days").format("YYYY-MM-DD")
    }
  }
})(VIPLetters);


var styles = {
  ListItemStyles: {
    width: "100%",
    display: "flex",
    justifyContent: "space-between",
    fontSize: 16,
    marginTop: 16,
    marginBottom: 16
  },
  progressContainer: {
    margin: 10,
    position: "relative"
  },
  progressIndicator: {
    marginLeft: "50%",
    left: -20
  }
};

/***/ }),

/***/ "OP5R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp2;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("RH2O");

var _materialUi = __webpack_require__("Q4lS");

var _delete = __webpack_require__("1Ilb");

var _delete2 = _interopRequireDefault(_delete);

var _aphrodite = __webpack_require__("BK4P");

var _InquiryActions = __webpack_require__("EJRV");

var InquiryActions = _interopRequireWildcard(_InquiryActions);

var _dates = __webpack_require__("5fJs");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SegmentListItem = (_dec = (0, _reactRedux.connect)(), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(SegmentListItem, _React$Component);

  function SegmentListItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, SegmentListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = SegmentListItem.__proto__ || Object.getPrototypeOf(SegmentListItem)).call.apply(_ref, [this].concat(args))), _this), _this.remove = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          index = _this$props.index;

      dispatch(InquiryActions.removeSegment(index));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(SegmentListItem, [{
    key: 'render',
    value: function render() {
      var _props$segment = this.props.segment,
          vendor = _props$segment.vendor,
          startDate = _props$segment.startDate,
          endDate = _props$segment.endDate;

      var datestring = startDate && endDate ? (0, _dates.dateString)(startDate, endDate) : '';

      return _react2.default.createElement(
        'li',
        { className: (0, _aphrodite.css)(styles.listItem) },
        _react2.default.createElement(
          'div',
          null,
          vendor || 'TBD',
          ' ',
          datestring
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _materialUi.IconButton,
            { className: (0, _aphrodite.css)(styles.buttonStyle), onTouchTap: this.remove },
            _react2.default.createElement(_delete2.default, null)
          )
        )
      );
    }
  }]);

  return SegmentListItem;
}(_react2.default.Component), _class2.propTypes = {
  index: _propTypes2.default.number.isRequired,
  segment: _propTypes2.default.shape().isRequired,
  dispatch: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
exports.default = SegmentListItem;


var styles = _aphrodite.StyleSheet.create({
  listItem: {
    width: 300,
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between'
  },
  buttonStyle: {
    height: 24,
    width: 24,
    padding: 0,
    position: 'relative',
    top: 5,
    marginRight: 5
  }
});

/***/ }),

/***/ "P3/v":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("Tc9k");

var _materialUi = __webpack_require__("Q4lS");

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _MergeVendors = __webpack_require__("iyi9");

var _MergeVendors2 = _interopRequireDefault(_MergeVendors);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Renderer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    windowHeight: state.Responsive.get('windowHeight')
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(Renderer, _React$Component);

  function Renderer() {
    _classCallCheck(this, Renderer);

    return _possibleConstructorReturn(this, (Renderer.__proto__ || Object.getPrototypeOf(Renderer)).apply(this, arguments));
  }

  _createClass(Renderer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          windowHeight = _props.windowHeight,
          _props$match$params = _props.match.params,
          toKeepId = _props$match$params.toKeepId,
          toMergeId = _props$match$params.toMergeId,
          goBack = _props.history.goBack;

      var top = (windowHeight - 161) / 2 + 161;

      var loadingEl = _react2.default.createElement(_materialUi.RefreshIndicator, {
        top: top,
        left: 900,
        status: 'loading'
      });
      var idString = toKeepId + ',' + toMergeId;

      return _react2.default.createElement(_reactRelay.QueryRenderer, {
        environment: _environment2.default,
        variables: {
          id: idString
        },
        query: _graphql || (_graphql = function _graphql() {
          return __webpack_require__("HdZY");
        }),
        render: function render(_ref) {
          var error = _ref.error,
              props = _ref.props;

          if (error) {
            return _react2.default.createElement(
              'div',
              null,
              error.message
            );
          } else if (props) {
            var _props$allVendors$edg = _slicedToArray(props.allVendors.edges, 2),
                toKeep = _props$allVendors$edg[0],
                toMerge = _props$allVendors$edg[1];

            return _react2.default.createElement(_MergeVendors2.default, {
              toKeep: toKeep.node,
              toMerge: toMerge.node,
              goBack: goBack
            });
          }

          return loadingEl;
        }
      });
    }
  }]);

  return Renderer;
}(_react2.default.Component), _class2.propTypes = {
  windowHeight: _propTypes2.default.number.isRequired,
  match: _propTypes2.default.shape({
    params: _propTypes2.default.shape({
      toKeepId: _propTypes2.default.string,
      toMergeId: _propTypes2.default.string
    })
  }).isRequired,
  history: _propTypes2.default.shape({
    goBack: _propTypes2.default.func
  }).isRequired
}, _temp)) || _class);
exports.default = Renderer;

/***/ }),

/***/ "PULU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 034aef2dfdb84dbf2b67daa35e5e71ee
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SegmentDetail_SetCheckbox_MutationVariables = {|
  input: {
    segmentId?: ?string;
    checkbox?: ?string;
    value?: ?boolean;
    clientMutationId?: ?string;
  };
|};

export type SegmentDetail_SetCheckbox_MutationResponse = {|
  +setCheckbox: ?{|
    +segment: ?{|
      +vipDrafted: boolean;
      +trip: ?{|
        +id: string;
        +draftVip: ?boolean;
        +history: ?$ReadOnlyArray<?{|
          +user: ?{|
            +firstName: string;
            +lastName: string;
          |};
          +comment: string;
          +dateCreated: any;
        |}>;
      |};
    |};
  |};
|};
*/

/*
mutation SegmentDetail_SetCheckbox_Mutation(
  $input: SetCheckboxInput!
) {
  setCheckbox(input: $input) {
    segment {
      vipDrafted
      trip {
        id
        draftVip
        history {
          user {
            firstName
            lastName
            id
          }
          comment
          dateCreated
          id
        }
      }
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "SetCheckboxInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "SegmentDetail_SetCheckbox_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "SetCheckboxInput!"
      }],
      "concreteType": "SetCheckboxPayload",
      "name": "setCheckbox",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Segment",
        "name": "segment",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "vipDrafted",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Trip",
          "name": "trip",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "draftVip",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Revision",
            "name": "history",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "User",
              "name": "user",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "firstName",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "lastName",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "comment",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "dateCreated",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "SegmentDetail_SetCheckbox_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "SetCheckboxInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "SegmentDetail_SetCheckbox_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "SetCheckboxInput!"
      }],
      "concreteType": "SetCheckboxPayload",
      "name": "setCheckbox",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Segment",
        "name": "segment",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "vipDrafted",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Trip",
          "name": "trip",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "draftVip",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Revision",
            "name": "history",
            "plural": true,
            "selections": [{
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "User",
              "name": "user",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "firstName",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "lastName",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "comment",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "dateCreated",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation SegmentDetail_SetCheckbox_Mutation(\n  $input: SetCheckboxInput!\n) {\n  setCheckbox(input: $input) {\n    segment {\n      vipDrafted\n      trip {\n        id\n        draftVip\n        history {\n          user {\n            firstName\n            lastName\n            id\n          }\n          comment\n          dateCreated\n          id\n        }\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "Pgvg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _getMuiTheme = __webpack_require__("K8T2");

var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);

var _firebase = __webpack_require__("kxiW");

var firebase = _interopRequireWildcard(_firebase);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _materialUi = __webpack_require__("Q4lS");

var _reactRedux = __webpack_require__("RH2O");

var _reactRouterDom = __webpack_require__("F8kA");

var _reactGoogleLogin = __webpack_require__("0hAu");

var _reactGoogleLogin2 = _interopRequireDefault(_reactGoogleLogin);

var _reactRelay = __webpack_require__("Tc9k");

var _exenv = __webpack_require__("u4m+");

var _exenv2 = _interopRequireDefault(_exenv);

var _aphrodite = __webpack_require__("BK4P");

var _Container = __webpack_require__("weyk");

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

var _Trips = __webpack_require__("78Lb");

var _Inquiry = __webpack_require__("Gm1F");

var _Vendors = __webpack_require__("xgZ9");

var _Clients = __webpack_require__("ruCO");

var _Segments = __webpack_require__("ydc5");

var _AuthActions = __webpack_require__("apKn");

var AuthActions = _interopRequireWildcard(_AuthActions);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _ResponsiveActions = __webpack_require__("yv5p");

var ResponsiveActions = _interopRequireWildcard(_ResponsiveActions);

var _Forms = __webpack_require__("KnFw");

var _Reports = __webpack_require__("dBMa");

var _Dashboard = __webpack_require__("Xra4");

var _Dashboard2 = _interopRequireDefault(_Dashboard);

var _RateQuoteGenerator = __webpack_require__("ZGSp");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AppContainer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    version: state.Auth.get("version"),
    username: state.Auth.get("username"),
    authenticated: state.Auth.get("authenticated")
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(AppContainer, _React$Component);

  function AppContainer(props) {
    _classCallCheck(this, AppContainer);

    var _this = _possibleConstructorReturn(this, (AppContainer.__proto__ || Object.getPrototypeOf(AppContainer)).call(this, props));

    _this.handleResize = function () {
      var dispatch = _this.props.dispatch;


      dispatch(ResponsiveActions.updateWindowWidth(window.innerWidth));
      dispatch(ResponsiveActions.updateWindowHeight(window.innerHeight));
    };

    _this.componentWillMount = function () {
      if (_exenv2.default.canUseDom) {
        _this.handleResize();
      }
    };

    _this.componentDidMount = function () {
      _this.checkVersion();
      _this.handleResize();
      window.addEventListener("resize", _this.handleResize);
      var storedJWT = localStorage.getItem("PPJWT");
      if (storedJWT) {
        _this.logIn({ ppToken: storedJWT });
      }
    };

    _this.componentWillUnmount = function () {
      window.removeEventListener("resize", _this.handleResize);
    };

    _this.checkVersion = function () {
      var _this$props = _this.props,
          release = _this$props.version,
          username = _this$props.username;


      if (username === "" || release === "LOCALDEV") {
        return;
      }

      var config = {
        apiKey: "AIzaSyB6MhtMfMoe1bcATV_JSm0poKsdzEmRjUE",
        authDomain: "ping-pong-1322.firebaseapp.com",
        databaseURL: "https://ping-pong-1322.firebaseio.com",
        storageBucket: "ping-pong-1322.appspot.com",
        messagingSenderId: "980255644690"
      };
      if (!firebase.apps.length) {
        firebase.initializeApp(config);
      }
      var database = firebase.database();
      database.ref("clients/" + username).set({
        release: release,
        timestamp: (0, _moment2.default)().format()
      });

      database.ref("server/frontend").on("value", function (snapshot) {
        var _snapshot$val = snapshot.val(),
            serverRelease = _snapshot$val.release,
            serverTimestamp = _snapshot$val.timestamp;

        if (release !== _this.state.release || serverRelease !== _this.state.serverRelease) {
          _this.setState({ release: release, serverRelease: serverRelease, serverTimestamp: serverTimestamp });
        }
      });
    };

    _this.acknowledge = function () {
      _this.setState({
        acknowledged: true
      });
    };

    _this.authSuccess = function (response) {
      var tokenId = response.tokenId;

      _this.logIn({ gidToken: tokenId });
    };

    _this.authFailure = function () {
      _this.props.dispatch(AuthActions.logout());
    };

    _this.logIn = function (input) {
      (0, _reactRelay.commitMutation)(_environment2.default, {
        mutation: _graphql || (_graphql = function _graphql() {
          return __webpack_require__("gPj6");
        }),
        variables: { input: input },
        onCompleted: function onCompleted(response) {
          var token = response.logIn.token;


          if (token === null) {
            _this.props.dispatch(AuthActions.logout());
          } else {
            var ppjwt = token.token,
                _token$user = token.user,
                id = _token$user.id,
                username = _token$user.username,
                firstName = _token$user.firstName,
                lastName = _token$user.lastName,
                isStaff = _token$user.isStaff,
                isSuperuser = _token$user.isSuperuser,
                groups = _token$user.groups;


            localStorage.setItem("PPJWT", ppjwt);
            _this.props.dispatch(AuthActions.setAuthData({
              authenticated: true,
              ppjwt: ppjwt,
              id: id,
              username: username,
              firstName: firstName,
              lastName: lastName,
              isStaff: isStaff,
              isSuperuser: isSuperuser,
              groups: groups
            }));
          }
        },
        onError: function onError(err) {
          return alert(err);
        }
      });
    };

    _this.state = {
      release: "",
      timestamp: "",
      serverRelease: "",
      serverTimestamp: "",
      acknowledged: false
    };
    return _this;
  }

  _createClass(AppContainer, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        muiTheme: (0, _getMuiTheme2.default)(_ourismanTravelTheme2.default)
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.checkVersion();
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          authenticated = _props.authenticated,
          history = _props.history;
      var _state = this.state,
          release = _state.release,
          serverRelease = _state.serverRelease,
          serverTimestamp = _state.serverTimestamp,
          acknowledged = _state.acknowledged;


      var displayServerTimestamp = (0, _moment2.default)(serverTimestamp).fromNow();

      // TODO: figure out what's up with Firebase and turn this back on!
      // const outOfDate = release !== serverRelease && !acknowledged;
      var outOfDate = false;

      var actions = [_react2.default.createElement(_materialUi.FlatButton, { label: "Acknowledge", primary: true, onTouchTap: this.acknowledge })];

      return _react2.default.createElement(
        "div",
        { id: "app-container" },
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            title: "Ping Pong has Been Updated",
            modal: true,
            open: outOfDate,
            actions: actions
          },
          "Ping Pong has been updated to version ",
          serverRelease,
          " as of\xA0",
          displayServerTimestamp,
          ". You are still using version ",
          release,
          ". Please reload the page once you have completed what you are currently working on."
        ),
        _react2.default.createElement(_Container.Header, { history: history }),
        _react2.default.createElement(_Container.NavBar, null),
        _react2.default.createElement(
          _Container.Body,
          null,
          authenticated ? _react2.default.createElement(
            _reactRouterDom.Switch,
            null,
            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: "/", component: _Dashboard2.default }),
            _react2.default.createElement(_reactRouterDom.Route, {
              path: "/trips/:tripId/segments/:segmentId/",
              component: _Segments.SegmentDetail
            }),
            _react2.default.createElement(_reactRouterDom.Route, { path: "/trips/:tripId?", component: _Trips.Trips }),
            _react2.default.createElement(_reactRouterDom.Route, { path: "/quote/", component: _RateQuoteGenerator.RateQuoteGenerator }),
            _react2.default.createElement(_reactRouterDom.Route, { path: "/inquiry/", component: _Inquiry.InquiryForm }),
            _react2.default.createElement(_reactRouterDom.Route, { path: "/reports/:selectedTab?", component: _Reports.Reports }),
            _react2.default.createElement(_reactRouterDom.Route, {
              path: "/vendors/:toKeepId/merge/:toMergeId/",
              component: _Vendors.MergeVendors
            }),
            _react2.default.createElement(_reactRouterDom.Route, { path: "/vendors/:vendorId?", component: _Vendors.Vendors }),
            _react2.default.createElement(_reactRouterDom.Route, { path: "/clients/:clientId?", component: _Clients.Clients }),
            _react2.default.createElement(_reactRouterDom.Route, {
              path: "/forms/responses/:responseId?",
              component: _Forms.Responses
            })
          ) : _react2.default.createElement(
            "div",
            { className: (0, _aphrodite.css)(styles.loggedOut) },
            _react2.default.createElement(
              _materialUi.Card,
              { className: (0, _aphrodite.css)(styles.logInBox) },
              _react2.default.createElement(
                _materialUi.CardText,
                null,
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.logInBoxContent) },
                  _react2.default.createElement(
                    "p",
                    null,
                    "You are not currently logged in"
                  ),
                  _react2.default.createElement(_reactGoogleLogin2.default, {
                    clientId: "980255644690-l42ac2t0r87qam6mg89bcs8g0f3jiffc.apps.googleusercontent.com",
                    onSuccess: this.authSuccess,
                    onFailure: this.authFailure,
                    prompt: "select_account",
                    className: (0, _aphrodite.css)(styles.buttonStyle),
                    redirectUri: "https://ourismantravel.pingpong.travel/accounts/google/login/callback/"
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return AppContainer;
}(_react2.default.Component), _class2.propTypes = {
  version: _propTypes2.default.string.isRequired,
  username: _propTypes2.default.string.isRequired,
  authenticated: _propTypes2.default.bool.isRequired,
  history: _propTypes2.default.shape({
    push: _propTypes2.default.func
  }).isRequired,
  dispatch: _propTypes2.default.func.isRequired
}, _class2.defaultProps = {
  username: ""
}, _temp)) || _class);


AppContainer.WrappedComponent.childContextTypes = {
  muiTheme: _propTypes2.default.object
};

exports.default = (0, _reactRouterDom.withRouter)(AppContainer);


var styles = _aphrodite.StyleSheet.create({
  loggedOut: {
    display: "flex",
    height: "calc(100vh - 64px)",
    justifyContent: "center"
  },
  logInBox: {
    alignSelf: "center",
    fontSize: 14,
    fontWeight: "bold",
    marginBottom: 5
  },
  buttonStyle: {
    background: _ourismanTravelTheme2.default.palette.accent1Color,
    border: "1px solid transparent",
    borderRadius: 2,
    color: _ourismanTravelTheme2.default.palette.canvasColor,
    display: "inline-block",
    fontSize: 16,
    fontWeight: "bold",
    paddingBottom: 10,
    paddingTop: 10,
    width: 190
  },
  logInBoxContent: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column"
  }
});

/***/ }),

/***/ "QM2w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _materialUi = __webpack_require__("Q4lS");

var _reactRouterDom = __webpack_require__("F8kA");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _rest = __webpack_require__("i4WM");

var _rest2 = _interopRequireDefault(_rest);

var _NotesComponent = __webpack_require__("WsVO");

var _NotesComponent2 = _interopRequireDefault(_NotesComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SimilarVendors = function SimilarVendors(props) {
  var toKeep = props.toKeep,
      vendors = props.vendors;


  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h3',
      null,
      'Similar Vendors by Name'
    ),
    _react2.default.createElement(
      'ul',
      null,
      vendors.map(function (vendor) {
        return _react2.default.createElement(
          'li',
          { key: vendor.relayId },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/vendors/' + vendor.relayId + '/' },
            vendor.name
          ),
          '\xA0(',
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/vendors/' + toKeep + '/merge/' + vendor.relayId + '/' },
            'merge'
          ),
          ')'
        );
      })
    )
  );
};

SimilarVendors.propTypes = {
  toKeep: _propTypes2.default.string.isRequired,
  vendors: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
};

var AmenityPrograms = function AmenityPrograms(props) {
  var programs = props.programs;


  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h3',
      null,
      'Amenity Programs'
    ),
    _react2.default.createElement(
      'ul',
      null,
      programs.map(function (program, index) {
        return _react2.default.createElement(
          'li',
          { key: index },
          program
        );
      })
    )
  );
};

AmenityPrograms.propTypes = {
  programs: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired
};

var Contact = function Contact(_ref) {
  var contact = _ref.contact;
  var email = contact.email,
      _contact$name = contact.name,
      name = _contact$name === undefined ? '' : _contact$name,
      _contact$position = contact.position,
      position = _contact$position === undefined ? '' : _contact$position;


  var displayString = email;
  var nameString = name;
  if (position !== '') {
    nameString = name + ' (' + position + ')';
  }
  if (nameString !== '') {
    displayString = nameString + ' <' + email + '>';
  }

  return _react2.default.createElement(
    'span',
    null,
    displayString
  );
};

Contact.propTypes = {
  contact: _propTypes2.default.shape({
    email: _propTypes2.default.string,
    name: _propTypes2.default.string,
    position: _propTypes2.default.string
  }).isRequired
};

var Contacts = function Contacts(_ref2) {
  var contacts = _ref2.contacts;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h3',
      null,
      'Contacts'
    ),
    _react2.default.createElement(
      'ul',
      null,
      contacts.map(function (contact, index) {
        return _react2.default.createElement(
          'li',
          { key: index },
          _react2.default.createElement(Contact, { contact: contact })
        );
      })
    )
  );
};

Contacts.propTypes = {
  contacts: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
};

var Travelers = function Travelers(_ref3) {
  var travelers = _ref3.travelers;
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'h3',
      null,
      'Travelers'
    ),
    _react2.default.createElement(
      'ul',
      null,
      travelers.map(function (_ref4) {
        var id = _ref4.id,
            fullName = _ref4.fullName;
        return _react2.default.createElement(
          'li',
          { key: id },
          _react2.default.createElement(
            _reactRouterDom.Link,
            { to: '/clients/' + id + '/' },
            fullName
          )
        );
      })
    )
  );
};

Travelers.propTypes = {
  travelers: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
};

var VendorDetail = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    viewport: state.Responsive.get('viewport'),
    windowHeight: state.Responsive.get('windowHeight')
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(VendorDetail, _React$Component);

  function VendorDetail(props) {
    _classCallCheck(this, VendorDetail);

    var _this = _possibleConstructorReturn(this, (VendorDetail.__proto__ || Object.getPrototypeOf(VendorDetail)).call(this, props));

    _this.findSimilarVendors = function (name) {
      (0, _rest2.default)('auto/vendor', name).then(function (response) {
        var objects = response.objects;

        _this.setState({
          similarVendors: objects.filter(function (_ref5) {
            var score = _ref5.score;
            return score >= 1;
          }).map(function (object) {
            return {
              relayId: object.relayId,
              name: object.name,
              sabreCode: object.sabreCode
            };
          })
        });
      }).catch(function (response) {
        console.log(response);
      });
    };

    _this.state = {
      similarVendors: []
    };
    return _this;
  }

  _createClass(VendorDetail, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.findSimilarVendors(this.props.vendor.name);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var oldId = this.props.vendor.id;
      var _nextProps$vendor = nextProps.vendor,
          newId = _nextProps$vendor.id,
          newName = _nextProps$vendor.name;


      if (oldId !== newId) {
        this.findSimilarVendors(newName);
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          viewport = _props.viewport,
          _props$vendor = _props.vendor,
          name = _props$vendor.name,
          id = _props$vendor.id,
          sabreCode = _props$vendor.sabreCode,
          contacts = _props$vendor.contacts,
          amenityPrograms = _props$vendor.amenityPrograms,
          travelers = _props$vendor.travelers,
          profileNotes = _props$vendor.profileNotes,
          windowHeight = _props.windowHeight;
      var similarVendors = this.state.similarVendors;


      var tripColumnStyles = viewport === 'desktop' ? _extends({
        height: windowHeight - 64
      }, styles.columnStyles, styles.desktopColumnStyles) : _extends({
        height: windowHeight - 64
      }, styles.columnStyles, styles.mobileColumnStyles);

      var dupes = similarVendors.filter(function (vendor) {
        return vendor.relayId !== id && (!sabreCode || !vendor.sabreCode || sabreCode && vendor.sabreCode && sabreCode === vendor.sabreCode);
      }).sort(function (_ref6, _ref7) {
        var name1 = _ref6.name;
        var name2 = _ref7.name;

        if (name1 < name2) {
          return -1;
        } else if (name1 > name2) {
          return 1;
        }
        return 0;
      });

      var contactList = contacts ? JSON.parse(contacts) : [];

      return _react2.default.createElement(
        _materialUi.Card,
        { style: tripColumnStyles },
        _react2.default.createElement(
          _materialUi.CardHeader,
          null,
          _react2.default.createElement(
            'h1',
            null,
            name
          ),
          _react2.default.createElement(
            'p',
            null,
            'Sabre Code: ',
            sabreCode || 'unknown'
          )
        ),
        _react2.default.createElement(
          _materialUi.CardText,
          null,
          _react2.default.createElement(
            _materialUi.Card,
            null,
            _react2.default.createElement(_materialUi.CardHeader, { title: 'Profile Notes' }),
            _react2.default.createElement(
              _materialUi.CardText,
              null,
              _react2.default.createElement(_NotesComponent2.default, { id: id, fieldName: 'profileNotes', value: profileNotes })
            )
          ),
          contactList.length > 0 ? _react2.default.createElement(Contacts, { contacts: contactList }) : null,
          amenityPrograms.length > 0 ? _react2.default.createElement(AmenityPrograms, { programs: amenityPrograms }) : null,
          dupes.length > 0 ? _react2.default.createElement(SimilarVendors, { toKeep: id, vendors: dupes }) : null,
          travelers.length > 0 ? _react2.default.createElement(Travelers, { travelers: travelers }) : null
        )
      );
    }
  }]);

  return VendorDetail;
}(_react2.default.Component), _class2.propTypes = {
  viewport: _propTypes2.default.string.isRequired,
  windowHeight: _propTypes2.default.number.isRequired,
  vendor: _propTypes2.default.shape().isRequired
}, _temp)) || _class);
exports.default = VendorDetail;


var styles = {
  columnStyles: {
    overflow: 'scroll',
    position: 'relative'
  },
  desktopColumnStyles: {
    width: 700
  },
  mobileColumnStyles: {
    width: '100%'
  }
};

/***/ }),

/***/ "RNKu":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _ActionTypes = __webpack_require__("zLtr");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _createReducer2 = __webpack_require__("AA0U");

var _createReducer3 = _interopRequireDefault(_createReducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = _immutable2.default.fromJS({
  inquiry: _immutable2.default.fromJS({
    tripDetails: {
      id: '',
      inbox: '',
      category: '',
      destination: '',
      travelStartDate: '',
      travelEndDate: '',
      specificDates: true,
      timeframe: '',
      selectedUser: '',
      notes: '',
      vipNotes: '',
      editing: true
    },
    travelers: [],
    itinerary: []
  }),
  meta: _immutable2.default.fromJS({
    addingTraveler: true,
    addingSegment: false,
    showOverview: true
  })
});

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _ActionTypes2.default.Inquiry.toggleNewTraveler, function (state, _ref) {
  var value = _ref.value;

  return state.setIn(['meta', 'addingTraveler'], value);
}), _defineProperty(_createReducer, _ActionTypes2.default.Inquiry.addTraveler, function (state, _ref2) {
  var traveler = _ref2.traveler;

  var travelers = state.getIn(['inquiry', 'travelers']);
  return state.setIn(['inquiry', 'travelers'], travelers.push(traveler)).setIn(['meta', 'addingTraveler'], false);
}), _defineProperty(_createReducer, _ActionTypes2.default.Inquiry.moveTraveler, function (state, _ref3) {
  var start = _ref3.start,
      end = _ref3.end;

  var travelers = state.getIn(['inquiry', 'travelers']);
  var target = travelers.get(start);

  return state.setIn(['inquiry', 'travelers'], travelers.delete(start).insert(end, target));
}), _defineProperty(_createReducer, _ActionTypes2.default.Inquiry.removeTraveler, function (state, _ref4) {
  var index = _ref4.index;

  return state.deleteIn(['inquiry', 'travelers', index]);
}), _defineProperty(_createReducer, _ActionTypes2.default.Inquiry.removeSegment, function (state, _ref5) {
  var index = _ref5.index;

  return state.deleteIn(['inquiry', 'itinerary', index]);
}), _defineProperty(_createReducer, _ActionTypes2.default.Inquiry.updateField, function (state, _ref6) {
  var field = _ref6.field,
      value = _ref6.value;

  return state.setIn(field, value);
}), _defineProperty(_createReducer, _ActionTypes2.default.Inquiry.addSegment, function (state, _ref7) {
  var segment = _ref7.segment;

  var itinerary = state.getIn(['inquiry', 'itinerary']);
  return state.setIn(['inquiry', 'itinerary'], itinerary.push(segment));
}), _defineProperty(_createReducer, _ActionTypes2.default.Inquiry.resetInquiryForm, function () {
  return initialState;
}), _createReducer));

/***/ }),

/***/ "Rh7a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash ae9ed04701f9261390286d7f62782d26
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SegmentDetailRenderer_SegmentDetails_QueryResponse = {|
  +allUsers: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +firstName: string;
      |};
    |}>;
  |};
  +segment: ?{|
    +id: string;
    +name: ?string;
    +vendor: ?{|
      +id: string;
      +name: string;
      +amenityPrograms: ?$ReadOnlyArray<?string>;
      +contacts: ?any;
    |};
    +dateString: ?string;
    +startDate: ?string;
    +endDate: ?string;
    +category: ?string;
    +bedType: ?string;
    +amenityProgram: ?string;
    +numAdults: ?number;
    +numChildren: ?number;
    +smokingRoom: ?boolean;
    +rates: ?$ReadOnlyArray<?number>;
    +currency: string;
    +averageDailyRate: boolean;
    +cancellationDeadline: ?any;
    +dropbox: boolean;
    +invoiced: boolean;
    +vipDrafted: boolean;
    +booked: boolean;
    +cancelled: boolean;
    +sabreLocator: string;
    +confirmationNumber: string;
    +cancellationNumber: string;
    +vipLetter: string;
    +vipContext: ?any;
    +notes: ?$ReadOnlyArray<?{|
      +id: string;
      +owner: {|
        +id: string;
        +firstName: string;
      |};
      +content: string;
      +created: any;
    |}>;
    +trip: ?{|
      +id: string;
      +searchId: ?string;
      +tripName: ?string;
      +primaryTravelerName: ?string;
      +destination: string;
      +dateString: ?string;
      +inquiry: boolean;
      +active: boolean;
      +cancelled: boolean;
      +inbox: ?string;
      +created: any;
      +modified: any;
      +tier: ?number;
      +fired: boolean;
      +lowPriority: boolean;
      +needsTraining: boolean;
      +needsVetting: boolean;
      +insideCircle: boolean;
      +vipNotes: string;
      +travelers: ?$ReadOnlyArray<?{|
        +id: string;
        +fullName: ?string;
        +firstName: string;
        +lastName: string;
        +birthdate: ?any;
        +adult: boolean;
        +vipNotes: string;
      |}>;
      +notes: ?$ReadOnlyArray<?{|
        +owner: {|
          +id: string;
          +firstName: string;
        |};
        +content: string;
        +created: any;
      |}>;
      +segments: ?$ReadOnlyArray<?{|
        +id: string;
        +name: ?string;
        +dropbox: boolean;
        +invoiced: boolean;
        +vipDrafted: boolean;
        +booked: boolean;
        +cancelled: boolean;
      |}>;
    |};
  |};
|};
*/

/*
query SegmentDetailRenderer_SegmentDetails_Query(
  $segmentId: ID!
) {
  allUsers {
    edges {
      node {
        firstName
        id
      }
    }
  }
  segment(id: $segmentId) {
    averageDailyRate
    id
    vendor {
      id
      name
      amenityPrograms
      contacts
    }
    dateString
    startDate
    endDate
    category
    bedType
    amenityProgram
    numAdults
    numChildren
    smokingRoom
    rates
    currency
    name
    cancellationDeadline
    dropbox
    invoiced
    vipDrafted
    booked
    cancelled
    sabreLocator
    confirmationNumber
    cancellationNumber
    vipLetter
    vipContext
    notes {
      id
      owner {
        id
        firstName
      }
      content
      created
    }
    trip {
      modified
      id
      tripName
      primaryTravelerName
      destination
      dateString
      inquiry
      active
      cancelled
      inbox
      created
      searchId
      tier
      fired
      lowPriority
      needsTraining
      needsVetting
      insideCircle
      vipNotes
      travelers {
        id
        fullName
        firstName
        lastName
        birthdate
        adult
        vipNotes
      }
      notes {
        owner {
          id
          firstName
        }
        content
        created
        id
      }
      segments {
        id
        name
        dropbox
        invoiced
        vipDrafted
        booked
        cancelled
      }
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "segmentId",
      "type": "ID!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "SegmentDetailRenderer_SegmentDetails_Query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "UserConnection",
      "name": "allUsers",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "UserEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "User",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstName",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "id",
        "variableName": "segmentId",
        "type": "ID!"
      }],
      "concreteType": "Segment",
      "name": "segment",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "averageDailyRate",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Vendor",
        "name": "vendor",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "amenityPrograms",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "contacts",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "dateString",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "startDate",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "endDate",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "category",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "bedType",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "amenityProgram",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "numAdults",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "numChildren",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "smokingRoom",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "rates",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "currency",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "name",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "cancellationDeadline",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "dropbox",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "invoiced",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "vipDrafted",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "booked",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "cancelled",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "sabreLocator",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "confirmationNumber",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "cancellationNumber",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "vipLetter",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "vipContext",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Note",
        "name": "notes",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "User",
          "name": "owner",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstName",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "content",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "created",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "modified",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tripName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "primaryTravelerName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "destination",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dateString",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "inquiry",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "active",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancelled",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "inbox",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "created",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "searchId",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tier",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "fired",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "lowPriority",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "needsTraining",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "needsVetting",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "insideCircle",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "vipNotes",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Traveler",
          "name": "travelers",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "fullName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "lastName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "birthdate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "adult",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "vipNotes",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Note",
          "name": "notes",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "owner",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "firstName",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "content",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "created",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Segment",
          "name": "segments",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dropbox",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "invoiced",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "vipDrafted",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "booked",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancelled",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "SegmentDetailRenderer_SegmentDetails_Query",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "segmentId",
      "type": "ID!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "SegmentDetailRenderer_SegmentDetails_Query",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "UserConnection",
      "name": "allUsers",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "UserEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "User",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "id",
        "variableName": "segmentId",
        "type": "ID!"
      }],
      "concreteType": "Segment",
      "name": "segment",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "name",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "averageDailyRate",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Vendor",
        "name": "vendor",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "amenityPrograms",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "contacts",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "dateString",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "startDate",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "endDate",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "category",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "bedType",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "amenityProgram",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "numAdults",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "numChildren",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "smokingRoom",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "rates",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "currency",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "cancellationDeadline",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "dropbox",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "invoiced",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "vipDrafted",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "booked",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "cancelled",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "sabreLocator",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "confirmationNumber",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "cancellationNumber",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "vipLetter",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "vipContext",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Note",
        "name": "notes",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "User",
          "name": "owner",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstName",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "content",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "created",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "searchId",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "modified",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tripName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "primaryTravelerName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "destination",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dateString",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "inquiry",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "active",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancelled",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "inbox",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "created",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tier",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "fired",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "lowPriority",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "needsTraining",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "needsVetting",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "insideCircle",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "vipNotes",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Traveler",
          "name": "travelers",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "fullName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "lastName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "birthdate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "adult",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "vipNotes",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Note",
          "name": "notes",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "owner",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "firstName",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "content",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "created",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Segment",
          "name": "segments",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dropbox",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "invoiced",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "vipDrafted",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "booked",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancelled",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "query SegmentDetailRenderer_SegmentDetails_Query(\n  $segmentId: ID!\n) {\n  allUsers {\n    edges {\n      node {\n        firstName\n        id\n      }\n    }\n  }\n  segment(id: $segmentId) {\n    averageDailyRate\n    id\n    vendor {\n      id\n      name\n      amenityPrograms\n      contacts\n    }\n    dateString\n    startDate\n    endDate\n    category\n    bedType\n    amenityProgram\n    numAdults\n    numChildren\n    smokingRoom\n    rates\n    currency\n    name\n    cancellationDeadline\n    dropbox\n    invoiced\n    vipDrafted\n    booked\n    cancelled\n    sabreLocator\n    confirmationNumber\n    cancellationNumber\n    vipLetter\n    vipContext\n    notes {\n      id\n      owner {\n        id\n        firstName\n      }\n      content\n      created\n    }\n    trip {\n      modified\n      id\n      tripName\n      primaryTravelerName\n      destination\n      dateString\n      inquiry\n      active\n      cancelled\n      inbox\n      created\n      searchId\n      tier\n      fired\n      lowPriority\n      needsTraining\n      needsVetting\n      insideCircle\n      vipNotes\n      travelers {\n        id\n        fullName\n        firstName\n        lastName\n        birthdate\n        adult\n        vipNotes\n      }\n      notes {\n        owner {\n          id\n          firstName\n        }\n        content\n        created\n        id\n      }\n      segments {\n        id\n        name\n        dropbox\n        invoiced\n        vipDrafted\n        booked\n        cancelled\n      }\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "RtMB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 63b0498d515df1e5380043449581bcab
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ClientListRenderer_ClientList_QueryResponse = {|
  +allTravelers: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string;
        +fullName: ?string;
        +displayName: string;
        +isPrimaryTraveler: boolean;
        +primaryTraveler: ?{|
          +fullName: ?string;
          +displayName: string;
        |};
      |};
    |}>;
  |};
|};
*/

/*
query ClientListRenderer_ClientList_Query {
  allTravelers {
    edges {
      node {
        id
        fullName
        displayName
        isPrimaryTraveler
        primaryTraveler {
          fullName
          displayName
          id
        }
      }
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientListRenderer_ClientList_Query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "TravelerConnection",
      "name": "allTravelers",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "TravelerEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Traveler",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "fullName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "displayName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isPrimaryTraveler",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Traveler",
            "name": "primaryTraveler",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "fullName",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "displayName",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ClientListRenderer_ClientList_Query",
  "query": {
    "argumentDefinitions": [],
    "kind": "Root",
    "name": "ClientListRenderer_ClientList_Query",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "TravelerConnection",
      "name": "allTravelers",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "TravelerEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Traveler",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "fullName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "displayName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isPrimaryTraveler",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Traveler",
            "name": "primaryTraveler",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "fullName",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "displayName",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "query ClientListRenderer_ClientList_Query {\n  allTravelers {\n    edges {\n      node {\n        id\n        fullName\n        displayName\n        isPrimaryTraveler\n        primaryTraveler {\n          fullName\n          displayName\n          id\n        }\n      }\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "Scq2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _exenv = __webpack_require__("u4m+");

var _exenv2 = _interopRequireDefault(_exenv);

var _materialUi = __webpack_require__("Q4lS");

var _ClientDetailsRenderer = __webpack_require__("ea+w");

var _ClientDetailsRenderer2 = _interopRequireDefault(_ClientDetailsRenderer);

var _ClientListRenderer = __webpack_require__("BVsG");

var _ClientListRenderer2 = _interopRequireDefault(_ClientListRenderer);

var _styles = __webpack_require__("DsNi");

var _styles2 = _interopRequireDefault(_styles);

var _ClientListFilters = __webpack_require__("mcCO");

var _ClientListFilters2 = _interopRequireDefault(_ClientListFilters);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Clients = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    viewport: state.Responsive.get('viewport'),
    windowHeight: state.Responsive.get('windowHeight')
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(Clients, _React$Component);

  function Clients(props) {
    _classCallCheck(this, Clients);

    var _this = _possibleConstructorReturn(this, (Clients.__proto__ || Object.getPrototypeOf(Clients)).call(this, props));

    _this.state = {
      onClient: false
    };
    return _this;
  }

  _createClass(Clients, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.setState({ onClient: _exenv2.default.canUseDom });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ onClient: true }); // eslint-disable-line
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          viewport = _props.viewport,
          activeClient = _props.match.params.clientId,
          windowHeight = _props.windowHeight;
      var onClient = this.state.onClient;

      var top = (windowHeight - 161) / 2 + 161;

      var ActiveClient = _react2.default.createElement(_ClientDetailsRenderer2.default, { activeClient: activeClient });

      if (viewport !== 'desktop' && activeClient) {
        return ActiveClient;
      }

      var loadingEl = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ClientListFilters2.default, { updateFilter: function updateFilter() {
            return null;
          } }),
        _react2.default.createElement(_materialUi.RefreshIndicator, { top: top, left: 277, status: 'loading' })
      );

      return _react2.default.createElement(
        'div',
        { className: _styles2.default.container },
        _react2.default.createElement(
          'div',
          { className: _styles2.default.list },
          onClient ? _react2.default.createElement(_ClientListRenderer2.default, {
            activeClient: activeClient,
            loadingEl: loadingEl
          }) : loadingEl
        ),
        _react2.default.createElement(
          'div',
          { className: _styles2.default.detail },
          activeClient ? ActiveClient : null
        )
      );
    }
  }]);

  return Clients;
}(_react2.default.Component), _class2.propTypes = {
  viewport: _propTypes2.default.string.isRequired,
  match: _propTypes2.default.shape({
    params: _propTypes2.default.object
  }).isRequired,
  windowHeight: _propTypes2.default.number.isRequired
}, _temp)) || _class);
exports.default = Clients;

/***/ }),

/***/ "TZ1C":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__("Q4lS");

var _styles = __webpack_require__("IQwA");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var VendorListFilter = (_temp = _class = function (_React$Component) {
  _inherits(VendorListFilter, _React$Component);

  function VendorListFilter() {
    _classCallCheck(this, VendorListFilter);

    return _possibleConstructorReturn(this, (VendorListFilter.__proto__ || Object.getPrototypeOf(VendorListFilter)).apply(this, arguments));
  }

  _createClass(VendorListFilter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          numVendors = _props.numVendors,
          numFiltered = _props.numFiltered,
          updateFilter = _props.updateFilter,
          filter = _props.filter;


      return _react2.default.createElement(
        'div',
        { className: _styles2.default.listFilter },
        _react2.default.createElement(
          'div',
          { className: _styles2.default.tripListFilters },
          _react2.default.createElement(
            'div',
            { className: _styles2.default.filter },
            _react2.default.createElement(_materialUi.TextField, {
              floatingLabelText: 'Filter vendors by name',
              onChange: updateFilter,
              value: filter
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _styles2.default.infoLine },
          numFiltered,
          ' (of ',
          numVendors,
          ') vendors displayed'
        )
      );
    }
  }]);

  return VendorListFilter;
}(_react2.default.Component), _class.propTypes = {
  numVendors: _propTypes2.default.number,
  numFiltered: _propTypes2.default.number,
  updateFilter: _propTypes2.default.func.isRequired,
  filter: _propTypes2.default.string
}, _class.defaultProps = {
  numVendors: 0,
  numFiltered: 0,
  filter: ''
}, _temp);
exports.default = VendorListFilter;

/***/ }),

/***/ "U1G/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _templateObject = _taggedTemplateLiteral(['\nquery TravelStatusQuery($startDate: String!, $endDate: String!) {\n  allTrips(startDate: $startDate, endDate: $endDate) {\n    edges {\n      node {\n        id,\n        tripName,\n        dateString,\n        startDate,\n        endDate,\n      }\n    }\n  }\n}\n'], ['\nquery TravelStatusQuery($startDate: String!, $endDate: String!) {\n  allTrips(startDate: $startDate, endDate: $endDate) {\n    edges {\n      node {\n        id,\n        tripName,\n        dateString,\n        startDate,\n        endDate,\n      }\n    }\n  }\n}\n']);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__("Q4lS");

var _reactApollo = __webpack_require__("3zLD");

var _aphrodite = __webpack_require__("BK4P");

var _reactRouterDom = __webpack_require__("F8kA");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _momentRange = __webpack_require__("l5j/");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var moment = (0, _momentRange.extendMoment)(_moment2.default);

var TravelStatusQuery = (0, _reactApollo.gql)(_templateObject);

var TravelStatus = (_dec = (0, _reactApollo.graphql)(TravelStatusQuery, {
  options: {
    variables: {
      startDate: moment().format('YYYY-MM-DD'),
      endDate: moment().add(14, 'days').format('YYYY-MM-DD')
    }
  }
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(TravelStatus, _React$Component);

  function TravelStatus(props) {
    _classCallCheck(this, TravelStatus);

    var _this = _possibleConstructorReturn(this, (TravelStatus.__proto__ || Object.getPrototypeOf(TravelStatus)).call(this, props));

    _this.selectDay = function (selectedDay) {
      return function () {
        _this.setState({ selectedDay: selectedDay });
      };
    };

    _this.state = {
      selectedDay: moment(props.data.variables.startDate).format('DDMMM').toUpperCase()
    };
    return _this;
  }

  _createClass(TravelStatus, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          data = _props.data,
          className = _props.className;


      if (data.loading) {
        return _react2.default.createElement(
          'div',
          { style: styles.cardStyles },
          _react2.default.createElement(
            _materialUi.Card,
            { className: (0, _aphrodite.css)(styles.progressContainer) },
            _react2.default.createElement(_materialUi.CardHeader, { title: 'Departures and returns' }),
            _react2.default.createElement(_materialUi.CircularProgress, { className: (0, _aphrodite.css)(styles.progressIndicator) })
          )
        );
      }

      var trips = data.allTrips.edges,
          _data$variables = data.variables,
          startDate = _data$variables.startDate,
          endDate = _data$variables.endDate;

      var momentStartDate = moment(startDate);
      var momentEndDate = moment(endDate);
      var dateRange = moment.range(startDate, endDate);

      var departuresByDay = {};
      var returnsByDay = {};
      trips.forEach(function (_ref) {
        var trip = _ref.node;

        var tripStartDate = moment(trip.startDate);
        var tripEndDate = moment(trip.endDate);
        var key = void 0;
        var list = void 0;
        if (momentStartDate <= tripStartDate || momentEndDate > tripStartDate) {
          key = tripStartDate.format('DDMMM').toUpperCase();
          list = departuresByDay[key] || [];
          list.push(trip);
          departuresByDay[key] = list;
        }
        if (momentStartDate <= tripEndDate || momentEndDate > tripEndDate) {
          key = tripEndDate.format('DDMMM').toUpperCase();
          list = returnsByDay[key] || [];
          list.push(trip);
          returnsByDay[key] = list;
        }
      });

      var selectedDay = this.state.selectedDay;

      var departing = departuresByDay[selectedDay] || [];
      var returning = returnsByDay[selectedDay] || [];

      return _react2.default.createElement(
        _materialUi.Card,
        { className: className },
        _react2.default.createElement(_materialUi.CardHeader, {
          title: 'Departures and Returns',
          subtitle: (momentStartDate.format('DDMMM') + ' - ' + momentEndDate.subtract(1, 'days').format('DDMMM')).toUpperCase()
        }),
        _react2.default.createElement(
          _materialUi.CardText,
          { className: (0, _aphrodite.css)(styles.days) },
          Array.from(dateRange.by('days', { exclusive: true })).map(function (day) {
            return _react2.default.createElement(
              _materialUi.Paper,
              {
                key: day.format(),
                className: (0, _aphrodite.css)(styles.day),
                onClick: _this2.selectDay(day.format('DDMMM').toUpperCase())
              },
              _react2.default.createElement(
                'div',
                { className: (0, _aphrodite.css)(styles.dayHeader) },
                day.format('DDMMM').toUpperCase()
              ),
              _react2.default.createElement(
                'div',
                null,
                (departuresByDay[day.format('DDMMM').toUpperCase()] || []).length,
                ' departures'
              ),
              _react2.default.createElement(
                'div',
                null,
                (returnsByDay[day.format('DDMMM').toUpperCase()] || []).length,
                ' returns'
              )
            );
          })
        ),
        _react2.default.createElement(
          _materialUi.CardText,
          { className: (0, _aphrodite.css)(styles.lists) },
          _react2.default.createElement(
            'div',
            { className: (0, _aphrodite.css)(styles.list) },
            _react2.default.createElement(
              'h2',
              { className: (0, _aphrodite.css)(styles.listHeader) },
              'Departing ',
              selectedDay,
              ' (',
              departing.length,
              ')'
            ),
            _react2.default.createElement(
              'ul',
              null,
              departing.map(function (trip) {
                return _react2.default.createElement(
                  'li',
                  { key: trip.id },
                  _react2.default.createElement(
                    _reactRouterDom.Link,
                    { to: '/trips/' + trip.id + '/' },
                    trip.tripName
                  )
                );
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _aphrodite.css)(styles.list) },
            _react2.default.createElement(
              'h2',
              { className: (0, _aphrodite.css)(styles.listHeader) },
              'Returning ',
              selectedDay,
              ' (',
              returning.length,
              ')'
            ),
            _react2.default.createElement(
              'ul',
              null,
              returning.map(function (trip) {
                return _react2.default.createElement(
                  'li',
                  { key: trip.id },
                  _react2.default.createElement(
                    _reactRouterDom.Link,
                    { to: '/trips/' + trip.id + '/' },
                    trip.tripName
                  )
                );
              })
            )
          )
        )
      );
    }
  }]);

  return TravelStatus;
}(_react2.default.Component), _class2.propTypes = {
  data: _propTypes2.default.shape().isRequired,
  className: _propTypes2.default.string
}, _class2.defaultProps = {
  className: ''
}, _temp)) || _class);


var styles = _aphrodite.StyleSheet.create({
  progressContainer: {
    margin: 10,
    position: 'relative'
  },
  progressIndicator: {
    marginLeft: '50%',
    left: -20
  },
  lists: {
    display: 'flex',
    justifyContent: 'space-evenly'
  },
  list: {
    padding: 10,
    width: 300
  },
  listHeader: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 5
  },
  days: {
    display: 'grid',
    '@media (min-width: 775px)': {
      gridTemplateColumns: 'repeat(7, minmax(95px, 1fr))'
    },
    '@media (max-width: 775px)': {
      gridTemplateColumns: 'repeat(auto-fill, minmax(95px, 1fr))'
    }
  },
  day: {
    padding: 5,
    margin: 5
  },
  dayHeader: {
    fontWeight: 'bold'
  }
});

exports.default = TravelStatus;

/***/ }),

/***/ "UCvn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("F8kA");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moveToInbox = __webpack_require__("sldj");

var _moveToInbox2 = _interopRequireDefault(_moveToInbox);

var _monetizationOn = __webpack_require__("UhHO");

var _monetizationOn2 = _interopRequireDefault(_monetizationOn);

var _email = __webpack_require__("LWqx");

var _email2 = _interopRequireDefault(_email);

var _confirmationNumber = __webpack_require__("Y4+6");

var _confirmationNumber2 = _interopRequireDefault(_confirmationNumber);

var _block = __webpack_require__("gj6W");

var _block2 = _interopRequireDefault(_block);

var _home = __webpack_require__("S5U3");

var _home2 = _interopRequireDefault(_home);

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

var _styles = __webpack_require__("IoNl");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Trip = (_temp = _class = function (_React$Component) {
  _inherits(Trip, _React$Component);

  function Trip() {
    _classCallCheck(this, Trip);

    return _possibleConstructorReturn(this, (Trip.__proto__ || Object.getPrototypeOf(Trip)).apply(this, arguments));
  }

  _createClass(Trip, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          active = _props.active,
          trip = _props.trip;
      var primaryTravelerName = trip.primaryTravelerName,
          destination = trip.destination,
          dateString = trip.dateString,
          id = trip.id,
          ownerName = trip.ownerName,
          specificDates = trip.specificDates,
          numTravelers = trip.numTravelers,
          fired = trip.fired,
          lowPriority = trip.lowPriority,
          highPriority = trip.highPriority,
          needsTraining = trip.needsTraining,
          needsVetting = trip.needsVetting,
          insideCircle = trip.insideCircle,
          numSegments = trip.numSegments,
          dropbox = trip.dropbox,
          invoiced = trip.invoice,
          vipDrafted = trip.draftVip,
          booked = trip.book,
          prospect = trip.prospect,
          welcomeHome = trip.welcomeHome;


      var cancelledIconColor = _ourismanTravelTheme2.default.palette.accent1Color;
      var cancelled = false;

      var flags = [fired ? "fired" : false, prospect ? "prospect" : false, insideCircle ? "insideCircle" : false, lowPriority ? "lowPriority" : false, needsTraining ? "needsTraining" : false, needsVetting ? "needsVetting" : false, highPriority ? "highPriority" : false].filter(function (flag) {
        return flag !== false;
      });
      var flagLabels = {
        fired: "fired",
        prospect: "prospect",
        insideCircle: "Inside Circle",
        lowPriority: "low priority",
        needsTraining: "needs training",
        needsVetting: "needs vetting",
        highPriority: "BMOC"
      };

      return _react2.default.createElement(
        _reactRouterDom.Link,
        { to: "/trips/" + id + "/", className: active ? _styles2.default.active : null },
        _react2.default.createElement(
          "div",
          { className: _styles2.default.tripListItem },
          _react2.default.createElement(
            "div",
            { className: _styles2.default.primaryDetails },
            _react2.default.createElement(
              "span",
              { className: _styles2.default.travelerName },
              primaryTravelerName
            ),
            _react2.default.createElement(
              "span",
              null,
              specificDates ? dateString : "dates TBD"
            ),
            _react2.default.createElement(
              "span",
              null,
              destination
            )
          ),
          _react2.default.createElement(
            "div",
            { className: _styles2.default.primaryDetails },
            _react2.default.createElement(
              "span",
              null,
              numSegments,
              " segments"
            ),
            _react2.default.createElement(
              "span",
              null,
              numTravelers,
              " travelers"
            )
          ),
          _react2.default.createElement(
            "div",
            { className: _styles2.default.secondaryDetails },
            _react2.default.createElement(
              "span",
              null,
              "assigned to: ",
              ownerName
            )
          ),
          _react2.default.createElement(
            "div",
            { className: _styles2.default.indicators },
            _react2.default.createElement(
              "div",
              { className: _styles2.default.flags },
              flags.map(function (flag, index) {
                return _react2.default.createElement(
                  "div",
                  { key: index, className: _styles2.default[flag] },
                  flagLabels[flag]
                );
              })
            ),
            _react2.default.createElement(
              "div",
              { className: _styles2.default.icons },
              _react2.default.createElement(
                "div",
                { className: _styles2.default.icon },
                cancelled && _react2.default.createElement(_block2.default, null) || booked && _react2.default.createElement(_confirmationNumber2.default, null) || null,
                _react2.default.createElement(
                  "span",
                  null,
                  cancelled ? "cancelled" : "book"
                )
              ),
              _react2.default.createElement(
                "div",
                { className: _styles2.default.icon },
                dropbox ? _react2.default.createElement(_moveToInbox2.default, { color: cancelled ? cancelledIconColor : null }) : null,
                _react2.default.createElement(
                  "span",
                  null,
                  "filed"
                )
              ),
              _react2.default.createElement(
                "div",
                { className: _styles2.default.icon },
                invoiced ? _react2.default.createElement(_monetizationOn2.default, { color: cancelled ? cancelledIconColor : null }) : null,
                _react2.default.createElement(
                  "span",
                  null,
                  "invoice"
                )
              ),
              _react2.default.createElement(
                "div",
                { className: _styles2.default.icon },
                vipDrafted ? _react2.default.createElement(_email2.default, { color: cancelled ? cancelledIconColor : null }) : null,
                _react2.default.createElement(
                  "span",
                  null,
                  "draft"
                )
              ),
              _react2.default.createElement(
                "div",
                { className: _styles2.default.icon },
                welcomeHome ? _react2.default.createElement(_home2.default, { color: cancelled ? cancelledIconColor : null }) : null,
                _react2.default.createElement(
                  "span",
                  null,
                  "welcome"
                )
              )
            )
          )
        )
      );
    }
    // eslint-disable-line

  }]);

  return Trip;
}(_react2.default.Component), _class.propTypes = {
  active: _propTypes2.default.bool.isRequired,
  trip: _propTypes2.default.shape().isRequired
}, _temp);
exports.default = Trip;

/***/ }),

/***/ "Uot5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 362214e9291b552326df0c9841011060
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type TravelerListItem_DeleteTraveler_MutationVariables = {|
  input: {
    tripId?: ?string;
    travelerId?: ?string;
    clientMutationId?: ?string;
  };
|};

export type TravelerListItem_DeleteTraveler_MutationResponse = {|
  +deleteTraveler: ?{|
    +trip: ?{|
      +travelers: ?$ReadOnlyArray<?{|
        +id: string;
      |}>;
      +tripName: ?string;
      +primaryTravelerName: ?string;
      +numTravelers: ?number;
    |};
  |};
|};
*/

/*
mutation TravelerListItem_DeleteTraveler_Mutation(
  $input: DeleteTravelerInput!
) {
  deleteTraveler(input: $input) {
    trip {
      travelers {
        id
      }
      tripName
      primaryTravelerName
      numTravelers
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "DeleteTravelerInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "TravelerListItem_DeleteTraveler_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "DeleteTravelerInput!"
      }],
      "concreteType": "DeleteTravelerPayload",
      "name": "deleteTraveler",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Traveler",
          "name": "travelers",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tripName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "primaryTravelerName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "numTravelers",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "TravelerListItem_DeleteTraveler_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "DeleteTravelerInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "TravelerListItem_DeleteTraveler_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "DeleteTravelerInput!"
      }],
      "concreteType": "DeleteTravelerPayload",
      "name": "deleteTraveler",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Traveler",
          "name": "travelers",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tripName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "primaryTravelerName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "numTravelers",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation TravelerListItem_DeleteTraveler_Mutation(\n  $input: DeleteTravelerInput!\n) {\n  deleteTraveler(input: $input) {\n    trip {\n      travelers {\n        id\n      }\n      tripName\n      primaryTravelerName\n      numTravelers\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "UwLa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__("Q4lS");

var _reactRelay = __webpack_require__("Tc9k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _DateRangeComponent = __webpack_require__("JW7h");

var _DateRangeComponent2 = _interopRequireDefault(_DateRangeComponent);

var _rest = __webpack_require__("i4WM");

var _rest2 = _interopRequireDefault(_rest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddSegment = (_temp = _class = function (_React$Component) {
  _inherits(AddSegment, _React$Component);

  function AddSegment(props) {
    _classCallCheck(this, AddSegment);

    var _this = _possibleConstructorReturn(this, (AddSegment.__proto__ || Object.getPrototypeOf(AddSegment)).call(this, props));

    _initialiseProps.call(_this);

    var _props$trip = props.trip,
        specificDates = _props$trip.specificDates,
        tripStartDate = _props$trip.startDate,
        segments = _props$trip.segments;


    var startDate = "";
    var filteredSegments = segments.filter(function (segment) {
      return !segment.cancelled && segment.endDate;
    });
    if (filteredSegments.length > 0) {
      startDate = filteredSegments.map(function (segment) {
        return segment.endDate;
      }).slice(-1)[0];
    } else if (specificDates) {
      startDate = tripStartDate;
    }

    _this.state = {
      segmentAutocompleteData: [],
      id: "",
      name: "",
      startDate: startDate,
      endDate: "",
      notes: "",
      confirmNewVendor: false
    };
    return _this;
  }

  _createClass(AddSegment, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          segmentAutocompleteData = _state.segmentAutocompleteData,
          name = _state.name,
          startDate = _state.startDate,
          endDate = _state.endDate,
          confirmNewVendor = _state.confirmNewVendor,
          notes = _state.notes;
      var _props$trip2 = this.props.trip,
          travelStartDate = _props$trip2.travelStartDate,
          travelEndDate = _props$trip2.travelEndDate,
          specificDates = _props$trip2.specificDates,
          timeframe = _props$trip2.timeframe;

      var ready = name !== "" && (startDate && endDate || specificDates === true && travelStartDate && travelEndDate || specificDates === false && timeframe);

      var actions = [_react2.default.createElement(_materialUi.FlatButton, { label: "No", primary: true, onTouchTap: this.cancelNewVendor }), _react2.default.createElement(_materialUi.FlatButton, { label: "Yes", primary: true, onTouchTap: this.confirmNewVendor })];

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          _materialUi.CardText,
          null,
          _react2.default.createElement(
            "div",
            { style: styles.formFieldsStyle },
            _react2.default.createElement(_materialUi.AutoComplete, {
              style: styles.formFieldStyle,
              menuStyle: { width: 500 },
              listStyle: { width: 500 },
              floatingLabelText: "Name",
              dataSource: segmentAutocompleteData,
              onUpdateInput: this.handleUpdateSegmentAutocomplete,
              onNewRequest: this.vendorSelected,
              filter: function filter() {
                return true;
              }
            }),
            _react2.default.createElement(_DateRangeComponent2.default, {
              startValue: startDate,
              endValue: endDate,
              startLabel: "Start Date",
              endLabel: "End Date",
              onChange: this.updateDates
            })
          ),
          _react2.default.createElement(_materialUi.TextField, {
            floatingLabelText: "Notes",
            value: notes,
            onChange: this.updateNotes,
            multiLine: true,
            fullWidth: true
          }),
          _react2.default.createElement(
            "div",
            { style: styles.formActionsStyle },
            _react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", secondary: true, onTouchTap: this.cancel }),
            _react2.default.createElement(_materialUi.FlatButton, {
              label: "Confirm",
              primary: true,
              onTouchTap: this.save,
              disabled: !ready
            })
          )
        ),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            title: "Confirm New Vendor",
            actions: actions,
            modal: true,
            open: confirmNewVendor
          },
          _react2.default.createElement(
            "p",
            null,
            "You did not select an existing vendor from our database. Are you sure that \"",
            name,
            "\" is not one of the following?"
          ),
          _react2.default.createElement(
            "ul",
            { style: styles.alternativeList },
            segmentAutocompleteData.filter(function (_ref) {
              var score = _ref.score;
              return score > 1;
            }).slice(0, 10).map(function (_ref2) {
              var vendorName = _ref2.name,
                  id = _ref2.value;
              return _react2.default.createElement(
                "li",
                { key: id, style: styles.alternativeVendor },
                _react2.default.createElement(
                  "span",
                  null,
                  vendorName
                ),
                _react2.default.createElement(_materialUi.FlatButton, {
                  label: "select",
                  onTouchTap: _this2.selectAlternateVendor(id, name)
                })
              );
            })
          )
        )
      );
    }
  }]);

  return AddSegment;
}(_react2.default.Component), _class.propTypes = {
  trip: _propTypes2.default.shape().isRequired,
  onComplete: _propTypes2.default.func.isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.cancel = function () {
    _this3.props.onComplete();
  };

  this.handleUpdateSegmentAutocomplete = function (value) {
    (0, _rest2.default)("auto/vendor", value).then(function (response) {
      var objects = response.objects;

      _this3.setState({
        name: value,
        segmentAutocompleteData: objects.map(function (object) {
          return {
            text: object.name,
            value: object.relayId,
            name: object.name,
            score: object.score
          };
        })
      });
    }).catch(function (response) {
      console.log(response);
    });
  };

  this.vendorSelected = function (selected, index) {
    if (index !== -1) {
      var id = selected.value,
          name = selected.name;

      _this3.setState({ id: id, name: name });
    }
  };

  this.selectAlternateVendor = function (id, name) {
    return function () {
      _this3.setState({ id: id, name: name, confirmNewVendor: false }, function () {
        return _this3.addVendor();
      });
    };
  };

  this.updateDates = function (e) {
    var startDate = e.startDate,
        endDate = e.endDate;

    _this3.setState({ startDate: startDate, endDate: endDate });
  };

  this.save = function () {
    if (!_this3.state.id) {
      _this3.setState({ confirmNewVendor: true });
    } else {
      _this3.addVendor();
    }
  };

  this.cancelNewVendor = function () {
    _this3.setState({ confirmNewVendor: false });
  };

  this.confirmNewVendor = function () {
    _this3.setState({ confirmNewVendor: false });
    _this3.addVendor();
  };

  this.addVendor = function () {
    var _props = _this3.props,
        tripId = _props.trip.id,
        onComplete = _props.onComplete;
    var _state2 = _this3.state,
        vendorId = _state2.id,
        vendorName = _state2.name,
        notes = _state2.notes;
    var _state3 = _this3.state,
        startDate = _state3.startDate,
        endDate = _state3.endDate;


    if (_moment2.default.isMoment(startDate)) {
      startDate = startDate.format("YYYY-MM-DDTHH:mm:ssZZ");
    }
    if (_moment2.default.isMoment(endDate)) {
      endDate = endDate.format("YYYY-MM-DDTHH:mm:ssZZ");
    }

    (0, _reactRelay.commitMutation)(_environment2.default, {
      mutation: _graphql || (_graphql = function _graphql() {
        return __webpack_require__("mGxo");
      }),
      variables: {
        input: {
          tripId: tripId,
          vendorId: vendorId,
          vendorName: vendorName,
          startDate: startDate,
          endDate: endDate,
          notes: notes
        }
      },
      onCompleted: function onCompleted() {
        return onComplete();
      },
      onError: function onError(err) {
        return alert(err);
      }
    });
  };

  this.updateNotes = function (e) {
    var value = e.target.value;

    _this3.setState({ notes: value });
  };
}, _temp);
exports.default = AddSegment;


var styles = {
  formFieldsStyle: {
    display: "flex",
    flexWrap: "wrap",
    alignItems: "flex-end"
  },
  formFieldStyle: {
    width: 256,
    marginRight: 24
  },
  formActionsStyle: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end"
  },
  alternativeList: {
    display: "flex",
    flexDirection: "column",
    width: "50%"
  },
  alternativeVendor: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    alignItems: "baseline"
  }
};

/***/ }),

/***/ "VcJq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp2;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("RH2O");

var _reactDateRange = __webpack_require__("rOYp");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _materialUi = __webpack_require__("Q4lS");

var _aphrodite = __webpack_require__("BK4P");

var _RateQuoteActions = __webpack_require__("wRbn");

var RateQuoteActions = _interopRequireWildcard(_RateQuoteActions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateEntry = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    arrival: state.RateQuote.get('arrival'),
    departure: state.RateQuote.get('departure'),
    dateString: state.RateQuote.get('dateString'),
    showDatePicker: state.RateQuote.get('showDatePicker')
  };
}), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(DateEntry, _React$Component);

  function DateEntry() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, DateEntry);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = DateEntry.__proto__ || Object.getPrototypeOf(DateEntry)).call.apply(_ref, [this].concat(args))), _this), _this.handleSelect = function (range) {
      _this.props.dispatch(RateQuoteActions.updateDateRange(range));
    }, _this.updateDate = function (e) {
      var value = e.target.value.toUpperCase();
      _this.props.dispatch(RateQuoteActions.updateDateString(value));
    }, _this.toggleDatePicker = function (e) {
      _this.props.dispatch(RateQuoteActions.toggleDatePicker(e.target.checked));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(DateEntry, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          arrival = _props.arrival,
          departure = _props.departure;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.container) },
          _react2.default.createElement(_materialUi.TextField, {
            value: this.props.dateString,
            floatingLabelText: 'Travel Dates',
            onChange: this.updateDate
          }),
          _react2.default.createElement(_materialUi.Toggle, {
            checked: this.props.showDatePicker,
            onClick: this.toggleDatePicker,
            label: '(show date picker)',
            labelPosition: 'right',
            className: (0, _aphrodite.css)(styles.toggle)
          })
        ),
        this.props.showDatePicker ? _react2.default.createElement(_reactDateRange.DateRange, {
          onChange: this.handleSelect,
          startDate: arrival ? (0, _moment2.default)(arrival) : '',
          endDate: departure ? (0, _moment2.default)(departure) : ''
        }) : ''
      );
    }
  }]);

  return DateEntry;
}(_react2.default.Component), _class2.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  arrival: _propTypes2.default.number,
  departure: _propTypes2.default.number,
  dateString: _propTypes2.default.string,
  showDatePicker: _propTypes2.default.bool
}, _class2.defaultProps = {
  showDatePicker: false,
  arrival: null,
  departure: null,
  dateString: ''
}, _temp2)) || _class);
exports.default = DateEntry;


var styles = _aphrodite.StyleSheet.create({
  container: {
    display: 'flex',
    alignItems: 'baseline'
  },
  toggle: {
    width: 200,
    marginLeft: 'auto'
  }
});

/***/ }),

/***/ "VnsJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("Tc9k");

var _materialUi = __webpack_require__("Q4lS");

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _VendorDetail = __webpack_require__("QM2w");

var _VendorDetail2 = _interopRequireDefault(_VendorDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Renderer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    windowHeight: state.Responsive.get('windowHeight')
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(Renderer, _React$Component);

  function Renderer() {
    _classCallCheck(this, Renderer);

    return _possibleConstructorReturn(this, (Renderer.__proto__ || Object.getPrototypeOf(Renderer)).apply(this, arguments));
  }

  _createClass(Renderer, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          windowHeight = _props.windowHeight,
          activeVendor = _props.activeVendor;

      var top = (windowHeight - 161) / 2 + 161;

      var loadingEl = _react2.default.createElement(_materialUi.RefreshIndicator, {
        top: top,
        left: 900,
        status: 'loading'
      });

      return _react2.default.createElement(_reactRelay.QueryRenderer, {
        environment: _environment2.default,
        variables: {
          vendorId: activeVendor
        },
        query: _graphql || (_graphql = function _graphql() {
          return __webpack_require__("y1yg");
        }),
        render: function render(_ref) {
          var error = _ref.error,
              props = _ref.props;

          if (error) {
            return _react2.default.createElement(
              'div',
              null,
              error.message
            );
          } else if (props) {
            var vendor = props.vendor;


            return _react2.default.createElement(_VendorDetail2.default, { vendor: vendor });
          }

          return loadingEl;
        }
      });
    }
  }]);

  return Renderer;
}(_react2.default.Component), _class2.propTypes = {
  windowHeight: _propTypes2.default.number.isRequired,
  activeVendor: _propTypes2.default.string.isRequired
}, _temp)) || _class);
exports.default = Renderer;

/***/ }),

/***/ "W63S":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp2, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__("Q4lS");

var _reactRedux = __webpack_require__("RH2O");

var _exitToApp = __webpack_require__("sWSj");

var _exitToApp2 = _interopRequireDefault(_exitToApp);

var _reactRelay = __webpack_require__("Tc9k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _aphrodite = __webpack_require__("BK4P");

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

var _AuthActions = __webpack_require__("apKn");

var AuthActions = _interopRequireWildcard(_AuthActions);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LogoutButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    authenticated: state.Auth.get('authenticated')
  };
}), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(LogoutButton, _React$Component);

  function LogoutButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LogoutButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LogoutButton.__proto__ || Object.getPrototypeOf(LogoutButton)).call.apply(_ref, [this].concat(args))), _this), _this.logOut = function (input) {
      (0, _reactRelay.commitMutation)(_environment2.default, {
        mutation: _graphql || (_graphql = function _graphql() {
          return __webpack_require__("o3qQ");
        }),
        variables: { input: input },
        onCompleted: function onCompleted() {
          _this.props.dispatch(AuthActions.logout());
        },
        onError: function onError(err) {
          return alert(err);
        }
      });
    }, _this.handleClick = function () {
      _this.props.dispatch(AuthActions.logout());
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(LogoutButton, [{
    key: 'render',
    value: function render() {
      var authenticated = this.props.authenticated;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.large) },
          _react2.default.createElement(_materialUi.RaisedButton, {
            label: 'Logout',
            primary: true,
            onClick: this.handleClick,
            icon: _react2.default.createElement(_exitToApp2.default, null),
            disabled: !authenticated
          })
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.small) },
          _react2.default.createElement(
            _materialUi.IconButton,
            {
              onClick: this.handleClick,
              disabled: !authenticated
            },
            _react2.default.createElement(_exitToApp2.default, { color: _ourismanTravelTheme2.default.palette.alternateTextColor })
          )
        )
      );
    }
  }]);

  return LogoutButton;
}(_react2.default.Component), _class2.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  authenticated: _propTypes2.default.bool.isRequired
}, _class2.contextTypes = {
  router: _propTypes2.default.object
}, _temp2)) || _class);


var styles = _aphrodite.StyleSheet.create({
  large: {
    '@media (max-width: 800px)': {
      display: 'none'
    }
  },
  small: {
    '@media (min-width: 800px)': {
      display: 'none'
    }
  }
});

exports.default = LogoutButton;

/***/ }),

/***/ "WexP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _momentRange = __webpack_require__("l5j/");

var _materialUi = __webpack_require__("Q4lS");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var moment = (0, _momentRange.extendMoment)(_moment2.default);

var Rate = function Rate(_ref) {
  var rate = _ref.rate,
      currency = _ref.currency,
      index = _ref.index,
      editing = _ref.editing,
      onChange = _ref.onChange;

  var dayNumber = index + 1;

  var displayRate = rate ? rate.toFixed(2) : 'n/a';

  return _react2.default.createElement(
    'div',
    { style: styles.rate },
    _react2.default.createElement(
      'div',
      { style: styles.rateHeader },
      'Day ',
      dayNumber
    ),
    _react2.default.createElement(
      'div',
      null,
      editing ? _react2.default.createElement(_materialUi.TextField, {
        id: 'rate' + index,
        value: rate,
        type: 'number',
        onChange: onChange
      }) : displayRate
    ),
    editing ? null : _react2.default.createElement(
      'div',
      { style: styles.rateHeader },
      currency
    )
  );
};

Rate.propTypes = {
  rate: _propTypes2.default.number.isRequired,
  currency: _propTypes2.default.string.isRequired,
  index: _propTypes2.default.number.isRequired,
  editing: _propTypes2.default.bool,
  onChange: _propTypes2.default.func
};

Rate.defaultProps = {
  editing: false,
  onChange: null
};

var DailyRates = (_temp = _class = function (_React$Component) {
  _inherits(DailyRates, _React$Component);

  function DailyRates(props) {
    _classCallCheck(this, DailyRates);

    var _this = _possibleConstructorReturn(this, (DailyRates.__proto__ || Object.getPrototypeOf(DailyRates)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        rates = _this$props.rates,
        currency = _this$props.currency,
        average = _this$props.average,
        startDate = _this$props.startDate,
        endDate = _this$props.endDate;


    var averageRate = !average && rates.length ? _this.average(rates) : rates[0] || 0;

    _this.state = {
      rates: rates,
      currency: currency,
      average: average,
      averageRate: averageRate,
      slicedRates: _this.sliceRates(rates, startDate, endDate)
    };
    return _this;
  }

  _createClass(DailyRates, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var startDate = nextProps.startDate,
          endDate = nextProps.endDate,
          _nextProps$rates = nextProps.rates,
          rates = _nextProps$rates === undefined ? [] : _nextProps$rates,
          average = nextProps.average;

      var slicedRates = this.sliceRates(rates, startDate, endDate);
      var averageRate = this.average(slicedRates);
      this.setState({
        rates: rates,
        slicedRates: slicedRates,
        averageRate: averageRate,
        average: average
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var editing = this.props.editing;
      var _state = this.state,
          rates = _state.rates,
          currency = _state.currency,
          average = _state.average,
          slicedRates = _state.slicedRates;


      var averageRate = this.average(rates);
      var formattedRate = 'n/a';
      if (!_lodash2.default.some(rates, function (x) {
        return x === null;
      })) {
        formattedRate = averageRate.toFixed(2);
      }

      var display = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h4',
          null,
          'Average Daily Rate: ',
          currency,
          ' ',
          formattedRate
        ),
        _react2.default.createElement(
          'div',
          { style: styles.rates },
          rates.map(function (rate, index) {
            return _react2.default.createElement(Rate, {
              rate: rate,
              currency: currency,
              key: index,
              index: index
            });
          })
        )
      );

      var edit = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h4',
          null,
          'Average Daily Rate:',
          _react2.default.createElement('br', null),
          _react2.default.createElement(_materialUi.TextField, {
            type: 'number',
            onChange: this.setAverageRate,
            value: averageRate,
            disabled: !average
          }),
          _react2.default.createElement('br', null),
          _react2.default.createElement(_materialUi.TextField, {
            floatingLabelText: 'Currency',
            value: currency,
            onChange: this.updateCurrency
          })
        ),
        average ? null : _react2.default.createElement(
          'div',
          { style: styles.rates },
          slicedRates.map(function (rate, index) {
            return _react2.default.createElement(Rate, {
              editing: true,
              rate: rate,
              currency: currency,
              key: index,
              index: index,
              onChange: _this2.updateRate(index)
            });
          })
        )
      );

      return editing ? edit : display;
    }
  }]);

  return DailyRates;
}(_react2.default.Component), _class.propTypes = {
  rates: _propTypes2.default.arrayOf(_propTypes2.default.number),
  currency: _propTypes2.default.string.isRequired,
  average: _propTypes2.default.number.isRequired,
  startDate: _propTypes2.default.string.isRequired,
  endDate: _propTypes2.default.string.isRequired,
  onChange: _propTypes2.default.func.isRequired,
  editing: _propTypes2.default.bool.isRequired
}, _class.defaultProps = {
  rates: []
}, _initialiseProps = function _initialiseProps() {
  var _this3 = this;

  this.setAverageRate = function (e) {
    var value = e.target.value;
    var onChange = _this3.props.onChange;

    var averageRate = parseFloat(value);

    var _state2 = _this3.state,
        rates = _state2.rates,
        slicedRates = _state2.slicedRates,
        currency = _state2.currency;

    var parsedValue = parseFloat(value);
    rates.fill(parsedValue);
    slicedRates.fill(parsedValue);
    onChange(slicedRates, currency);

    _this3.setState({
      averageRate: averageRate,
      rates: rates,
      slicedRates: slicedRates
    });
  };

  this.toggleAverage = function () {
    _this3.setState({ average: !_this3.state.average });
  };

  this.updateRate = function (index) {
    return function (e) {
      var value = e.target.value;
      var onChange = _this3.props.onChange;
      var _state3 = _this3.state,
          rates = _state3.rates,
          slicedRates = _state3.slicedRates,
          currency = _state3.currency;

      var newRates = [].concat(_toConsumableArray(rates));
      var newSliced = [].concat(_toConsumableArray(slicedRates));

      newRates[index] = parseFloat(value);
      newSliced[index] = parseFloat(value);
      onChange(newSliced, currency);

      _this3.setState({
        rates: newRates,
        averageRate: _this3.average(rates)
      });
    };
  };

  this.average = function (rates) {
    if (rates.length === 0) {
      return 0;
    }
    return rates.reduce(function (a, b) {
      return a + b;
    }) / rates.length;
  };

  this.sliceRates = function (rates, startDate, endDate) {
    var momentStartDate = moment(startDate);
    var momentEndDate = moment(endDate);
    var duration = moment.range(momentStartDate, momentEndDate).diff('days');
    var slicedRates = rates.slice(0, duration);

    while (slicedRates.length < duration) {
      slicedRates.push(0);
    }

    return slicedRates;
  };

  this.updateCurrency = function (e) {
    var value = e.target.value;
    var onChange = _this3.props.onChange;
    var slicedRates = _this3.state.slicedRates;


    _this3.setState({
      currency: value
    });
    onChange(slicedRates, value);
  };
}, _temp);
exports.default = DailyRates;


var styles = {
  rates: {
    display: 'flex',
    justifyContent: 'flex-start',
    flexWrap: 'wrap'
  },
  rate: {
    padding: 5,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  },
  rateHeader: {
    width: '100%',
    textAlign: 'center',
    padding: 3,
    background: _ourismanTravelTheme2.default.palette.primary3Color
  }
};

/***/ }),

/***/ "WsVO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _templateObject = _taggedTemplateLiteral(["\n  mutation submitNotes($id: String!, $field: String!, $note: String!) {\n    setNoteField(id: $id, field: $field, note: $note) {\n      field\n      note\n    }\n  }\n"], ["\n  mutation submitNotes($id: String!, $field: String!, $note: String!) {\n    setNoteField(id: $id, field: $field, note: $note) {\n      field\n      note\n    }\n  }\n"]);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__("Q4lS");

var _reactApollo = __webpack_require__("3zLD");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Notes = (_temp = _class = function (_React$Component) {
  _inherits(Notes, _React$Component);

  function Notes(props) {
    _classCallCheck(this, Notes);

    var _this = _possibleConstructorReturn(this, (Notes.__proto__ || Object.getPrototypeOf(Notes)).call(this, props));

    _this.handleUnload = function (e) {
      var isDirty = _this.state.isDirty;

      var event = e || window.event;

      if (!isDirty) {
        return undefined;
      }

      var message = "You have unsaved changes in your notes, leaving without " + "saving will cause them to be lost.";

      event.preventDefault();
      event.returnValue = message;
      return message;
    };

    _this.handleChange = function (value) {
      _this.setState({ value: value, isDirty: true });
      _this.props.onChange(true);
    };

    _this.edit = function () {
      _this.setState({ editing: true });
    };

    _this.cancel = function () {
      _this.setState({ editing: false, value: _this.props.value, isDirty: false });
      _this.props.onChange(false);
    };

    _this.submit = function () {
      var _this$props = _this.props,
          id = _this$props.id,
          fieldName = _this$props.fieldName,
          mutate = _this$props.mutate;
      var value = _this.state.value;


      mutate({
        variables: {
          id: id,
          field: fieldName,
          note: value
        }
      });

      _this.setState({ editing: false, isDirty: false });
      _this.props.onChange(false);
    };

    _this.content = function () {
      var ReactQuill = _this.ReactQuill;
      var _this$state = _this.state,
          editing = _this$state.editing,
          value = _this$state.value;


      if (editing && typeof window !== "undefined" && ReactQuill) {
        return _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(ReactQuill, { value: value, onChange: _this.handleChange })
        );
      }
      return (
        // eslint-disable-next-line react/no-danger
        _react2.default.createElement("div", { className: "ql-editor", dangerouslySetInnerHTML: { __html: value } })
      );
    };

    _this.buttons = function () {
      var editing = _this.state.editing;


      if (editing) {
        return _react2.default.createElement(
          "div",
          null,
          _react2.default.createElement(_materialUi.FlatButton, { label: "Cancel", onClick: _this.cancel }),
          _react2.default.createElement(_materialUi.FlatButton, { label: "Submit", onClick: _this.submit })
        );
      }

      return _react2.default.createElement(_materialUi.FlatButton, { label: "Edit", onClick: _this.edit });
    };

    if (typeof window !== "undefined") {
      _this.ReactQuill = __webpack_require__("TWqO"); // eslint-disable-line global-require
    }

    _this.state = {
      value: _this.props.value,
      editing: false,
      isDirty: false
    };
    return _this;
  }

  _createClass(Notes, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      window.addEventListener("beforeunload", this.handleUnload);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      window.removeEventListener("beforeunload", this.handleUnload);
    }
  }, {
    key: "render",
    value: function render() {
      var content = this.content();
      var buttons = this.buttons();

      return _react2.default.createElement(
        "div",
        null,
        content,
        buttons
      );
    }
  }]);

  return Notes;
}(_react2.default.Component), _class.propTypes = {
  id: _propTypes2.default.string.isRequired,
  fieldName: _propTypes2.default.string,
  value: _propTypes2.default.string,
  mutate: _propTypes2.default.func.isRequired,
  onChange: _propTypes2.default.func
}, _class.defaultProps = {
  fieldName: "Notes",
  value: "",
  onChange: function onChange() {}
}, _temp);


var submitNotes = (0, _reactApollo.gql)(_templateObject);

var NotesWithData = (0, _reactApollo.graphql)(submitNotes)(Notes);

exports.default = NotesWithData;

/***/ }),

/***/ "XhpN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _aphrodite = __webpack_require__("BK4P");

var _RateQuote = __webpack_require__("wYIP");

var _RateQuote2 = _interopRequireDefault(_RateQuote);

var _RateEntry = __webpack_require__("FjB9");

var _RateEntry2 = _interopRequireDefault(_RateEntry);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RateQuoteGenerator = function RateQuoteGenerator() {
  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      { className: (0, _aphrodite.css)(styles.rateQuoteContainer) },
      _react2.default.createElement(_RateEntry2.default, { className: (0, _aphrodite.css)(styles.rateQuoteCard) }),
      _react2.default.createElement(_RateQuote2.default, { className: (0, _aphrodite.css)(styles.rateQuoteCard) })
    )
  );
};

exports.default = RateQuoteGenerator;


var styles = _aphrodite.StyleSheet.create({
  rateQuoteContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    paddingRight: 15
  },
  rateQuoteCard: {
    marginTop: 15,
    marginLeft: 15,
    '@media (min-width: 925px)': {
      maxWidth: 'calc(50% - 15px)',
      minWidth: 'calc(50% - 15px)'
    },
    '@media (max-width: 925px)': {
      maxWidth: 'calc(100% - 15px)',
      minWidth: 'calc(100% - 15px)'
    }
  }
});

/***/ }),

/***/ "Xra4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _aphrodite = __webpack_require__("BK4P");

var _Widgets = __webpack_require__("jbrW");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  return _react2.default.createElement(
    'div',
    { className: (0, _aphrodite.css)(styles.widgets) },
    _react2.default.createElement(_Widgets.TravelStatus, { className: (0, _aphrodite.css)(styles.largeWidget) }),
    _react2.default.createElement(_Widgets.VIPLetters, { className: (0, _aphrodite.css)(styles.widget) }),
    _react2.default.createElement(_Widgets.TripAssignments, { className: (0, _aphrodite.css)(styles.widget) }),
    _react2.default.createElement(_Widgets.DateCalculations, { className: (0, _aphrodite.css)(styles.widget) })
  );
};

var styles = _aphrodite.StyleSheet.create({
  widgets: {
    display: 'grid',
    paddingRight: 15,
    gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))'
  },
  widget: {
    marginTop: 15,
    marginLeft: 15
  },
  largeWidget: {
    marginTop: 15,
    marginLeft: 15,
    '@media (min-width: 580px)': {
      gridColumnEnd: 'span 2'
    },
    '@media (min-width: 875px)': {
      gridColumnEnd: 'span 3'
    }
  }
});

/***/ }),

/***/ "XwAW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__("Q4lS");

var _styles = __webpack_require__("kLrL");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ResponseListFilters = (_temp = _class = function (_React$Component) {
  _inherits(ResponseListFilters, _React$Component);

  function ResponseListFilters() {
    _classCallCheck(this, ResponseListFilters);

    return _possibleConstructorReturn(this, (ResponseListFilters.__proto__ || Object.getPrototypeOf(ResponseListFilters)).apply(this, arguments));
  }

  _createClass(ResponseListFilters, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          numTotal = _props.numTotal,
          numFiltered = _props.numFiltered,
          updateFilter = _props.updateFilter,
          filter = _props.filter;


      return _react2.default.createElement(
        'div',
        { className: _styles2.default.listFilter },
        _react2.default.createElement(
          'div',
          { className: _styles2.default.filters },
          _react2.default.createElement(_materialUi.TextField, { floatingLabelText: 'Filter responses', onChange: updateFilter, value: filter })
        ),
        _react2.default.createElement(
          'div',
          { className: _styles2.default.infoLine },
          numFiltered,
          ' (of ',
          numTotal,
          ') responses displayed'
        )
      );
    }
  }]);

  return ResponseListFilters;
}(_react2.default.Component), _class.propTypes = {
  numTotal: _propTypes2.default.number,
  numFiltered: _propTypes2.default.number,
  updateFilter: _propTypes2.default.func.isRequired,
  filter: _propTypes2.default.string
}, _class.defaultProps = {
  numTotal: 0,
  numFiltered: 0,
  filter: ''
}, _temp);
exports.default = ResponseListFilters;

/***/ }),

/***/ "YcI5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__("F8kA");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _aphrodite = __webpack_require__("BK4P");

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Response = (_temp = _class = function (_React$Component) {
  _inherits(Response, _React$Component);

  function Response() {
    _classCallCheck(this, Response);

    return _possibleConstructorReturn(this, (Response.__proto__ || Object.getPrototypeOf(Response)).apply(this, arguments));
  }

  _createClass(Response, [{
    key: 'render',
    // eslint-disable-line
    value: function render() {
      var _props = this.props,
          _props$response = _props.response,
          id = _props$response.id,
          display = _props$response.display,
          created = _props$response.created,
          active = _props.active;


      return _react2.default.createElement(
        _reactRouterDom.Link,
        {
          to: '/forms/responses/' + id + '/',
          className: active ? (0, _aphrodite.css)(styles.active) : undefined
        },
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.listItem) },
          _react2.default.createElement(
            'span',
            { className: (0, _aphrodite.css)(styles.listDisplayName) },
            display
          ),
          _react2.default.createElement(
            'span',
            { className: (0, _aphrodite.css)(styles.timestamp) },
            (0, _moment2.default)(created).format('MMMM Do YYYY, h:mm:ss a')
          )
        )
      );
    }
  }]);

  return Response;
}(_react2.default.Component), _class.propTypes = {
  response: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    name: _propTypes2.default.string
  }).isRequired,
  active: _propTypes2.default.bool
}, _class.defaultProps = {
  active: false
}, _temp);
exports.default = Response;


var styles = _aphrodite.StyleSheet.create({
  listItem: {
    borderBottom: '1px solid ' + _ourismanTravelTheme2.default.palette.borderColor,
    color: _ourismanTravelTheme2.default.palette.textColor,
    display: 'flex',
    flexDirection: 'column',
    fontSize: '14px',
    padding: '5px'
  },
  listDisplayName: {
    fontWeight: 'bold'
  },
  timestamp: {
    fontSize: 10
  },
  active: {
    background: _ourismanTravelTheme2.default.palette.accent2Color,
    borderRight: '5px solid ' + _ourismanTravelTheme2.default.palette.accent3Color,
    boxSizing: 'border-box',
    display: 'inline-block',
    width: '100%'
  }
});

/***/ }),

/***/ "YgJF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__("Q4lS");

var _aphrodite = __webpack_require__("BK4P");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _momentParseformat = __webpack_require__("m0Xp");

var _momentParseformat2 = _interopRequireDefault(_momentParseformat);

var _DateFieldComponent = __webpack_require__("kg8o");

var _DateFieldComponent2 = _interopRequireDefault(_DateFieldComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateCalculations = (_temp = _class = function (_React$Component) {
  _inherits(DateCalculations, _React$Component);

  function DateCalculations(props) {
    _classCallCheck(this, DateCalculations);

    var _this = _possibleConstructorReturn(this, (DateCalculations.__proto__ || Object.getPrototypeOf(DateCalculations)).call(this, props));

    _this.changeDays = function (_ref) {
      var value = _ref.target.value;

      _this.setState({ days: value });
    };

    _this.changeSign = function (event, index, value) {
      _this.setState({ sign: value });
    };

    _this.changeDate = function (_ref2) {
      var value = _ref2.target.value;

      _this.setState({ date: value });
    };

    _this.state = {
      days: 180,
      sign: 'after',
      date: (0, _moment2.default)().format('MMMM Do YYYY')
    };
    return _this;
  }

  _createClass(DateCalculations, [{
    key: 'render',
    value: function render() {
      var className = this.props.className;
      var _state = this.state,
          days = _state.days,
          sign = _state.sign,
          date = _state.date;


      var parsedDate = (0, _moment2.default)(date, (0, _momentParseformat2.default)(date));
      var result = void 0;
      if (sign === 'after') {
        result = parsedDate.add(days, 'days');
      } else {
        result = parsedDate.subtract(days, 'days');
      }

      return _react2.default.createElement(
        _materialUi.Card,
        { className: className },
        _react2.default.createElement(_materialUi.CardHeader, { title: 'Date Calculations' }),
        _react2.default.createElement(
          _materialUi.CardText,
          null,
          _react2.default.createElement(
            'div',
            { className: (0, _aphrodite.css)(styles.firstLine) },
            _react2.default.createElement(_materialUi.TextField, {
              type: 'number',
              id: 'days',
              className: (0, _aphrodite.css)(styles.daysInput), value: days, onChange: this.changeDays
            }),
            _react2.default.createElement(
              'span',
              { className: (0, _aphrodite.css)(styles.daysSpan) },
              'days'
            ),
            _react2.default.createElement(
              _materialUi.DropDownMenu,
              { value: sign, onChange: this.changeSign },
              _react2.default.createElement(_materialUi.MenuItem, { value: 'after', primaryText: 'after' }),
              _react2.default.createElement(_materialUi.MenuItem, { value: 'before', primaryText: 'before' })
            ),
            _react2.default.createElement('br', null)
          ),
          _react2.default.createElement(_DateFieldComponent2.default, {
            id: 'date',
            className: (0, _aphrodite.css)(styles.dateInput),
            value: date,
            onChange: this.changeDate
          }),
          _react2.default.createElement(
            'div',
            { className: (0, _aphrodite.css)(styles.resultsDiv) },
            'is ',
            _react2.default.createElement(
              'span',
              { className: (0, _aphrodite.css)(styles.resultsSpan) },
              result.format('MMMM Do YYYY')
            )
          )
        )
      );
    }
  }]);

  return DateCalculations;
}(_react2.default.Component), _class.propTypes = {
  className: _propTypes2.default.string
}, _class.defaultProps = {
  className: ''
}, _temp);
exports.default = DateCalculations;


var styles = _aphrodite.StyleSheet.create({
  daysInput: {
    width: 50
  },
  dateInput: {
    width: '100%'
  },
  firstLine: {
    display: 'flex',
    alignItems: 'baseline'
  },
  daysSpan: {
    paddingLeft: 24
  },
  resultsSpan: {
    fontWeight: 'bold',
    fontSize: 20
  },
  resultsDiv: {
    paddingTop: 15
  }
});

/***/ }),

/***/ "YjfQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 9f2473f1048d1ed3fecdd7d2cfd553c7
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ClientDetails_TriggerWecomeBack_MutationVariables = {|
  input: {
    travelerId?: ?string;
    clientMutationId?: ?string;
  };
|};

export type ClientDetails_TriggerWecomeBack_MutationResponse = {|
  +triggerWelcomeBack: ?{|
    +traveler: ?{|
      +welcomeBack: boolean;
    |};
  |};
|};
*/

/*
mutation ClientDetails_TriggerWecomeBack_Mutation(
  $input: TriggerWelcomeBackInput!
) {
  triggerWelcomeBack(input: $input) {
    traveler {
      welcomeBack
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "TriggerWelcomeBackInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientDetails_TriggerWecomeBack_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "TriggerWelcomeBackInput!"
      }],
      "concreteType": "TriggerWelcomeBackPayload",
      "name": "triggerWelcomeBack",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Traveler",
        "name": "traveler",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "welcomeBack",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ClientDetails_TriggerWecomeBack_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "TriggerWelcomeBackInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "ClientDetails_TriggerWecomeBack_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "TriggerWelcomeBackInput!"
      }],
      "concreteType": "TriggerWelcomeBackPayload",
      "name": "triggerWelcomeBack",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Traveler",
        "name": "traveler",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "welcomeBack",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation ClientDetails_TriggerWecomeBack_Mutation(\n  $input: TriggerWelcomeBackInput!\n) {\n  triggerWelcomeBack(input: $input) {\n    traveler {\n      welcomeBack\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "Yobl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__("Q4lS");

var _reactRelay = __webpack_require__("Tc9k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouterDom = __webpack_require__("F8kA");

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddNotes = (_temp = _class = function (_React$Component) {
  _inherits(AddNotes, _React$Component);

  function AddNotes(props) {
    _classCallCheck(this, AddNotes);

    var _this = _possibleConstructorReturn(this, (AddNotes.__proto__ || Object.getPrototypeOf(AddNotes)).call(this, props));

    _this.updateNote = function (value) {
      _this.setState({ note: value });
    };

    _this.save = function () {
      _this.setState({ submitting: true });

      var _this$props = _this.props,
          onComplete = _this$props.onComplete,
          tripId = _this$props.trip.id;
      var note = _this.state.note;


      (0, _reactRelay.commitMutation)(_environment2.default, {
        mutation: _graphql || (_graphql = function _graphql() {
          return __webpack_require__("+Rwz");
        }),
        variables: { input: { tripId: tripId, note: note } },
        onCompleted: function onCompleted() {
          return onComplete();
        },
        onError: function onError(err) {
          _this.setState({ submitting: false });
          alert(err);
        }
      });
    };

    _this.state = {
      note: "",
      submitting: false
    };

    if (typeof window !== "undefined") {
      _this.ReactQuill = __webpack_require__("TWqO"); // eslint-disable-line global-require
    }
    return _this;
  }

  _createClass(AddNotes, [{
    key: "render",
    value: function render() {
      var onComplete = this.props.onComplete;
      var _state = this.state,
          note = _state.note,
          submitting = _state.submitting;


      return _react2.default.createElement(
        _materialUi.Card,
        null,
        _react2.default.createElement(
          _materialUi.CardText,
          null,
          _react2.default.createElement(_reactRouterDom.Prompt, { message: "You are currently adding a note, leaving now will discard any changes made." }),
          _react2.default.createElement(this.ReactQuill, { value: note, onChange: this.updateNote }),
          _react2.default.createElement(
            "div",
            { style: styles.noteActions },
            _react2.default.createElement(_materialUi.FlatButton, {
              label: "Cancel",
              secondary: true,
              onTouchTap: onComplete,
              disabled: submitting
            }),
            _react2.default.createElement(_materialUi.FlatButton, {
              label: "Add Note",
              primary: true,
              onTouchTap: this.save,
              disabled: submitting
            })
          )
        )
      );
    }
  }]);

  return AddNotes;
}(_react2.default.Component), _class.propTypes = {
  onComplete: _propTypes2.default.func.isRequired,
  trip: _propTypes2.default.shape().isRequired
}, _temp);
exports.default = AddNotes;


var styles = {
  noteActions: {
    width: "100%",
    display: "flex",
    justifyContent: "flex-end"
  }
};

/***/ }),

/***/ "YpiJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRouterDom = __webpack_require__("F8kA");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__("DsNi");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Client = function (_React$Component) {
  _inherits(Client, _React$Component);

  function Client() {
    _classCallCheck(this, Client);

    return _possibleConstructorReturn(this, (Client.__proto__ || Object.getPrototypeOf(Client)).apply(this, arguments));
  }

  _createClass(Client, [{
    key: 'render',
    // eslint-disable-line
    value: function render() {
      var _props = this.props,
          _props$client = _props.client,
          id = _props$client.id,
          displayName = _props$client.displayName,
          fullName = _props$client.fullName,
          isPrimaryTraveler = _props$client.isPrimaryTraveler,
          primaryTraveler = _props$client.primaryTraveler,
          active = _props.active;


      return _react2.default.createElement(
        _reactRouterDom.Link,
        {
          to: '/clients/' + id + '/',
          className: active ? _styles2.default.active : null
        },
        _react2.default.createElement(
          'div',
          { className: _styles2.default.clientListItem },
          displayName || fullName,
          !isPrimaryTraveler && primaryTraveler && _react2.default.createElement(
            'div',
            {
              className: _styles2.default.primaryTravelerName
            },
            '(',
            primaryTraveler.fullName,
            ')'
          ) || null
        )
      );
    }
  }]);

  return Client;
}(_react2.default.Component);

exports.default = Client;


Client.propTypes = {
  client: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    fullName: _propTypes2.default.string
  }).isRequired,
  active: _propTypes2.default.bool.isRequired
};

/***/ }),

/***/ "ZGSp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RateQuoteGenerator = undefined;

var _RateQuoteGenerator2 = __webpack_require__("XhpN");

var _RateQuoteGenerator3 = _interopRequireDefault(_RateQuoteGenerator2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.RateQuoteGenerator = _RateQuoteGenerator3.default;

/***/ }),

/***/ "ZUio":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__("Q4lS");

var _reactRouterDom = __webpack_require__("F8kA");

var _Sales = __webpack_require__("99iq");

var _Sales2 = _interopRequireDefault(_Sales);

var _Admin = __webpack_require__("DqTz");

var _Admin2 = _interopRequireDefault(_Admin);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Reports = (_temp = _class = function (_React$Component) {
  _inherits(Reports, _React$Component);

  function Reports(props) {
    _classCallCheck(this, Reports);

    var _this = _possibleConstructorReturn(this, (Reports.__proto__ || Object.getPrototypeOf(Reports)).call(this, props));

    _initialiseProps.call(_this);

    var selectedTab = props.match.params.selectedTab;


    _this.state = { selectedTab: selectedTab };
    return _this;
  }

  _createClass(Reports, [{
    key: 'render',
    value: function render() {
      var selectedTab = this.state.selectedTab;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _materialUi.Tabs,
          { value: selectedTab, onChange: this.handleChange },
          _react2.default.createElement(
            _materialUi.Tab,
            { label: 'Admin Report', value: 'admin' },
            _react2.default.createElement(_Admin2.default, null)
          ),
          _react2.default.createElement(
            _materialUi.Tab,
            { label: 'Sales Report', value: 'sales' },
            _react2.default.createElement(_reactRouterDom.Route, { path: '/reports/sales/', component: _Sales2.default })
          )
        )
      );
    }
  }]);

  return Reports;
}(_react2.default.Component), _class.propTypes = {
  match: _propTypes2.default.shape({
    params: _propTypes2.default.shape({
      selectedTab: _propTypes2.default.string
    })
  }),
  history: _propTypes2.default.shape().isRequired
}, _class.defaultProps = {
  match: { params: { selectedTab: 'admin' } }
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleChange = function (selectedTab) {
    var history = _this2.props.history;

    _this2.setState({ selectedTab: selectedTab });
    history.push('/reports/' + selectedTab + '/');
  };
}, _temp);
exports.default = Reports;

/***/ }),

/***/ "Zg14":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _process$env$API_SERV = process.env.API_SERVER,
    API_SERVER = _process$env$API_SERV === undefined ? "http://localhost:8000" : _process$env$API_SERV;
exports.default = API_SERVER;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("W2nU")))

/***/ }),

/***/ "aAyi":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 7632d0e8a76eae7c18299a05e3c96d0e
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type TripDetailsRenderer_TripDetails_QueryResponse = {|
  +allUsers: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string;
        +username: string;
        +firstName: string;
        +lastName: string;
        +groups: ?$ReadOnlyArray<?string>;
      |};
    |}>;
  |};
  +trip: ?{|
    +id: string;
    +searchId: ?string;
    +tripName: ?string;
    +primaryTravelerName: ?string;
    +destination: string;
    +dateString: ?string;
    +numAdults: number;
    +numChildren: number;
    +specificDates: boolean;
    +startDate: ?string;
    +endDate: ?string;
    +timeFrame: ?string;
    +category: ?{|
      +id: string;
      +name: string;
    |};
    +owner: ?{|
      +id: string;
      +username: string;
      +firstName: string;
      +lastName: string;
    |};
    +travelers: ?$ReadOnlyArray<?{|
      +id: string;
      +firstName: string;
      +lastName: string;
      +isPrimaryTraveler: boolean;
      +primaryTravelerName: string;
      +primaryTraveler: ?{|
        +id: string;
      |};
      +birthdate: ?any;
      +adult: boolean;
      +currentTier: ?number;
      +fired: boolean;
      +lowPriority: boolean;
      +needsTraining: boolean;
      +needsVetting: boolean;
      +highPriority: boolean;
    |}>;
    +segments: ?$ReadOnlyArray<?{|
      +id: string;
      +vendor: ?{|
        +id: string;
        +name: string;
        +amenityPrograms: ?$ReadOnlyArray<?string>;
      |};
      +trip: ?{|
        +id: string;
        +searchId: ?string;
      |};
      +name: ?string;
      +dateString: ?string;
      +startDate: ?string;
      +endDate: ?string;
      +category: ?string;
      +bedType: ?string;
      +amenityProgram: ?string;
      +numAdults: ?number;
      +numChildren: ?number;
      +smokingRoom: ?boolean;
      +rates: ?$ReadOnlyArray<?number>;
      +currency: string;
      +averageDailyRate: boolean;
      +cancellationDeadline: ?any;
      +dropbox: boolean;
      +invoiced: boolean;
      +vipDrafted: boolean;
      +booked: boolean;
      +cancelled: boolean;
      +sabreLocator: string;
      +confirmationNumber: string;
      +cancellationNumber: string;
      +vipLetter: string;
      +notes: ?$ReadOnlyArray<?{|
        +id: string;
        +owner: {|
          +id: string;
          +firstName: string;
        |};
        +content: string;
        +created: any;
      |}>;
    |}>;
    +history: ?$ReadOnlyArray<?{|
      +user: ?{|
        +firstName: string;
        +lastName: string;
      |};
      +comment: string;
      +dateCreated: any;
    |}>;
    +notes: ?$ReadOnlyArray<?{|
      +owner: {|
        +id: string;
        +firstName: string;
      |};
      +content: string;
      +created: any;
    |}>;
    +vipNotes: string;
    +inquiry: boolean;
    +active: boolean;
    +cancelled: boolean;
    +inbox: ?string;
    +created: any;
    +modified: any;
    +tier: ?number;
    +fired: boolean;
    +lowPriority: boolean;
    +highPriority: boolean;
    +needsTraining: boolean;
    +needsVetting: boolean;
    +insideCircle: boolean;
    +prospect: boolean;
    +tasks: ?$ReadOnlyArray<?{|
      +id: string;
      +taskType: "DRAFT_WH" | "CANCEL_WH" | "OTHER";
      +description: string;
      +completed: boolean;
      +dueDate: ?any;
      +voided: boolean;
      +voidDate: ?any;
      +history: ?$ReadOnlyArray<?{|
        +name: ?string;
        +action: ?string;
        +timestamp: ?string;
      |}>;
    |}>;
  |};
|};
*/

/*
query TripDetailsRenderer_TripDetails_Query(
  $tripId: ID!
) {
  allUsers {
    edges {
      node {
        id
        username
        firstName
        lastName
        groups
      }
    }
  }
  trip(id: $tripId) {
    notes {
      owner {
        id
        firstName
      }
      content
      created
      id
    }
    id
    tripName
    primaryTravelerName
    destination
    dateString
    numAdults
    numChildren
    specificDates
    startDate
    endDate
    timeFrame
    category {
      id
      name
    }
    owner {
      id
      username
      firstName
      lastName
    }
    travelers {
      adult
      id
      lastName
      isPrimaryTraveler
      primaryTravelerName
      primaryTraveler {
        id
      }
      birthdate
      firstName
      currentTier
      fired
      lowPriority
      needsTraining
      needsVetting
      highPriority
    }
    segments {
      rates
      id
      trip {
        id
        searchId
      }
      name
      dateString
      startDate
      endDate
      category
      bedType
      amenityProgram
      numAdults
      numChildren
      smokingRoom
      vendor {
        id
        name
        amenityPrograms
      }
      currency
      averageDailyRate
      cancellationDeadline
      dropbox
      invoiced
      vipDrafted
      booked
      cancelled
      sabreLocator
      confirmationNumber
      cancellationNumber
      vipLetter
      notes {
        id
        owner {
          id
          firstName
        }
        content
        created
      }
    }
    history {
      user {
        firstName
        lastName
        id
      }
      comment
      dateCreated
      id
    }
    searchId
    vipNotes
    inquiry
    active
    cancelled
    inbox
    created
    modified
    tier
    fired
    lowPriority
    highPriority
    needsTraining
    needsVetting
    insideCircle
    prospect
    tasks {
      id
      taskType
      description
      completed
      dueDate
      voided
      voidDate
      history {
        name
        action
        timestamp
      }
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "tripId",
      "type": "ID!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "TripDetailsRenderer_TripDetails_Query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "UserConnection",
      "name": "allUsers",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "UserEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "User",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "username",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "lastName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "groups",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "id",
        "variableName": "tripId",
        "type": "ID!"
      }],
      "concreteType": "Trip",
      "name": "trip",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Note",
        "name": "notes",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "User",
          "name": "owner",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstName",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "content",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "created",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "tripName",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "primaryTravelerName",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "destination",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "dateString",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "numAdults",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "numChildren",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "specificDates",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "startDate",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "endDate",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "timeFrame",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "TripCategory",
        "name": "category",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "User",
        "name": "owner",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "username",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "firstName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "lastName",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Traveler",
        "name": "travelers",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "adult",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "lastName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "isPrimaryTraveler",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "primaryTravelerName",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Traveler",
          "name": "primaryTraveler",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "birthdate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "firstName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "currentTier",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "fired",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "lowPriority",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "needsTraining",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "needsVetting",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "highPriority",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Segment",
        "name": "segments",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "rates",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Trip",
          "name": "trip",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "searchId",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dateString",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "startDate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "endDate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "category",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "bedType",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "amenityProgram",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "numAdults",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "numChildren",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "smokingRoom",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Vendor",
          "name": "vendor",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "amenityPrograms",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "currency",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "averageDailyRate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancellationDeadline",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dropbox",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "invoiced",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "vipDrafted",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "booked",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancelled",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "sabreLocator",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "confirmationNumber",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancellationNumber",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "vipLetter",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Note",
          "name": "notes",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "owner",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "firstName",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "content",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "created",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Revision",
        "name": "history",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "lastName",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "comment",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dateCreated",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "searchId",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "vipNotes",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "inquiry",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "active",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "cancelled",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "inbox",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "created",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "modified",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "tier",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "fired",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "lowPriority",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "highPriority",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "needsTraining",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "needsVetting",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "insideCircle",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "prospect",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "name": "tasks",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "taskType",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "description",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "completed",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dueDate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "voided",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "voidDate",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "TaskHistoryObject",
          "name": "history",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "action",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "timestamp",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "TripDetailsRenderer_TripDetails_Query",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "tripId",
      "type": "ID!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "TripDetailsRenderer_TripDetails_Query",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "UserConnection",
      "name": "allUsers",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "UserEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "User",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "username",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "lastName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "groups",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }, {
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "id",
        "variableName": "tripId",
        "type": "ID!"
      }],
      "concreteType": "Trip",
      "name": "trip",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "searchId",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Note",
        "name": "notes",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "User",
          "name": "owner",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstName",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "content",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "created",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "tripName",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "primaryTravelerName",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "destination",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "dateString",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "numAdults",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "numChildren",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "specificDates",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "startDate",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "endDate",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "timeFrame",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "TripCategory",
        "name": "category",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "User",
        "name": "owner",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "username",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "firstName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "lastName",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Traveler",
        "name": "travelers",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "firstName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "adult",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "lastName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "isPrimaryTraveler",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "primaryTravelerName",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Traveler",
          "name": "primaryTraveler",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "birthdate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "currentTier",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "fired",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "lowPriority",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "needsTraining",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "needsVetting",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "highPriority",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Segment",
        "name": "segments",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Vendor",
          "name": "vendor",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "amenityPrograms",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "rates",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Trip",
          "name": "trip",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "searchId",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "name",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dateString",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "startDate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "endDate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "category",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "bedType",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "amenityProgram",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "numAdults",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "numChildren",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "smokingRoom",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "currency",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "averageDailyRate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancellationDeadline",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dropbox",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "invoiced",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "vipDrafted",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "booked",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancelled",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "sabreLocator",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "confirmationNumber",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancellationNumber",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "vipLetter",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Note",
          "name": "notes",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "User",
            "name": "owner",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "firstName",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "content",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "created",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Revision",
        "name": "history",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "lastName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "comment",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dateCreated",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "vipNotes",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "inquiry",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "active",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "cancelled",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "inbox",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "created",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "modified",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "tier",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "fired",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "lowPriority",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "highPriority",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "needsTraining",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "needsVetting",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "insideCircle",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "prospect",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Task",
        "name": "tasks",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "taskType",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "description",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "completed",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dueDate",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "voided",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "voidDate",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "TaskHistoryObject",
          "name": "history",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "action",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "timestamp",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "query TripDetailsRenderer_TripDetails_Query(\n  $tripId: ID!\n) {\n  allUsers {\n    edges {\n      node {\n        id\n        username\n        firstName\n        lastName\n        groups\n      }\n    }\n  }\n  trip(id: $tripId) {\n    notes {\n      owner {\n        id\n        firstName\n      }\n      content\n      created\n      id\n    }\n    id\n    tripName\n    primaryTravelerName\n    destination\n    dateString\n    numAdults\n    numChildren\n    specificDates\n    startDate\n    endDate\n    timeFrame\n    category {\n      id\n      name\n    }\n    owner {\n      id\n      username\n      firstName\n      lastName\n    }\n    travelers {\n      adult\n      id\n      lastName\n      isPrimaryTraveler\n      primaryTravelerName\n      primaryTraveler {\n        id\n      }\n      birthdate\n      firstName\n      currentTier\n      fired\n      lowPriority\n      needsTraining\n      needsVetting\n      highPriority\n    }\n    segments {\n      rates\n      id\n      trip {\n        id\n        searchId\n      }\n      name\n      dateString\n      startDate\n      endDate\n      category\n      bedType\n      amenityProgram\n      numAdults\n      numChildren\n      smokingRoom\n      vendor {\n        id\n        name\n        amenityPrograms\n      }\n      currency\n      averageDailyRate\n      cancellationDeadline\n      dropbox\n      invoiced\n      vipDrafted\n      booked\n      cancelled\n      sabreLocator\n      confirmationNumber\n      cancellationNumber\n      vipLetter\n      notes {\n        id\n        owner {\n          id\n          firstName\n        }\n        content\n        created\n      }\n    }\n    history {\n      user {\n        firstName\n        lastName\n        id\n      }\n      comment\n      dateCreated\n      id\n    }\n    searchId\n    vipNotes\n    inquiry\n    active\n    cancelled\n    inbox\n    created\n    modified\n    tier\n    fired\n    lowPriority\n    highPriority\n    needsTraining\n    needsVetting\n    insideCircle\n    prospect\n    tasks {\n      id\n      taskType\n      description\n      completed\n      dueDate\n      voided\n      voidDate\n      history {\n        name\n        action\n        timestamp\n      }\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "aDnY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _ActionTypes = __webpack_require__("zLtr");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _createReducer2 = __webpack_require__("AA0U");

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function formatDate(date) {
  var dateFormat = 'DDMMM';
  return date.format(dateFormat).toUpperCase();
}

var initialState = _immutable2.default.fromJS({
  arrival: null,
  departure: null,
  duration: 0,
  dateString: '',
  destination: '',
  vendorName: '',
  vendorURL: '',
  roomRates: '',
  amenityType: '',
  amenities: ''
});

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _ActionTypes2.default.RateQuote.updateDateRange, function (state, _ref) {
  var string = _ref.string;
  var startDate = string.startDate,
      endDate = string.endDate;

  var duration = Math.floor(_moment2.default.duration(endDate - startDate).asDays());
  var dateString = formatDate(startDate) + '-' + duration + 'NT';

  return state.merge({
    arrival: startDate.valueOf(),
    departure: endDate.valueOf(),
    duration: duration,
    dateString: dateString
  });
}), _defineProperty(_createReducer, _ActionTypes2.default.RateQuote.updateDateString, function (state, _ref2) {
  var string = _ref2.string;

  var dateStringRE = /(\d{1,2})(\w{3})[\- ](\d+)[Nn][Tt]/;
  var match = dateStringRE.exec(string);

  if (match) {
    var _match = _slicedToArray(match, 4),
        entry = _match[0],
        day = _match[1],
        month = _match[2],
        duration = _match[3];

    var startDate = (0, _moment2.default)(day + ' ' + month + ' ' + (0, _moment2.default)().format('YYYY'));

    if (startDate < (0, _moment2.default)()) {
      startDate.add(1, 'years');
    }

    var endDate = (0, _moment2.default)(startDate).add(_moment2.default.duration(parseInt(duration), 'days'));

    return state.merge({
      arrival: startDate.valueOf(),
      departure: endDate.valueOf(),
      duration: parseInt(duration),
      dateString: string
    });
  }
  return state.merge({
    dateString: string
  });
}), _defineProperty(_createReducer, _ActionTypes2.default.RateQuote.toggleDatePicker, function (state, _ref3) {
  var string = _ref3.string;

  return state.set('showDatePicker', string);
}), _defineProperty(_createReducer, _ActionTypes2.default.RateQuote.updateString, function (state, _ref4) {
  var fieldName = _ref4.fieldName,
      value = _ref4.value;

  return state.set(fieldName, value);
}), _createReducer));

/***/ }),

/***/ "aHX8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRedux = __webpack_require__("RH2O");

var _materialUi = __webpack_require__("Q4lS");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactHelmet = __webpack_require__("PIAa");

var _reactRelay = __webpack_require__("Tc9k");

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _styles = __webpack_require__("IoNl");

var _styles2 = _interopRequireDefault(_styles);

var _TravelerListItem = __webpack_require__("ffVy");

var _TravelerListItem2 = _interopRequireDefault(_TravelerListItem);

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

var _EditTrip = __webpack_require__("tTpR");

var _EditTrip2 = _interopRequireDefault(_EditTrip);

var _VoidTrip = __webpack_require__("JqB5");

var _VoidTrip2 = _interopRequireDefault(_VoidTrip);

var _SegmentListItem = __webpack_require__("kujC");

var _SegmentListItem2 = _interopRequireDefault(_SegmentListItem);

var _AddSegment = __webpack_require__("UwLa");

var _AddSegment2 = _interopRequireDefault(_AddSegment);

var _AddTraveler = __webpack_require__("wJEc");

var _AddTraveler2 = _interopRequireDefault(_AddTraveler);

var _NoteListItem = __webpack_require__("abLE");

var _NoteListItem2 = _interopRequireDefault(_NoteListItem);

var _AddNote = __webpack_require__("Yobl");

var _AddNote2 = _interopRequireDefault(_AddNote);

var _NotesComponent = __webpack_require__("WsVO");

var _NotesComponent2 = _interopRequireDefault(_NotesComponent);

var _TaskListItem = __webpack_require__("3dDk");

var _TaskListItem2 = _interopRequireDefault(_TaskListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultState = {
  addingTraveler: false,
  addingSegment: false,
  editing: false,
  cancelling: false,
  cancelReason: "",
  showNotes: false,
  addingNote: false,
  titleHeight: 109,
  showVIPNotes: false,
  disableVIPHide: false,
  showAllTasks: false
};

var TripDetails = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    windowHeight: state.Responsive.get("windowHeight")
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(TripDetails, _React$Component);

  function TripDetails(props) {
    _classCallCheck(this, TripDetails);

    var _this = _possibleConstructorReturn(this, (TripDetails.__proto__ || Object.getPrototypeOf(TripDetails)).call(this, props));

    _this.setTitleHeight = function () {
      var oldTitleHeight = _this.state.titleHeight;

      var titleHeight = document.getElementById("title").clientHeight;
      if (titleHeight !== oldTitleHeight) {
        _this.setState({ titleHeight: titleHeight });
      }
    };

    _this.toggle = function (prop) {
      return function () {
        var key = "" + prop;
        var oldValue = _this.state[key];
        var newState = {};
        newState[key] = !oldValue;
        _this.setState(newState);
      };
    };

    _this.noteState = function (disableVIPHide) {
      _this.setState({ disableVIPHide: disableVIPHide });
    };

    _this.addTask = function (taskType) {
      return function () {
        var tripId = _this.props.trip.id;


        (0, _reactRelay.commitMutation)(_environment2.default, {
          mutation: _graphql || (_graphql = function _graphql() {
            return __webpack_require__("eU/k");
          }),
          variables: { input: { tripId: tripId, taskType: taskType } },
          onError: function onError(err) {
            return alert(err);
          }
        });
      };
    };

    _this.state = defaultState;
    return _this;
  }

  _createClass(TripDetails, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.setTitleHeight();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.setTitleHeight();
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var oldId = this.props.trip.id;
      var newId = nextProps.trip.id;


      var oldTitleHeight = this.state.titleHeight;
      var newTitleHeight = document.getElementById("title").clientHeight;

      var newState = defaultState;
      newState.titleHeight = newTitleHeight;

      if (oldId !== newId || oldTitleHeight !== newTitleHeight) {
        this.setState(newState);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          trip = _props.trip,
          users = _props.users,
          windowHeight = _props.windowHeight;
      var primaryTravelerName = trip.primaryTravelerName,
          destination = trip.destination,
          dateString = trip.dateString,
          endDate = trip.endDate,
          inbox = trip.inbox,
          owner = trip.owner,
          travelers = trip.travelers,
          category = trip.category.name,
          cancelled = trip.cancelled,
          segments = trip.segments,
          tripNotes = trip.notes,
          created = trip.created,
          modified = trip.modified,
          fired = trip.fired,
          lowPriority = trip.lowPriority,
          highPriority = trip.highPriority,
          insideCircle = trip.insideCircle,
          needsTraining = trip.needsTraining,
          needsVetting = trip.needsVetting,
          prospect = trip.prospect,
          id = trip.id,
          vipNotes = trip.vipNotes,
          tasks = trip.tasks;

      var numTravelers = travelers.length;
      var numAdults = travelers.filter(function (traveler) {
        return traveler.adult;
      }).length;
      var numChildren = numTravelers - numAdults;
      var numSegments = segments.length;

      var totalTasks = tasks.length;
      var toDo = tasks.filter(function (task) {
        return !task.completed && !task.voided;
      });
      var completed = tasks.filter(function (task) {
        return task.completed && !task.voided;
      });
      var voided = tasks.filter(function (task) {
        return task.voided;
      });

      var wHTasks = toDo.filter(function (task) {
        return task.taskType === "DRAFT_WH" || task.taskType === "CANCEL_WH";
      });
      var hasWHTask = wHTasks.length > 0;
      var needsWHTask = !hasWHTask && (0, _moment2.default)(endDate) > (0, _moment2.default)();

      var addWHTaskType = void 0;
      if (needsWHTask) {
        var numDrafted = completed.filter(function (task) {
          return task.taskType === "DRAFT_WH";
        }).length;
        var numCancelled = completed.filter(function (task) {
          return task.taskType === "CANCEL_WH";
        }).length;

        if (numDrafted > numCancelled) {
          addWHTaskType = "cancel_wh";
        } else {
          addWHTaskType = "draft_wh";
        }
      } else {
        addWHTaskType = null;
      }

      var numToDo = toDo.length;
      var numCompleted = completed.length;
      var numVoided = voided.length;

      var combinedNotes = _lodash2.default.concat.apply(_lodash2.default, [tripNotes].concat(_toConsumableArray(segments.map(function (segment) {
        return segment.notes.map(function (note) {
          return _extends({}, note, {
            segmentName: segment.name
          });
        });
      })))).sort(function (_ref, _ref2) {
        var firstDate = _ref.created;
        var secondDate = _ref2.created;

        if (firstDate < secondDate) {
          return 1;
        } else if (firstDate > secondDate) {
          return -1;
        }
        return 0;
      });
      var numNotes = combinedNotes.length;

      var _state = this.state,
          editing = _state.editing,
          cancelling = _state.cancelling,
          addingTraveler = _state.addingTraveler,
          addingSegment = _state.addingSegment,
          showNotes = _state.showNotes,
          addingNote = _state.addingNote,
          titleHeight = _state.titleHeight,
          showVIPNotes = _state.showVIPNotes,
          disableVIPHide = _state.disableVIPHide,
          showAllTasks = _state.showAllTasks;


      var preventAction = editing || cancelling || addingTraveler || addingSegment;
      var preventCancel = preventAction || _lodash2.default.some(segments.map(function (segment) {
        if (segment.booked && !segment.cancelled) {
          return true;
        } else if (segment.cancelled && (segment.invoiced || segment.vipSent)) {
          return true;
        }

        return false;
      }));

      var detailsContainerStyle = {
        maxHeight: windowHeight - titleHeight - 64,
        top: titleHeight
      };

      var createdMoment = (0, _moment2.default)(created);
      var modifiedMoment = (0, _moment2.default)(modified);
      var createdStamp = (0, _moment2.default)(createdMoment).format("dddd, MMMM Do YYYY, h:mm a");
      var createdFromNow = (0, _moment2.default)(createdMoment).fromNow();
      var modifiedStamp = (0, _moment2.default)(modifiedMoment).format("dddd, MMMM Do YYYY, h:mm a");
      var modifiedFromNow = (0, _moment2.default)(modifiedMoment).fromNow();

      var flags = [fired ? "fired" : false, prospect ? "prospect" : false, insideCircle ? "insideCircle" : false, lowPriority ? "lowPriority" : false, needsTraining ? "needsTraining" : false, needsVetting ? "needsVetting" : false, highPriority ? "highPriority" : false].filter(function (flag) {
        return flag !== false;
      });
      var flagLabels = {
        fired: "fired",
        prospect: "prospect",
        insideCircle: "Inside Circle",
        lowPriority: "low priority",
        needsTraining: "needs training",
        needsVetting: "needs vetting",
        highPriority: "BMOC"
      };

      var pageTitle = primaryTravelerName + " " + dateString + " " + destination;

      return _react2.default.createElement(
        "div",
        { style: styles.tripContainer },
        _react2.default.createElement(
          _reactHelmet.Helmet,
          null,
          _react2.default.createElement(
            "title",
            null,
            pageTitle
          )
        ),
        _react2.default.createElement(
          "div",
          { className: _styles2.default.tripTitle, id: "title" },
          _react2.default.createElement(
            "div",
            { className: _styles2.default.leftBlock },
            _react2.default.createElement(
              "span",
              {
                className: cancelled ? _styles2.default.cancelledPrimary : _styles2.default.titlePrimary
              },
              primaryTravelerName
            ),
            _react2.default.createElement(
              "span",
              {
                className: cancelled ? _styles2.default.cancelledSecondary : _styles2.default.titleSecondary
              },
              destination
            ),
            _react2.default.createElement(
              "span",
              {
                className: cancelled ? _styles2.default.cancelledSecondary : _styles2.default.titleSecondary
              },
              dateString
            )
          ),
          _react2.default.createElement(
            "div",
            { className: _styles2.default.middleBlock },
            _react2.default.createElement(
              "div",
              { className: _styles2.default.flags },
              flags.map(function (flag, index) {
                return _react2.default.createElement(
                  "div",
                  { key: index, className: _styles2.default[flag] },
                  flagLabels[flag]
                );
              })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: _styles2.default.rightBlock },
            _react2.default.createElement(
              "span",
              null,
              "Contact Inbox:"
            ),
            _react2.default.createElement(
              "span",
              null,
              inbox || "none set"
            ),
            _react2.default.createElement(
              "span",
              null,
              "Assigned To:"
            ),
            _react2.default.createElement(
              "span",
              null,
              owner.firstName + " " + owner.lastName[0] + "."
            ),
            _react2.default.createElement(
              "span",
              null,
              "Trip Type:"
            ),
            _react2.default.createElement(
              "span",
              null,
              category
            ),
            _react2.default.createElement(
              "span",
              { className: _styles2.default.button },
              _react2.default.createElement(_materialUi.FlatButton, {
                label: "Edit Details",
                primary: true,
                onTouchTap: this.toggle("editing"),
                disabled: preventAction
              })
            ),
            _react2.default.createElement(
              "span",
              { className: _styles2.default.button },
              cancelled ? _react2.default.createElement(
                "span",
                {
                  style: {
                    color: "red",
                    textTransform: "uppercase"
                  }
                },
                "Voided"
              ) : _react2.default.createElement(_materialUi.FlatButton, {
                label: "Void Trip",
                secondary: true,
                onTouchTap: this.toggle("cancelling"),
                disabled: preventCancel
              })
            )
          ),
          _react2.default.createElement(
            "div",
            { className: _styles2.default.timestamp },
            _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                "span",
                { className: _styles2.default.label },
                "Created:"
              ),
              _react2.default.createElement(
                "span",
                { className: _styles2.default.data },
                createdStamp
              ),
              _react2.default.createElement(
                "span",
                { className: _styles2.default.data },
                "(",
                createdFromNow,
                ")"
              )
            ),
            _react2.default.createElement(
              "div",
              null,
              _react2.default.createElement(
                "span",
                { className: _styles2.default.label },
                "Modified:"
              ),
              _react2.default.createElement(
                "span",
                { className: _styles2.default.data },
                modifiedStamp
              ),
              _react2.default.createElement(
                "span",
                { className: _styles2.default.data },
                "(",
                modifiedFromNow,
                ")"
              )
            )
          )
        ),
        _react2.default.createElement(
          "div",
          { style: detailsContainerStyle, className: _styles2.default.tripDetails },
          editing ? _react2.default.createElement(_EditTrip2.default, {
            trip: trip,
            users: users,
            handleSave: this.toggle("editing")
          }) : null,
          cancelling ? _react2.default.createElement(_VoidTrip2.default, { trip: trip, handleSave: this.toggle("cancelling") }) : null,
          _react2.default.createElement(
            "h4",
            null,
            "Tasks (",
            numToDo,
            " to do, ",
            numCompleted,
            " completed, ",
            numVoided,
            " ",
            "voided)",
            _react2.default.createElement(_materialUi.FlatButton, {
              label: showAllTasks ? "Hide" : "Show All",
              onTouchTap: this.toggle("showAllTasks"),
              disabled: numToDo === totalTasks
            }),
            _react2.default.createElement(_materialUi.FlatButton, {
              label: "Add Welcome Home Task",
              disabled: !needsWHTask,
              onTouchTap: this.addTask(addWHTaskType)
            })
          ),
          _react2.default.createElement(
            "ol",
            null,
            toDo.map(function (task, index) {
              return _react2.default.createElement(_TaskListItem2.default, { key: index, index: index, task: task });
            }),
            showAllTasks ? completed.map(function (task, index) {
              return _react2.default.createElement(_TaskListItem2.default, { key: index, index: index, task: task });
            }) : null,
            showAllTasks ? voided.map(function (task, index) {
              return _react2.default.createElement(_TaskListItem2.default, { key: index, index: index, task: task });
            }) : null
          ),
          _react2.default.createElement(
            "h4",
            null,
            "Notes (",
            numNotes,
            " notes)",
            " ",
            _react2.default.createElement(_materialUi.FlatButton, {
              label: showNotes ? "Hide" : "Show",
              onTouchTap: this.toggle("showNotes")
            })
          ),
          showNotes ? _react2.default.createElement(
            "ol",
            null,
            combinedNotes.map(function (note, index) {
              return _react2.default.createElement(_NoteListItem2.default, { key: index, index: index, note: note });
            })
          ) : null,
          _react2.default.createElement(_materialUi.FlatButton, {
            label: "Add Note",
            disabled: addingNote,
            onTouchTap: this.toggle("addingNote")
          }),
          addingNote ? _react2.default.createElement(_AddNote2.default, { trip: trip, onComplete: this.toggle("addingNote") }) : null,
          _react2.default.createElement(
            "h4",
            null,
            "Travelers (",
            numAdults,
            " adults, ",
            numChildren,
            " children)"
          ),
          _react2.default.createElement(
            "ol",
            null,
            travelers.map(function (traveler, index) {
              return _react2.default.createElement(_TravelerListItem2.default, {
                key: index,
                index: index,
                trip: trip,
                traveler: traveler
              });
            })
          ),
          _react2.default.createElement(_materialUi.FlatButton, {
            label: "Add Traveler",
            disabled: preventAction,
            onTouchTap: this.toggle("addingTraveler")
          }),
          addingTraveler ? _react2.default.createElement(_AddTraveler2.default, {
            index: numTravelers,
            trip: trip,
            onComplete: this.toggle("addingTraveler")
          }) : null,
          _react2.default.createElement(
            "h4",
            null,
            "VIP Notes",
            " ",
            _react2.default.createElement(_materialUi.FlatButton, {
              label: showVIPNotes ? "Hide" : "Show",
              onTouchTap: this.toggle("showVIPNotes"),
              disabled: disableVIPHide
            })
          ),
          showVIPNotes ? _react2.default.createElement(
            _materialUi.Card,
            { style: styles.vipNotes },
            _react2.default.createElement(
              _materialUi.CardText,
              null,
              _react2.default.createElement(_NotesComponent2.default, {
                id: id,
                fieldName: "vipNotes",
                value: vipNotes,
                onChange: this.noteState
              })
            )
          ) : null,
          _react2.default.createElement(
            "h4",
            null,
            "Itinerary (",
            numSegments,
            " segments)"
          ),
          _react2.default.createElement(
            "ol",
            null,
            segments.map(function (segment, index) {
              return _react2.default.createElement(_SegmentListItem2.default, {
                key: index,
                index: index,
                trip: trip,
                segment: segment
              });
            })
          ),
          _react2.default.createElement(_materialUi.FlatButton, {
            label: "Add Segment",
            disabled: preventAction,
            onTouchTap: this.toggle("addingSegment")
          }),
          addingSegment ? _react2.default.createElement(_AddSegment2.default, { trip: trip, onComplete: this.toggle("addingSegment") }) : null
        )
      );
    }
  }]);

  return TripDetails;
}(_react2.default.Component), _class2.propTypes = {
  trip: _propTypes2.default.shape().isRequired,
  windowHeight: _propTypes2.default.number.isRequired,
  users: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
}, _temp)) || _class);
exports.default = TripDetails;


var styles = {
  titleContainer: {
    position: "fixed",
    background: _ourismanTravelTheme2.default.palette.primary3Color,
    zIndex: 10
  },
  titleTop: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap"
  },
  titleBlock: {
    display: "flex",
    flexDirection: "column",
    flex: "2 1 content",
    marginRight: 30
  },
  titlePrimary: {
    fontSize: 36
  },
  titleSecondary: {
    fontSize: 24
  },
  actionBlock: {
    display: "flex",
    flexDirection: "column",
    flex: "1 0 content"
  },
  actionItem: {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between"
  },
  actionItemContent: {
    flex: "1 0 content"
  },
  vipNotes: {
    margin: 5
  }
};

/***/ }),

/***/ "abLE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _aphrodite = __webpack_require__("BK4P");

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NoteListItem = function NoteListItem(_ref) {
  var note = _ref.note;
  var content = note.content,
      firstName = note.owner.firstName,
      created = note.created,
      segmentName = note.segmentName;

  var timestamp = (0, _moment2.default)(created).format('dddd, MMMM Do YYYY, h:mm a');
  var fromNow = (0, _moment2.default)(created).fromNow();

  return _react2.default.createElement(
    'li',
    { className: newCss(styles.noteList) },
    _react2.default.createElement(
      'div',
      { className: newCss(styles.noteMeta) },
      _react2.default.createElement(
        'span',
        { className: newCss(styles.noteUser) },
        firstName
      ),
      _react2.default.createElement(
        'span',
        { className: newCss(styles.noteTimestamp) },
        timestamp
      ),
      _react2.default.createElement(
        'span',
        { className: newCss(styles.noteFromNow) },
        '(',
        fromNow,
        ')'
      )
    ),
    segmentName !== undefined ? _react2.default.createElement(
      'div',
      null,
      'Segment note for ',
      _react2.default.createElement(
        'b',
        null,
        segmentName
      ),
      ':'
    ) : null,
    _react2.default.createElement('div', {
      className: 'ql-editor',
      dangerouslySetInnerHTML: { __html: content }
    })
  );
};
NoteListItem.propTypes = {
  note: _propTypes2.default.shape().isRequired
};

exports.default = NoteListItem;


var globalSelectorHandler = function globalSelectorHandler(selector, _, generateSubtreeStyles) {
  if (selector[0] !== '*') {
    return null;
  }

  return generateSubtreeStyles(selector.slice(1));
};
var globalExtension = { selectorHandler: globalSelectorHandler };

var _StyleSheet$extend = _aphrodite.StyleSheet.extend([globalExtension]),
    newStyleSheet = _StyleSheet$extend.StyleSheet,
    newCss = _StyleSheet$extend.css;

var styles = newStyleSheet.create({
  noteList: {
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 5,
    ':nth-child(even)': {
      background: _ourismanTravelTheme2.default.palette.primary3Color
    }
  },
  noteMeta: {
    display: 'flex',
    alignItems: 'baseline',
    borderBottom: '1px solid ' + _ourismanTravelTheme2.default.palette.borderColor
  },
  noteUser: {
    paddingRight: 5,
    fontWeight: 'bold',
    fontSize: 12
  },
  noteTimestamp: {
    color: _ourismanTravelTheme2.default.palette.accent1Color,
    paddingRight: 5,
    fontSize: 10
  },
  noteFromNow: {
    color: _ourismanTravelTheme2.default.palette.accent1Color,
    fontSize: 10
  },
  noteContent: {
    whiteSpace: 'pre-wrap'
  }
});

/***/ }),

/***/ "apKn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setAuthData = setAuthData;
exports.logout = logout;
exports.login = login;

var _ActionTypes = __webpack_require__("zLtr");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function setAuthData(obj) {
  return {
    type: _ActionTypes2.default.Auth.setAuthData,
    obj: obj
  };
}

function logout() {
  return {
    type: _ActionTypes2.default.Auth.logout
  };
}

function login(token) {
  return {
    type: _ActionTypes2.default.Auth.login,
    token: token
  };
}

/***/ }),

/***/ "azRA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"styles-container--1NgW4","list":"styles-list--3sjWh","detail":"styles-detail--1ItKi","listFilter":"styles-listFilter--1GqPo","listItems":"styles-listItems--dar6q","active":"styles-active--1uDSQ","vipLetter":"styles-vipLetter--27vN0"};

/***/ }),

/***/ "c8yp":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c5d9e887b91b58885239cbe6873d623a
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ResponseDetailsRenderer_ResponseDetails_QueryResponse = {|
  +response: ?{|
    +savedSchema: any;
    +savedUiSchema: any;
    +response: any;
    +simpleDisplay: ?$ReadOnlyArray<?$ReadOnlyArray<?string>>;
  |};
|};
*/

/*
query ResponseDetailsRenderer_ResponseDetails_Query(
  $responseId: ID!
) {
  response(id: $responseId) {
    savedSchema
    savedUiSchema
    response
    simpleDisplay
    id
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "responseId",
      "type": "ID!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "ResponseDetailsRenderer_ResponseDetails_Query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "id",
        "variableName": "responseId",
        "type": "ID!"
      }],
      "concreteType": "FormResponse",
      "name": "response",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "savedSchema",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "savedUiSchema",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "response",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "simpleDisplay",
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ResponseDetailsRenderer_ResponseDetails_Query",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "responseId",
      "type": "ID!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "ResponseDetailsRenderer_ResponseDetails_Query",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "id",
        "variableName": "responseId",
        "type": "ID!"
      }],
      "concreteType": "FormResponse",
      "name": "response",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "savedSchema",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "savedUiSchema",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "response",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "simpleDisplay",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "query ResponseDetailsRenderer_ResponseDetails_Query(\n  $responseId: ID!\n) {\n  response(id: $responseId) {\n    savedSchema\n    savedUiSchema\n    response\n    simpleDisplay\n    id\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "dBMa":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Reports = exports.SalesReport = exports.AdminReport = undefined;

var _Admin = __webpack_require__("DqTz");

var _Admin2 = _interopRequireDefault(_Admin);

var _Sales = __webpack_require__("99iq");

var _Sales2 = _interopRequireDefault(_Sales);

var _Reports = __webpack_require__("ZUio");

var _Reports2 = _interopRequireDefault(_Reports);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AdminReport = _Admin2.default;
exports.SalesReport = _Sales2.default;
exports.Reports = _Reports2.default;

/***/ }),

/***/ "eKLQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class, _class2, _temp;

var _templateObject = _taggedTemplateLiteral(['\nquery SuggestedTravelersQuery($travelers: [String]!) {\n  allTravelers(travelers: $travelers) {\n    edges {\n      node {\n        id,\n        firstName,\n        lastName,\n        fullName,\n        displayName,\n        email,\n        birthdate,\n        adult,\n        isPrimaryTraveler,\n        primaryTraveler {\n          id\n        },\n        primaryTravelerName,\n        insideCircle,\n        needsTraining,\n        needsVetting,\n        fullName,\n      }\n    }\n  }\n}\n'], ['\nquery SuggestedTravelersQuery($travelers: [String]!) {\n  allTravelers(travelers: $travelers) {\n    edges {\n      node {\n        id,\n        firstName,\n        lastName,\n        fullName,\n        displayName,\n        email,\n        birthdate,\n        adult,\n        isPrimaryTraveler,\n        primaryTraveler {\n          id\n        },\n        primaryTravelerName,\n        insideCircle,\n        needsTraining,\n        needsVetting,\n        fullName,\n      }\n    }\n  }\n}\n']);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactApollo = __webpack_require__("3zLD");

var _aphrodite = __webpack_require__("BK4P");

var _reactRedux = __webpack_require__("RH2O");

var _materialUi = __webpack_require__("Q4lS");

var _add = __webpack_require__("XPiC");

var _add2 = _interopRequireDefault(_add);

var _InquiryActions = __webpack_require__("EJRV");

var InquiryActions = _interopRequireWildcard(_InquiryActions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var SuggestedTravelersQuery = (0, _reactApollo.gql)(_templateObject);

var SuggestedTravelers = (_dec = (0, _reactRedux.connect)(), _dec2 = (0, _reactApollo.graphql)(SuggestedTravelersQuery), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(SuggestedTravelers, _React$Component);

  function SuggestedTravelers(props) {
    _classCallCheck(this, SuggestedTravelers);

    var _this = _possibleConstructorReturn(this, (SuggestedTravelers.__proto__ || Object.getPrototypeOf(SuggestedTravelers)).call(this, props));

    _this.travelerSelected = function (selected) {
      return function () {
        var id = selected.id,
            firstName = selected.firstName,
            lastName = selected.lastName,
            fullName = selected.fullName,
            displayName = selected.displayName,
            email = selected.email,
            birthdate = selected.birthdate,
            isAdult = selected.adult,
            isPrimaryTraveler = selected.isPrimaryTraveler,
            primaryTraveler = selected.primaryTraveler,
            primaryTravelerName = selected.primaryTravelerName,
            insideCircle = selected.insideCircle,
            needsTraining = selected.needsTraining,
            needsVetting = selected.needsVetting;


        var traveler = {
          id: id,
          firstName: firstName,
          lastName: lastName,
          fullName: fullName,
          displayName: displayName,
          email: email,
          birthdate: birthdate,
          isAdult: isAdult,
          isPrimaryTraveler: isPrimaryTraveler,
          primaryTravelerId: primaryTraveler ? primaryTraveler.id : '',
          primaryTravelerName: primaryTravelerName,
          insideCircle: insideCircle,
          needsTraining: needsTraining,
          needsVetting: needsVetting
        };

        _this.props.dispatch(InquiryActions.addTraveler(traveler));
      };
    };

    _this.content = function () {
      if (_this.props.data.loading) {
        return _react2.default.createElement(
          'div',
          null,
          'Loading\u2026'
        );
      }

      var trips = _this.props.data.allTravelers.edges;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'ul',
          null,
          trips.map(function (_ref) {
            var traveler = _ref.node;
            return _react2.default.createElement(
              'li',
              { key: traveler.id, className: (0, _aphrodite.css)(styles.listItem) },
              traveler.displayName || traveler.fullName,
              _react2.default.createElement(
                _materialUi.IconButton,
                {
                  onTouchTap: _this.travelerSelected(traveler),
                  className: (0, _aphrodite.css)(styles.buttonStyle)
                },
                _react2.default.createElement(_add2.default, null)
              )
            );
          })
        )
      );
    };

    _this.state = {
      foo: 'bar'
    };
    return _this;
  }

  _createClass(SuggestedTravelers, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styles.container) },
        _react2.default.createElement(
          'h2',
          null,
          'Suggested travelers:'
        ),
        this.content()
      );
    }
  }]);

  return SuggestedTravelers;
}(_react2.default.Component), _class2.propTypes = {
  data: _propTypes2.default.shape().isRequired,
  dispatch: _propTypes2.default.func.isRequired
}, _temp)) || _class) || _class);


var styles = _aphrodite.StyleSheet.create({
  container: {
    marginRight: 15,
    marginLeft: 15
  },
  buttonStyle: {
    height: 24,
    width: 24,
    padding: 0,
    position: 'relative',
    top: 5,
    marginRight: 5
  },
  listItem: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'baseline'
  }
});

exports.default = SuggestedTravelers;

/***/ }),

/***/ "eU/k":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 751d8e04df2627ccc191898e41ff0540
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type TripDetails_AddTask_MutationVariables = {|
  input: {
    tripId?: ?string;
    taskType?: ?string;
    clientMutationId?: ?string;
  };
|};

export type TripDetails_AddTask_MutationResponse = {|
  +addTask: ?{|
    +trip: ?{|
      +id: string;
      +welcomeHome: ?boolean;
      +tasks: ?$ReadOnlyArray<?{|
        +taskType: "DRAFT_WH" | "CANCEL_WH" | "OTHER";
        +description: string;
        +completed: boolean;
        +voided: boolean;
        +history: ?$ReadOnlyArray<?{|
          +name: ?string;
          +action: ?string;
          +timestamp: ?string;
        |}>;
      |}>;
    |};
  |};
|};
*/

/*
mutation TripDetails_AddTask_Mutation(
  $input: AddTaskInput!
) {
  addTask(input: $input) {
    trip {
      id
      welcomeHome
      tasks {
        taskType
        description
        completed
        voided
        history {
          name
          action
          timestamp
        }
        id
      }
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "AddTaskInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "TripDetails_AddTask_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "AddTaskInput!"
      }],
      "concreteType": "AddTaskPayload",
      "name": "addTask",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "welcomeHome",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "name": "tasks",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "taskType",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "description",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "completed",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "voided",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TaskHistoryObject",
            "name": "history",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "action",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "timestamp",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "TripDetails_AddTask_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "AddTaskInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "TripDetails_AddTask_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "AddTaskInput!"
      }],
      "concreteType": "AddTaskPayload",
      "name": "addTask",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "welcomeHome",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "name": "tasks",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "taskType",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "description",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "completed",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "voided",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TaskHistoryObject",
            "name": "history",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "action",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "timestamp",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation TripDetails_AddTask_Mutation(\n  $input: AddTaskInput!\n) {\n  addTask(input: $input) {\n    trip {\n      id\n      welcomeHome\n      tasks {\n        taskType\n        description\n        completed\n        voided\n        history {\n          name\n          action\n          timestamp\n        }\n        id\n      }\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "ea+w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("Tc9k");

var _materialUi = __webpack_require__("Q4lS");

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _ClientDetail = __webpack_require__("DaVp");

var _ClientDetail2 = _interopRequireDefault(_ClientDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Renderer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    windowHeight: state.Responsive.get("windowHeight")
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(Renderer, _React$Component);

  function Renderer() {
    _classCallCheck(this, Renderer);

    return _possibleConstructorReturn(this, (Renderer.__proto__ || Object.getPrototypeOf(Renderer)).apply(this, arguments));
  }

  _createClass(Renderer, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          windowHeight = _props.windowHeight,
          activeClient = _props.activeClient;

      var top = (windowHeight - 161) / 2 + 161;

      var loadingEl = _react2.default.createElement(_materialUi.RefreshIndicator, { top: top, left: 900, status: "loading" });

      return _react2.default.createElement(_reactRelay.QueryRenderer, {
        environment: _environment2.default,
        variables: {
          clientId: activeClient
        },
        query: _graphql || (_graphql = function _graphql() {
          return __webpack_require__("i9/w");
        }),
        render: function render(_ref) {
          var error = _ref.error,
              props = _ref.props;

          if (error) {
            return _react2.default.createElement(
              "div",
              null,
              error.message
            );
          } else if (props) {
            var client = props.traveler;


            return _react2.default.createElement(_ClientDetail2.default, { client: client });
          }

          return loadingEl;
        }
      });
    }
  }]);

  return Renderer;
}(_react2.default.Component), _class2.propTypes = {
  windowHeight: _propTypes2.default.number.isRequired,
  activeClient: _propTypes2.default.string.isRequired
}, _temp)) || _class);
exports.default = Renderer;

/***/ }),

/***/ "ffVy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _dec, _class, _class2, _temp2, _graphql2;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__("Q4lS");

var _arrowDropDown = __webpack_require__("Pvnv");

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _arrowDropUp = __webpack_require__("Bly6");

var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);

var _reactRedux = __webpack_require__("RH2O");

var _delete = __webpack_require__("1Ilb");

var _delete2 = _interopRequireDefault(_delete);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _modeEdit = __webpack_require__("LWNG");

var _modeEdit2 = _interopRequireDefault(_modeEdit);

var _reactRouterDom = __webpack_require__("F8kA");

var _reactRelay = __webpack_require__("Tc9k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function reorderTraveler(input) {
  (0, _reactRelay.commitMutation)(_environment2.default, {
    mutation: _graphql || (_graphql = function _graphql() {
      return __webpack_require__("InNJ");
    }),
    variables: { input: input },
    onError: function onError(err) {
      return alert(err);
    }
  });
}

var TravelerListItem = (_dec = (0, _reactRedux.connect)(), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(TravelerListItem, _React$Component);

  function TravelerListItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TravelerListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TravelerListItem.__proto__ || Object.getPrototypeOf(TravelerListItem)).call.apply(_ref, [this].concat(args))), _this), _this.moveUp = function () {
      var _this$props = _this.props,
          tripId = _this$props.trip.id,
          travelerId = _this$props.traveler.id,
          index = _this$props.index;


      reorderTraveler({
        tripId: tripId,
        travelerId: travelerId,
        oldIndex: index,
        newIndex: index - 1
      });
    }, _this.moveDown = function () {
      var _this$props2 = _this.props,
          tripId = _this$props2.trip.id,
          travelerId = _this$props2.traveler.id,
          index = _this$props2.index;

      reorderTraveler({
        tripId: tripId,
        travelerId: travelerId,
        oldIndex: index,
        newIndex: index + 1
      });
    }, _this.remove = function () {
      var _this$props3 = _this.props,
          tripId = _this$props3.trip.id,
          travelerId = _this$props3.traveler.id;


      (0, _reactRelay.commitMutation)(_environment2.default, {
        mutation: _graphql2 || (_graphql2 = function _graphql2() {
          return __webpack_require__("Uot5");
        }),
        variables: { input: { tripId: tripId, travelerId: travelerId } },
        onError: function onError(err) {
          return alert(err);
        }
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TravelerListItem, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$traveler = _props.traveler,
          id = _props$traveler.id,
          firstName = _props$traveler.firstName,
          lastName = _props$traveler.lastName,
          primaryTravelerName = _props$traveler.primaryTravelerName,
          birthdate = _props$traveler.birthdate,
          adult = _props$traveler.adult,
          index = _props.index;

      var travelerName = lastName + ', ' + firstName;
      var primaryTraveler = primaryTravelerName ? ' (' + primaryTravelerName + ')' : null;

      var age = function () {
        if (birthdate) {
          return (0, _moment2.default)().diff((0, _moment2.default)(birthdate), 'years');
        } else if (adult) {
          return '18+';
        }

        return 'child';
      }();

      var listItemStyle = _extends({}, styles.listItemStyle, {
        background: index % 2 !== 0 ? _ourismanTravelTheme2.default.palette.primary3Color : ''
      });

      return _react2.default.createElement(
        'li',
        { style: listItemStyle },
        _react2.default.createElement(
          'div',
          { style: styles.listTravelerStyle },
          _react2.default.createElement(
            'div',
            null,
            _react2.default.createElement(
              _reactRouterDom.Link,
              { to: '/clients/' + id + '/' },
              travelerName
            ),
            ' (',
            age,
            ')'
          ),
          primaryTraveler ? _react2.default.createElement(
            'div',
            { style: styles.primaryTravelerStyle },
            primaryTraveler
          ) : null
        ),
        _react2.default.createElement(
          'div',
          { style: styles.listActionStyle },
          _react2.default.createElement(
            _materialUi.IconButton,
            {
              style: styles.buttonStyle,
              onTouchTap: this.moveUp
            },
            _react2.default.createElement(_arrowDropUp2.default, null)
          ),
          _react2.default.createElement(
            _materialUi.IconButton,
            {
              style: styles.buttonStyle,
              onTouchTap: this.moveDown
            },
            _react2.default.createElement(_arrowDropDown2.default, null)
          ),
          _react2.default.createElement(
            'a',
            { href: '/edit/' + id + '/', target: '_blank', rel: 'noopener noreferrer' },
            _react2.default.createElement(_modeEdit2.default, null)
          ),
          _react2.default.createElement(
            _materialUi.IconButton,
            {
              style: styles.buttonStyle,
              onTouchTap: this.remove
            },
            _react2.default.createElement(_delete2.default, null)
          )
        )
      );
    }
  }]);

  return TravelerListItem;
}(_react2.default.Component), _class2.propTypes = {
  trip: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }).isRequired,
  traveler: _propTypes2.default.shape({
    id: _propTypes2.default.string
  }).isRequired,
  index: _propTypes2.default.number.isRequired
}, _temp2)) || _class);


var styles = {
  buttonStyle: {
    padding: 0,
    width: 20,
    height: 5
  },
  listItemStyle: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    width: '100%',
    justifyContent: 'space-between'
  },
  listTravelerStyle: {
    flex: '2 0 content'
  },
  listActionStyle: {
    flex: '1 0 content',
    display: 'flex',
    alignItems: 'baseline'
  },
  primaryTravelerStyle: {
    color: 'grey',
    fontSize: 8,
    paddingLeft: 8
  }
};

exports.default = TravelerListItem;

/***/ }),

/***/ "fqvC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 19c444abeceaf8ae3b852a0d8b1725fd
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ClientDetail_SetClientFlag_MutationVariables = {|
  input: {
    travelerId?: ?string;
    checkbox?: ?string;
    value?: ?boolean;
    clientMutationId?: ?string;
  };
|};

export type ClientDetail_SetClientFlag_MutationResponse = {|
  +setClientFlag: ?{|
    +traveler: ?{|
      +insideCircle: boolean;
      +lowPriority: boolean;
      +needsTraining: boolean;
      +needsVetting: boolean;
      +fired: boolean;
      +prospect: boolean;
      +acceptPolicies: boolean;
      +acceptPoliciesTimestamp: ?any;
      +highPriority: boolean;
    |};
  |};
|};
*/

/*
mutation ClientDetail_SetClientFlag_Mutation(
  $input: SetClientFlagInput!
) {
  setClientFlag(input: $input) {
    traveler {
      insideCircle
      lowPriority
      needsTraining
      needsVetting
      fired
      prospect
      acceptPolicies
      acceptPoliciesTimestamp
      highPriority
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "SetClientFlagInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientDetail_SetClientFlag_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "SetClientFlagInput!"
      }],
      "concreteType": "SetClientFlagPayload",
      "name": "setClientFlag",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Traveler",
        "name": "traveler",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "insideCircle",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "lowPriority",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "needsTraining",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "needsVetting",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "fired",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "prospect",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "acceptPolicies",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "acceptPoliciesTimestamp",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "highPriority",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ClientDetail_SetClientFlag_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "SetClientFlagInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "ClientDetail_SetClientFlag_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "SetClientFlagInput!"
      }],
      "concreteType": "SetClientFlagPayload",
      "name": "setClientFlag",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Traveler",
        "name": "traveler",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "insideCircle",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "lowPriority",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "needsTraining",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "needsVetting",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "fired",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "prospect",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "acceptPolicies",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "acceptPoliciesTimestamp",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "highPriority",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation ClientDetail_SetClientFlag_Mutation(\n  $input: SetClientFlagInput!\n) {\n  setClientFlag(input: $input) {\n    traveler {\n      insideCircle\n      lowPriority\n      needsTraining\n      needsVetting\n      fired\n      prospect\n      acceptPolicies\n      acceptPoliciesTimestamp\n      highPriority\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "gPj6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 28180c7928593fbea5c8c2a7fe718d47
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type AppContainer_LogIn_MutationVariables = {|
  input: {
    gidToken?: ?string;
    ppToken?: ?string;
    clientMutationId?: ?string;
  };
|};

export type AppContainer_LogIn_MutationResponse = {|
  +logIn: ?{|
    +token: ?{|
      +token: string;
      +user: {|
        +id: string;
        +username: string;
        +firstName: string;
        +lastName: string;
        +isStaff: boolean;
        +isSuperuser: boolean;
        +groups: ?$ReadOnlyArray<?string>;
      |};
    |};
  |};
|};
*/

/*
mutation AppContainer_LogIn_Mutation(
  $input: LogInInput!
) {
  logIn(input: $input) {
    token {
      token
      user {
        id
        username
        firstName
        lastName
        isStaff
        isSuperuser
        groups
      }
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "LogInInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "AppContainer_LogIn_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "LogInInput!"
      }],
      "concreteType": "LogInPayload",
      "name": "logIn",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "PingPongJWT",
        "name": "token",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "token",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "username",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "lastName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isStaff",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isSuperuser",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "groups",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "AppContainer_LogIn_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "LogInInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "AppContainer_LogIn_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "LogInInput!"
      }],
      "concreteType": "LogInPayload",
      "name": "logIn",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "PingPongJWT",
        "name": "token",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "token",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "User",
          "name": "user",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "username",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "lastName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isStaff",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isSuperuser",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "groups",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation AppContainer_LogIn_Mutation(\n  $input: LogInInput!\n) {\n  logIn(input: $input) {\n    token {\n      token\n      user {\n        id\n        username\n        firstName\n        lastName\n        isStaff\n        isSuperuser\n        groups\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "gl9Z":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("Tc9k");

var _materialUi = __webpack_require__("Q4lS");

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _TripDetails = __webpack_require__("aHX8");

var _TripDetails2 = _interopRequireDefault(_TripDetails);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Renderer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    windowHeight: state.Responsive.get("windowHeight"),
    filter: state.Trips.get("filter"),
    selectedUser: state.Trips.get("selectedUser")
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(Renderer, _React$Component);

  function Renderer() {
    _classCallCheck(this, Renderer);

    return _possibleConstructorReturn(this, (Renderer.__proto__ || Object.getPrototypeOf(Renderer)).apply(this, arguments));
  }

  _createClass(Renderer, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          windowHeight = _props.windowHeight,
          activeTrip = _props.activeTrip;

      var top = (windowHeight - 161) / 2 + 161;

      var loadingEl = _react2.default.createElement(_materialUi.RefreshIndicator, { top: top, left: 900, status: "loading" });

      return _react2.default.createElement(_reactRelay.QueryRenderer, {
        environment: _environment2.default,
        variables: {
          tripId: activeTrip
        },
        query: _graphql || (_graphql = function _graphql() {
          return __webpack_require__("aAyi");
        }),
        render: function render(_ref) {
          var error = _ref.error,
              props = _ref.props;

          if (error) {
            return _react2.default.createElement(
              "div",
              null,
              error.message
            );
          } else if (props) {
            var trip = props.trip,
                userEdges = props.allUsers.edges;

            var users = userEdges.map(function (_ref2) {
              var node = _ref2.node;
              return node;
            });

            return _react2.default.createElement(_TripDetails2.default, { trip: trip, users: users });
          }

          return loadingEl;
        }
      });
    }
  }]);

  return Renderer;
}(_react2.default.Component), _class2.propTypes = {
  windowHeight: _propTypes2.default.number.isRequired,
  activeTrip: _propTypes2.default.string.isRequired
}, _temp)) || _class);
exports.default = Renderer;

/***/ }),

/***/ "gtrU":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _ActionTypes = __webpack_require__("zLtr");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _createReducer2 = __webpack_require__("AA0U");

var _createReducer3 = _interopRequireDefault(_createReducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = _immutable2.default.fromJS({
  windowHeight: 0,
  windowWidth: '',
  viewport: 'desktop'
});

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _ActionTypes2.default.Responsive.updateWindowWidth, function (state, _ref) {
  var width = _ref.width;

  var viewport = width >= 800 ? 'desktop' : 'mobile';
  return state.set('windowWidth', width).set('viewport', viewport);
}), _defineProperty(_createReducer, _ActionTypes2.default.Responsive.updateWindowHeight, function (state, _ref2) {
  var height = _ref2.height;

  return state.set('windowHeight', height);
}), _createReducer));

/***/ }),

/***/ "hO+Y":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__("Q4lS");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _aphrodite = __webpack_require__("BK4P");

var _DateRangeComponent = __webpack_require__("JW7h");

var _DateRangeComponent2 = _interopRequireDefault(_DateRangeComponent);

var _AdminReport = __webpack_require__("txmD");

var _AdminReport2 = _interopRequireDefault(_AdminReport);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateFormat = 'DDMMM';

var AdminReportRenderer = function (_React$Component) {
  _inherits(AdminReportRenderer, _React$Component);

  function AdminReportRenderer(props) {
    _classCallCheck(this, AdminReportRenderer);

    var _this = _possibleConstructorReturn(this, (AdminReportRenderer.__proto__ || Object.getPrototypeOf(AdminReportRenderer)).call(this, props));

    _this.updateDates = function (e) {
      var startDate = e.startDate,
          endDate = e.endDate;

      _this.setState({
        enteredStart: startDate,
        enteredEnd: endDate
      });
    };

    _this.setDates = function () {
      var _this$state = _this.state,
          enteredStart = _this$state.enteredStart,
          enteredEnd = _this$state.enteredEnd;

      _this.setState({
        startDate: enteredStart,
        endDate: enteredEnd
      });
    };

    var defaultStart = (0, _moment2.default)().day(-6).startOf('day');
    var defaultEnd = (0, _moment2.default)().day(1).startOf('day');

    _this.state = {
      startDate: defaultStart,
      endDate: defaultEnd,
      enteredStart: defaultStart,
      enteredEnd: defaultEnd
    };
    return _this;
  }

  _createClass(AdminReportRenderer, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          startDate = _state.startDate,
          endDate = _state.endDate,
          enteredStart = _state.enteredStart,
          enteredEnd = _state.enteredEnd;

      var formattedStartDate = startDate.format(DateFormat).toUpperCase();
      var formattedEndDate = endDate.format(DateFormat).toUpperCase();
      var duration = _moment2.default.range(startDate, endDate).diff('days');
      var dateString = formattedStartDate + '-' + duration + 'NT';

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _materialUi.Card,
          { className: (0, _aphrodite.css)(styles.report) },
          _react2.default.createElement(_materialUi.CardHeader, { title: 'Admin Report for ' + dateString }),
          _react2.default.createElement(
            _materialUi.CardText,
            { className: (0, _aphrodite.css)(styles.settings) },
            _react2.default.createElement(_DateRangeComponent2.default, {
              startValue: formattedStartDate,
              endValue: formattedEndDate,
              startLabel: 'Start Date',
              endLabel: 'End Date',
              onChange: this.updateDates,
              allowPast: true
            }),
            _react2.default.createElement(_materialUi.RaisedButton, {
              primary: true,
              label: 'Set Dates',
              onTouchTap: this.setDates,
              disabled: startDate === enteredStart || endDate === enteredEnd
            })
          )
        ),
        _react2.default.createElement(_AdminReport2.default, { startDate: startDate, endDate: endDate, dateString: dateString })
      );
    }
  }]);

  return AdminReportRenderer;
}(_react2.default.Component);

exports.default = AdminReportRenderer;


var styles = _aphrodite.StyleSheet.create({
  report: {
    margin: 15,
    minHeight: '100%'
  },
  settings: {
    display: 'flex',
    alignItems: 'baseline'
  }
});

/***/ }),

/***/ "hO6s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash c6431e6fda52f5b0a6a65cf945df3d13
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type TripListRenderer_TripList_QueryResponse = {|
  +allTrips: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string;
        +tripName: ?string;
        +primaryTravelerName: ?string;
        +destination: string;
        +dateString: ?string;
        +specificDates: boolean;
        +ownerId: ?string;
        +ownerName: ?string;
        +numSegments: ?number;
        +dropbox: ?boolean;
        +invoice: ?boolean;
        +actionableInvoice: ?boolean;
        +draftVip: ?boolean;
        +book: ?boolean;
        +cancel: ?boolean;
        +welcomeHome: ?boolean;
        +numTravelers: ?number;
        +inbox: ?string;
        +tier: ?number;
        +fired: boolean;
        +lowPriority: boolean;
        +needsTraining: boolean;
        +needsVetting: boolean;
        +insideCircle: boolean;
        +prospect: boolean;
        +highPriority: boolean;
      |};
    |}>;
  |};
|};
*/

/*
query TripListRenderer_TripList_Query {
  allTrips {
    edges {
      node {
        book
        id
        primaryTravelerName
        destination
        dateString
        specificDates
        ownerId
        ownerName
        numSegments
        dropbox
        invoice
        actionableInvoice
        draftVip
        tripName
        cancel
        welcomeHome
        numTravelers
        inbox
        tier
        fired
        lowPriority
        needsTraining
        needsVetting
        insideCircle
        prospect
        highPriority
      }
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "TripListRenderer_TripList_Query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "TripConnection",
      "name": "allTrips",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "TripEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Trip",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "book",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "primaryTravelerName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "destination",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dateString",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "specificDates",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "ownerId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "ownerName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "numSegments",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dropbox",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "invoice",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "actionableInvoice",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "draftVip",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "tripName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancel",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "welcomeHome",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "numTravelers",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "inbox",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "tier",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "fired",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "lowPriority",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "needsTraining",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "needsVetting",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "insideCircle",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "prospect",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "highPriority",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "TripListRenderer_TripList_Query",
  "query": {
    "argumentDefinitions": [],
    "kind": "Root",
    "name": "TripListRenderer_TripList_Query",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "TripConnection",
      "name": "allTrips",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "TripEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Trip",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "tripName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "book",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "primaryTravelerName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "destination",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dateString",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "specificDates",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "ownerId",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "ownerName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "numSegments",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dropbox",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "invoice",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "actionableInvoice",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "draftVip",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancel",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "welcomeHome",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "numTravelers",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "inbox",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "tier",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "fired",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "lowPriority",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "needsTraining",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "needsVetting",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "insideCircle",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "prospect",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "highPriority",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "query TripListRenderer_TripList_Query {\n  allTrips {\n    edges {\n      node {\n        book\n        id\n        primaryTravelerName\n        destination\n        dateString\n        specificDates\n        ownerId\n        ownerName\n        numSegments\n        dropbox\n        invoice\n        actionableInvoice\n        draftVip\n        tripName\n        cancel\n        welcomeHome\n        numTravelers\n        inbox\n        tier\n        fired\n        lowPriority\n        needsTraining\n        needsVetting\n        insideCircle\n        prospect\n        highPriority\n      }\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "hpIb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _aphrodite = __webpack_require__("BK4P");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NavBar = (_temp = _class = function (_React$Component) {
  _inherits(NavBar, _React$Component);

  function NavBar() {
    _classCallCheck(this, NavBar);

    return _possibleConstructorReturn(this, (NavBar.__proto__ || Object.getPrototypeOf(NavBar)).apply(this, arguments));
  }

  _createClass(NavBar, [{
    key: 'render',
    value: function render() {
      var children = this.props.children;


      return _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styles.bodyStyle) },
        children
      );
    } // eslint-disable-line

  }]);

  return NavBar;
}(_react2.default.Component), _class.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]).isRequired
}, _temp);
exports.default = NavBar;


var styles = _aphrodite.StyleSheet.create({
  bodyStyle: {
    paddingTop: 64,
    '@media (min-width: 800px)': {
      paddingLeft: 81
    }
  }
});

/***/ }),

/***/ "hrrM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _templateObject = _taggedTemplateLiteral(['\nquery UpcomingTripsQuery($travelers: [String]!) {\n  allTrips(travelers: $travelers) {\n    edges {\n      node {\n        id,\n        tripName,\n      }\n    }\n  }\n}\n'], ['\nquery UpcomingTripsQuery($travelers: [String]!) {\n  allTrips(travelers: $travelers) {\n    edges {\n      node {\n        id,\n        tripName,\n      }\n    }\n  }\n}\n']);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactApollo = __webpack_require__("3zLD");

var _reactRouterDom = __webpack_require__("F8kA");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var UpcomingTripsQuery = (0, _reactApollo.gql)(_templateObject);

var UpcomingTrips = (_dec = (0, _reactApollo.graphql)(UpcomingTripsQuery), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(UpcomingTrips, _React$Component);

  function UpcomingTrips(props) {
    _classCallCheck(this, UpcomingTrips);

    var _this = _possibleConstructorReturn(this, (UpcomingTrips.__proto__ || Object.getPrototypeOf(UpcomingTrips)).call(this, props));

    _this.content = function () {
      if (_this.props.data.loading) {
        return _react2.default.createElement(
          'div',
          null,
          'Loading\u2026'
        );
      }

      var trips = _this.props.data.allTrips.edges;


      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'ul',
          null,
          trips.map(function (_ref) {
            var _ref$node = _ref.node,
                id = _ref$node.id,
                tripName = _ref$node.tripName;
            return _react2.default.createElement(
              'li',
              { key: id },
              _react2.default.createElement(
                _reactRouterDom.Link,
                { to: '/trips/' + id + '/', target: '_blank' },
                tripName
              )
            );
          })
        )
      );
    };

    _this.state = {
      foo: 'bar'
    };
    return _this;
  }

  _createClass(UpcomingTrips, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'h2',
          null,
          'Upcoming trips for travelers:'
        ),
        this.content()
      );
    }
  }]);

  return UpcomingTrips;
}(_react2.default.Component), _class2.propTypes = {
  data: _propTypes2.default.shape().isRequired
}, _temp)) || _class);
exports.default = UpcomingTrips;

/***/ }),

/***/ "i4WM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = search;

var _isomorphicFetch = __webpack_require__("j9g7");

var _isomorphicFetch2 = _interopRequireDefault(_isomorphicFetch);

var _network = __webpack_require__("Zg14");

var _network2 = _interopRequireDefault(_network);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NODE_ENV = "production";
function search(endpoint, query) {
  var version = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "v1";

  var restURL = NODE_ENV === "development" ? _network2.default : "";
  var url = restURL + "/api/" + version + "/search/" + endpoint + "/?q=" + query;

  return (0, _isomorphicFetch2.default)(url, {
    method: "GET",
    headers: {
      authorization: "Bearer " + localStorage.getItem("PPJWT"),
      "content-type": "application/json"
    },
    credentials: "same-origin"
  }).then(function (response) {
    return response.json();
  });
}

/***/ }),

/***/ "i9/w":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 1edf4fee19458b0eb25b9fe9fe6261d5
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ClientDetailsRenderer_ClientDetails_QueryResponse = {|
  +traveler: ?{|
    +id: string;
    +cbPlusProfileId: ?number;
    +cbPlusProfileName: ?string;
    +cbPlusCreationDate: ?any;
    +displayName: string;
    +fullName: ?string;
    +firstName: string;
    +middleName: string;
    +lastName: string;
    +birthdate: ?any;
    +gender: ?string;
    +smoking: ?boolean;
    +passportExpiry: ?any;
    +isPrimaryTraveler: boolean;
    +primaryTraveler: ?{|
      +id: string;
      +fullName: ?string;
    |};
    +phone: ?$ReadOnlyArray<?{|
      +label: ?string;
      +value: ?string;
    |}>;
    +email: ?$ReadOnlyArray<?string>;
    +address1: string;
    +address2: string;
    +apt: string;
    +city: string;
    +state: string;
    +country: string;
    +zipcode: string;
    +currentTier: ?number;
    +insideCircle: boolean;
    +lowPriority: boolean;
    +highPriority: boolean;
    +needsTraining: boolean;
    +needsVetting: boolean;
    +fired: boolean;
    +welcomeCampaign: boolean;
    +welcomeBack: boolean;
    +prospect: boolean;
    +acceptPolicies: boolean;
    +acceptPoliciesTimestamp: ?any;
    +profile: any;
    +vipNotes: string;
    +profileNotes: string;
    +travelers: ?{|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +id: string;
          +displayName: string;
          +fullName: ?string;
          +vipNotes: string;
        |};
      |}>;
    |};
    +trips: ?{|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +id: string;
          +tripName: ?string;
          +owner: ?{|
            +firstName: string;
          |};
        |};
      |}>;
    |};
    +responseSet: ?{|
      +edges: $ReadOnlyArray<?{|
        +node: ?{|
          +id: string;
          +display: string;
        |};
      |}>;
    |};
  |};
|};
*/

/*
query ClientDetailsRenderer_ClientDetails_Query(
  $clientId: ID!
) {
  traveler(id: $clientId) {
    state
    id
    cbPlusProfileName
    cbPlusCreationDate
    displayName
    fullName
    firstName
    middleName
    lastName
    birthdate
    gender
    smoking
    passportExpiry
    isPrimaryTraveler
    primaryTraveler {
      id
      fullName
    }
    phone {
      label
      value
    }
    email
    address1
    address2
    apt
    city
    cbPlusProfileId
    country
    zipcode
    currentTier
    insideCircle
    lowPriority
    highPriority
    needsTraining
    needsVetting
    fired
    welcomeCampaign
    welcomeBack
    prospect
    acceptPolicies
    acceptPoliciesTimestamp
    profile
    vipNotes
    profileNotes
    travelers(first: 100) {
      edges {
        node {
          id
          displayName
          fullName
          vipNotes
        }
      }
    }
    trips(first: 100) {
      edges {
        node {
          id
          tripName
          owner {
            firstName
            id
          }
        }
      }
    }
    responseSet(first: 10) {
      edges {
        node {
          id
          display
        }
      }
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "clientId",
      "type": "ID!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientDetailsRenderer_ClientDetails_Query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "id",
        "variableName": "clientId",
        "type": "ID!"
      }],
      "concreteType": "Traveler",
      "name": "traveler",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "state",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "cbPlusProfileName",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "cbPlusCreationDate",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "displayName",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "fullName",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "firstName",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "middleName",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "lastName",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "birthdate",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "gender",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "smoking",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "passportExpiry",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "isPrimaryTraveler",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Traveler",
        "name": "primaryTraveler",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "fullName",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "HStoreObject",
        "name": "phone",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "label",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "value",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "email",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "address1",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "address2",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "apt",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "city",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "cbPlusProfileId",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "country",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "zipcode",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "currentTier",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "insideCircle",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "lowPriority",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "highPriority",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "needsTraining",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "needsVetting",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "fired",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "welcomeCampaign",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "welcomeBack",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "prospect",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "acceptPolicies",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "acceptPoliciesTimestamp",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "profile",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "vipNotes",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "profileNotes",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": [{
          "kind": "Literal",
          "name": "first",
          "value": 100,
          "type": "Int"
        }],
        "concreteType": "TravelerConnection",
        "name": "travelers",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "TravelerEdge",
          "name": "edges",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Traveler",
            "name": "node",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "displayName",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "fullName",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "vipNotes",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": "travelers{\"first\":100}"
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": [{
          "kind": "Literal",
          "name": "first",
          "value": 100,
          "type": "Int"
        }],
        "concreteType": "TripConnection",
        "name": "trips",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "TripEdge",
          "name": "edges",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Trip",
            "name": "node",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "tripName",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "User",
              "name": "owner",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "firstName",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": "trips{\"first\":100}"
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": [{
          "kind": "Literal",
          "name": "first",
          "value": 10,
          "type": "Int"
        }],
        "concreteType": "FormResponseConnection",
        "name": "responseSet",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "FormResponseEdge",
          "name": "edges",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "FormResponse",
            "name": "node",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "display",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": "responseSet{\"first\":10}"
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ClientDetailsRenderer_ClientDetails_Query",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "clientId",
      "type": "ID!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "ClientDetailsRenderer_ClientDetails_Query",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "id",
        "variableName": "clientId",
        "type": "ID!"
      }],
      "concreteType": "Traveler",
      "name": "traveler",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "cbPlusProfileId",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "state",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "cbPlusProfileName",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "cbPlusCreationDate",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "displayName",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "fullName",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "firstName",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "middleName",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "lastName",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "birthdate",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "gender",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "smoking",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "passportExpiry",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "isPrimaryTraveler",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Traveler",
        "name": "primaryTraveler",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "fullName",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "HStoreObject",
        "name": "phone",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "label",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "value",
          "storageKey": null
        }],
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "email",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "address1",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "address2",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "apt",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "city",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "country",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "zipcode",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "currentTier",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "insideCircle",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "lowPriority",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "highPriority",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "needsTraining",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "needsVetting",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "fired",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "welcomeCampaign",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "welcomeBack",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "prospect",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "acceptPolicies",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "acceptPoliciesTimestamp",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "profile",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "vipNotes",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "profileNotes",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": [{
          "kind": "Literal",
          "name": "first",
          "value": 100,
          "type": "Int"
        }],
        "concreteType": "TravelerConnection",
        "name": "travelers",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "TravelerEdge",
          "name": "edges",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Traveler",
            "name": "node",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "displayName",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "fullName",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "vipNotes",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": "travelers{\"first\":100}"
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": [{
          "kind": "Literal",
          "name": "first",
          "value": 100,
          "type": "Int"
        }],
        "concreteType": "TripConnection",
        "name": "trips",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "TripEdge",
          "name": "edges",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Trip",
            "name": "node",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "tripName",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "User",
              "name": "owner",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "firstName",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }],
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": "trips{\"first\":100}"
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": [{
          "kind": "Literal",
          "name": "first",
          "value": 10,
          "type": "Int"
        }],
        "concreteType": "FormResponseConnection",
        "name": "responseSet",
        "plural": false,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "FormResponseEdge",
          "name": "edges",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "FormResponse",
            "name": "node",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "display",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": "responseSet{\"first\":10}"
      }],
      "storageKey": null
    }]
  },
  "text": "query ClientDetailsRenderer_ClientDetails_Query(\n  $clientId: ID!\n) {\n  traveler(id: $clientId) {\n    state\n    id\n    cbPlusProfileName\n    cbPlusCreationDate\n    displayName\n    fullName\n    firstName\n    middleName\n    lastName\n    birthdate\n    gender\n    smoking\n    passportExpiry\n    isPrimaryTraveler\n    primaryTraveler {\n      id\n      fullName\n    }\n    phone {\n      label\n      value\n    }\n    email\n    address1\n    address2\n    apt\n    city\n    cbPlusProfileId\n    country\n    zipcode\n    currentTier\n    insideCircle\n    lowPriority\n    highPriority\n    needsTraining\n    needsVetting\n    fired\n    welcomeCampaign\n    welcomeBack\n    prospect\n    acceptPolicies\n    acceptPoliciesTimestamp\n    profile\n    vipNotes\n    profileNotes\n    travelers(first: 100) {\n      edges {\n        node {\n          id\n          displayName\n          fullName\n          vipNotes\n        }\n      }\n    }\n    trips(first: 100) {\n      edges {\n        node {\n          id\n          tripName\n          owner {\n            firstName\n            id\n          }\n        }\n      }\n    }\n    responseSet(first: 10) {\n      edges {\n        node {\n          id\n          display\n        }\n      }\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "iyi9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _initialiseProps, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__("Q4lS");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRelay = __webpack_require__("Tc9k");

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AmenityPrograms = function AmenityPrograms(_ref) {
  var programs = _ref.programs;

  var programEls = [_react2.default.createElement(
    'li',
    { key: '0' },
    '(none listed)'
  )];
  if (programs.length > 0) {
    programEls = programs.map(function (program, index) {
      return _react2.default.createElement(
        'li',
        { key: index },
        program
      );
    });
  }

  return _react2.default.createElement(
    'ul',
    null,
    programEls
  );
};

AmenityPrograms.propTypes = {
  programs: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

AmenityPrograms.defaultProps = {
  programs: []
};

var Contact = function Contact(_ref2) {
  var contact = _ref2.contact;
  var email = contact.email,
      _contact$name = contact.name,
      name = _contact$name === undefined ? '' : _contact$name,
      _contact$position = contact.position,
      position = _contact$position === undefined ? '' : _contact$position;


  var displayString = email;
  var nameString = name;
  if (position !== '') {
    nameString = name + ' (' + position + ')';
  }
  if (nameString !== '') {
    displayString = nameString + ' <' + email + '>';
  }

  return _react2.default.createElement(
    'span',
    null,
    displayString
  );
};

Contact.propTypes = {
  contact: _propTypes2.default.shape().isRequired
};

var Contacts = function Contacts(_ref3) {
  var contacts = _ref3.contacts;

  var contactEls = [_react2.default.createElement(
    'li',
    { key: '0' },
    '(none listed)'
  )];
  if (contacts.length > 0) {
    contactEls = contacts.map(function (contact, index) {
      return _react2.default.createElement(
        'li',
        { key: index },
        _react2.default.createElement(Contact, { contact: contact })
      );
    });
  }

  return _react2.default.createElement(
    'ul',
    null,
    contactEls
  );
};

Contacts.propTypes = {
  contacts: _propTypes2.default.arrayOf(_propTypes2.default.string)
};

Contacts.defaultProps = {
  contacts: []
};

var MergeVendors = (_temp = _class = function (_React$Component) {
  _inherits(MergeVendors, _React$Component);

  function MergeVendors(props) {
    _classCallCheck(this, MergeVendors);

    var _this = _possibleConstructorReturn(this, (MergeVendors.__proto__ || Object.getPrototypeOf(MergeVendors)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props = _this.props,
        toKeep = _this$props.toKeep,
        toMerge = _this$props.toMerge;

    var left = _extends({}, toKeep);
    var right = _extends({}, toMerge);

    if (typeof left.contacts === 'string') {
      left.contacts = JSON.parse(left.contacts);
    } else {
      left.contacts = [];
    }

    if (typeof right.contacts === 'string') {
      right.contacts = JSON.parse(right.contacts);
    } else {
      right.contacts = [];
    }

    var mergedData = _extends({}, left);
    var selectionData = {
      name: 'left',
      sabreCode: 'left',
      contacts: 'left',
      amenityPrograms: 'left'
    };

    if (!left.sabreCode && right.sabreCode) {
      mergedData.sabreCode = right.sabreCode;
      selectionData.sabreCode = 'right';
    } else if (!left.sabreCode && !right.sabreCode) {
      selectionData.sabreCode = 'none';
    }

    if (left.contacts.length === 0 && right.contacts.length > 0) {
      mergedData.contacts = right.contacts;
      selectionData.contacts = 'right';
    } else if (left.contacts.length === 0 && right.contacts.length === 0) {
      selectionData.contacts = 'none';
    }

    if (left.amenityPrograms.length === 0 && right.amenityPrograms.length > 0) {
      mergedData.amenityPrograms = right.amenityPrograms;
      selectionData.amenityPrograms = 'right';
    } else if (left.amenityPrograms.length === 0 && right.amenityPrograms.length === 0) {
      selectionData.amenityPrograms = 'none';
    }

    _this.state = {
      left: left,
      right: right,
      mergedData: mergedData,
      selectionData: selectionData,
      working: false
    };
    return _this;
  }

  _createClass(MergeVendors, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          left = _state.left,
          right = _state.right,
          _state$mergedData = _state.mergedData,
          name = _state$mergedData.name,
          sabreCode = _state$mergedData.sabreCode,
          contacts = _state$mergedData.contacts,
          amenityPrograms = _state$mergedData.amenityPrograms,
          selectionData = _state.selectionData,
          working = _state.working;


      var disabled = {
        left: {
          name: working || left.name === right.name,
          sabreCode: working || !left.sabreCode || left.sabreCode === right.sabreCode,
          contacts: working || left.contacts.length === 0 || left.contacts === right.contacts,
          amenityPrograms: working || left.amenityPrograms.length === 0 || left.amenityPrograms === right.amenityPrograms
        },
        right: {
          name: working || left.name === right.name,
          sabreCode: working || !right.sabreCode || left.sabreCode === right.sabreCode,
          contacts: working || right.contacts.length === 0 || left.contacts === right.contacts,
          amenityPrograms: working || right.amenityPrograms.length === 0 || left.amenityPrograms === right.amenityPrograms
        }
      };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_materialUi.CardHeader, { title: 'Merged Vendor Data' }),
        _react2.default.createElement(
          _materialUi.CardText,
          null,
          _react2.default.createElement(
            'div',
            { style: styles.vendorData },
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { style: styles.fieldName },
                'Name:'
              ),
              _react2.default.createElement(
                'span',
                { style: styles.fieldContent },
                name
              )
            ),
            _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(
                'span',
                { style: styles.fieldName },
                'Sabre Code:'
              ),
              _react2.default.createElement(
                'span',
                { style: styles.fieldContent },
                sabreCode || '(unknown)'
              )
            ),
            _react2.default.createElement(
              'h4',
              null,
              'Contacts'
            ),
            _react2.default.createElement(Contacts, { contacts: contacts }),
            _react2.default.createElement(
              'h4',
              null,
              'Amenity Programs'
            ),
            _react2.default.createElement(AmenityPrograms, { programs: amenityPrograms })
          ),
          _react2.default.createElement(
            'div',
            { style: styles.sideBySideContainer },
            _react2.default.createElement(
              _materialUi.Card,
              { style: styles.sideBySideData },
              _react2.default.createElement(
                _materialUi.CardText,
                null,
                _react2.default.createElement(
                  'div',
                  { style: styles.vendorData },
                  _react2.default.createElement(_materialUi.Checkbox, {
                    value: left.name,
                    label: left.name,
                    disabled: disabled.left.name,
                    checked: selectionData.name === 'left',
                    onCheck: this.selectSimple('name', 'left')
                  }),
                  _react2.default.createElement(_materialUi.Checkbox, {
                    value: left.sabreCode,
                    label: left.sabreCode ? left.sabreCode : '(unknown)',
                    disabled: disabled.left.sabreCode,
                    checked: selectionData.sabreCode === 'left',
                    onCheck: this.selectSimple('sabreCode', 'left')
                  }),
                  _react2.default.createElement(_materialUi.Checkbox, {
                    value: left.contacts,
                    label: 'Contacts',
                    disabled: disabled.left.contacts,
                    checked: selectionData.contacts === 'left',
                    onCheck: this.selectList('contacts', 'left')
                  }),
                  _react2.default.createElement(Contacts, { contacts: left.contacts }),
                  _react2.default.createElement(_materialUi.Checkbox, {
                    value: left.amenityPrograms,
                    label: 'Amenity Programs',
                    disabled: disabled.left.amenityPrograms,
                    checked: selectionData.amenityPrograms === 'left',
                    onCheck: this.selectList('amenityPrograms', 'left')
                  }),
                  _react2.default.createElement(AmenityPrograms, { programs: left.amenityPrograms })
                )
              )
            ),
            _react2.default.createElement(
              _materialUi.Card,
              { style: styles.sideBySideData },
              _react2.default.createElement(
                _materialUi.CardText,
                null,
                _react2.default.createElement(
                  'div',
                  { style: styles.vendorData },
                  _react2.default.createElement(_materialUi.Checkbox, {
                    value: right.name,
                    label: right.name,
                    disabled: disabled.right.name,
                    checked: selectionData.name === 'right',
                    onCheck: this.selectSimple('name', 'right')
                  }),
                  _react2.default.createElement(_materialUi.Checkbox, {
                    value: right.sabreCode,
                    label: right.sabreCode ? right.sabreCode : '(unknown)',
                    disabled: disabled.right.sabreCode,
                    checked: selectionData.sabreCode === 'right',
                    onCheck: this.selectSimple('sabreCode', 'right')
                  }),
                  _react2.default.createElement(_materialUi.Checkbox, {
                    value: right.contacts,
                    label: 'Contacts',
                    disabled: disabled.right.contacts,
                    checked: selectionData.contacts === 'right',
                    onCheck: this.selectList('contacts', 'right')
                  }),
                  _react2.default.createElement(Contacts, { contacts: right.contacts }),
                  _react2.default.createElement(_materialUi.Checkbox, {
                    value: right.amenityPrograms,
                    label: 'Amenity Programs',
                    disabled: disabled.right.amenityPrograms,
                    checked: selectionData.amenityPrograms === 'right',
                    onCheck: this.selectList('amenityPrograms', 'right')
                  }),
                  _react2.default.createElement(AmenityPrograms, { programs: right.amenityPrograms })
                )
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { style: styles.buttons },
            working ? _react2.default.createElement(_materialUi.LinearProgress, { mode: 'indeterminate' }) : _react2.default.createElement(
              'div',
              null,
              _react2.default.createElement(_materialUi.RaisedButton, {
                style: styles.button,
                secondary: true,
                label: 'Cancel',
                onTouchTap: this.cancel,
                disabled: working
              }),
              _react2.default.createElement(_materialUi.RaisedButton, {
                style: styles.button,
                primary: true,
                label: 'Confirm Merge',
                onTouchTap: this.merge,
                disabled: working
              })
            )
          )
        )
      );
    }
  }]);

  return MergeVendors;
}(_react2.default.Component), _class.contextTypes = {
  router: _propTypes2.default.object
}, _class.propTypes = {
  toKeep: _propTypes2.default.shape().isRequired,
  toMerge: _propTypes2.default.shape().isRequired,
  goBack: _propTypes2.default.func.isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.selectSimple = function (field, option) {
    return function (e, checked) {
      var _state2 = _this2.state,
          mergedData = _state2.mergedData,
          selectionData = _state2.selectionData;

      var selectedVendor = _this2.state[option];

      if (checked === true) {
        mergedData[field] = selectedVendor[field];
        selectionData[field] = option;
      } else {
        mergedData[field] = '';
        selectionData[field] = 'none';
      }

      _this2.setState({ mergedData: mergedData, selectionData: selectionData });
    };
  };

  this.selectList = function (field, option) {
    return function (e, checked) {
      var _state3 = _this2.state,
          mergedData = _state3.mergedData,
          selectionData = _state3.selectionData;

      var selectedVendor = _this2.state[option];

      if (checked === true) {
        mergedData[field] = selectedVendor[field];
        selectionData[field] = option;
      } else {
        mergedData[field] = [];
        selectionData[field] = 'none';
      }

      _this2.setState({ mergedData: mergedData, selectionData: selectionData });
    };
  };

  this.cancel = function () {
    _this2.props.goBack();
  };

  this.merge = function () {
    var _props = _this2.props,
        toKeep = _props.toKeep.id,
        toMerge = _props.toMerge.id;
    var _state$mergedData2 = _this2.state.mergedData,
        name = _state$mergedData2.name,
        sabreCode = _state$mergedData2.sabreCode,
        contacts = _state$mergedData2.contacts,
        amenityPrograms = _state$mergedData2.amenityPrograms;


    _this2.setState({ working: true });

    var input = { toKeep: toKeep, toMerge: toMerge, name: name, sabreCode: sabreCode, contacts: contacts, amenityPrograms: amenityPrograms };

    (0, _reactRelay.commitMutation)(_environment2.default, {
      mutation: _graphql || (_graphql = function _graphql() {
        return __webpack_require__("JhVn");
      }),
      variables: { input: input },
      onCompleted: function onCompleted() {
        window.location = '/edit/' + toKeep + '/';
      },
      onError: function onError(err) {
        return alert(err);
      }
    });
  };
}, _temp);
exports.default = MergeVendors;


var styles = {
  vendorData: {
    display: 'flex',
    flexDirection: 'column'
  },
  fieldName: {
    fontWeight: 'bold',
    marginRight: 5
  },
  sideBySideContainer: {
    display: 'flex',
    flexWrap: 'wrap',
    flex: '2 0 auto',
    justifyContent: 'space-between'
  },
  sideBySideData: {
    width: '49%'
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
    paddingTop: 5,
    width: '100%'
  },
  button: {
    marginLeft: 5
  }
};

/***/ }),

/***/ "j7JY":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp2;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("RH2O");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _materialUi = __webpack_require__("Q4lS");

var _arrowDropDown = __webpack_require__("Pvnv");

var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);

var _arrowDropUp = __webpack_require__("Bly6");

var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);

var _delete = __webpack_require__("1Ilb");

var _delete2 = _interopRequireDefault(_delete);

var _aphrodite = __webpack_require__("BK4P");

var _InquiryActions = __webpack_require__("EJRV");

var InquiryActions = _interopRequireWildcard(_InquiryActions);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var TravelerListItem = (_dec = (0, _reactRedux.connect)(), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(TravelerListItem, _React$Component);

  function TravelerListItem() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, TravelerListItem);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = TravelerListItem.__proto__ || Object.getPrototypeOf(TravelerListItem)).call.apply(_ref, [this].concat(args))), _this), _this.moveUp = function () {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          index = _this$props.index;

      dispatch(InquiryActions.moveTraveler(index, index - 1));
    }, _this.moveDown = function () {
      var _this$props2 = _this.props,
          dispatch = _this$props2.dispatch,
          index = _this$props2.index;

      dispatch(InquiryActions.moveTraveler(index, index + 1));
    }, _this.remove = function () {
      var _this$props3 = _this.props,
          dispatch = _this$props3.dispatch,
          index = _this$props3.index;

      dispatch(InquiryActions.removeTraveler(index));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(TravelerListItem, [{
    key: 'render',
    value: function render() {
      var _props$traveler = this.props.traveler,
          fullName = _props$traveler.fullName,
          displayName = _props$traveler.displayName,
          birthdate = _props$traveler.birthdate,
          isAdult = _props$traveler.isAdult;

      var name = displayName || fullName;

      var age = void 0;
      if (birthdate) {
        age = (0, _moment2.default)().diff((0, _moment2.default)(birthdate), 'years');
      } else {
        age = isAdult ? '18+' : 'child';
      }

      return _react2.default.createElement(
        'li',
        { className: (0, _aphrodite.css)(styles.listItem) },
        _react2.default.createElement(
          'div',
          null,
          name,
          ' (',
          age,
          ')'
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            _materialUi.IconButton,
            { className: (0, _aphrodite.css)(styles.buttonStyle), onTouchTap: this.moveUp },
            _react2.default.createElement(_arrowDropUp2.default, null)
          ),
          _react2.default.createElement(
            _materialUi.IconButton,
            { className: (0, _aphrodite.css)(styles.buttonStyle), onTouchTap: this.moveDown },
            _react2.default.createElement(_arrowDropDown2.default, null)
          ),
          _react2.default.createElement(
            _materialUi.IconButton,
            { className: (0, _aphrodite.css)(styles.buttonStyle), onTouchTap: this.remove },
            _react2.default.createElement(_delete2.default, null)
          )
        )
      );
    }
  }]);

  return TravelerListItem;
}(_react2.default.Component), _class2.propTypes = {
  index: _propTypes2.default.number.isRequired,
  traveler: _propTypes2.default.shape().isRequired,
  dispatch: _propTypes2.default.func.isRequired
}, _temp2)) || _class);
exports.default = TravelerListItem;


var styles = _aphrodite.StyleSheet.create({
  listItem: {
    width: 300,
    display: 'flex',
    alignItems: 'baseline',
    justifyContent: 'space-between'
  },
  buttonStyle: {
    height: 24,
    width: 24,
    padding: 0,
    position: 'relative',
    top: 5,
    marginRight: 5
  }
});

/***/ }),

/***/ "jFoS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__("Q4lS");

var _reactRedux = __webpack_require__("RH2O");

var _styles = __webpack_require__("kLrL");

var _styles2 = _interopRequireDefault(_styles);

var _ResponseListFilters = __webpack_require__("XwAW");

var _ResponseListFilters2 = _interopRequireDefault(_ResponseListFilters);

var _ResponseListRenderer = __webpack_require__("/Zpr");

var _ResponseListRenderer2 = _interopRequireDefault(_ResponseListRenderer);

var _ResponseDetailsRenderer = __webpack_require__("Fz6x");

var _ResponseDetailsRenderer2 = _interopRequireDefault(_ResponseDetailsRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Responses = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    viewport: state.Responsive.get('viewport'),
    windowHeight: state.Responsive.get('windowHeight')
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(Responses, _React$Component);

  function Responses(props) {
    _classCallCheck(this, Responses);

    var _this = _possibleConstructorReturn(this, (Responses.__proto__ || Object.getPrototypeOf(Responses)).call(this, props));

    _this.state = {
      onClient: false
    };
    return _this;
  }

  _createClass(Responses, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setState({ onClient: true }); // eslint-disable-line react/no-did-mount-set-state
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          windowHeight = _props.windowHeight,
          activeResponse = _props.match.params.responseId,
          viewport = _props.viewport;
      var onClient = this.state.onClient;

      var top = (windowHeight - 161) / 2 + 161;

      var loadingEl = _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_ResponseListFilters2.default, { updateFilter: function updateFilter() {
            return null;
          } }),
        _react2.default.createElement(_materialUi.RefreshIndicator, { top: top, left: 277, status: 'loading' })
      );

      var ActiveResponse = _react2.default.createElement(_ResponseDetailsRenderer2.default, { activeResponse: activeResponse });

      if (viewport !== 'desktop' && activeResponse) {
        return ActiveResponse;
      }

      return _react2.default.createElement(
        'div',
        { className: _styles2.default.container },
        _react2.default.createElement(
          'div',
          { className: _styles2.default.list },
          onClient ? _react2.default.createElement(_ResponseListRenderer2.default, {
            activeResponse: activeResponse, loadingEl: loadingEl
          }) : loadingEl
        ),
        _react2.default.createElement(
          'div',
          { className: _styles2.default.detail },
          activeResponse ? ActiveResponse : null
        )
      );
    }
  }]);

  return Responses;
}(_react2.default.Component), _class2.propTypes = {
  viewport: _propTypes2.default.string.isRequired,
  match: _propTypes2.default.shape({
    params: _propTypes2.default.object
  }).isRequired,
  windowHeight: _propTypes2.default.number.isRequired
}, _temp)) || _class);
exports.default = Responses;

/***/ }),

/***/ "jbrW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TravelStatus = exports.VIPLetters = exports.DateCalculations = exports.TripAssignments = undefined;

var _TripAssignments2 = __webpack_require__("/7px");

var _TripAssignments3 = _interopRequireDefault(_TripAssignments2);

var _DateCalculations2 = __webpack_require__("YgJF");

var _DateCalculations3 = _interopRequireDefault(_DateCalculations2);

var _VIPLetters2 = __webpack_require__("Mjw5");

var _VIPLetters3 = _interopRequireDefault(_VIPLetters2);

var _TravelStatus2 = __webpack_require__("U1G/");

var _TravelStatus3 = _interopRequireDefault(_TravelStatus2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.TripAssignments = _TripAssignments3.default;
exports.DateCalculations = _DateCalculations3.default;
exports.VIPLetters = _VIPLetters3.default;
exports.TravelStatus = _TravelStatus3.default;

/***/ }),

/***/ "jlGH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__("Q4lS");

var _aphrodite = __webpack_require__("BK4P");

var _reactRedux = __webpack_require__("RH2O");

var _InquiryActions = __webpack_require__("EJRV");

var InquiryActions = _interopRequireWildcard(_InquiryActions);

var _DateRangeComponent = __webpack_require__("JW7h");

var _DateRangeComponent2 = _interopRequireDefault(_DateRangeComponent);

var _rest = __webpack_require__("i4WM");

var _rest2 = _interopRequireDefault(_rest);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddSegment = (_dec = (0, _reactRedux.connect)(function (state) {
  return { inquiry: state.Inquiry.get('inquiry').toJS() };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(AddSegment, _React$Component);

  function AddSegment(props) {
    _classCallCheck(this, AddSegment);

    var _this = _possibleConstructorReturn(this, (AddSegment.__proto__ || Object.getPrototypeOf(AddSegment)).call(this, props));

    _this.onCancel = function () {
      _this.props.dispatch(InquiryActions.updateField(['meta', 'addingSegment'], false));
    };

    _this.onSave = function () {
      if (!_this.state.id && _this.state.vendor) {
        _this.setState({ confirmNewVendor: true });
      } else {
        _this.addVendor();
      }
    };

    _this.cancelNewVendor = function () {
      _this.setState({ confirmNewVendor: false });
    };

    _this.confirmNewVendor = function () {
      _this.setState({ confirmNewVendor: false });
      _this.addVendor();
    };

    _this.addVendor = function () {
      var dispatch = _this.props.dispatch;
      var _this$state = _this.state,
          id = _this$state.id,
          vendor = _this$state.vendor,
          startDate = _this$state.startDate,
          endDate = _this$state.endDate,
          notes = _this$state.notes;
      var updateField = InquiryActions.updateField,
          addSegment = InquiryActions.addSegment;


      dispatch(updateField(['meta', 'addingSegment'], false));
      dispatch(addSegment({ id: id, vendor: vendor, startDate: startDate, endDate: endDate, notes: notes }));
    };

    _this.handleUpdateSegmentAutocomplete = function (value) {
      (0, _rest2.default)('auto/vendor', value).then(function (response) {
        var objects = response.objects;

        _this.setState({
          vendor: value,
          segmentAutocompleteData: objects.map(function (object) {
            return {
              text: object.name,
              value: object.relayId,
              name: object.name,
              score: object.score
            };
          })
        });
      }).catch(function (response) {
        console.log(response);
      });
    };

    _this.vendorSelected = function (selected, index) {
      var _this$props = _this.props,
          dispatch = _this$props.dispatch,
          destination = _this$props.inquiry.tripDetails.destination;


      if (index !== -1) {
        var id = selected.value,
            name = selected.name;


        _this.setState({ id: id, name: name });
        if (!destination) {
          dispatch(InquiryActions.updateField(['inquiry', 'tripDetails', 'destination'], name));
        }
      }
    };

    _this.updateTextField = function (field) {
      return function (e) {
        var newState = { dirty: true };
        newState[field] = e.target.value;
        _this.setState(newState);
      };
    };

    _this.updateDates = function (e) {
      var startDate = e.startDate,
          endDate = e.endDate;

      _this.setState({ startDate: startDate, endDate: endDate });
    };

    _this.state = {
      segmentAutocompleteData: [],
      id: '',
      vendor: '',
      startDate: '',
      endDate: '',
      notes: '',
      confirmNewVendor: false
    };
    return _this;
  }

  _createClass(AddSegment, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          vendor = _state.vendor,
          segmentAutocompleteData = _state.segmentAutocompleteData,
          startDate = _state.startDate,
          endDate = _state.endDate,
          notes = _state.notes,
          confirmNewVendor = _state.confirmNewVendor;


      var actions = [_react2.default.createElement(_materialUi.FlatButton, {
        label: 'No',
        primary: true,
        onTouchTap: this.cancelNewVendor
      }), _react2.default.createElement(_materialUi.FlatButton, {
        label: 'Yes',
        primary: true,
        onTouchTap: this.confirmNewVendor
      })];

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _materialUi.Paper,
          { className: (0, _aphrodite.css)(styles.addBox) },
          _react2.default.createElement(_materialUi.AutoComplete, {
            style: styles.formFieldStyle,
            menuStyle: { width: 500 },
            listStyle: { width: 500 },
            floatingLabelText: 'Vendor',
            dataSource: segmentAutocompleteData,
            onUpdateInput: this.handleUpdateSegmentAutocomplete,
            onNewRequest: this.vendorSelected,
            filter: function filter() {
              return true;
            },
            fullWidth: true
          }),
          _react2.default.createElement(_DateRangeComponent2.default, {
            startValue: startDate,
            endValue: endDate,
            startLabel: 'Start Date',
            endLabel: 'End Date',
            onChange: this.updateDates
          }),
          _react2.default.createElement(_materialUi.TextField, {
            floatingLabelText: 'Notes',
            value: notes,
            onChange: this.updateTextField('notes'),
            fullWidth: true
          }),
          _react2.default.createElement(
            'div',
            { className: (0, _aphrodite.css)(styles.controls) },
            _react2.default.createElement(_materialUi.FlatButton, { label: 'Cancel', onTouchTap: this.onCancel, secondary: true }),
            _react2.default.createElement(_materialUi.FlatButton, { label: 'Submit', onTouchTap: this.onSave, primary: true })
          )
        ),
        _react2.default.createElement(
          _materialUi.Dialog,
          {
            title: 'Confirm New Vendor',
            actions: actions,
            modal: true,
            open: confirmNewVendor
          },
          _react2.default.createElement(
            'p',
            null,
            'You did not select an existing vendor from our database. Are you sure that \u201C',
            vendor,
            '\u201D is not one of the following?'
          ),
          _react2.default.createElement(
            'ul',
            { style: styles.alternativeList },
            segmentAutocompleteData.filter(function (_ref) {
              var score = _ref.score;
              return score > 1;
            }).slice(0, 10).map(function (_ref2) {
              var text = _ref2.text,
                  id = _ref2.value;
              return _react2.default.createElement(
                'li',
                { key: id, style: styles.alternativeVendor },
                _react2.default.createElement(
                  'span',
                  null,
                  text
                ),
                _react2.default.createElement(_materialUi.FlatButton, {
                  label: 'select',
                  onTouchTap: _this2.selectAlternateVendor(id, text)
                })
              );
            })
          )
        )
      );
    }
  }]);

  return AddSegment;
}(_react2.default.Component), _class2.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  inquiry: _propTypes2.default.shape().isRequired
}, _temp)) || _class);
exports.default = AddSegment;


var styles = _aphrodite.StyleSheet.create({
  addBox: {
    marginLeft: 15,
    flexGrow: 1,
    padding: '0 15px 15px 15px',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 839,
    '@media (min-width: 970px)': {
      minWidth: 839
    }
  },
  controls: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%'
  },
  checkBox: {
    width: 256
  }
});

/***/ }),

/***/ "kLrL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin
module.exports = {"container":"styles-container--3wsFs","list":"styles-list--12VTf","detail":"styles-detail--8oTRb","listFilter":"styles-listFilter--27ORP","listItems":"styles-listItems--rv7pW","active":"styles-active--1cAuj","listItem":"styles-listItem--1dXl2","listDisplayName":"styles-listDisplayName--3MSd-","timestamp":"styles-timestamp--1FC1Y","response":"styles-response--pXuiz","question":"styles-question--3Y2si","answer":"styles-answer--1h0_7"};

/***/ }),

/***/ "kg8o":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__("Q4lS");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _momentParseformat = __webpack_require__("m0Xp");

var _momentParseformat2 = _interopRequireDefault(_momentParseformat);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DateField = (_temp = _class = function (_React$Component) {
  _inherits(DateField, _React$Component);

  function DateField(props) {
    _classCallCheck(this, DateField);

    var _this = _possibleConstructorReturn(this, (DateField.__proto__ || Object.getPrototypeOf(DateField)).call(this, props));

    _this.onChange = function (e) {
      var _this$props = _this.props,
          passedOnChange = _this$props.onChange,
          parseDate = _this$props.parseDate;
      var value = e.target.value;


      if (parseDate) {
        var nextState = _this.processValue(value);
        _this.setState(nextState);

        var input = nextState.input,
            parsedValue = nextState.parsedValue;


        var newValue = parsedValue && parsedValue.isValid() ? parsedValue.format('YYYY-MM-DD') : input;

        passedOnChange({ target: { value: newValue } });
      } else {
        _this.setState({
          input: value,
          parsedValue: value,
          errorText: null
        });
        passedOnChange(e);
      }
    };

    _this.processValue = function (value) {
      var format = 'dddd, MMMM Do YYYY';

      var enteredFormat = (0, _momentParseformat2.default)(value);
      var parsedValue = (0, _moment2.default)(value, enteredFormat);
      if (parsedValue < (0, _moment2.default)() && enteredFormat.search('Y') < 0) {
        parsedValue.add(1, 'years');
      }

      return {
        input: value,
        parsedValue: parsedValue && parsedValue.isValid() ? parsedValue : null,
        errorText: parsedValue && parsedValue.isValid() ? parsedValue.format(format) : "can't interpret date"
      };
    };

    _this.state = {
      input: _this.props.value,
      parsedValue: '',
      errorText: ''
    };
    return _this;
  }

  _createClass(DateField, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          input = _state.input,
          errorText = _state.errorText,
          parsedValue = _state.parsedValue;

      var textFieldProps = _extends({}, this.props);
      delete textFieldProps.parseDate;
      delete textFieldProps.onChange;
      delete textFieldProps.value;
      delete textFieldProps.className;

      var errorStyle = {
        color: parsedValue && (0, _moment2.default)(parsedValue).isValid() ? _ourismanTravelTheme2.default.palette.primary1Color : _ourismanTravelTheme2.default.palette.accent2Color
      };

      return _react2.default.createElement(_materialUi.TextField, _extends({}, textFieldProps, {
        className: this.props.className,
        value: input,
        onChange: this.onChange,
        errorText: errorText,
        errorStyle: errorStyle,
        floatingLabelFocusStyle: errorStyle
      }));
    }
  }]);

  return DateField;
}(_react2.default.Component), _class.propTypes = {
  value: _propTypes2.default.string,
  onChange: _propTypes2.default.func.isRequired,
  parseDate: _propTypes2.default.bool,
  className: _propTypes2.default.string
}, _class.defaultProps = {
  value: '',
  parseDate: true,
  className: ''
}, _temp);
exports.default = DateField;

/***/ }),

/***/ "kujC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _graphql, _graphql2;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__("Q4lS");

var _delete = __webpack_require__("1Ilb");

var _delete2 = _interopRequireDefault(_delete);

var _moveToInbox = __webpack_require__("sldj");

var _moveToInbox2 = _interopRequireDefault(_moveToInbox);

var _monetizationOn = __webpack_require__("UhHO");

var _monetizationOn2 = _interopRequireDefault(_monetizationOn);

var _email = __webpack_require__("LWqx");

var _email2 = _interopRequireDefault(_email);

var _confirmationNumber = __webpack_require__("Y4+6");

var _confirmationNumber2 = _interopRequireDefault(_confirmationNumber);

var _block = __webpack_require__("gj6W");

var _block2 = _interopRequireDefault(_block);

var _expandMore = __webpack_require__("jFa1");

var _expandMore2 = _interopRequireDefault(_expandMore);

var _expandLess = __webpack_require__("8bfn");

var _expandLess2 = _interopRequireDefault(_expandLess);

var _contentCopy = __webpack_require__("o9LU");

var _contentCopy2 = _interopRequireDefault(_contentCopy);

var _reactRelay = __webpack_require__("Tc9k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _SegmentDetails = __webpack_require__("rhst");

var _SegmentDetails2 = _interopRequireDefault(_SegmentDetails);

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SegmentListItem = (_temp = _class = function (_React$Component) {
  _inherits(SegmentListItem, _React$Component);

  function SegmentListItem(props) {
    _classCallCheck(this, SegmentListItem);

    var _this = _possibleConstructorReturn(this, (SegmentListItem.__proto__ || Object.getPrototypeOf(SegmentListItem)).call(this, props));

    _this.remove = function () {
      var _this$props = _this.props,
          segmentId = _this$props.segment.id,
          tripId = _this$props.trip.id;


      if (confirm("Are you sure you want to delete this segment?")) {
        (0, _reactRelay.commitMutation)(_environment2.default, {
          mutation: _graphql || (_graphql = function _graphql() {
            return __webpack_require__("+B6H");
          }),
          variables: { input: { tripId: tripId, segmentId: segmentId } },
          onError: function onError(err) {
            return alert(err);
          }
        });
      }
    };

    _this.toggleExpanded = function () {
      _this.setState({ expanded: !_this.state.expanded });
    };

    _this.duplicateSegment = function () {
      var segmentId = _this.props.segment.id;


      (0, _reactRelay.commitMutation)(_environment2.default, {
        mutation: _graphql2 || (_graphql2 = function _graphql2() {
          return __webpack_require__("9FEW");
        }),
        variables: { input: { segmentId: segmentId } },
        onError: function onError(err) {
          return alert(err);
        }
      });
    };

    _this.state = {
      expanded: false
    };
    return _this;
  }

  _createClass(SegmentListItem, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      var oldId = this.props.segment.id;
      var newId = nextProps.segment.id;


      if (oldId !== newId) {
        this.setState({ expanded: false });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _props = this.props,
          segment = _props.segment,
          index = _props.index;
      var vendor = segment.vendor,
          dateString = segment.dateString,
          dropbox = segment.dropbox,
          invoiced = segment.invoiced,
          booked = segment.booked,
          cancelled = segment.cancelled,
          vipDrafted = segment.vipDrafted;
      var expanded = this.state.expanded;

      var vendorName = vendor === null ? "TBD" : vendor.name;

      var cancelledIconColor = _ourismanTravelTheme2.default.palette.accent1Color;
      var tripDataStyle = styles.tripDataStyle;
      if (cancelled) {
        tripDataStyle = _extends({}, tripDataStyle, {
          color: cancelledIconColor,
          textDecoration: "line-through"
        });
      }

      var needsDB = booked && !dropbox || cancelled && dropbox;
      var needsInvoice = booked && !invoiced || cancelled && invoiced;
      var needsDraft = booked && !vipDrafted || cancelled && vipDrafted;

      var preventDelete = booked || cancelled || needsDB || needsInvoice || needsDraft;

      var listSummaryStyle = _extends({}, styles.listSummaryStyle, {
        background: index % 2 !== 0 ? _ourismanTravelTheme2.default.palette.primary3Color : ""
      });

      var ExpandButton = expanded ? _expandLess2.default : _expandMore2.default;

      return _react2.default.createElement(
        "li",
        { style: styles.listItemStyle },
        _react2.default.createElement(
          "div",
          { style: listSummaryStyle },
          _react2.default.createElement(
            "div",
            { style: tripDataStyle, onTouchTap: this.toggleExpanded },
            _react2.default.createElement(
              "span",
              { style: styles.segmentVendorStyle },
              vendorName
            ),
            _react2.default.createElement(
              "span",
              { style: styles.segmentDateStyle },
              dateString
            )
          ),
          _react2.default.createElement(
            "div",
            { style: styles.segmentIconStyle, onTouchTap: this.toggleExpanded },
            _react2.default.createElement(
              "span",
              { style: { width: 18, paddingRight: 2, paddingLeft: 2 } },
              cancelled && _react2.default.createElement(_block2.default, null) || !booked && _react2.default.createElement(_confirmationNumber2.default, null) || null
            ),
            _react2.default.createElement(
              "span",
              { style: { width: 18, paddingRight: 2, paddingLeft: 2 } },
              needsDB ? _react2.default.createElement(_moveToInbox2.default, { color: cancelled ? cancelledIconColor : null }) : null
            ),
            _react2.default.createElement(
              "span",
              { style: { width: 18, paddingRight: 2, paddingLeft: 2 } },
              needsInvoice ? _react2.default.createElement(_monetizationOn2.default, { color: cancelled ? cancelledIconColor : null }) : null
            ),
            _react2.default.createElement(
              "span",
              { style: { width: 18, paddingRight: 2, paddingLeft: 2 } },
              needsDraft ? _react2.default.createElement(_email2.default, { color: cancelled ? cancelledIconColor : null }) : null
            )
          ),
          _react2.default.createElement(
            "div",
            { style: styles.listActionStyle },
            _react2.default.createElement(
              _materialUi.IconButton,
              {
                style: styles.buttonStyle,
                onTouchTap: this.toggleExpanded,
                tooltip: expanded ? "Hide Segment Details" : "View Segment Details",
                tooltipPosition: "bottom-left"
              },
              _react2.default.createElement(ExpandButton, null)
            ),
            _react2.default.createElement(
              _materialUi.IconButton,
              {
                style: styles.buttonStyle,
                onTouchTap: this.duplicateSegment,
                tooltip: "Duplicate Segment",
                tooltipPosition: "bottom-left"
              },
              _react2.default.createElement(_contentCopy2.default, null)
            ),
            _react2.default.createElement(
              _materialUi.IconButton,
              {
                style: styles.buttonStyle,
                onTouchTap: this.remove,
                disabled: preventDelete,
                tooltip: "Delete Segment",
                tooltipPosition: "bottom-left"
              },
              _react2.default.createElement(_delete2.default, null)
            )
          )
        ),
        _react2.default.createElement(
          "div",
          null,
          expanded ? _react2.default.createElement(_SegmentDetails2.default, {
            segment: segment,
            onComplete: this.toggleExpanded
          }) : null
        )
      );
    }
  }]);

  return SegmentListItem;
}(_react2.default.Component), _class.propTypes = {
  segment: _propTypes2.default.shape().isRequired,
  trip: _propTypes2.default.shape().isRequired,
  index: _propTypes2.default.number.isRequired
}, _temp);
exports.default = SegmentListItem;


var styles = {
  buttonStyle: {
    padding: 0,
    margin: "0px 4px 0px 4px",
    width: 20,
    height: 5
  },
  listItemStyle: {
    display: "flex",
    flexDirection: "column"
  },
  listSummaryStyle: {
    display: "flex",
    alignItems: "baseline",
    width: "100%",
    justifyContent: "space-between"
  },
  tripDataStyle: {
    flex: "2 1 50%",
    display: "flex",
    flexWrap: "wrap",
    justifyContent: "space-between"
  },
  segmentVendorStyle: {
    flex: "2 1 content"
  },
  segmentDateStyle: {
    flex: "0 0 content"
  },
  segmentIconStyle: {
    flex: "1 0 45%",
    display: "flex",
    justifyContent: "center",
    alignItems: "baseline"
  },
  listActionStyle: {
    flex: "1 0 5%",
    display: "flex"
  },
  primaryTravelerStyle: {
    color: "grey",
    fontSize: 8,
    paddingLeft: 8
  }
};

/***/ }),

/***/ "m2u7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 717d7069c4b53b95a5bcb7e80362f5ac
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type AddTraveler_AddTraveler_MutationVariables = {|
  input: {
    tripId?: ?string;
    travelerId?: ?string;
    firstName?: ?string;
    lastName?: ?string;
    email?: ?string;
    birthdate?: ?string;
    isAdult?: ?boolean;
    isPrimaryTraveler?: ?boolean;
    primaryTravelerId?: ?string;
    primaryTravelerName?: ?string;
    relationship?: ?string;
    insideCircle?: ?boolean;
    needsTraining?: ?boolean;
    needsVetting?: ?boolean;
    clientMutationId?: ?string;
  };
|};

export type AddTraveler_AddTraveler_MutationResponse = {|
  +addTraveler: ?{|
    +trip: ?{|
      +numTravelers: ?number;
      +tripName: ?string;
      +primaryTravelerName: ?string;
      +travelers: ?$ReadOnlyArray<?{|
        +id: string;
        +firstName: string;
        +lastName: string;
        +isPrimaryTraveler: boolean;
        +primaryTravelerName: string;
        +primaryTraveler: ?{|
          +id: string;
        |};
        +birthdate: ?any;
        +adult: boolean;
      |}>;
    |};
  |};
|};
*/

/*
mutation AddTraveler_AddTraveler_Mutation(
  $input: AddTravelerInput!
) {
  addTraveler(input: $input) {
    trip {
      numTravelers
      tripName
      primaryTravelerName
      travelers {
        id
        firstName
        lastName
        isPrimaryTraveler
        primaryTravelerName
        primaryTraveler {
          id
        }
        birthdate
        adult
      }
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "AddTravelerInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddTraveler_AddTraveler_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "AddTravelerInput!"
      }],
      "concreteType": "AddTravelerPayload",
      "name": "addTraveler",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "numTravelers",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tripName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "primaryTravelerName",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Traveler",
          "name": "travelers",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "lastName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isPrimaryTraveler",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "primaryTravelerName",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Traveler",
            "name": "primaryTraveler",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "birthdate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "adult",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "AddTraveler_AddTraveler_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "AddTravelerInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "AddTraveler_AddTraveler_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "AddTravelerInput!"
      }],
      "concreteType": "AddTravelerPayload",
      "name": "addTraveler",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "numTravelers",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "tripName",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "primaryTravelerName",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Traveler",
          "name": "travelers",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "firstName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "lastName",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "isPrimaryTraveler",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "primaryTravelerName",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Traveler",
            "name": "primaryTraveler",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "birthdate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "adult",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation AddTraveler_AddTraveler_Mutation(\n  $input: AddTravelerInput!\n) {\n  addTraveler(input: $input) {\n    trip {\n      numTravelers\n      tripName\n      primaryTravelerName\n      travelers {\n        id\n        firstName\n        lastName\n        isPrimaryTraveler\n        primaryTravelerName\n        primaryTraveler {\n          id\n        }\n        birthdate\n        adult\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "mGxo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash a52081cd83166c459d6c41f6761e2252
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type AddSegment_AddSegmentToTrip_MutationVariables = {|
  input: {
    tripId?: ?string;
    vendorId?: ?string;
    vendorName?: ?string;
    startDate?: ?string;
    endDate?: ?string;
    notes?: ?string;
    clientMutationId?: ?string;
  };
|};

export type AddSegment_AddSegmentToTrip_MutationResponse = {|
  +addSegment: ?{|
    +trip: ?{|
      +numSegments: ?number;
      +dropbox: ?boolean;
      +invoice: ?boolean;
      +draftVip: ?boolean;
      +book: ?boolean;
      +cancel: ?boolean;
      +welcomeHome: ?boolean;
      +tasks: ?$ReadOnlyArray<?{|
        +taskType: "DRAFT_WH" | "CANCEL_WH" | "OTHER";
        +description: string;
        +completed: boolean;
        +voided: boolean;
        +history: ?$ReadOnlyArray<?{|
          +name: ?string;
          +action: ?string;
          +timestamp: ?string;
        |}>;
      |}>;
      +segments: ?$ReadOnlyArray<?{|
        +id: string;
        +vendor: ?{|
          +id: string;
          +name: string;
          +amenityPrograms: ?$ReadOnlyArray<?string>;
        |};
        +trip: ?{|
          +id: string;
          +searchId: ?string;
        |};
        +name: ?string;
        +dateString: ?string;
        +startDate: ?string;
        +endDate: ?string;
        +category: ?string;
        +bedType: ?string;
        +amenityProgram: ?string;
        +numAdults: ?number;
        +numChildren: ?number;
        +smokingRoom: ?boolean;
        +rates: ?$ReadOnlyArray<?number>;
        +currency: string;
        +averageDailyRate: boolean;
        +cancellationDeadline: ?any;
        +dropbox: boolean;
        +invoiced: boolean;
        +vipDrafted: boolean;
        +vipSent: boolean;
        +booked: boolean;
        +cancelled: boolean;
        +sabreLocator: string;
        +confirmationNumber: string;
        +cancellationNumber: string;
        +vipLetter: string;
        +notes: ?$ReadOnlyArray<?{|
          +id: string;
          +owner: {|
            +id: string;
            +firstName: string;
          |};
          +content: string;
          +created: any;
        |}>;
      |}>;
    |};
  |};
|};
*/

/*
mutation AddSegment_AddSegmentToTrip_Mutation(
  $input: AddSegmentInput!
) {
  addSegment(input: $input) {
    trip {
      numSegments
      dropbox
      invoice
      draftVip
      book
      cancel
      welcomeHome
      tasks {
        taskType
        description
        completed
        voided
        history {
          name
          action
          timestamp
        }
        id
      }
      segments {
        currency
        id
        trip {
          id
          searchId
        }
        name
        dateString
        startDate
        endDate
        category
        bedType
        amenityProgram
        numAdults
        numChildren
        smokingRoom
        rates
        vendor {
          id
          name
          amenityPrograms
        }
        averageDailyRate
        cancellationDeadline
        dropbox
        invoiced
        vipDrafted
        vipSent
        booked
        cancelled
        sabreLocator
        confirmationNumber
        cancellationNumber
        vipLetter
        notes {
          id
          owner {
            id
            firstName
          }
          content
          created
        }
      }
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "AddSegmentInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "AddSegment_AddSegmentToTrip_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "AddSegmentInput!"
      }],
      "concreteType": "AddSegmentPayload",
      "name": "addSegment",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "numSegments",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dropbox",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "invoice",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "draftVip",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "book",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancel",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "welcomeHome",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "name": "tasks",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "taskType",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "description",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "completed",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "voided",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TaskHistoryObject",
            "name": "history",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "action",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "timestamp",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Segment",
          "name": "segments",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "currency",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Trip",
            "name": "trip",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "searchId",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dateString",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "startDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "endDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "category",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "bedType",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "amenityProgram",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "numAdults",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "numChildren",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "smokingRoom",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "rates",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Vendor",
            "name": "vendor",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "amenityPrograms",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "averageDailyRate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancellationDeadline",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dropbox",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "invoiced",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "vipDrafted",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "vipSent",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "booked",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancelled",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "sabreLocator",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "confirmationNumber",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancellationNumber",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "vipLetter",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "name": "notes",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "User",
              "name": "owner",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "firstName",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "content",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "created",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "AddSegment_AddSegmentToTrip_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "AddSegmentInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "AddSegment_AddSegmentToTrip_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "AddSegmentInput!"
      }],
      "concreteType": "AddSegmentPayload",
      "name": "addSegment",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Trip",
        "name": "trip",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "numSegments",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "dropbox",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "invoice",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "draftVip",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "book",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "cancel",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "welcomeHome",
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Task",
          "name": "tasks",
          "plural": true,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "taskType",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "description",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "completed",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "voided",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "TaskHistoryObject",
            "name": "history",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "action",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "timestamp",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Segment",
          "name": "segments",
          "plural": true,
          "selections": [{
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Vendor",
            "name": "vendor",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "name",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "amenityPrograms",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "currency",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Trip",
            "name": "trip",
            "plural": false,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "searchId",
              "storageKey": null
            }],
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dateString",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "startDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "endDate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "category",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "bedType",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "amenityProgram",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "numAdults",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "numChildren",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "smokingRoom",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "rates",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "averageDailyRate",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancellationDeadline",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "dropbox",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "invoiced",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "vipDrafted",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "vipSent",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "booked",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancelled",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "sabreLocator",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "confirmationNumber",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "cancellationNumber",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "vipLetter",
            "storageKey": null
          }, {
            "kind": "LinkedField",
            "alias": null,
            "args": null,
            "concreteType": "Note",
            "name": "notes",
            "plural": true,
            "selections": [{
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "id",
              "storageKey": null
            }, {
              "kind": "LinkedField",
              "alias": null,
              "args": null,
              "concreteType": "User",
              "name": "owner",
              "plural": false,
              "selections": [{
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "id",
                "storageKey": null
              }, {
                "kind": "ScalarField",
                "alias": null,
                "args": null,
                "name": "firstName",
                "storageKey": null
              }],
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "content",
              "storageKey": null
            }, {
              "kind": "ScalarField",
              "alias": null,
              "args": null,
              "name": "created",
              "storageKey": null
            }],
            "storageKey": null
          }],
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation AddSegment_AddSegmentToTrip_Mutation(\n  $input: AddSegmentInput!\n) {\n  addSegment(input: $input) {\n    trip {\n      numSegments\n      dropbox\n      invoice\n      draftVip\n      book\n      cancel\n      welcomeHome\n      tasks {\n        taskType\n        description\n        completed\n        voided\n        history {\n          name\n          action\n          timestamp\n        }\n        id\n      }\n      segments {\n        currency\n        id\n        trip {\n          id\n          searchId\n        }\n        name\n        dateString\n        startDate\n        endDate\n        category\n        bedType\n        amenityProgram\n        numAdults\n        numChildren\n        smokingRoom\n        rates\n        vendor {\n          id\n          name\n          amenityPrograms\n        }\n        averageDailyRate\n        cancellationDeadline\n        dropbox\n        invoiced\n        vipDrafted\n        vipSent\n        booked\n        cancelled\n        sabreLocator\n        confirmationNumber\n        cancellationNumber\n        vipLetter\n        notes {\n          id\n          owner {\n            id\n            firstName\n          }\n          content\n          created\n        }\n      }\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "mL6h":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash f13f50aaac8152a0f1a7b1b55ce7784f
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type VendorListRenderer_VendorList_QueryResponse = {|
  +allVendors: ?{|
    +edges: $ReadOnlyArray<?{|
      +node: ?{|
        +id: string;
        +name: string;
      |};
    |}>;
  |};
|};
*/

/*
query VendorListRenderer_VendorList_Query {
  allVendors {
    edges {
      node {
        id
        name
      }
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorListRenderer_VendorList_Query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "VendorConnection",
      "name": "allVendors",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "VendorEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Vendor",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "VendorListRenderer_VendorList_Query",
  "query": {
    "argumentDefinitions": [],
    "kind": "Root",
    "name": "VendorListRenderer_VendorList_Query",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": null,
      "concreteType": "VendorConnection",
      "name": "allVendors",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "VendorEdge",
        "name": "edges",
        "plural": true,
        "selections": [{
          "kind": "LinkedField",
          "alias": null,
          "args": null,
          "concreteType": "Vendor",
          "name": "node",
          "plural": false,
          "selections": [{
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "id",
            "storageKey": null
          }, {
            "kind": "ScalarField",
            "alias": null,
            "args": null,
            "name": "name",
            "storageKey": null
          }],
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "query VendorListRenderer_VendorList_Query {\n  allVendors {\n    edges {\n      node {\n        id\n        name\n      }\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "mcCO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__("Q4lS");

var _styles = __webpack_require__("DsNi");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ClientListFilter = (_temp = _class = function (_React$Component) {
  _inherits(ClientListFilter, _React$Component);

  function ClientListFilter() {
    _classCallCheck(this, ClientListFilter);

    return _possibleConstructorReturn(this, (ClientListFilter.__proto__ || Object.getPrototypeOf(ClientListFilter)).apply(this, arguments));
  }

  _createClass(ClientListFilter, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          numClients = _props.numClients,
          numFiltered = _props.numFiltered,
          updateFilter = _props.updateFilter,
          filter = _props.filter;


      return _react2.default.createElement(
        'div',
        { className: _styles2.default.listFilter },
        _react2.default.createElement(
          'div',
          { className: _styles2.default.tripListFilters },
          _react2.default.createElement(
            'div',
            { className: _styles2.default.filter },
            _react2.default.createElement(_materialUi.TextField, {
              floatingLabelText: 'Filter clients by name',
              onChange: updateFilter,
              value: filter
            })
          )
        ),
        _react2.default.createElement(
          'div',
          { className: _styles2.default.infoLine },
          numFiltered,
          ' (of ',
          numClients,
          ') clients displayed'
        )
      );
    }
  }]);

  return ClientListFilter;
}(_react2.default.Component), _class.propTypes = {
  numClients: _propTypes2.default.number,
  numFiltered: _propTypes2.default.number,
  updateFilter: _propTypes2.default.func.isRequired,
  filter: _propTypes2.default.string
}, _class.defaultProps = {
  numClients: 0,
  numFiltered: 0,
  filter: ''
}, _temp);
exports.default = ClientListFilter;

/***/ }),

/***/ "nPTA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash f45c3b40209541e0cd92e097dea00530
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type SegmentDetail_UpdateVIPLetter_MutationVariables = {|
  input: {
    segmentId?: ?string;
    vipContext?: ?any;
    clientMutationId?: ?string;
  };
|};

export type SegmentDetail_UpdateVIPLetter_MutationResponse = {|
  +updateVipLetter: ?{|
    +segment: ?{|
      +id: string;
    |};
  |};
|};
*/

/*
mutation SegmentDetail_UpdateVIPLetter_Mutation(
  $input: UpdateVIPLetterInput!
) {
  updateVipLetter(input: $input) {
    segment {
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "UpdateVIPLetterInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "SegmentDetail_UpdateVIPLetter_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "UpdateVIPLetterInput!"
      }],
      "concreteType": "UpdateVIPLetterPayload",
      "name": "updateVipLetter",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Segment",
        "name": "segment",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "SegmentDetail_UpdateVIPLetter_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "UpdateVIPLetterInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "SegmentDetail_UpdateVIPLetter_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "UpdateVIPLetterInput!"
      }],
      "concreteType": "UpdateVIPLetterPayload",
      "name": "updateVipLetter",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Segment",
        "name": "segment",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation SegmentDetail_UpdateVIPLetter_Mutation(\n  $input: UpdateVIPLetterInput!\n) {\n  updateVipLetter(input: $input) {\n    segment {\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "o3qQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash f40b54490f44b2a995fb89655e9ec6e9
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type LogoutButton_LogOut_MutationVariables = {|
  input: {
    ppjwt?: ?string;
    clientMutationId?: ?string;
  };
|};

export type LogoutButton_LogOut_MutationResponse = {|
  +logOut: ?{|
    +token: ?{|
      +token: string;
    |};
  |};
|};
*/

/*
mutation LogoutButton_LogOut_Mutation(
  $input: LogOutInput!
) {
  logOut(input: $input) {
    token {
      token
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "LogOutInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "LogoutButton_LogOut_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "LogOutInput!"
      }],
      "concreteType": "LogOutPayload",
      "name": "logOut",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "PingPongJWT",
        "name": "token",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "token",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "LogoutButton_LogOut_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "LogOutInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "LogoutButton_LogOut_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "LogOutInput!"
      }],
      "concreteType": "LogOutPayload",
      "name": "logOut",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "PingPongJWT",
        "name": "token",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "token",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation LogoutButton_LogOut_Mutation(\n  $input: LogOutInput!\n) {\n  logOut(input: $input) {\n    token {\n      token\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "pY8a":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createReducer;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _browser = __webpack_require__("AHhf");

var Sentry = _interopRequireWildcard(_browser);

var _ActionTypes = __webpack_require__("zLtr");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _createReducer2 = __webpack_require__("AA0U");

var _createReducer3 = _interopRequireDefault(_createReducer2);

var _package = __webpack_require__("7YgM");

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var NODE_ENV = "production";

var defaultAuthState = {
  authenticated: false,
  token: "",
  id: "",
  username: "",
  firstName: "",
  lastName: "",
  isStaff: "",
  isSuperuser: "",
  groups: []
};

var initialState = _immutable2.default.fromJS(_extends({}, defaultAuthState, {
  version: NODE_ENV === "development" ? "LOCALDEV" : _package.version
}));

exports.default = (0, _createReducer3.default)(initialState, (_createReducer = {}, _defineProperty(_createReducer, _ActionTypes2.default.Auth.setAuthData, function (state, _ref) {
  var obj = _ref.obj;
  var id = obj.id,
      firstName = obj.firstName,
      lastName = obj.lastName;

  Sentry.configureScope(function (scope) {
    scope.setUser({ id: id, firstName: firstName, lastName: lastName });
  });
  return state.merge(obj);
}), _defineProperty(_createReducer, _ActionTypes2.default.Auth.logout, function (state) {
  localStorage.removeItem("PPJWT");
  Sentry.configureScope(function (scope) {
    scope.setUser();
  });
  return state.merge(defaultAuthState);
}), _defineProperty(_createReducer, _ActionTypes2.default.Auth.login, function (state) {
  return state;
}), _createReducer));

/***/ }),

/***/ "pzu2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp2;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__("Q4lS");

var _add = __webpack_require__("XPiC");

var _add2 = _interopRequireDefault(_add);

var _aphrodite = __webpack_require__("BK4P");

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var NewInquiryButton = (_temp2 = _class = function (_React$Component) {
  _inherits(NewInquiryButton, _React$Component);

  function NewInquiryButton() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, NewInquiryButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = NewInquiryButton.__proto__ || Object.getPrototypeOf(NewInquiryButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleClick = function () {
      _this.props.history.push('/inquiry/');
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(NewInquiryButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.large) },
          _react2.default.createElement(_materialUi.RaisedButton, {
            label: 'New Inquiry',
            primary: true,
            onClick: this.handleClick,
            icon: _react2.default.createElement(_add2.default, null)
          })
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.small) },
          _react2.default.createElement(
            _materialUi.IconButton,
            { onClick: this.handleClick },
            _react2.default.createElement(_add2.default, { color: _ourismanTravelTheme2.default.palette.alternateTextColor })
          )
        )
      );
    }
  }]);

  return NewInquiryButton;
}(_react2.default.Component), _class.propTypes = {
  history: _propTypes2.default.shape({
    push: _propTypes2.default.func
  }).isRequired
}, _temp2);
exports.default = NewInquiryButton;


var styles = _aphrodite.StyleSheet.create({
  large: {
    '@media (max-width: 800px)': {
      display: 'none'
    }
  },
  small: {
    '@media (min-width: 800px)': {
      display: 'none'
    }
  }
});

/***/ }),

/***/ "r4x5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _reduxForm = __webpack_require__("ttGY");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _reduxForm.reducer.normalize({
  createBooking: {
    dateString: function dateString(value) {
      return value && value.toUpperCase();
    },
    bookingYear: function bookingYear(value, previousValue, allValues) {
      var dateString = allValues.dateString;

      if (dateString && /^\d{1,2}\w{3}-\d+NT/i.test(dateString)) {
        var _dateString$split = dateString.split('-'),
            _dateString$split2 = _slicedToArray(_dateString$split, 1),
            date = _dateString$split2[0];

        var bookingDate = (0, _moment2.default)(date, 'DDMMM').startOf('day');
        if (bookingDate && bookingDate.isValid()) {
          if (bookingDate < (0, _moment2.default)().startOf('day')) {
            value = bookingDate.year() + 1;
          }
        }
      }

      return value;
    }
  }
});

/***/ }),

/***/ "rhst":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__("Q4lS");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _modeEdit = __webpack_require__("LWNG");

var _modeEdit2 = _interopRequireDefault(_modeEdit);

var _email = __webpack_require__("LWqx");

var _email2 = _interopRequireDefault(_email);

var _reactRedux = __webpack_require__("RH2O");

var _reactRouterDom = __webpack_require__("F8kA");

var _reactRelay = __webpack_require__("Tc9k");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _DailyRates = __webpack_require__("WexP");

var _DailyRates2 = _interopRequireDefault(_DailyRates);

var _EditSegment = __webpack_require__("85Hc");

var _EditSegment2 = _interopRequireDefault(_EditSegment);

var _NoteListItem = __webpack_require__("abLE");

var _NoteListItem2 = _interopRequireDefault(_NoteListItem);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var DisplayData = function DisplayData(_ref) {
  var _ref$segment = _ref.segment,
      category = _ref$segment.category,
      smokingRoom = _ref$segment.smokingRoom,
      numAdults = _ref$segment.numAdults,
      numChildren = _ref$segment.numChildren,
      startDate = _ref$segment.startDate,
      endDate = _ref$segment.endDate,
      cancellationDeadline = _ref$segment.cancellationDeadline,
      sabreLocator = _ref$segment.sabreLocator,
      confirmationNumber = _ref$segment.confirmationNumber,
      cancellationNumber = _ref$segment.cancellationNumber,
      rates = _ref$segment.rates,
      currency = _ref$segment.currency,
      averageDailyRate = _ref$segment.averageDailyRate,
      notes = _ref$segment.notes,
      bedType = _ref$segment.bedType,
      amenityProgram = _ref$segment.amenityProgram,
      vendor = _ref$segment.vendor;

  var displayCategory = category !== "" ? category : "no category set";
  var displayBedType = bedType !== "" ? bedType : "no bedding set";
  var displayAmenity = amenityProgram !== "" ? amenityProgram : "no amenity program set";
  var smoking = smokingRoom ? "smoking" : "non-smoking";
  var formatDate = function formatDate(date) {
    return (0, _moment2.default)(date).format("DDMMM YYYY").toUpperCase();
  };
  var numNotes = notes.length;

  return _react2.default.createElement(
    "div",
    null,
    _react2.default.createElement(
      "h3",
      null,
      vendor ? _react2.default.createElement(
        _reactRouterDom.Link,
        { to: "/vendors/" + vendor.id + "/" },
        vendor.name
      ) : "TBD"
    ),
    _react2.default.createElement(
      "p",
      null,
      displayAmenity,
      ", ",
      displayCategory,
      ", ",
      displayBedType,
      ", ",
      smoking,
      ",\xA0",
      numAdults,
      " adults, ",
      numChildren,
      " children"
    ),
    _react2.default.createElement(
      "div",
      { style: styles.detailColumns },
      _react2.default.createElement(
        "div",
        { style: styles.detailColumn },
        _react2.default.createElement(
          "span",
          null,
          "Check In: ",
          formatDate(startDate)
        ),
        _react2.default.createElement(
          "span",
          null,
          "Check Out: ",
          formatDate(endDate)
        ),
        _react2.default.createElement(
          "span",
          null,
          "Cancellation: ",
          formatDate(cancellationDeadline)
        )
      ),
      _react2.default.createElement(
        "div",
        { style: styles.detailColumn },
        _react2.default.createElement(
          "span",
          null,
          "SABRE Locator: ",
          sabreLocator
        ),
        _react2.default.createElement(
          "span",
          null,
          "Confirmation Number: ",
          confirmationNumber
        ),
        _react2.default.createElement(
          "span",
          null,
          "Cancellation Number: ",
          cancellationNumber
        )
      )
    ),
    _react2.default.createElement(_DailyRates2.default, {
      rates: rates,
      currency: currency,
      average: averageDailyRate
    }),
    _react2.default.createElement(
      "h5",
      null,
      "Notes (",
      numNotes,
      ")"
    ),
    numNotes > 0 ? _react2.default.createElement(
      "ul",
      null,
      notes.map(function (note, index) {
        return _react2.default.createElement(_NoteListItem2.default, { key: index, index: index, note: note });
      })
    ) : null
  );
};

DisplayData.propTypes = {
  segment: _propTypes2.default.shape({
    category: _propTypes2.default.string,
    smokingRoom: _propTypes2.default.bool,
    numAdults: _propTypes2.default.number,
    numChildren: _propTypes2.default.number,
    startDate: _propTypes2.default.string,
    endDate: _propTypes2.default.string,
    cancellationDeadline: _propTypes2.default.string,
    sabreLocator: _propTypes2.default.string,
    confirmationNumber: _propTypes2.default.string,
    cancellationNumber: _propTypes2.default.string,
    rates: _propTypes2.default.arrayOf(_propTypes2.default.number),
    currency: _propTypes2.default.string,
    averageDailyRate: _propTypes2.default.numbe,
    notes: _propTypes2.default.arrayOf(_propTypes2.default.object),
    bedType: _propTypes2.default.string,
    amenityProgram: _propTypes2.default.string,
    vendor: _propTypes2.default.obects
  }).isRequired
};

var SegmentDetails = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    auth: state.Auth.toJS()
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(SegmentDetails, _React$Component);

  function SegmentDetails(props) {
    _classCallCheck(this, SegmentDetails);

    var _this = _possibleConstructorReturn(this, (SegmentDetails.__proto__ || Object.getPrototypeOf(SegmentDetails)).call(this, props));

    _this.setCheckbox = function (checkbox) {
      return function (e, checked) {
        var segmentId = _this.props.segment.id;


        (0, _reactRelay.commitMutation)(_environment2.default, {
          mutation: _graphql || (_graphql = function _graphql() {
            return __webpack_require__("AVJT");
          }),
          variables: { input: { segmentId: segmentId, checkbox: checkbox, value: checked } },
          onError: function onError(err) {
            return alert(err);
          }
        });
      };
    };

    _this.toggleEditing = function () {
      _this.setState({ editing: !_this.state.editing });
    };

    _this.composeVIP = function () {
      var _this$props$segment = _this.props.segment,
          segmentId = _this$props$segment.id,
          tripId = _this$props$segment.trip.id;


      _this.context.router.push("/trips/" + tripId + "/segments/" + segmentId + "/");
    };

    _this.state = {
      editing: false
    };
    return _this;
  }

  _createClass(SegmentDetails, [{
    key: "render",
    value: function render() {
      var editing = this.state.editing;
      var _props = this.props,
          segment = _props.segment,
          _props$auth = _props.auth,
          authenticated = _props$auth.authenticated,
          groups = _props$auth.groups;
      var dropbox = segment.dropbox,
          invoiced = segment.invoiced,
          vipDrafted = segment.vipDrafted,
          cancelled = segment.cancelled,
          segmentId = segment.id,
          tripId = segment.trip.id;


      var authorized = authenticated && groups.indexOf("admin") > -1;
      var locked = cancelled && !authorized;

      return _react2.default.createElement(
        _materialUi.Card,
        { style: styles.segmentDetailStyle },
        _react2.default.createElement(
          _materialUi.CardText,
          null,
          _react2.default.createElement(
            "div",
            { style: styles.segmentStatus },
            _react2.default.createElement(
              "h4",
              null,
              "Status:"
            ),
            _react2.default.createElement(
              "div",
              { style: styles.checkbox },
              _react2.default.createElement(_materialUi.Checkbox, {
                label: "Filed",
                labelPosition: "right",
                checked: dropbox,
                onCheck: this.setCheckbox("dropbox"),
                iconStyle: styles.checkboxIconStyle,
                disabled: locked
              })
            ),
            _react2.default.createElement(
              "div",
              { style: styles.checkbox },
              _react2.default.createElement(_materialUi.Checkbox, {
                label: "Invoiced",
                labelPosition: "right",
                checked: invoiced,
                onCheck: this.setCheckbox("invoiced"),
                iconStyle: styles.checkboxIconStyle,
                disabled: locked
              })
            ),
            _react2.default.createElement(
              "div",
              { style: styles.checkbox },
              _react2.default.createElement(_materialUi.Checkbox, {
                label: "VIP Drafted",
                labelPosition: "right",
                checked: vipDrafted,
                onCheck: this.setCheckbox("vipDrafted"),
                iconStyle: styles.checkboxIconStyle,
                disabled: locked
              })
            )
          ),
          _react2.default.createElement(
            "h4",
            null,
            "Details",
            _react2.default.createElement(
              _materialUi.IconButton,
              {
                tooltip: "Edit Segment",
                disabled: editing || locked,
                onTouchTap: this.toggleEditing
              },
              _react2.default.createElement(_modeEdit2.default, null)
            ),
            authorized && segment.vendor ? _react2.default.createElement(
              _reactRouterDom.Link,
              { to: "/trips/" + tripId + "/segments/" + segmentId + "/" },
              _react2.default.createElement(_email2.default, null)
            ) : null
          ),
          editing ? _react2.default.createElement(_EditSegment2.default, { segment: segment, onComplete: this.toggleEditing }) : _react2.default.createElement(DisplayData, { segment: segment })
        )
      );
    }
  }]);

  return SegmentDetails;
}(_react2.default.Component), _class2.contextTypes = {
  router: _propTypes2.default.object
}, _class2.propTypes = {
  segment: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    dropbox: _propTypes2.default.bool,
    invoiced: _propTypes2.default.bool,
    vipDrafted: _propTypes2.default.bool,
    cancelled: _propTypes2.default.bool,
    trip: _propTypes2.default.object
  }).isRequired,
  auth: _propTypes2.default.shape({
    authenticated: _propTypes2.default.bool,
    groups: _propTypes2.default.arrayOf(_propTypes2.default.string)
  }).isRequired
}, _temp)) || _class);


var styles = {
  segmentDetailStyle: {
    margin: 5
  },
  segmentStatus: {
    width: "100%",
    display: "flex",
    alignItems: "center"
  },
  checkbox: {
    paddingLeft: 5,
    flex: "1 0 auto"
  },
  checkboxIconStyle: {
    paddingLeft: 3
  },
  detailColumns: {
    display: "flex",
    justifyContent: "space-between",
    flexWrap: "wrap"
  },
  detailColumn: {
    display: "flex",
    flexDirection: "column"
  }
};

exports.default = SegmentDetails;

/***/ }),

/***/ "ruCO":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Clients = undefined;

var _Clients2 = __webpack_require__("Scq2");

var _Clients3 = _interopRequireDefault(_Clients2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Clients = _Clients3.default;

/***/ }),

/***/ "rumv":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp, _initialiseProps;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__("Q4lS");

var _aphrodite = __webpack_require__("BK4P");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("RH2O");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _InquiryActions = __webpack_require__("EJRV");

var InquiryActions = _interopRequireWildcard(_InquiryActions);

var _DateFieldComponent = __webpack_require__("kg8o");

var _DateFieldComponent2 = _interopRequireDefault(_DateFieldComponent);

var _rest = __webpack_require__("i4WM");

var _rest2 = _interopRequireDefault(_rest);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var AddTraveler = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    inquiry: state.Inquiry.get('inquiry').toJS()
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(AddTraveler, _React$Component);

  function AddTraveler(props) {
    _classCallCheck(this, AddTraveler);

    var _this = _possibleConstructorReturn(this, (AddTraveler.__proto__ || Object.getPrototypeOf(AddTraveler)).call(this, props));

    _initialiseProps.call(_this);

    if (typeof window !== 'undefined') {
      _this.ReactQuill = __webpack_require__("TWqO"); // eslint-disable-line global-require
    }

    var travelers = _this.props.inquiry.travelers;


    var isPrimaryTraveler = void 0;
    var primaryTravelerId = void 0;
    var primaryTravelerName = void 0;
    if (travelers.length === 0) {
      isPrimaryTraveler = true;
      primaryTravelerId = '';
      primaryTravelerName = '';
    } else {
      var primary = travelers[0];
      isPrimaryTraveler = false;
      primaryTravelerId = primary.id;
      primaryTravelerName = primary.lastName + ', ' + primary.firstName;
    }

    _this.state = {
      travelerAutocompleteData: [],
      profileAutocompleteData: [],
      dirty: false,
      firstName: '',
      lastName: '',
      email: '',
      birthdate: '',
      validDate: false,
      isAdult: true,
      insideCircle: false,
      needsTraining: false,
      needsVetting: true,
      isPrimaryTraveler: isPrimaryTraveler,
      primaryTravelerId: primaryTravelerId,
      primaryTravelerName: primaryTravelerName,
      relationship: '',
      vipNotes: ''
    };
    return _this;
  }

  _createClass(AddTraveler, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          dirty = _state.dirty,
          firstName = _state.firstName,
          lastName = _state.lastName,
          email = _state.email,
          isAdult = _state.isAdult,
          insideCircle = _state.insideCircle,
          needsTraining = _state.needsTraining,
          needsVetting = _state.needsVetting,
          validAdult = _state.validAdult,
          primaryTravelerName = _state.primaryTravelerName,
          relationship = _state.relationship,
          isPrimaryTraveler = _state.isPrimaryTraveler,
          vipNotes = _state.vipNotes,
          travelerAutocompleteData = _state.travelerAutocompleteData,
          profileAutocompleteData = _state.profileAutocompleteData,
          birthdate = _state.birthdate;


      var ready = dirty && (birthdate === '' || (0, _moment2.default)(birthdate).isValid());

      return _react2.default.createElement(
        _materialUi.Paper,
        { className: (0, _aphrodite.css)(styles.addBox) },
        _react2.default.createElement(_materialUi.AutoComplete, {
          hintText: 'Search for an existing traveler',
          menuStyle: { width: 500 },
          listStyle: { width: 500 },
          dataSource: travelerAutocompleteData,
          onUpdateInput: this.handleUpdateTravelerAutocomplete,
          onNewRequest: this.travelerSelected,
          fullWidth: true,
          filter: function filter() {
            return true;
          }
        }),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.formRow) },
          _react2.default.createElement(_materialUi.TextField, { floatingLabelText: 'First name', onChange: this.updateTextField('firstName'), value: firstName }),
          _react2.default.createElement(_materialUi.TextField, { floatingLabelText: 'Last name', onChange: this.updateTextField('lastName'), value: lastName }),
          _react2.default.createElement(_materialUi.TextField, { floatingLabelText: 'Email Address', onChange: this.updateTextField('email'), value: email })
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.formRow) },
          _react2.default.createElement(_DateFieldComponent2.default, { className: (0, _aphrodite.css)(styles.birthdate), floatingLabelText: 'Birthdate', onChange: this.updateBirthdate }),
          _react2.default.createElement(_materialUi.Checkbox, { checked: isAdult, label: 'Adult', className: (0, _aphrodite.css)(styles.checkBox), disabled: validAdult, onCheck: this.handleCheckbox('isAdult') }),
          _react2.default.createElement('div', { className: (0, _aphrodite.css)(styles.checkBox) })
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.formRow) },
          _react2.default.createElement(_materialUi.Checkbox, { checked: insideCircle, label: 'Inside Circle', className: (0, _aphrodite.css)(styles.checkBox), onCheck: this.handleCheckbox('insideCircle') }),
          _react2.default.createElement(_materialUi.Checkbox, { checked: needsTraining, label: 'Needs Training', className: (0, _aphrodite.css)(styles.checkBox), onCheck: this.handleCheckbox('needsTraining') }),
          _react2.default.createElement(_materialUi.Checkbox, { checked: needsVetting, label: 'Needs Vetting', className: (0, _aphrodite.css)(styles.checkBox), onCheck: this.handleCheckbox('needsVetting') })
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.formRow) },
          _react2.default.createElement(_materialUi.Checkbox, { checked: isPrimaryTraveler, label: 'Primary Traveler', className: (0, _aphrodite.css)(styles.checkBox), onCheck: this.handleCheckbox('isPrimaryTraveler') }),
          _react2.default.createElement(_materialUi.AutoComplete, {
            floatingLabelText: 'CB+ Profile Name',
            menuStyle: { width: 500 },
            listStyle: { width: 500 },
            searchText: primaryTravelerName,
            dataSource: profileAutocompleteData,
            onUpdateInput: this.handleUpdateProfileAutocomplete,
            onNewRequest: this.profileSelected,
            disabled: isPrimaryTraveler,
            filter: function filter() {
              return true;
            }
          }),
          _react2.default.createElement(_materialUi.TextField, { floatingLabelText: 'Relationship', onChange: this.updateTextField('relationship'), value: relationship, disabled: isPrimaryTraveler })
        ),
        _react2.default.createElement(
          'div',
          null,
          _react2.default.createElement(
            'h2',
            null,
            'VIP Notes'
          ),
          _react2.default.createElement(this.ReactQuill, { value: vipNotes, onChange: this.updateVipNotes })
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.controls) },
          _react2.default.createElement(_materialUi.FlatButton, { label: 'Cancel', onTouchTap: this.onCancel, secondary: true }),
          _react2.default.createElement(_materialUi.FlatButton, { label: 'Submit', onTouchTap: this.onSubmit, primary: true, disabled: !ready })
        )
      );
    }
  }]);

  return AddTraveler;
}(_react2.default.Component), _class2.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  inquiry: _propTypes2.default.shape().isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.handleUpdateTravelerAutocomplete = function (value) {
    (0, _rest2.default)('auto/traveler', value).then(function (response) {
      var objects = response.objects;

      _this2.setState({
        travelerAutocompleteData: objects.map(function (object) {
          var emailString = object.email[0] !== '' ? ' (' + object.email + ')' : '';
          var displayName = object.displayName || object.fullName;
          var text = '' + displayName + emailString;

          return {
            text: text,
            value: object.relayId,
            fullName: object.fullName,
            displayName: object.displayName,
            firstName: object.firstName,
            lastName: object.lastName,
            email: object.email[0],
            birthdate: object.birthdate,
            isAdult: object.adult,
            isPrimaryTraveler: object.isPrimaryTraveler,
            primaryTravelerId: object.primaryTravelerId,
            primaryTravelerName: object.primaryTravelerName,
            insideCircle: object.insideCircle,
            needsTraining: object.needsTraining,
            needsVetting: object.needsVetting
          };
        })
      });
    }).catch(function (response) {
      console.log(response);
    });
  };

  this.travelerSelected = function (selected, index) {
    if (index !== -1) {
      var id = selected.value,
          firstName = selected.firstName,
          lastName = selected.lastName,
          fullName = selected.fullName,
          displayName = selected.displayName,
          email = selected.email,
          birthdate = selected.birthdate,
          isAdult = selected.isAdult,
          isPrimaryTraveler = selected.isPrimaryTraveler,
          primaryTravelerId = selected.primaryTravelerId,
          primaryTravelerName = selected.primaryTravelerName,
          insideCircle = selected.insideCircle,
          needsTraining = selected.needsTraining,
          needsVetting = selected.needsVetting;


      var traveler = {
        id: id,
        firstName: firstName,
        lastName: lastName,
        fullName: fullName,
        displayName: displayName,
        email: email,
        birthdate: birthdate,
        isAdult: isAdult,
        isPrimaryTraveler: isPrimaryTraveler,
        primaryTravelerId: primaryTravelerId,
        primaryTravelerName: primaryTravelerName,
        insideCircle: insideCircle,
        needsTraining: needsTraining,
        needsVetting: needsVetting
      };

      _this2.props.dispatch(InquiryActions.addTraveler(traveler));
    }
  };

  this.handleUpdateProfileAutocomplete = function (value) {
    (0, _rest2.default)('auto/traveler', value + '&primary=true').then(function (response) {
      var objects = response.objects;

      _this2.setState({
        primaryTravelerId: '',
        primaryTravelerName: value,
        profileAutocompleteData: objects.map(function (object) {
          return {
            text: object.displayName || object.fullName,
            value: object.relayId,
            displayName: object.displayName || object.fullName,
            firstName: object.firstName,
            lastName: object.lastName
          };
        })
      });
    }).catch(function (response) {
      console.log(response);
    });
  };

  this.profileSelected = function (selected, index) {
    if (index === -1) {
      _this2.setState({
        primaryTravelerId: '',
        primaryTravelerName: selected
      });
    } else {
      var primaryTravelerId = selected.value,
          primaryTravelerName = selected.displayName;


      _this2.setState({
        primaryTravelerId: primaryTravelerId,
        primaryTravelerName: primaryTravelerName
      });
    }
  };

  this.onSubmit = function () {
    var _state2 = _this2.state,
        firstName = _state2.firstName,
        lastName = _state2.lastName,
        email = _state2.email,
        birthdate = _state2.birthdate,
        isAdult = _state2.isAdult,
        insideCircle = _state2.insideCircle,
        needsTraining = _state2.needsTraining,
        needsVetting = _state2.needsVetting,
        isPrimaryTraveler = _state2.isPrimaryTraveler,
        primaryTravelerId = _state2.primaryTravelerId,
        primaryTravelerName = _state2.primaryTravelerName,
        relationship = _state2.relationship,
        vipNotes = _state2.vipNotes;


    _this2.props.dispatch(InquiryActions.addTraveler({
      id: '',
      firstName: firstName,
      lastName: lastName,
      fullName: lastName + ', ' + firstName,
      email: email,
      birthdate: birthdate,
      isAdult: isAdult,
      insideCircle: insideCircle,
      needsTraining: needsTraining,
      needsVetting: needsVetting,
      isPrimaryTraveler: isPrimaryTraveler,
      primaryTravelerId: primaryTravelerId,
      primaryTravelerName: primaryTravelerName,
      relationship: relationship,
      vipNotes: vipNotes
    }));
  };

  this.onCancel = function () {
    _this2.props.dispatch(InquiryActions.toggleNewTraveler(false));
  };

  this.updateTextField = function (field) {
    return function (e) {
      var newState = { dirty: true };
      newState[field] = e.target.value;
      _this2.setState(newState);
    };
  };

  this.updateBirthdate = function (e) {
    var value = e.target.value;
    var isAdult = _this2.state.isAdult;

    var validDate = (0, _moment2.default)(value).isValid();

    _this2.setState({
      dirty: true,
      birthdate: value,
      validDate: validDate,
      isAdult: validDate ? (0, _moment2.default)().diff((0, _moment2.default)(value), 'years') > 17 : isAdult
    });
  };

  this.handleCheckbox = function (fieldname) {
    return function (e, checked) {
      var newState = { dirty: true };

      if (fieldname === 'isPrimaryTraveler' && checked) {
        newState.primaryTravelerId = '';
        newState.primaryTravelerName = '';
        newState.relationship = '';
      }

      newState[fieldname] = checked;
      _this2.setState(newState);
    };
  };

  this.handleVipNotes = function (vipNotes) {
    _this2.setState({
      vipNotes: vipNotes,
      dirty: true
    });
  };
}, _temp)) || _class);
exports.default = AddTraveler;


var styles = _aphrodite.StyleSheet.create({
  addBox: {
    marginLeft: 15,
    flexGrow: 1,
    padding: '0 15px 15px 15px',
    display: 'flex',
    flexDirection: 'column',
    maxWidth: 839
  },
  formRow: {
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    alignItems: 'baseline'
  },
  controls: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%'
  },
  checkBox: {
    width: 256
  },
  birthdate: {
    marginBottom: 15
  }
});

/***/ }),

/***/ "tNoA":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 576c7e9cf8b76f8fffd8ca9d29bf0a21
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type ClientDetail_TriggerWelcomeCampaign_MutationVariables = {|
  input: {
    travelerId?: ?string;
    clientMutationId?: ?string;
  };
|};

export type ClientDetail_TriggerWelcomeCampaign_MutationResponse = {|
  +triggerWelcomeCampaign: ?{|
    +traveler: ?{|
      +welcomeCampaign: boolean;
    |};
  |};
|};
*/

/*
mutation ClientDetail_TriggerWelcomeCampaign_Mutation(
  $input: TriggerWelcomeCampaignInput!
) {
  triggerWelcomeCampaign(input: $input) {
    traveler {
      welcomeCampaign
      id
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "TriggerWelcomeCampaignInput!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "ClientDetail_TriggerWelcomeCampaign_Mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "TriggerWelcomeCampaignInput!"
      }],
      "concreteType": "TriggerWelcomeCampaignPayload",
      "name": "triggerWelcomeCampaign",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Traveler",
        "name": "traveler",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "welcomeCampaign",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Mutations"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "ClientDetail_TriggerWelcomeCampaign_Mutation",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "input",
      "type": "TriggerWelcomeCampaignInput!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "ClientDetail_TriggerWelcomeCampaign_Mutation",
    "operation": "mutation",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "input",
        "variableName": "input",
        "type": "TriggerWelcomeCampaignInput!"
      }],
      "concreteType": "TriggerWelcomeCampaignPayload",
      "name": "triggerWelcomeCampaign",
      "plural": false,
      "selections": [{
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Traveler",
        "name": "traveler",
        "plural": false,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "welcomeCampaign",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "mutation ClientDetail_TriggerWelcomeCampaign_Mutation(\n  $input: TriggerWelcomeCampaignInput!\n) {\n  triggerWelcomeCampaign(input: $input) {\n    traveler {\n      welcomeCampaign\n      id\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "tTpR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class, _class2, _temp, _initialiseProps, _graphql, _graphql2;

var _templateObject = _taggedTemplateLiteral(["\n  query TripDetailsQuery {\n    allUsers(groups_Name: \"Team\") {\n      edges {\n        node {\n          id\n          firstName\n          username\n        }\n      }\n    }\n    tripCategories {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n  }\n"], ["\n  query TripDetailsQuery {\n    allUsers(groups_Name: \"Team\") {\n      edges {\n        node {\n          id\n          firstName\n          username\n        }\n      }\n    }\n    tripCategories {\n      edges {\n        node {\n          id\n          name\n        }\n      }\n    }\n  }\n"]);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _materialUi = __webpack_require__("Q4lS");

var _reactRedux = __webpack_require__("RH2O");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactApollo = __webpack_require__("3zLD");

var _reactRelay = __webpack_require__("Tc9k");

var _aphrodite = __webpack_require__("BK4P");

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _DateRangeComponent = __webpack_require__("JW7h");

var _DateRangeComponent2 = _interopRequireDefault(_DateRangeComponent);

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var EditTripQuery = (0, _reactApollo.gql)(_templateObject);

var EditTrip = (_dec = (0, _reactRedux.connect)(), _dec2 = (0, _reactApollo.graphql)(EditTripQuery), _dec(_class = _dec2(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(EditTrip, _React$Component);

  function EditTrip(props) {
    _classCallCheck(this, EditTrip);

    var _this = _possibleConstructorReturn(this, (EditTrip.__proto__ || Object.getPrototypeOf(EditTrip)).call(this, props));

    _initialiseProps.call(_this);

    var _this$props$trip = _this.props.trip,
        owner = _this$props$trip.owner,
        inbox = _this$props$trip.inbox,
        category = _this$props$trip.category,
        destination = _this$props$trip.destination,
        specificDates = _this$props$trip.specificDates,
        startDate = _this$props$trip.startDate,
        endDate = _this$props$trip.endDate,
        _this$props$trip$time = _this$props$trip.timeFrame,
        timeFrame = _this$props$trip$time === undefined ? "" : _this$props$trip$time,
        needsVetting = _this$props$trip.needsVetting,
        segments = _this$props$trip.segments,
        prospect = _this$props$trip.prospect;


    var segmentStartDate = null;
    var segmentEndDate = null;
    var validSegments = segments.filter(function (segment) {
      return segment.cancelled === false;
    });
    if (validSegments.length > 0) {
      var segmentDates = validSegments.map(function (segment) {
        return [(0, _moment2.default)(segment.startDate), (0, _moment2.default)(segment.endDate)];
      }).reduce(function (first, second) {
        var start = first[0] && second[0] && _moment2.default.min(first[0], second[0]) || first[0] || second[0] || null;
        var end = first[1] && second[1] && _moment2.default.max(first[1], second[1]) || first[1] || second[1] || null;

        return [start, end];
      });
      segmentStartDate = segmentDates[0];
      segmentEndDate = segmentDates[1];
    }

    _this.state = {
      owner: owner,
      inbox: inbox,
      categoryId: category.id,
      categoryName: category.name,
      destination: destination,
      specificDates: specificDates,
      startDate: startDate,
      endDate: endDate,
      timeFrame: timeFrame,
      ownerId: owner.id,
      needsVetting: needsVetting,
      prospect: prospect,
      segmentStartDate: segmentStartDate,
      segmentEndDate: segmentEndDate,
      validDates: true
    };
    return _this;
  }

  _createClass(EditTrip, [{
    key: "render",
    value: function render() {
      var _state = this.state,
          inbox = _state.inbox,
          categoryId = _state.categoryId,
          destination = _state.destination,
          specificDates = _state.specificDates,
          startDate = _state.startDate,
          endDate = _state.endDate,
          timeFrame = _state.timeFrame,
          needsVetting = _state.needsVetting,
          validDates = _state.validDates,
          prospect = _state.prospect,
          ownerId = _state.ownerId;
      var _props = this.props,
          data = _props.data,
          segments = _props.trip.segments;


      var users = [];
      var categories = [];
      if (!data.loading) {
        users = data.allUsers.edges.map(function (_ref) {
          var node = _ref.node;
          return node;
        });
        categories = data.tripCategories.edges.map(function (_ref2) {
          var node = _ref2.node;
          return node;
        });
      }

      return _react2.default.createElement(
        _materialUi.Paper,
        { className: (0, _aphrodite.css)(styles.detailsContainer) },
        _react2.default.createElement(
          "h3",
          null,
          "Admin"
        ),
        _react2.default.createElement(
          "div",
          { className: (0, _aphrodite.css)(styles.fieldsGroup) },
          _react2.default.createElement(
            _materialUi.SelectField,
            {
              className: (0, _aphrodite.css)(styles.formField),
              floatingLabelText: "Inbox:",
              value: inbox,
              onChange: this.updateSelect("inbox")
            },
            ["team@", "insidecircle@", "david@", "jessica@"].map(function (option, index) {
              return _react2.default.createElement(_materialUi.MenuItem, { key: index, value: option, primaryText: option });
            })
          ),
          _react2.default.createElement(
            _materialUi.SelectField,
            {
              className: (0, _aphrodite.css)(styles.formField),
              floatingLabelText: "Assign trip to:",
              value: ownerId,
              onChange: this.updateSelect("ownerId")
            },
            users.map(function (_ref3) {
              var id = _ref3.id,
                  firstName = _ref3.firstName;
              return _react2.default.createElement(_materialUi.MenuItem, { key: id, value: id, primaryText: firstName });
            })
          ),
          _react2.default.createElement(
            _materialUi.SelectField,
            {
              className: (0, _aphrodite.css)(styles.formField),
              floatingLabelText: "Trip Category:",
              value: categoryId,
              onChange: this.updateSelect("categoryId")
            },
            categories.map(function (_ref4) {
              var id = _ref4.id,
                  name = _ref4.name;
              return _react2.default.createElement(_materialUi.MenuItem, { key: id, value: id, primaryText: name });
            })
          ),
          _react2.default.createElement(_materialUi.Checkbox, {
            className: (0, _aphrodite.css)(styles.formField),
            checked: needsVetting,
            onCheck: this.toggleNeedsVetting,
            label: "Needs Vetting"
          }),
          _react2.default.createElement(_materialUi.Checkbox, {
            className: (0, _aphrodite.css)(styles.formField),
            checked: prospect,
            onCheck: this.toggleProspect,
            label: "Prospect"
          })
        ),
        _react2.default.createElement(
          "h3",
          null,
          "Trip Overview"
        ),
        _react2.default.createElement(
          "div",
          { className: (0, _aphrodite.css)(styles.fieldsGroup) },
          _react2.default.createElement(_materialUi.TextField, {
            floatingLabelText: "Trip Name",
            value: destination,
            onChange: this.updateTextField("destination"),
            fullWidth: true
          }),
          _react2.default.createElement(
            "div",
            null,
            specificDates ? _react2.default.createElement(_DateRangeComponent2.default, {
              startValue: startDate,
              endValue: endDate,
              startLabel: "Travel Start Date",
              endLabel: "Travel End Date",
              onChange: this.updateTravelDates
            }) : _react2.default.createElement(_materialUi.TextField, {
              floatingLabelText: "Timeframe",
              value: timeFrame,
              onChange: this.updateTextField("timeFrame")
            }),
            _react2.default.createElement(_materialUi.Toggle, {
              className: (0, _aphrodite.css)(styles.specificDates),
              checked: specificDates,
              onClick: this.toggleField("specificDates"),
              label: "Specific Dates",
              labelPosition: "right"
            }),
            _react2.default.createElement(_materialUi.FlatButton, {
              label: "Fit to segments",
              disabled: segments.length < 1,
              onTouchTap: this.fitToSegments
            })
          )
        ),
        validDates ? null : _react2.default.createElement(
          "div",
          { className: (0, _aphrodite.css)(styles.errorMessage) },
          _react2.default.createElement(
            "span",
            null,
            "Specified dates are invalid or do not contain all segments."
          )
        ),
        _react2.default.createElement(
          "div",
          { className: (0, _aphrodite.css)(styles.formActions) },
          _react2.default.createElement(_materialUi.RaisedButton, {
            className: (0, _aphrodite.css)(styles.formButton),
            label: "Cancel",
            secondary: true,
            onTouchTap: this.close
          }),
          _react2.default.createElement(_materialUi.RaisedButton, {
            className: (0, _aphrodite.css)(styles.formButton),
            label: "Save",
            primary: true,
            onTouchTap: this.save,
            disabled: !validDates
          })
        )
      );
    }
  }]);

  return EditTrip;
}(_react2.default.Component), _class2.propTypes = {
  trip: _propTypes2.default.shape({
    owner: _propTypes2.default.shape({ id: _propTypes2.default.string })
  }).isRequired,
  handleSave: _propTypes2.default.func.isRequired,
  data: _propTypes2.default.shape().isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.close = function () {
    _this2.props.handleSave();
  };

  this.fitToSegments = function () {
    var tripId = _this2.props.trip.id;
    var _state2 = _this2.state,
        inbox = _state2.inbox,
        ownerId = _state2.ownerId,
        categoryId = _state2.categoryId,
        destination = _state2.destination,
        specificDates = _state2.specificDates,
        timeFrame = _state2.timeFrame,
        needsVetting = _state2.needsVetting,
        prospect = _state2.prospect;
    var _state3 = _this2.state,
        startDate = _state3.segmentStartDate,
        endDate = _state3.segmentEndDate;


    if (_moment2.default.isMoment(startDate)) {
      startDate = startDate.format("YYYY-MM-DDTHH:mm:ssZZ");
    }
    if (_moment2.default.isMoment(endDate)) {
      endDate = endDate.format("YYYY-MM-DDTHH:mm:ssZZ");
    }

    (0, _reactRelay.commitMutation)(_environment2.default, {
      mutation: _graphql || (_graphql = function _graphql() {
        return __webpack_require__("5d3T");
      }),
      variables: {
        input: {
          tripId: tripId,
          inbox: inbox,
          ownerId: ownerId,
          categoryId: categoryId,
          destination: destination,
          specificDates: specificDates,
          timeFrame: timeFrame,
          startDate: startDate,
          endDate: endDate,
          needsVetting: needsVetting,
          prospect: prospect
        }
      },
      onCompleted: function onCompleted() {
        return _this2.close();
      },
      onError: function onError(err) {
        return alert(err);
      }
    });
  };

  this.save = function () {
    var tripId = _this2.props.trip.id;
    var _state4 = _this2.state,
        inbox = _state4.inbox,
        ownerId = _state4.ownerId,
        categoryId = _state4.categoryId,
        destination = _state4.destination,
        specificDates = _state4.specificDates,
        timeFrame = _state4.timeFrame,
        needsVetting = _state4.needsVetting,
        prospect = _state4.prospect;
    var _state5 = _this2.state,
        startDate = _state5.startDate,
        endDate = _state5.endDate;


    if (_moment2.default.isMoment(startDate)) {
      startDate = startDate.format("YYYY-MM-DDTHH:mm:ssZZ");
    }
    if (_moment2.default.isMoment(endDate)) {
      endDate = endDate.format("YYYY-MM-DDTHH:mm:ssZZ");
    }

    (0, _reactRelay.commitMutation)(_environment2.default, {
      mutation: _graphql2 || (_graphql2 = function _graphql2() {
        return __webpack_require__("5d3T");
      }),
      variables: {
        input: {
          tripId: tripId,
          inbox: inbox,
          ownerId: ownerId,
          categoryId: categoryId,
          destination: destination,
          specificDates: specificDates,
          timeFrame: timeFrame,
          startDate: startDate,
          endDate: endDate,
          needsVetting: needsVetting,
          prospect: prospect
        }
      },
      onCompleted: function onCompleted() {
        return _this2.close();
      },
      onError: function onError(err) {
        return alert(err);
      }
    });
  };

  this.updateTextField = function (fieldName) {
    return function (e) {
      var value = e.target.value;

      var newState = _this2.state;
      newState[fieldName] = value;
      _this2.setState(newState);
    };
  };

  this.toggleField = function (fieldName) {
    return function (e) {
      var checked = e.target.checked;

      var stateUpdate = {};
      stateUpdate[fieldName] = checked;
      _this2.setState(stateUpdate);
    };
  };

  this.selectInbox = function (e, value) {
    _this2.setState({ inbox: value });
  };

  this.updateSelect = function (name) {
    return function (e, index, value) {
      var newState = {};
      newState[name] = value;
      _this2.setState(newState);
    };
  };

  this.updateTravelDates = function (e) {
    var startDate = e.startDate,
        endDate = e.endDate;
    var _state6 = _this2.state,
        segmentStartDate = _state6.segmentStartDate,
        segmentEndDate = _state6.segmentEndDate;


    var validStart = startDate && startDate.isValid() && (segmentStartDate === null || startDate <= segmentStartDate);
    var validEnd = endDate && endDate.isValid() && (segmentEndDate === null || endDate >= segmentEndDate);
    var validDates = validStart && validEnd;

    _this2.setState({ startDate: startDate, endDate: endDate, validDates: validDates });
  };

  this.toggleNeedsVetting = function (e, checked) {
    _this2.setState({ needsVetting: checked });
  };

  this.toggleProspect = function (e, checked) {
    _this2.setState({ prospect: checked });
  };
}, _temp)) || _class) || _class);


var styles = _aphrodite.StyleSheet.create({
  formActions: {
    display: "flex",
    justifyContent: "flex-end"
  },
  errorMessage: {
    color: _ourismanTravelTheme2.default.palette.accent1Color,
    justify: "right",
    width: "100%",
    display: "flex",
    justifyContent: "flex-end"
  },
  formButton: {
    marginRight: 15
  },
  fieldsGroup: {
    display: "flex",
    justifyContent: "space-between",
    width: "100%",
    flexWrap: "wrap",
    alignItems: "baseline",
    marginBottom: 15
  },
  specificDates: {
    marginTop: 15
  },
  detailsContainer: {
    padding: 15
  },
  checkboxes: {
    display: "flex"
  },
  formField: {
    flexShrink: 1,
    flexBasis: "30%"
  }
});

exports.default = EditTrip;

/***/ }),

/***/ "txmD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp;

var _templateObject = _taggedTemplateLiteral(["\n  query AdminReport($startDate: String!, $endDate: String!) {\n    adminReport(startDate: $startDate, endDate: $endDate) {\n      dormant\n      pending\n      booked\n      voided\n      numCreated\n      numVoided\n      numBooked\n      numCancelled\n      numSegmentsBooked\n      numSegmentsCancelled\n      numDrafted\n      numInvoiced\n      numSegments\n      timeToBook\n      timeToDropbox\n      timeToInvoice\n      icDormant\n      icPending\n      icBooked\n      icVoided\n      icNumCreated\n      icNumVoided\n      icNumBooked\n      icNumCancelled\n      icNumSegmentsBooked\n      icNumSegmentsCancelled\n      icNumDrafted\n      icNumInvoiced\n      icNumSegments\n      icTimeToBook\n      icTimeToDropbox\n      icTimeToInvoice\n      otherDormant\n      otherPending\n      otherBooked\n      otherVoided\n      otherNumCreated\n      otherNumVoided\n      otherNumBooked\n      otherNumCancelled\n      otherNumSegmentsBooked\n      otherNumSegmentsCancelled\n      otherNumDrafted\n      otherNumInvoiced\n      otherNumSegments\n      otherTimeToBook\n      otherTimeToDropbox\n      otherTimeToInvoice\n      avgTripsCreated\n      avgTripsBooked\n      icAvgTripsCreated\n      icAvgTripsBooked\n      otherAvgTripsCreated\n      otherAvgTripsBooked\n      tripCounts\n    }\n  }\n"], ["\n  query AdminReport($startDate: String!, $endDate: String!) {\n    adminReport(startDate: $startDate, endDate: $endDate) {\n      dormant\n      pending\n      booked\n      voided\n      numCreated\n      numVoided\n      numBooked\n      numCancelled\n      numSegmentsBooked\n      numSegmentsCancelled\n      numDrafted\n      numInvoiced\n      numSegments\n      timeToBook\n      timeToDropbox\n      timeToInvoice\n      icDormant\n      icPending\n      icBooked\n      icVoided\n      icNumCreated\n      icNumVoided\n      icNumBooked\n      icNumCancelled\n      icNumSegmentsBooked\n      icNumSegmentsCancelled\n      icNumDrafted\n      icNumInvoiced\n      icNumSegments\n      icTimeToBook\n      icTimeToDropbox\n      icTimeToInvoice\n      otherDormant\n      otherPending\n      otherBooked\n      otherVoided\n      otherNumCreated\n      otherNumVoided\n      otherNumBooked\n      otherNumCancelled\n      otherNumSegmentsBooked\n      otherNumSegmentsCancelled\n      otherNumDrafted\n      otherNumInvoiced\n      otherNumSegments\n      otherTimeToBook\n      otherTimeToDropbox\n      otherTimeToInvoice\n      avgTripsCreated\n      avgTripsBooked\n      icAvgTripsCreated\n      icAvgTripsBooked\n      otherAvgTripsCreated\n      otherAvgTripsBooked\n      tripCounts\n    }\n  }\n"]);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactApollo = __webpack_require__("3zLD");

var _materialUi = __webpack_require__("Q4lS");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _aphrodite = __webpack_require__("BK4P");

var _victory = __webpack_require__("37UR");

var _ourismanTravelTheme = __webpack_require__("Mc/I");

var _ourismanTravelTheme2 = _interopRequireDefault(_ourismanTravelTheme);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var AdminReportQuery = (0, _reactApollo.gql)(_templateObject);

var AdminReport = (_dec = (0, _reactApollo.graphql)(AdminReportQuery), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(AdminReport, _React$Component);

  function AdminReport() {
    _classCallCheck(this, AdminReport);

    return _possibleConstructorReturn(this, (AdminReport.__proto__ || Object.getPrototypeOf(AdminReport)).apply(this, arguments));
  }

  _createClass(AdminReport, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          data = _props.data,
          dateString = _props.dateString;


      if (data.loading) {
        return _react2.default.createElement(
          _materialUi.CardText,
          { className: (0, _aphrodite.css)(styles.report) },
          _react2.default.createElement(_materialUi.CircularProgress, { className: (0, _aphrodite.css)(styles.progressIndicator) })
        );
      }

      var _data$adminReport = data.adminReport,
          dormant = _data$adminReport.dormant,
          pending = _data$adminReport.pending,
          booked = _data$adminReport.booked,
          voided = _data$adminReport.voided,
          numCreated = _data$adminReport.numCreated,
          numVoided = _data$adminReport.numVoided,
          numBooked = _data$adminReport.numBooked,
          numCancelled = _data$adminReport.numCancelled,
          numSegmentsBooked = _data$adminReport.numSegmentsBooked,
          numSegmentsCancelled = _data$adminReport.numSegmentsCancelled,
          numDrafted = _data$adminReport.numDrafted,
          numInvoiced = _data$adminReport.numInvoiced,
          numSegments = _data$adminReport.numSegments,
          timeToBook = _data$adminReport.timeToBook,
          timeToDropbox = _data$adminReport.timeToDropbox,
          timeToInvoice = _data$adminReport.timeToInvoice,
          icDormant = _data$adminReport.icDormant,
          icPending = _data$adminReport.icPending,
          icBooked = _data$adminReport.icBooked,
          icVoided = _data$adminReport.icVoided,
          icNumCreated = _data$adminReport.icNumCreated,
          icNumVoided = _data$adminReport.icNumVoided,
          icNumBooked = _data$adminReport.icNumBooked,
          icNumCancelled = _data$adminReport.icNumCancelled,
          icNumSegmentsBooked = _data$adminReport.icNumSegmentsBooked,
          icNumSegmentsCancelled = _data$adminReport.icNumSegmentsCancelled,
          icNumDrafted = _data$adminReport.icNumDrafted,
          icNumInvoiced = _data$adminReport.icNumInvoiced,
          icNumSegments = _data$adminReport.icNumSegments,
          icTimeToBook = _data$adminReport.icTimeToBook,
          icTimeToDropbox = _data$adminReport.icTimeToDropbox,
          icTimeToInvoice = _data$adminReport.icTimeToInvoice,
          otherDormant = _data$adminReport.otherDormant,
          otherPending = _data$adminReport.otherPending,
          otherBooked = _data$adminReport.otherBooked,
          otherVoided = _data$adminReport.otherVoided,
          otherNumCreated = _data$adminReport.otherNumCreated,
          otherNumVoided = _data$adminReport.otherNumVoided,
          otherNumBooked = _data$adminReport.otherNumBooked,
          otherNumCancelled = _data$adminReport.otherNumCancelled,
          otherNumSegmentsBooked = _data$adminReport.otherNumSegmentsBooked,
          otherNumSegmentsCancelled = _data$adminReport.otherNumSegmentsCancelled,
          otherNumDrafted = _data$adminReport.otherNumDrafted,
          otherNumInvoiced = _data$adminReport.otherNumInvoiced,
          otherNumSegments = _data$adminReport.otherNumSegments,
          otherTimeToBook = _data$adminReport.otherTimeToBook,
          otherTimeToDropbox = _data$adminReport.otherTimeToDropbox,
          otherTimeToInvoice = _data$adminReport.otherTimeToInvoice,
          avgTripsCreated = _data$adminReport.avgTripsCreated,
          avgTripsBooked = _data$adminReport.avgTripsBooked,
          icAvgTripsCreated = _data$adminReport.icAvgTripsCreated,
          icAvgTripsBooked = _data$adminReport.icAvgTripsBooked,
          otherAvgTripsCreated = _data$adminReport.otherAvgTripsCreated,
          otherAvgTripsBooked = _data$adminReport.otherAvgTripsBooked,
          tripCounts = _data$adminReport.tripCounts;


      var formattedDuration = function formattedDuration(seconds) {
        if (seconds === 0) {
          return "n/a";
        }
        var momentDuration = _moment2.default.duration(seconds, "seconds");
        var hours = momentDuration.as("hours").toFixed(0);

        if (hours < 1) {
          return momentDuration.humanize();
        }

        return hours + " hours";
      };

      var bookDuration = formattedDuration(timeToBook);
      var dropboxDuration = formattedDuration(timeToDropbox);
      var invoiceDuration = formattedDuration(timeToInvoice);

      var icBookDuration = formattedDuration(icTimeToBook);
      var icDropboxDuration = formattedDuration(icTimeToDropbox);
      var icInvoiceDuration = formattedDuration(icTimeToInvoice);

      var otherBookDuration = formattedDuration(otherTimeToBook);
      var otherDropboxDuration = formattedDuration(otherTimeToDropbox);
      var otherInvoiceDuration = formattedDuration(otherTimeToInvoice);

      var tripCountRaw = JSON.parse(tripCounts);

      var icTripsData = Object.entries(tripCountRaw.insideCircle).map(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
            k = _ref2[0],
            v = _ref2[1];

        return { month: k, count: v };
      });
      var otherTripsData = Object.entries(tripCountRaw.other).map(function (_ref3) {
        var _ref4 = _slicedToArray(_ref3, 2),
            k = _ref4[0],
            v = _ref4[1];

        return {
          month: k,
          count: v
        };
      });

      var axisStyles = {
        tickLabels: {
          fontSize: 5
        }
      };
      var lineStyles = {
        labels: {
          fontSize: 5
        }
      };

      return _react2.default.createElement(
        "div",
        null,
        _react2.default.createElement(
          _materialUi.Card,
          { className: (0, _aphrodite.css)(styles.report) },
          _react2.default.createElement(_materialUi.CardHeader, { title: "All Time Averages" }),
          _react2.default.createElement(
            _materialUi.CardText,
            null,
            _react2.default.createElement(
              "div",
              { className: (0, _aphrodite.css)(styles.summaryContainer) },
              _react2.default.createElement(
                _materialUi.Paper,
                { className: (0, _aphrodite.css)(styles.summaryBox) },
                _react2.default.createElement(
                  "span",
                  { className: (0, _aphrodite.css)(styles.boxHeader) },
                  "All Trips"
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Average trips created per month:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    avgTripsCreated
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Average trips booked per month:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    avgTripsBooked
                  )
                )
              ),
              _react2.default.createElement(
                _materialUi.Paper,
                { className: (0, _aphrodite.css)(styles.summaryBox) },
                _react2.default.createElement(
                  "span",
                  { className: (0, _aphrodite.css)(styles.boxHeader) },
                  "Inside Circle Trips"
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Average trips created per month:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    icAvgTripsCreated
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Average trips booked per month:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    icAvgTripsBooked
                  )
                )
              ),
              _react2.default.createElement(
                _materialUi.Paper,
                { className: (0, _aphrodite.css)(styles.summaryBox) },
                _react2.default.createElement(
                  "span",
                  { className: (0, _aphrodite.css)(styles.boxHeader) },
                  "Other Trips"
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Average trips created per month:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    otherAvgTripsCreated
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Average trips booked per month:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    otherAvgTripsBooked
                  )
                )
              )
            ),
            _react2.default.createElement(
              "div",
              { className: (0, _aphrodite.css)(styles.summaryContainer) },
              _react2.default.createElement(
                _victory.VictoryChart,
                { domainPadding: 20, height: 200 },
                _react2.default.createElement(_victory.VictoryLegend, {
                  x: 75,
                  y: 50,
                  orientation: "horizontal",
                  data: [{
                    name: "Inside Circle",
                    symbol: {
                      fill: _ourismanTravelTheme2.default.palette.insideCircle
                    }
                  }, {
                    name: "Other",
                    symbol: {
                      fill: _ourismanTravelTheme2.default.palette.accent2Color
                    }
                  }],
                  style: { labels: { fontSize: 7 } }
                }),
                _react2.default.createElement(_victory.VictoryAxis, {
                  style: axisStyles,
                  tickValues: Object.keys(tripCountRaw.all)
                }),
                _react2.default.createElement(_victory.VictoryAxis, { dependentAxis: true, style: axisStyles }),
                _react2.default.createElement(
                  _victory.VictoryStack,
                  { colorScale: "qualitative", offset: 6 },
                  _react2.default.createElement(_victory.VictoryArea, {
                    data: icTripsData,
                    x: "month",
                    y: "count",
                    labels: function labels(datum) {
                      return datum.y;
                    },
                    style: _extends({}, lineStyles, {
                      data: {
                        fill: _ourismanTravelTheme2.default.palette.insideCircle
                      }
                    })
                  }),
                  _react2.default.createElement(_victory.VictoryArea, {
                    data: otherTripsData,
                    x: "month",
                    y: "count",
                    labels: function labels(datum) {
                      return datum.y;
                    },
                    style: _extends({}, lineStyles, {
                      data: {
                        fill: _ourismanTravelTheme2.default.palette.accent2Color
                      }
                    })
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _materialUi.Card,
          { className: (0, _aphrodite.css)(styles.report) },
          _react2.default.createElement(_materialUi.CardHeader, { title: "All Trips" }),
          _react2.default.createElement(
            _materialUi.CardText,
            null,
            _react2.default.createElement(
              "div",
              { className: (0, _aphrodite.css)(styles.summaryContainer) },
              _react2.default.createElement(
                _materialUi.Paper,
                { className: (0, _aphrodite.css)(styles.summaryBoxWithChart) },
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryBoxData) },
                  _react2.default.createElement(
                    "span",
                    { className: (0, _aphrodite.css)(styles.boxHeader) },
                    "General trip information"
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Trips dormant for seven or more days:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      dormant
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Trips pending:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      pending
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Trips booked:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      booked
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Trips voided:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      voided
                    )
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryBoxChart) },
                  _react2.default.createElement(_victory.VictoryPie, {
                    colorScale: "warm",
                    labelRadius: 70,
                    style: {
                      labels: {
                        fill: "white",
                        fontSize: 15,
                        fontWeight: "bold"
                      }
                    },
                    data: [{ x: "Pending", y: pending }, { x: "Booked", y: booked }, { x: "Voided", y: voided }]
                  })
                )
              ),
              _react2.default.createElement(
                _materialUi.Paper,
                { className: (0, _aphrodite.css)(styles.summaryBox) },
                _react2.default.createElement(
                  "span",
                  { className: (0, _aphrodite.css)(styles.boxHeader) },
                  "Average times during ",
                  dateString
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Trip created to all segments booked:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    bookDuration
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Segment booked to filed:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    dropboxDuration
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Segment booked to invoiced:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    invoiceDuration
                  )
                )
              ),
              _react2.default.createElement(
                _materialUi.Paper,
                { className: (0, _aphrodite.css)(styles.summaryBox) },
                _react2.default.createElement(
                  "span",
                  { className: (0, _aphrodite.css)(styles.boxHeader) },
                  "Trips acted upon during ",
                  dateString
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Trips created:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    numCreated
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Trips voided:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    numVoided
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Trips with segments booked:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    numBooked
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Trips with segments cancelled:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    numCancelled
                  )
                )
              ),
              _react2.default.createElement(
                _materialUi.Paper,
                { className: (0, _aphrodite.css)(styles.summaryBoxWithChart) },
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryBoxData) },
                  _react2.default.createElement(
                    "span",
                    { className: (0, _aphrodite.css)(styles.boxHeader) },
                    "Segments acted upon during ",
                    dateString
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Total:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      numSegments
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Segments booked:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      numSegmentsBooked
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Segments cancelled:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      numSegmentsCancelled
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Segments with VIP drafted:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      numDrafted
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Segments invoiced:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      numInvoiced
                    )
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryBoxChart) },
                  _react2.default.createElement(_victory.VictoryPie, {
                    colorScale: "warm",
                    labelRadius: 70,
                    style: {
                      labels: {
                        fill: "white",
                        fontSize: 15,
                        fontWeight: "bold"
                      }
                    },
                    data: [{ x: "Booked", y: numSegmentsBooked }, { x: "Cancelled", y: numSegmentsCancelled }]
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _materialUi.Card,
          { className: (0, _aphrodite.css)(styles.report) },
          _react2.default.createElement(_materialUi.CardHeader, { title: "Inside Circle Trips" }),
          _react2.default.createElement(
            _materialUi.CardText,
            null,
            _react2.default.createElement(
              "div",
              { className: (0, _aphrodite.css)(styles.summaryContainer) },
              _react2.default.createElement(
                _materialUi.Paper,
                { className: (0, _aphrodite.css)(styles.summaryBoxWithChart) },
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryBoxData) },
                  _react2.default.createElement(
                    "span",
                    { className: (0, _aphrodite.css)(styles.boxHeader) },
                    "General trip information"
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Trips dormant for seven or more days:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      icDormant
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Trips pending:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      icPending
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Trips booked:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      icBooked
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Trips voided:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      icVoided
                    )
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryBoxChart) },
                  _react2.default.createElement(_victory.VictoryPie, {
                    colorScale: "warm",
                    labelRadius: 70,
                    style: {
                      labels: {
                        fill: "white",
                        fontSize: 15,
                        fontWeight: "bold"
                      }
                    },
                    data: [{ x: "Pending", y: icPending }, { x: "Booked", y: icBooked }, { x: "Voided", y: icVoided }]
                  })
                )
              ),
              _react2.default.createElement(
                _materialUi.Paper,
                { className: (0, _aphrodite.css)(styles.summaryBox) },
                _react2.default.createElement(
                  "span",
                  { className: (0, _aphrodite.css)(styles.boxHeader) },
                  "Average times during ",
                  dateString
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Trip created to all segments booked:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    icBookDuration
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Segment booked to filed:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    icDropboxDuration
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Segment booked to invoiced:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    icInvoiceDuration
                  )
                )
              ),
              _react2.default.createElement(
                _materialUi.Paper,
                { className: (0, _aphrodite.css)(styles.summaryBox) },
                _react2.default.createElement(
                  "span",
                  { className: (0, _aphrodite.css)(styles.boxHeader) },
                  "Trips acted upon during ",
                  dateString
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Trips created:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    icNumCreated
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Trips voided:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    icNumVoided
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Trips with segments booked:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    icNumBooked
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Trips with segments cancelled:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    icNumCancelled
                  )
                )
              ),
              _react2.default.createElement(
                _materialUi.Paper,
                { className: (0, _aphrodite.css)(styles.summaryBoxWithChart) },
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryBoxData) },
                  _react2.default.createElement(
                    "span",
                    { className: (0, _aphrodite.css)(styles.boxHeader) },
                    "Segments acted upon during ",
                    dateString
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Total:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      icNumSegments
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Segments booked:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      icNumSegmentsBooked
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Segments cancelled:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      icNumSegmentsCancelled
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Segments with VIP drafted:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      icNumDrafted
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Segments invoiced:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      icNumInvoiced
                    )
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryBoxChart) },
                  _react2.default.createElement(_victory.VictoryPie, {
                    colorScale: "warm",
                    labelRadius: 70,
                    style: {
                      labels: {
                        fill: "white",
                        fontSize: 15,
                        fontWeight: "bold"
                      }
                    },
                    data: [{ x: "Booked", y: icNumSegmentsBooked }, { x: "Cancelled", y: icNumSegmentsCancelled }]
                  })
                )
              )
            )
          )
        ),
        _react2.default.createElement(
          _materialUi.Card,
          { className: (0, _aphrodite.css)(styles.report) },
          _react2.default.createElement(_materialUi.CardHeader, { title: "Other Trips" }),
          _react2.default.createElement(
            _materialUi.CardText,
            null,
            _react2.default.createElement(
              "div",
              { className: (0, _aphrodite.css)(styles.summaryContainer) },
              _react2.default.createElement(
                _materialUi.Paper,
                { className: (0, _aphrodite.css)(styles.summaryBoxWithChart) },
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryBoxData) },
                  _react2.default.createElement(
                    "span",
                    { className: (0, _aphrodite.css)(styles.boxHeader) },
                    "General trip information"
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Trips dormant for seven or more days:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      otherDormant
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Trips pending:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      otherPending
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Trips booked:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      otherBooked
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Trips voided:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      otherVoided
                    )
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryBoxChart) },
                  _react2.default.createElement(_victory.VictoryPie, {
                    colorScale: "warm",
                    labelRadius: 70,
                    style: {
                      labels: {
                        fill: "white",
                        fontSize: 15,
                        fontWeight: "bold"
                      }
                    },
                    data: [{ x: "Pending", y: otherPending }, { x: "Booked", y: otherBooked }, { x: "Voided", y: otherVoided }]
                  })
                )
              ),
              _react2.default.createElement(
                _materialUi.Paper,
                { className: (0, _aphrodite.css)(styles.summaryBox) },
                _react2.default.createElement(
                  "span",
                  { className: (0, _aphrodite.css)(styles.boxHeader) },
                  "Average times during ",
                  dateString
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Trip created to all segments booked:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    otherBookDuration
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Segment booked to filed:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    otherDropboxDuration
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Segment booked to invoiced:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    otherInvoiceDuration
                  )
                )
              ),
              _react2.default.createElement(
                _materialUi.Paper,
                { className: (0, _aphrodite.css)(styles.summaryBox) },
                _react2.default.createElement(
                  "span",
                  { className: (0, _aphrodite.css)(styles.boxHeader) },
                  "Trips acted upon during ",
                  dateString
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Trips created:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    otherNumCreated
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Trips voided:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    otherNumVoided
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Trips with segments booked:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    otherNumBooked
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryRow) },
                  _react2.default.createElement(
                    "span",
                    null,
                    "Trips with segments cancelled:"
                  ),
                  _react2.default.createElement(
                    "span",
                    null,
                    otherNumCancelled
                  )
                )
              ),
              _react2.default.createElement(
                _materialUi.Paper,
                { className: (0, _aphrodite.css)(styles.summaryBoxWithChart) },
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryBoxData) },
                  _react2.default.createElement(
                    "span",
                    { className: (0, _aphrodite.css)(styles.boxHeader) },
                    "Segments acted upon during ",
                    dateString
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Total:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      otherNumSegments
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Segments booked:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      otherNumSegmentsBooked
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Segments cancelled:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      otherNumSegmentsCancelled
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Segments with VIP drafted:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      otherNumDrafted
                    )
                  ),
                  _react2.default.createElement(
                    "div",
                    { className: (0, _aphrodite.css)(styles.summaryRow) },
                    _react2.default.createElement(
                      "span",
                      null,
                      "Segments invoiced:"
                    ),
                    _react2.default.createElement(
                      "span",
                      null,
                      otherNumInvoiced
                    )
                  )
                ),
                _react2.default.createElement(
                  "div",
                  { className: (0, _aphrodite.css)(styles.summaryBoxChart) },
                  _react2.default.createElement(_victory.VictoryPie, {
                    colorScale: "warm",
                    labelRadius: 70,
                    style: {
                      labels: {
                        fill: "white",
                        fontSize: 15,
                        fontWeight: "bold"
                      }
                    },
                    data: [{ x: "Booked", y: otherNumSegmentsBooked }, { x: "Cancelled", y: otherNumSegmentsCancelled }]
                  })
                )
              )
            )
          )
        )
      );
    }
  }]);

  return AdminReport;
}(_react2.default.Component), _class2.propTypes = {
  data: _propTypes2.default.shape({
    loading: _propTypes2.default.bool.isRequired,
    allResponses: _propTypes2.default.shape({
      dormant: _propTypes2.default.number.isRequired,
      modified: _propTypes2.default.arrayOf(_propTypes2.default.shape()).isRequired
    })
  }).isRequired,
  dateString: _propTypes2.default.string.isRequired
}, _temp)) || _class);


var styles = _aphrodite.StyleSheet.create({
  report: {
    margin: 15,
    minHeight: "100%"
  },
  progressIndicator: {
    position: "relative",
    marginLeft: "50%",
    left: -20,
    top: -20
  },
  summaryContainer: {
    display: "flex",
    flexWrap: "wrap"
  },
  summaryBox: {
    display: "flex",
    flexDirection: "column",
    padding: 10,
    marginRight: 25,
    marginBottom: 25,
    width: 350
  },
  summaryBoxWithChart: {
    display: "flex",
    flexWrap: "wrap",
    padding: 10,
    marginRight: 25,
    marginBottom: 25,
    width: 725
  },
  summaryBoxData: {
    display: "flex",
    flexDirection: "column",
    width: 330,
    marginRight: 25,
    marginBottom: 25
  },
  summaryBoxChart: {
    width: 330
  },
  boxHeader: {
    fontWeight: "bold",
    lineHeight: "1.5em"
  },
  summaryRow: {
    display: "flex",
    justifyContent: "space-between"
  }
});

exports.default = AdminReport;

/***/ }),

/***/ "u6o6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = __webpack_require__("BYKG");

var _immutable2 = _interopRequireDefault(_immutable);

var _ActionTypes = __webpack_require__("zLtr");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

var _createReducer2 = __webpack_require__("AA0U");

var _createReducer3 = _interopRequireDefault(_createReducer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var initialState = _immutable2.default.fromJS({
  selectedUser: 'all',
  filter: 'all',
  activeTrip: null
});

exports.default = (0, _createReducer3.default)(initialState, _defineProperty({}, _ActionTypes2.default.Trips.setValue, function (state, _ref) {
  var field = _ref.field,
      value = _ref.value;

  return state.set(field, value);
}));

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-SG": "oYA3",
	"./en-SG.js": "oYA3",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./ga": "U5Iz",
	"./ga.js": "U5Iz",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it-ch": "/E8D",
	"./it-ch.js": "/E8D",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ku": "kI9l",
	"./ku.js": "kI9l",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "wJEc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _graphql, _class, _temp, _initialiseProps;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _materialUi = __webpack_require__("Q4lS");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _reactRelay = __webpack_require__("Tc9k");

var _DateFieldComponent = __webpack_require__("kg8o");

var _DateFieldComponent2 = _interopRequireDefault(_DateFieldComponent);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _rest = __webpack_require__("i4WM");

var _rest2 = _interopRequireDefault(_rest);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function addTraveler(input, onComplete) {
  (0, _reactRelay.commitMutation)(_environment2.default, {
    mutation: _graphql || (_graphql = function _graphql() {
      return __webpack_require__("m2u7");
    }),
    variables: { input: input },
    onCompleted: function onCompleted() {
      return onComplete();
    },
    onError: function onError(err) {
      return alert(err);
    }
  });
}

var AddTraveler = (_temp = _class = function (_React$Component) {
  _inherits(AddTraveler, _React$Component);

  function AddTraveler(props) {
    _classCallCheck(this, AddTraveler);

    var _this = _possibleConstructorReturn(this, (AddTraveler.__proto__ || Object.getPrototypeOf(AddTraveler)).call(this, props));

    _initialiseProps.call(_this);

    var _this$getPrimaryTrave = _this.getPrimaryTraveler(),
        isPrimaryTraveler = _this$getPrimaryTrave.isPrimaryTraveler,
        primaryTravelerId = _this$getPrimaryTrave.primaryTravelerId,
        primaryTravelerName = _this$getPrimaryTrave.primaryTravelerName;

    _this.state = {
      travelerAutocompleteData: [],
      profileAutocompleteData: [],
      id: '',
      fullName: '',
      displayName: '',
      firstName: '',
      lastName: '',
      email: '',
      birthdate: '',
      validDate: false,
      isAdult: true,
      isPrimaryTraveler: isPrimaryTraveler,
      primaryTravelerId: primaryTravelerId,
      primaryTravelerName: primaryTravelerName,
      relationship: '',
      insideCircle: false,
      needsTraining: false,
      needsVetting: true
    };
    return _this;
  }

  _createClass(AddTraveler, [{
    key: 'render',
    value: function render() {
      var _state = this.state,
          travelerAutocompleteData = _state.travelerAutocompleteData,
          id = _state.id,
          firstName = _state.firstName,
          lastName = _state.lastName,
          email = _state.email,
          isAdult = _state.isAdult,
          validDate = _state.validDate,
          isPrimaryTraveler = _state.isPrimaryTraveler,
          primaryTravelerName = _state.primaryTravelerName,
          profileAutocompleteData = _state.profileAutocompleteData,
          relationship = _state.relationship,
          insideCircle = _state.insideCircle,
          needsTraining = _state.needsTraining,
          needsVetting = _state.needsVetting;

      var ready = id || email || firstName && lastName;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          _materialUi.CardText,
          null,
          _react2.default.createElement(_materialUi.AutoComplete, {
            hintText: 'Search for an existing traveler',
            menuStyle: { width: 500 },
            listStyle: { width: 500 },
            dataSource: travelerAutocompleteData,
            onUpdateInput: this.handleUpdateTravelerAutocomplete,
            onNewRequest: this.travelerSelected,
            fullWidth: true,
            filter: function filter() {
              return true;
            }
          }),
          _react2.default.createElement(
            'div',
            { style: styles.formFieldsStyle },
            _react2.default.createElement(_materialUi.TextField, {
              style: styles.formFieldStyle,
              value: lastName,
              floatingLabelText: 'Last Name',
              onChange: this.updateTextField('lastName')
            }),
            _react2.default.createElement(_materialUi.TextField, {
              style: styles.formFieldStyle,
              value: firstName,
              floatingLabelText: 'First Name',
              onChange: this.updateTextField('firstName')
            }),
            _react2.default.createElement(_materialUi.TextField, {
              style: styles.formFieldStyle,
              value: email,
              floatingLabelText: 'Email Address',
              onChange: this.updateTextField('email')
            }),
            _react2.default.createElement(
              'div',
              { style: styles.formFieldGroupStyle },
              _react2.default.createElement(_DateFieldComponent2.default, {
                style: styles.formFieldStyle,
                floatingLabelText: 'Birthdate',
                onChange: this.updateBirthdate
              }),
              _react2.default.createElement(_materialUi.Checkbox, {
                style: styles.formCheckboxStyle,
                checked: isAdult,
                label: 'Adult',
                onCheck: this.handleIsAdult,
                disabled: validDate
              })
            ),
            _react2.default.createElement(
              'div',
              { style: styles.formFieldStyle },
              _react2.default.createElement(_materialUi.Toggle, {
                checked: isPrimaryTraveler,
                onClick: this.togglePrimaryTraveler,
                label: 'CB+ Profile',
                labelPosition: 'right'
              }),
              isPrimaryTraveler ? null : _react2.default.createElement(_materialUi.AutoComplete, {
                floatingLabelText: 'CB+ Profile Name',
                menuStyle: { width: 500 },
                listStyle: { width: 500 },
                searchText: primaryTravelerName,
                dataSource: profileAutocompleteData,
                onUpdateInput: this.handleUpdateProfileAutocomplete,
                onNewRequest: this.profileSelected,
                fullWidth: true,
                filter: function filter() {
                  return true;
                }
              }),
              isPrimaryTraveler ? null : _react2.default.createElement(_materialUi.TextField, {
                floatingLabelText: 'Traveler Relationship',
                value: relationship,
                onChange: this.updateTextField('relationship')
              })
            ),
            _react2.default.createElement(
              'div',
              { style: styles.formFieldStyle },
              _react2.default.createElement(_materialUi.Checkbox, {
                checked: insideCircle,
                label: 'Inside Circle',
                onCheck: this.handleCheckbox('insideCircle')
              })
            ),
            _react2.default.createElement(
              'div',
              { style: styles.formFieldStyle },
              _react2.default.createElement(_materialUi.Checkbox, {
                checked: needsTraining,
                label: 'Needs Training',
                onCheck: this.handleCheckbox('needsTraining')
              })
            ),
            _react2.default.createElement(
              'div',
              { style: styles.formFieldStyle },
              _react2.default.createElement(_materialUi.Checkbox, {
                checked: needsVetting,
                label: 'Needs Vetting',
                onCheck: this.handleCheckbox('needsVetting')
              })
            )
          ),
          _react2.default.createElement(
            'div',
            { style: styles.formActionsStyle },
            _react2.default.createElement(_materialUi.FlatButton, {
              label: 'Cancel',
              secondary: true,
              onTouchTap: this.cancel
            }),
            _react2.default.createElement(_materialUi.FlatButton, {
              label: 'Confirm',
              primary: true,
              onTouchTap: this.save,
              disabled: !ready
            })
          )
        )
      );
    }
  }]);

  return AddTraveler;
}(_react2.default.Component), _class.propTypes = {
  onComplete: _propTypes2.default.func.isRequired,
  trip: _propTypes2.default.shape().isRequired,
  index: _propTypes2.default.number.isRequired
}, _initialiseProps = function _initialiseProps() {
  var _this2 = this;

  this.getPrimaryTraveler = function () {
    var index = _this2.props.index;

    var primaryTraveler = {
      isPrimaryTraveler: true,
      primaryTravelerId: '',
      primaryTravelerName: ''
    };

    if (index === 0) {
      return primaryTraveler;
    }

    var travelers = _this2.props.trip.travelers;

    var previous = travelers[index - 1];

    if (previous.isPrimaryTraveler) {
      Object.assign(primaryTraveler, {
        isPrimaryTraveler: false,
        primaryTravelerId: previous.id,
        primaryTravelerName: previous.lastName + ', ' + previous.firstName
      });
    } else if (previous.primaryTraveler !== null) {
      Object.assign(primaryTraveler, {
        isPrimaryTraveler: false,
        primaryTravelerId: previous.primaryTraveler.id,
        primaryTravelerName: previous.primaryTravelerName
      });
    } else {
      Object.assign(primaryTraveler, {
        isPrimaryTraveler: false,
        primaryTravelerId: '',
        primaryTravelerName: previous.primaryTravelerName
      });
    }

    return primaryTraveler;
  };

  this.cancel = function () {
    _this2.props.onComplete();
  };

  this.handleUpdateTravelerAutocomplete = function (value) {
    (0, _rest2.default)('auto/traveler', value).then(function (response) {
      var objects = response.objects;

      _this2.setState({
        travelerAutocompleteData: objects.map(function (object) {
          var emailString = object.email[0] !== '' ? ' (' + object.email + ')' : '';
          var displayName = object.displayName || object.fullName;
          var text = '' + displayName + emailString;

          return {
            text: text,
            value: object.relayId,
            fullName: object.fullName,
            displayName: object.displayName,
            firstName: object.firstName,
            lastName: object.lastName,
            email: object.email[0],
            birthdate: object.birthdate,
            isAdult: object.adult,
            isPrimaryTraveler: object.isPrimaryTraveler,
            primaryTravelerId: object.primaryTravelerId,
            primaryTravelerName: object.primaryTravelerName,
            relationship: object.relationship
          };
        })
      });
    }).catch(function (response) {
      console.log(response);
    });
  };

  this.travelerSelected = function (selected, index) {
    if (index !== -1) {
      var _props = _this2.props,
          tripId = _props.trip.id,
          onComplete = _props.onComplete;
      var travelerId = selected.value,
          firstName = selected.firstName,
          lastName = selected.lastName,
          _selected$email = selected.email,
          email = _selected$email === undefined ? '' : _selected$email,
          birthdate = selected.birthdate,
          isAdult = selected.isAdult,
          isPrimaryTraveler = selected.isPrimaryTraveler,
          primaryTravelerId = selected.primaryTravelerId,
          primaryTravelerName = selected.primaryTravelerName,
          relationship = selected.relationship;


      addTraveler({
        tripId: tripId,
        travelerId: travelerId,
        firstName: firstName,
        lastName: lastName,
        email: email,
        birthdate: birthdate,
        isAdult: isAdult,
        isPrimaryTraveler: isPrimaryTraveler,
        primaryTravelerId: primaryTravelerId,
        primaryTravelerName: primaryTravelerName,
        relationship: relationship
      }, onComplete);
    }
  };

  this.handleUpdateProfileAutocomplete = function (value) {
    (0, _rest2.default)('auto/traveler', value + '&primary=true').then(function (response) {
      var objects = response.objects;

      _this2.setState({
        primaryTravelerId: '',
        primaryTravelerName: value,
        profileAutocompleteData: objects.map(function (object) {
          return {
            text: object.lastName + ', ' + object.firstName,
            value: object.relayId,
            firstName: object.firstName,
            lastName: object.lastName
          };
        })
      });
    }).catch(function (response) {
      console.log(response);
    });
  };

  this.profileSelected = function (selected, index) {
    if (index === -1) {
      _this2.setState({
        primaryTravelerId: '',
        primaryTravelerName: selected
      });
    } else {
      var primaryTravelerId = selected.value,
          firstName = selected.firstName,
          lastName = selected.lastName;

      var primaryTravelerName = lastName + ', ' + firstName;

      _this2.setState({
        primaryTravelerId: primaryTravelerId,
        primaryTravelerName: primaryTravelerName
      });
    }
  };

  this.updateTextField = function (fieldName) {
    return function (e) {
      var value = e.target.value;

      var newState = _this2.state;
      newState[fieldName] = value;
      _this2.setState(newState);
    };
  };

  this.updateBirthdate = function (e) {
    var value = e.target.value;
    var isAdult = _this2.state.isAdult;

    var validDate = (0, _moment2.default)(value).isValid();

    _this2.setState({
      birthdate: value,
      validDate: validDate,
      isAdult: validDate ? (0, _moment2.default)().diff((0, _moment2.default)(value), 'years') > 17 : isAdult
    });
  };

  this.handleIsAdult = function (e, checked) {
    _this2.setState({ isAdult: checked });
  };

  this.togglePrimaryTraveler = function (e) {
    var checked = e.target.checked;

    _this2.setState({
      isPrimaryTraveler: checked,
      primaryTravelerId: '',
      primaryTravelerName: ''
    });
  };

  this.save = function () {
    var _props2 = _this2.props,
        tripId = _props2.trip.id,
        onComplete = _props2.onComplete;
    var _state2 = _this2.state,
        firstName = _state2.firstName,
        lastName = _state2.lastName,
        email = _state2.email,
        birthdate = _state2.birthdate,
        isAdult = _state2.isAdult,
        isPrimaryTraveler = _state2.isPrimaryTraveler,
        primaryTravelerId = _state2.primaryTravelerId,
        primaryTravelerName = _state2.primaryTravelerName,
        relationship = _state2.relationship,
        insideCircle = _state2.insideCircle,
        needsTraining = _state2.needsTraining,
        needsVetting = _state2.needsVetting;


    addTraveler({
      tripId: tripId,
      firstName: firstName,
      lastName: lastName,
      email: email,
      birthdate: birthdate,
      isAdult: isAdult,
      isPrimaryTraveler: isPrimaryTraveler,
      primaryTravelerId: primaryTravelerId,
      primaryTravelerName: primaryTravelerName,
      relationship: relationship,
      insideCircle: insideCircle,
      needsTraining: needsTraining,
      needsVetting: needsVetting
    }, onComplete);
  };

  this.handleCheckbox = function (fieldname) {
    return function (e, checked) {
      var newState = {};
      newState[fieldname] = checked;
      _this2.setState(newState);
    };
  };
}, _temp);
exports.default = AddTraveler;


var styles = {
  formFieldsStyle: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'baseline'
  },
  formFieldStyle: {
    width: 256,
    marginRight: 'auto'
  },
  formCheckboxStyle: {
    width: 256,
    alignSelf: 'flex-end'
  },
  formActionsStyle: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end'
  },
  formFieldGroupStyle: {
    width: 256
  }
};

/***/ }),

/***/ "wRbn":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateDateRange = updateDateRange;
exports.updateDateString = updateDateString;
exports.toggleDatePicker = toggleDatePicker;
exports.updateString = updateString;

var _ActionTypes = __webpack_require__("zLtr");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateDateRange(string) {
  return {
    type: _ActionTypes2.default.RateQuote.updateDateRange,
    string: string
  };
}

function updateDateString(string) {
  return {
    type: _ActionTypes2.default.RateQuote.updateDateString,
    string: string
  };
}

function toggleDatePicker(string) {
  return {
    type: _ActionTypes2.default.RateQuote.toggleDatePicker,
    string: string
  };
}

function updateString(fieldName, value) {
  return {
    type: _ActionTypes2.default.RateQuote.updateString,
    fieldName: fieldName,
    value: value
  };
}

/***/ }),

/***/ "wYIP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp2;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRedux = __webpack_require__("RH2O");

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _materialUi = __webpack_require__("Q4lS");

var _aphrodite = __webpack_require__("BK4P");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var RoomRate = function RoomRate(rate, index) {
  return _react2.default.createElement(
    "div",
    { key: index },
    _react2.default.createElement(
      "span",
      { className: (0, _aphrodite.css)(styles.roomRate), key: index },
      rate
    ),
    _react2.default.createElement("br", null)
  );
};

var Amenity = function Amenity(amenity, index) {
  return _react2.default.createElement(
    "li",
    { key: index },
    amenity
  );
};

var RateQuote = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    departure: state.RateQuote.get("departure"),
    dateString: state.RateQuote.get("dateString"),
    destination: state.RateQuote.get("destination"),
    vendorName: state.RateQuote.get("vendorName"),
    vendorURL: state.RateQuote.get("vendorURL"),
    rateType: state.RateQuote.get("rateType"),
    deposit: state.RateQuote.get("deposit"),
    cancellation: state.RateQuote.get("cancellation"),
    roomRates: state.RateQuote.get("roomRates"),
    amenities: state.RateQuote.get("amenities"),
    amenityType: state.RateQuote.get("amenityType"),
    averageRate: state.RateQuote.get("averageRate")
  };
}), _dec(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(RateQuote, _React$Component);

  function RateQuote() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, RateQuote);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = RateQuote.__proto__ || Object.getPrototypeOf(RateQuote)).call.apply(_ref, [this].concat(args))), _this), _this.vendorDisplay = function () {
      var _this$props = _this.props,
          vendorName = _this$props.vendorName,
          vendorURL = _this$props.vendorURL;

      if (vendorURL) {
        return _react2.default.createElement(
          "a",
          { href: vendorURL, className: (0, _aphrodite.css)(styles.vendorLink) },
          vendorName
        );
      }
      return vendorName;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(RateQuote, [{
    key: "render",
    value: function render() {
      var className = this.props.className;

      var departure = (0, _moment2.default)(this.props.departure).format("DDMMM").toUpperCase();

      return _react2.default.createElement(
        _materialUi.Card,
        { className: className },
        _react2.default.createElement(_materialUi.CardTitle, { title: "Formatted Rate Quote" }),
        _react2.default.createElement(
          _materialUi.CardText,
          { className: (0, _aphrodite.css)(styles.rateQuote) },
          _react2.default.createElement(
            "p",
            null,
            _react2.default.createElement(
              "b",
              null,
              this.props.dateString,
              " (departing ",
              departure,
              ") -",
              " ",
              this.props.destination
            )
          ),
          _react2.default.createElement(
            "p",
            null,
            _react2.default.createElement(
              "b",
              null,
              this.vendorDisplay()
            )
          ),
          _react2.default.createElement(
            "p",
            { className: (0, _aphrodite.css)(styles.rateInfo) },
            this.props.rateType,
            " - ",
            this.props.deposit,
            " ",
            this.props.cancellation,
            " ",
            _react2.default.createElement(
              "i",
              null,
              "In addition to any applicable hotel cancellation policies, we charge a 50 USD cancelation fee per reservation. Please refer to our",
              " ",
              _react2.default.createElement(
                "a",
                { href: "https://www.ourismantravel.com/booking-policies/" },
                "booking policies"
              ),
              " ",
              "for full details."
            ),
            this.props.averageRate ? "Average nightly rates shown below exclude taxes and fees." : ""
          ),
          this.props.roomRates.split("\n").map(RoomRate),
          _react2.default.createElement(
            "p",
            null,
            _react2.default.createElement(
              "b",
              null,
              this.props.amenityType,
              " Amenities:"
            )
          ),
          _react2.default.createElement(
            "ul",
            null,
            this.props.amenities.split("\n").map(Amenity)
          )
        )
      );
    }
  }]);

  return RateQuote;
}(_react2.default.Component), _class2.propTypes = {
  className: _propTypes2.default.string.isRequired,
  departure: _propTypes2.default.number,
  dateString: _propTypes2.default.string,
  destination: _propTypes2.default.string.isRequired,
  vendorName: _propTypes2.default.string.isRequired,
  vendorURL: _propTypes2.default.string.isRequired,
  rateType: _propTypes2.default.string,
  deposit: _propTypes2.default.string,
  cancellation: _propTypes2.default.string,
  roomRates: _propTypes2.default.string.isRequired,
  amenities: _propTypes2.default.string.isRequired,
  amenityType: _propTypes2.default.string.isRequired,
  averageRate: _propTypes2.default.string
}, _class2.defaultProps = {
  departure: null,
  dateString: ""
}, _temp2)) || _class);
exports.default = RateQuote;


var styles = _aphrodite.StyleSheet.create({
  rateQuote: {
    fontFamily: "arial, sans-serif",
    fontSize: 12.8
  },
  roomRate: {
    WebkitMarginAfter: 0,
    WebkitMarginBefore: 0
  },
  rateInfo: {
    fontStyle: "italic"
  },
  vendorLink: {
    textDecoration: "underline"
  }
});

/***/ }),

/***/ "weyk":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NewInquiryButton = exports.LogoutButton = exports.GlobalSearchBox = exports.Body = exports.NavBar = exports.Header = undefined;

var _Header2 = __webpack_require__("44Vo");

var _Header3 = _interopRequireDefault(_Header2);

var _NavBar2 = __webpack_require__("9tc1");

var _NavBar3 = _interopRequireDefault(_NavBar2);

var _Body2 = __webpack_require__("hpIb");

var _Body3 = _interopRequireDefault(_Body2);

var _GlobalSearchBox2 = __webpack_require__("GQCW");

var _GlobalSearchBox3 = _interopRequireDefault(_GlobalSearchBox2);

var _LogoutButton2 = __webpack_require__("W63S");

var _LogoutButton3 = _interopRequireDefault(_LogoutButton2);

var _NewInquiryButton2 = __webpack_require__("pzu2");

var _NewInquiryButton3 = _interopRequireDefault(_NewInquiryButton2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Header = _Header3.default;
exports.NavBar = _NavBar3.default;
exports.Body = _Body3.default;
exports.GlobalSearchBox = _GlobalSearchBox3.default;
exports.LogoutButton = _LogoutButton3.default;
exports.NewInquiryButton = _NewInquiryButton3.default;

/***/ }),

/***/ "wsBE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AppContainer = undefined;

var _AppContainer2 = __webpack_require__("Pgvg");

var _AppContainer3 = _interopRequireDefault(_AppContainer2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.AppContainer = _AppContainer3.default;

/***/ }),

/***/ "xgZ9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MergeVendors = exports.Vendors = undefined;

var _Vendors2 = __webpack_require__("6pLH");

var _Vendors3 = _interopRequireDefault(_Vendors2);

var _MergeVendorsRenderer = __webpack_require__("P3/v");

var _MergeVendorsRenderer2 = _interopRequireDefault(_MergeVendorsRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Vendors = _Vendors3.default;
exports.MergeVendors = _MergeVendorsRenderer2.default;

/***/ }),

/***/ "xnrt":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _dec2, _class, _class2, _temp2;

var _templateObject = _taggedTemplateLiteral(['\n  mutation inquiryFormSubmit($input: SubmitInquiryInput!) {\n    submitInquiry(input: $input) {\n      trip {\n        id\n      }\n    }\n  }\n'], ['\n  mutation inquiryFormSubmit($input: SubmitInquiryInput!) {\n    submitInquiry(input: $input) {\n      trip {\n        id\n      }\n    }\n  }\n']);

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _aphrodite = __webpack_require__("BK4P");

var _materialUi = __webpack_require__("Q4lS");

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _reactApollo = __webpack_require__("3zLD");

var _InquiryActions = __webpack_require__("EJRV");

var InquiryActions = _interopRequireWildcard(_InquiryActions);

var _AddTraveler = __webpack_require__("rumv");

var _AddTraveler2 = _interopRequireDefault(_AddTraveler);

var _UpcomingTrips = __webpack_require__("hrrM");

var _UpcomingTrips2 = _interopRequireDefault(_UpcomingTrips);

var _SuggestedTravelers = __webpack_require__("eKLQ");

var _SuggestedTravelers2 = _interopRequireDefault(_SuggestedTravelers);

var _TravelerListItem = __webpack_require__("j7JY");

var _TravelerListItem2 = _interopRequireDefault(_TravelerListItem);

var _TripDetails = __webpack_require__("/rVg");

var _TripDetails2 = _interopRequireDefault(_TripDetails);

var _AddSegment = __webpack_require__("jlGH");

var _AddSegment2 = _interopRequireDefault(_AddSegment);

var _SegmentListItem = __webpack_require__("OP5R");

var _SegmentListItem2 = _interopRequireDefault(_SegmentListItem);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var submitInquiry = (0, _reactApollo.gql)(_templateObject);

var InquiryForm = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    inquiry: state.Inquiry.get('inquiry').toJS(),
    meta: state.Inquiry.get('meta').toJS()
  };
}), _dec2 = (0, _reactApollo.graphql)(submitInquiry), _dec(_class = _dec2(_class = (_temp2 = _class2 = function (_React$Component) {
  _inherits(InquiryForm, _React$Component);

  function InquiryForm() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, InquiryForm);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = InquiryForm.__proto__ || Object.getPrototypeOf(InquiryForm)).call.apply(_ref, [this].concat(args))), _this), _this.addTravelerBlock = function () {
      var _this$props = _this.props,
          addingTraveler = _this$props.meta.addingTraveler,
          travelers = _this$props.inquiry.travelers;


      if (addingTraveler) {
        return _react2.default.createElement(_AddTraveler2.default, null);
      }

      if (travelers.length > 0) {
        var travelerIds = travelers.map(function (traveler) {
          return traveler.id;
        }).filter(function (id) {
          return id !== undefined && id !== '';
        });

        return travelerIds.length > 0 ? _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.suggestions) },
          _react2.default.createElement(_SuggestedTravelers2.default, { travelers: travelerIds }),
          _react2.default.createElement(_UpcomingTrips2.default, { travelers: travelerIds })
        ) : null;
      }

      return null;
    }, _this.toggleBoolean = function (name) {
      return function () {
        var _this$props2 = _this.props,
            meta = _this$props2.meta,
            dispatch = _this$props2.dispatch;

        var currentValue = meta[name];

        dispatch(InquiryActions.updateField(['meta', name], !currentValue));
      };
    }, _this.cancel = function () {
      _this.props.dispatch(InquiryActions.resetInquiryForm());
      _this.props.history.goBack();
    }, _this.reset = function () {
      _this.props.dispatch(InquiryActions.resetInquiryForm());
    }, _this.submit = function () {
      var _this$props3 = _this.props,
          inquiry = _this$props3.inquiry,
          mutate = _this$props3.mutate;
      var _inquiry$tripDetails = inquiry.tripDetails,
          travelStartDate = _inquiry$tripDetails.travelStartDate,
          travelEndDate = _inquiry$tripDetails.travelEndDate;


      if (_moment2.default.isMoment(inquiry.tripDetails.travelStartDate)) {
        inquiry.tripDetails.travelStartDate = travelStartDate.format('YYYY-MM-DDTHH:mm:ssZZ');
      }
      if (_moment2.default.isMoment(inquiry.tripDetails.travelEndDate)) {
        inquiry.tripDetails.travelEndDate = travelEndDate.format('YYYY-MM-DDTHH:mm:ssZZ');
      }
      inquiry.travelers = inquiry.travelers.map(function (traveler) {
        if (_moment2.default.isMoment(traveler.birthdate)) {
          traveler.birthdate = traveler.birthdate.format('YYYY-MM-DDTHH:mm:ssZZ');
        }
        return traveler;
      });
      inquiry.itinerary = inquiry.itinerary.map(function (segment) {
        if (_moment2.default.isMoment(segment.startDate)) {
          segment.startDate = segment.startDate.format('YYYY-MM-DDTHH:mm:ssZZ');
        }
        if (_moment2.default.isMoment(segment.endDate)) {
          segment.endDate = segment.endDate.format('YYYY-MM-DDTHH:mm:ssZZ');
        }
        return segment;
      });

      mutate({
        variables: {
          input: { inquiry: inquiry }
        }
      }).then(function (_ref2) {
        var id = _ref2.data.submitInquiry.trip.id;

        _this.props.dispatch(InquiryActions.resetInquiryForm());
        _this.props.history.push('/trips/' + id + '/');
      });
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(InquiryForm, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          _props$inquiry = _props.inquiry,
          travelers = _props$inquiry.travelers,
          itinerary = _props$inquiry.itinerary,
          tripDetails = _props$inquiry.tripDetails,
          _props$meta = _props.meta,
          addingTraveler = _props$meta.addingTraveler,
          showOverview = _props$meta.showOverview,
          addingSegment = _props$meta.addingSegment;


      var hasTravelers = travelers.length > 0;
      var inboxSet = tripDetails.inbox !== '';
      var userSet = tripDetails.selectedUser !== '';
      var categorySet = tripDetails.category !== '';
      var destinationSet = tripDetails.destination !== '';
      var datesSet = tripDetails.specificDates && tripDetails.travelStartDate && tripDetails.travelEndDate || !tripDetails.specificDates && tripDetails.timeframe;
      var ready = hasTravelers && inboxSet && userSet && categorySet && destinationSet && datesSet;

      return _react2.default.createElement(
        'div',
        { className: (0, _aphrodite.css)(styles.container) },
        _react2.default.createElement(
          'h1',
          { className: (0, _aphrodite.css)(styles.title) },
          'New Travel Inquiry'
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.section) },
          _react2.default.createElement(
            'h2',
            null,
            'Travelers (',
            travelers.length,
            ')'
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _aphrodite.css)(styles.listContainer) },
            _react2.default.createElement(
              'div',
              { className: (0, _aphrodite.css)(styles.itemList) },
              !hasTravelers ? _react2.default.createElement(
                'span',
                { className: (0, _aphrodite.css)(styles.errorMessage) },
                'At least one traveler must be entered.'
              ) : null,
              _react2.default.createElement(
                'ol',
                null,
                travelers.map(function (traveler, index) {
                  return _react2.default.createElement(_TravelerListItem2.default, { key: index, index: index, traveler: traveler });
                })
              ),
              _react2.default.createElement(_materialUi.FlatButton, { label: 'Add Traveler', disabled: addingTraveler, onTouchTap: this.toggleBoolean('addingTraveler') })
            ),
            this.addTravelerBlock()
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.section) },
          _react2.default.createElement(
            'h2',
            null,
            'Trip Overview ',
            _react2.default.createElement(_materialUi.FlatButton, {
              label: showOverview ? 'hide' : 'show',
              onTouchTap: this.toggleBoolean('showOverview')
            })
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _aphrodite.css)(styles.listContainer) },
            _react2.default.createElement(
              'div',
              { className: (0, _aphrodite.css)(styles.itemList) },
              _react2.default.createElement(
                'ul',
                null,
                !inboxSet ? _react2.default.createElement(
                  'li',
                  { className: (0, _aphrodite.css)(styles.errorMessage) },
                  'An inbox must be selected.'
                ) : null,
                !userSet ? _react2.default.createElement(
                  'li',
                  { className: (0, _aphrodite.css)(styles.errorMessage) },
                  'The trip must be assigned to someone.'
                ) : null,
                !categorySet ? _react2.default.createElement(
                  'li',
                  { className: (0, _aphrodite.css)(styles.errorMessage) },
                  'A trip category must be selected.'
                ) : null,
                !destinationSet ? _react2.default.createElement(
                  'li',
                  { className: (0, _aphrodite.css)(styles.errorMessage) },
                  'A destination must be entered.'
                ) : null,
                !datesSet ? _react2.default.createElement(
                  'li',
                  { className: (0, _aphrodite.css)(styles.errorMessage) },
                  'Travel dates or a timeframe must be entered.'
                ) : null
              )
            ),
            showOverview ? _react2.default.createElement(_TripDetails2.default, null) : null
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.section) },
          _react2.default.createElement(
            'h2',
            null,
            'Segments (',
            itinerary.length,
            ')'
          ),
          _react2.default.createElement(
            'div',
            { className: (0, _aphrodite.css)(styles.listContainer) },
            _react2.default.createElement(
              'div',
              { className: (0, _aphrodite.css)(styles.itemList) },
              _react2.default.createElement(
                'ol',
                null,
                itinerary.map(function (segment, index) {
                  return _react2.default.createElement(_SegmentListItem2.default, {
                    key: index,
                    index: index,
                    segment: segment
                  });
                })
              ),
              _react2.default.createElement(_materialUi.FlatButton, { label: 'Add Segment', disabled: addingSegment, onTouchTap: this.toggleBoolean('addingSegment') })
            ),
            addingSegment ? _react2.default.createElement(_AddSegment2.default, null) : null
          )
        ),
        _react2.default.createElement(
          'div',
          { className: (0, _aphrodite.css)(styles.formActions) },
          _react2.default.createElement(_materialUi.RaisedButton, { className: (0, _aphrodite.css)(styles.actionButton), label: 'Reset', secondary: true, onTouchTap: this.reset }),
          _react2.default.createElement(_materialUi.RaisedButton, { className: (0, _aphrodite.css)(styles.actionButton), label: 'Cancel', secondary: true, onTouchTap: this.cancel }),
          _react2.default.createElement(_materialUi.RaisedButton, {
            className: (0, _aphrodite.css)(styles.actionButton),
            label: 'Submit Inquiry',
            primary: true,
            onTouchTap: this.submit,
            disabled: !ready
          })
        )
      );
    }
  }]);

  return InquiryForm;
}(_react2.default.Component), _class2.propTypes = {
  dispatch: _propTypes2.default.func.isRequired,
  inquiry: _propTypes2.default.shape().isRequired,
  meta: _propTypes2.default.shape().isRequired,
  history: _propTypes2.default.shape().isRequired,
  mutate: _propTypes2.default.func.isRequired
}, _temp2)) || _class) || _class);


var styles = _aphrodite.StyleSheet.create({
  container: {
    padding: 15
  },
  title: {
    margin: 0
  },
  section: {
    marginTop: 15
  },
  listContainer: {
    display: 'flex',
    flexWrap: 'wrap'
  },
  itemList: {
    fontSize: 13,
    marginLeft: 15,
    marginTop: 5,
    width: 300
  },
  suggestions: {
    display: 'flex',
    justifyContent: 'space-around'
  },
  formActions: {
    width: '100%',
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: 15
  },
  actionButton: {
    marginLeft: 15
  },
  errorMessage: {
    color: 'red',
    fontSize: 13
  }
});

exports.default = InquiryForm;

/***/ }),

/***/ "y1yg":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * 
 * @relayHash 61092cb45c239161d5db2dbe1bd6f376
 */

/* eslint-disable */



/*::
import type {ConcreteBatch} from 'relay-runtime';
export type VendorDetailsRenderer_VendorDetails_QueryResponse = {|
  +vendor: ?{|
    +id: string;
    +name: string;
    +sabreCode: string;
    +contacts: ?any;
    +amenityPrograms: ?$ReadOnlyArray<?string>;
    +profileNotes: string;
    +travelers: ?$ReadOnlyArray<?{|
      +id: string;
      +fullName: ?string;
    |}>;
  |};
|};
*/

/*
query VendorDetailsRenderer_VendorDetails_Query(
  $vendorId: ID!
) {
  vendor(id: $vendorId) {
    id
    name
    sabreCode
    contacts
    amenityPrograms
    profileNotes
    travelers {
      id
      fullName
    }
  }
}
*/

var batch /*: ConcreteBatch*/ = {
  "fragment": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "vendorId",
      "type": "ID!",
      "defaultValue": null
    }],
    "kind": "Fragment",
    "metadata": null,
    "name": "VendorDetailsRenderer_VendorDetails_Query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "id",
        "variableName": "vendorId",
        "type": "ID!"
      }],
      "concreteType": "Vendor",
      "name": "vendor",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "name",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "sabreCode",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "contacts",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "amenityPrograms",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "profileNotes",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Traveler",
        "name": "travelers",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "fullName",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }],
    "type": "Query"
  },
  "id": null,
  "kind": "Batch",
  "metadata": {},
  "name": "VendorDetailsRenderer_VendorDetails_Query",
  "query": {
    "argumentDefinitions": [{
      "kind": "LocalArgument",
      "name": "vendorId",
      "type": "ID!",
      "defaultValue": null
    }],
    "kind": "Root",
    "name": "VendorDetailsRenderer_VendorDetails_Query",
    "operation": "query",
    "selections": [{
      "kind": "LinkedField",
      "alias": null,
      "args": [{
        "kind": "Variable",
        "name": "id",
        "variableName": "vendorId",
        "type": "ID!"
      }],
      "concreteType": "Vendor",
      "name": "vendor",
      "plural": false,
      "selections": [{
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "id",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "name",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "sabreCode",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "contacts",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "amenityPrograms",
        "storageKey": null
      }, {
        "kind": "ScalarField",
        "alias": null,
        "args": null,
        "name": "profileNotes",
        "storageKey": null
      }, {
        "kind": "LinkedField",
        "alias": null,
        "args": null,
        "concreteType": "Traveler",
        "name": "travelers",
        "plural": true,
        "selections": [{
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "id",
          "storageKey": null
        }, {
          "kind": "ScalarField",
          "alias": null,
          "args": null,
          "name": "fullName",
          "storageKey": null
        }],
        "storageKey": null
      }],
      "storageKey": null
    }]
  },
  "text": "query VendorDetailsRenderer_VendorDetails_Query(\n  $vendorId: ID!\n) {\n  vendor(id: $vendorId) {\n    id\n    name\n    sabreCode\n    contacts\n    amenityPrograms\n    profileNotes\n    travelers {\n      id\n      fullName\n    }\n  }\n}\n"
};

module.exports = batch;

/***/ }),

/***/ "yCYw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _momentRange = __webpack_require__("l5j/");

var _materialUi = __webpack_require__("Q4lS");

var _lodash = __webpack_require__("M4fF");

var _lodash2 = _interopRequireDefault(_lodash);

var _reactRouterDom = __webpack_require__("F8kA");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _DateRangeComponent = __webpack_require__("JW7h");

var _DateRangeComponent2 = _interopRequireDefault(_DateRangeComponent);

var _styles = __webpack_require__("81cR");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var moment = (0, _momentRange.extendMoment)(_moment2.default);
var DateFormat = "DDMMM";

var SalesReport = (_temp = _class = function (_React$Component) {
  _inherits(SalesReport, _React$Component);

  function SalesReport(props) {
    _classCallCheck(this, SalesReport);

    var _this = _possibleConstructorReturn(this, (SalesReport.__proto__ || Object.getPrototypeOf(SalesReport)).call(this, props));

    _this.updateDates = function (e) {
      var startDate = e.startDate,
          endDate = e.endDate;

      _this.setState({
        enteredStart: startDate,
        enteredEnd: endDate
      });
    };

    _this.testDate = function (date) {
      var _this$state = _this.state,
          startDate = _this$state.startDate,
          endDate = _this$state.endDate;

      var momentDate = moment.isMoment(date) ? date : moment(date);

      return startDate <= momentDate && momentDate < endDate;
    };

    _this.updateSlider = function (e, value) {
      _this.setState({ upcomingTripDays: value });
    };

    _this.setDates = function () {
      var _this$state2 = _this.state,
          enteredStart = _this$state2.enteredStart,
          enteredEnd = _this$state2.enteredEnd;

      _this.setState({
        startDate: enteredStart,
        endDate: enteredEnd
      });
    };

    var defaultStart = moment().day(-6).startOf("day");
    var defaultEnd = moment().day(1).startOf("day");

    _this.state = {
      startDate: defaultStart,
      endDate: defaultEnd,
      enteredStart: defaultStart,
      enteredEnd: defaultEnd,
      upcomingTripDays: 30
    };
    return _this;
  }

  _createClass(SalesReport, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var trips = this.props.trips;
      var _state = this.state,
          startDate = _state.startDate,
          endDate = _state.endDate,
          upcomingTripDays = _state.upcomingTripDays,
          enteredStart = _state.enteredStart,
          enteredEnd = _state.enteredEnd;

      var formattedStartDate = startDate.format(DateFormat).toUpperCase();
      var formattedEndDate = endDate.format(DateFormat).toUpperCase();
      var duration = moment.range(startDate, endDate).diff("days");
      var dateString = formattedStartDate + "-" + duration + "NT";

      var tripsByWeek = {};
      _lodash2.default.each(trips, function (trip) {
        var created = trip.created;

        var momentCreated = moment(created);
        var tripWeek = "" + momentCreated.isoWeek() + momentCreated.year();

        tripsByWeek[tripWeek] = (tripsByWeek[tripWeek] || 0) + 1;
      });
      var tripsCreated = tripsByWeek["" + startDate.isoWeek() + startDate.year()];

      var counts = _lodash2.default.values(tripsByWeek);
      var avgTripsCreated = +(_lodash2.default.reduce(counts, function (memo, count) {
        return memo + count;
      }) / counts.length).toFixed(1);

      var prospects = {};
      var numProspects = 0;
      _lodash2.default.each(trips.filter(function (trip) {
        return !trip.cancelled && trip.prospect && !trip.specificDates && trip.segments.length === 0;
      }), function (trip) {
        var ownerName = trip.ownerName;

        var ownerList = prospects[ownerName] || [];
        prospects[ownerName] = [].concat(_toConsumableArray(ownerList), [trip]);
        numProspects += 1;
      });

      var needsBooking = trips.filter(function (trip) {
        return !trip.cancelled && _lodash2.default.some(trip.segments, function (segment) {
          return !segment.booked && !segment.cancelled;
        });
      });

      var tripsVoided = trips.filter(function (_ref) {
        var cancelledTimestamp = _ref.cancelledTimestamp;
        return _this2.testDate(cancelledTimestamp);
      });

      var tripsByInbox = {
        "team@": 0,
        "insidecircle@": 0
      };
      _lodash2.default.each(trips, function (trip) {
        var created = trip.created,
            inbox = trip.inbox;


        if (_this2.testDate(created)) {
          tripsByInbox[inbox] += 1;
        }
      });

      var segmentFacts = {
        bookings: 0,
        cancellations: 0,
        lastMinute: 0
      };
      var lastMinuteTrips = {};
      _lodash2.default.each(trips, function (trip) {
        var segments = trip.segments,
            created = trip.created,
            travelStartDate = trip.travelStartDate,
            cancelled = trip.cancelled;

        if (travelStartDate !== null && !cancelled) {
          var momentStartDate = moment(travelStartDate);
          var cutOff = moment(created).add(7, "days");

          if (momentStartDate >= moment() && momentStartDate <= cutOff) {
            segmentFacts.lastMinute += 1;

            var ownerName = trip.ownerName;

            var ownerList = lastMinuteTrips[ownerName] || [];
            lastMinuteTrips[ownerName] = [].concat(_toConsumableArray(ownerList), [trip]);
          }
        }

        _lodash2.default.each(segments, function (_ref2) {
          var bookedTimestamp = _ref2.bookedTimestamp,
              cancelledTimestamp = _ref2.cancelledTimestamp;

          if (_this2.testDate(bookedTimestamp)) {
            segmentFacts.bookings += 1;
          }

          if (_this2.testDate(cancelledTimestamp)) {
            segmentFacts.cancellations += 1;
          }
        });
      });

      var tripsByYear = {};
      _lodash2.default.each(trips.filter(function (_ref3) {
        var travelStartDate = _ref3.travelStartDate,
            cancelled = _ref3.cancelled;
        return !cancelled && travelStartDate !== null && moment(travelStartDate) > moment();
      }), function (_ref4) {
        var travelStartDate = _ref4.travelStartDate;

        var momentStartDate = moment(travelStartDate);
        var year = momentStartDate.year();
        var month = momentStartDate.format("MMMM");

        var yearObj = tripsByYear[year] || {};
        var monthCount = yearObj[month] || 0;

        yearObj[month] = monthCount + 1;
        tripsByYear[year] = yearObj;
      });

      var futureTripCounts = {};
      _lodash2.default.each(_lodash2.default.toPairs(tripsByYear), function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            year = _ref6[0],
            months = _ref6[1];

        futureTripCounts[year] = _lodash2.default.toPairs(months).map(function (_ref7, index) {
          var _ref8 = _slicedToArray(_ref7, 2),
              month = _ref8[0],
              count = _ref8[1];

          var key = year + "." + index;
          return _react2.default.createElement(
            _materialUi.Paper,
            { key: key, className: _styles2.default.futureTravelBox },
            month,
            " ",
            year,
            ": ",
            count,
            " trips"
          );
        });
      });

      var tooLate = {};
      var numTooLate = 0;
      _lodash2.default.each(needsBooking.filter(function (_ref9) {
        var travelStartDate = _ref9.travelStartDate;
        return moment(travelStartDate) < moment();
      }), function (trip) {
        var ownerName = trip.ownerName;

        var ownerList = tooLate[ownerName] || [];
        tooLate[ownerName] = [].concat(_toConsumableArray(ownerList), [trip]);
        numTooLate += 1;
      });

      var upcoming = {};
      var numUpcoming = 0;
      _lodash2.default.each(needsBooking.filter(function (_ref10) {
        var travelStartDate = _ref10.travelStartDate;
        return moment(travelStartDate) < moment().add(upcomingTripDays, "days");
      }), function (trip) {
        var ownerName = trip.ownerName;

        var ownerList = upcoming[ownerName] || [];
        upcoming[ownerName] = [].concat(_toConsumableArray(ownerList), [trip]);
        numUpcoming += 1;
      });

      var tbdTrips = {};
      var numTbd = 0;
      _lodash2.default.each(needsBooking.filter(function (_ref11) {
        var travelStartDate = _ref11.travelStartDate;
        return travelStartDate === null;
      }), function (trip) {
        var ownerName = trip.ownerName;

        var ownerList = tbdTrips[ownerName] || [];
        tbdTrips[ownerName] = [].concat(_toConsumableArray(ownerList), [trip]);
        numTbd += 1;
      });

      return _react2.default.createElement(
        _materialUi.Card,
        { className: _styles2.default.report },
        _react2.default.createElement(_materialUi.CardHeader, { title: "Sales Report for " + dateString }),
        _react2.default.createElement(
          _materialUi.CardText,
          { className: _styles2.default.settings },
          _react2.default.createElement(_DateRangeComponent2.default, {
            startValue: formattedStartDate,
            endValue: formattedEndDate,
            startLabel: "Start Date",
            endLabel: "End Date",
            onChange: this.updateDates,
            allowPast: true
          }),
          _react2.default.createElement(_materialUi.RaisedButton, {
            primary: true,
            label: "Set Dates",
            onTouchTap: this.setDates,
            disabled: startDate === enteredStart || endDate === enteredEnd
          })
        ),
        _react2.default.createElement(
          _materialUi.CardText,
          null,
          _react2.default.createElement(
            "div",
            { className: _styles2.default.summaryContainer },
            _react2.default.createElement(
              _materialUi.Paper,
              { className: _styles2.default.summaryBox },
              _react2.default.createElement(
                "span",
                null,
                "Trips created: ",
                tripsCreated,
                " (average ",
                avgTripsCreated,
                ")"
              ),
              _react2.default.createElement(
                "span",
                null,
                "Trips needing booking: ",
                needsBooking.length
              ),
              _react2.default.createElement(
                "span",
                null,
                "Trips voided: ",
                tripsVoided.length
              )
            ),
            _react2.default.createElement(
              _materialUi.Paper,
              { className: _styles2.default.summaryBox },
              _react2.default.createElement(
                "span",
                null,
                "Trips from team@ inbox: ",
                tripsByInbox["team@"]
              ),
              _react2.default.createElement(
                "span",
                null,
                "Trips from insidecircle@ inbox: ",
                tripsByInbox["insidecircle@"]
              )
            ),
            _react2.default.createElement(
              _materialUi.Paper,
              { className: _styles2.default.summaryBox },
              _react2.default.createElement(
                "span",
                null,
                "Bookings made: ",
                segmentFacts.bookings
              ),
              _react2.default.createElement(
                "span",
                null,
                "Cancellations made: ",
                segmentFacts.cancellations
              ),
              _react2.default.createElement(
                "span",
                null,
                "Inquiries added w/in 7 days of travel: ",
                segmentFacts.lastMinute
              )
            )
          ),
          _react2.default.createElement(
            "h3",
            null,
            "Trips with Future Travel"
          ),
          _lodash2.default.toPairs(futureTripCounts).map(function (_ref12) {
            var _ref13 = _slicedToArray(_ref12, 2),
                year = _ref13[0],
                months = _ref13[1];

            return _react2.default.createElement(
              "div",
              { key: year },
              _react2.default.createElement(
                "h4",
                null,
                year
              ),
              _react2.default.createElement(
                "div",
                { className: _styles2.default.futureTravelContainer },
                months
              )
            );
          }),
          _react2.default.createElement(
            "h3",
            null,
            numTooLate,
            " trips too late to book:"
          ),
          _react2.default.createElement(
            "div",
            { className: _styles2.default.splitList },
            _lodash2.default.toPairs(tooLate).map(function (_ref14) {
              var _ref15 = _slicedToArray(_ref14, 2),
                  owner = _ref15[0],
                  ownedTrips = _ref15[1];

              return _react2.default.createElement(
                "div",
                { key: owner },
                _react2.default.createElement(
                  "h4",
                  null,
                  owner,
                  " (",
                  ownedTrips.length,
                  " trips)"
                ),
                _react2.default.createElement(
                  "ul",
                  null,
                  ownedTrips.map(function (trip) {
                    var id = trip.id,
                        tripName = trip.tripName;

                    return _react2.default.createElement(
                      "li",
                      { key: id },
                      _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: "/trips/" + id + "/" },
                        tripName
                      )
                    );
                  })
                )
              );
            })
          ),
          _react2.default.createElement(
            "h3",
            null,
            numUpcoming,
            " unbooked trips traveling in next ",
            upcomingTripDays,
            " ",
            "days:"
          ),
          _react2.default.createElement(_materialUi.Slider, {
            min: 7,
            max: 365,
            step: 1,
            onChange: _lodash2.default.debounce(this.updateSlider, 100),
            value: upcomingTripDays
          }),
          _react2.default.createElement(
            "div",
            { className: _styles2.default.splitList },
            _lodash2.default.toPairs(upcoming).map(function (_ref16) {
              var _ref17 = _slicedToArray(_ref16, 2),
                  owner = _ref17[0],
                  ownedTrips = _ref17[1];

              return _react2.default.createElement(
                "div",
                { key: owner },
                _react2.default.createElement(
                  "h4",
                  null,
                  owner,
                  " (",
                  ownedTrips.length,
                  " trips)"
                ),
                _react2.default.createElement(
                  "ul",
                  null,
                  ownedTrips.map(function (trip) {
                    var id = trip.id,
                        tripName = trip.tripName;

                    return _react2.default.createElement(
                      "li",
                      { key: id },
                      _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: "/trips/" + id + "/" },
                        tripName
                      )
                    );
                  })
                )
              );
            })
          ),
          _react2.default.createElement(
            "h3",
            null,
            segmentFacts.lastMinute,
            " inquiries added w/in 7 days of travel:"
          ),
          _react2.default.createElement(
            "div",
            { className: _styles2.default.splitList },
            _lodash2.default.toPairs(lastMinuteTrips).map(function (_ref18) {
              var _ref19 = _slicedToArray(_ref18, 2),
                  owner = _ref19[0],
                  ownedTrips = _ref19[1];

              return _react2.default.createElement(
                "div",
                { key: owner },
                _react2.default.createElement(
                  "h4",
                  null,
                  owner,
                  " (",
                  ownedTrips.length,
                  " trips)"
                ),
                _react2.default.createElement(
                  "ul",
                  null,
                  ownedTrips.map(function (trip) {
                    var id = trip.id,
                        tripName = trip.tripName;

                    return _react2.default.createElement(
                      "li",
                      { key: id },
                      _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: "/trips/" + id + "/" },
                        tripName
                      )
                    );
                  })
                )
              );
            })
          ),
          _react2.default.createElement(
            "h3",
            null,
            numTbd,
            " trips without travel dates:"
          ),
          _react2.default.createElement(
            "div",
            { className: _styles2.default.splitList },
            _lodash2.default.toPairs(tbdTrips).map(function (_ref20) {
              var _ref21 = _slicedToArray(_ref20, 2),
                  owner = _ref21[0],
                  ownedTrips = _ref21[1];

              return _react2.default.createElement(
                "div",
                { key: owner },
                _react2.default.createElement(
                  "h4",
                  null,
                  owner,
                  " (",
                  ownedTrips.length,
                  " trips)"
                ),
                _react2.default.createElement(
                  "ul",
                  null,
                  ownedTrips.map(function (trip) {
                    var id = trip.id,
                        tripName = trip.tripName;

                    return _react2.default.createElement(
                      "li",
                      { key: id },
                      _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: "/trips/" + id + "/" },
                        tripName
                      )
                    );
                  })
                )
              );
            })
          ),
          _react2.default.createElement(
            "h3",
            null,
            numProspects,
            " sales prospects:"
          ),
          _react2.default.createElement(
            "div",
            { className: _styles2.default.splitList },
            _lodash2.default.toPairs(prospects).map(function (_ref22) {
              var _ref23 = _slicedToArray(_ref22, 2),
                  owner = _ref23[0],
                  ownedTrips = _ref23[1];

              return _react2.default.createElement(
                "div",
                { key: owner },
                _react2.default.createElement(
                  "h4",
                  null,
                  owner,
                  " (",
                  ownedTrips.length,
                  " trips)"
                ),
                _react2.default.createElement(
                  "ul",
                  null,
                  ownedTrips.map(function (trip) {
                    var id = trip.id,
                        tripName = trip.tripName;

                    return _react2.default.createElement(
                      "li",
                      { key: id },
                      _react2.default.createElement(
                        _reactRouterDom.Link,
                        { to: "/trips/" + id + "/" },
                        tripName
                      )
                    );
                  })
                )
              );
            })
          )
        )
      );
    }
  }]);

  return SalesReport;
}(_react2.default.Component), _class.propTypes = {
  trips: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired
}, _temp);
exports.default = SalesReport;

/***/ }),

/***/ "ydc5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SegmentDetail = undefined;

var _SegmentDetailRenderer = __webpack_require__("yzIV");

var _SegmentDetailRenderer2 = _interopRequireDefault(_SegmentDetailRenderer);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.SegmentDetail = _SegmentDetailRenderer2.default;

/***/ }),

/***/ "yv5p":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateWindowWidth = updateWindowWidth;
exports.updateWindowHeight = updateWindowHeight;

var _ActionTypes = __webpack_require__("zLtr");

var _ActionTypes2 = _interopRequireDefault(_ActionTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function updateWindowWidth(width) {
  return {
    type: _ActionTypes2.default.Responsive.updateWindowWidth,
    width: width
  };
}

function updateWindowHeight(height) {
  return {
    type: _ActionTypes2.default.Responsive.updateWindowHeight,
    height: height
  };
}

/***/ }),

/***/ "yzIV":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dec, _class, _class2, _temp, _graphql;

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _reactRelay = __webpack_require__("Tc9k");

var _materialUi = __webpack_require__("Q4lS");

var _reactRedux = __webpack_require__("RH2O");

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _environment = __webpack_require__("5Dr9");

var _environment2 = _interopRequireDefault(_environment);

var _SegmentDetail = __webpack_require__("Et58");

var _SegmentDetail2 = _interopRequireDefault(_SegmentDetail);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Renderer = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    windowHeight: state.Responsive.get("windowHeight")
  };
}), _dec(_class = (_temp = _class2 = function (_React$Component) {
  _inherits(Renderer, _React$Component);

  function Renderer() {
    _classCallCheck(this, Renderer);

    return _possibleConstructorReturn(this, (Renderer.__proto__ || Object.getPrototypeOf(Renderer)).apply(this, arguments));
  }

  _createClass(Renderer, [{
    key: "render",
    value: function render() {
      var _props = this.props,
          windowHeight = _props.windowHeight,
          segmentId = _props.match.params.segmentId;

      var top = (windowHeight - 161) / 2 + 161;

      var loadingEl = _react2.default.createElement(_materialUi.RefreshIndicator, { top: top, left: 900, status: "loading" });

      return _react2.default.createElement(_reactRelay.QueryRenderer, {
        environment: _environment2.default,
        variables: { segmentId: segmentId },
        query: _graphql || (_graphql = function _graphql() {
          return __webpack_require__("Rh7a");
        }),
        render: function render(_ref) {
          var error = _ref.error,
              props = _ref.props;

          if (error) {
            return _react2.default.createElement(
              "div",
              null,
              error.message
            );
          } else if (props) {
            var segment = props.segment,
                allUsers = props.allUsers;


            return _react2.default.createElement(_SegmentDetail2.default, { segment: segment, users: allUsers });
          }

          return loadingEl;
        }
      });
    }
  }]);

  return Renderer;
}(_react2.default.Component), _class2.propTypes = {
  windowHeight: _propTypes2.default.number.isRequired,
  match: _propTypes2.default.shape({
    params: _propTypes2.default.object
  }).isRequired
}, _temp)) || _class);
exports.default = Renderer;

/***/ }),

/***/ "zL3R":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("U7vG");

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__("KSGD");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styles = __webpack_require__("azRA");

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var VIPLetter = function VIPLetter(props) {
  var primaryContactDisplayName = props.primaryContactDisplayName,
      amenityProgram = props.amenityProgram,
      vendorName = props.vendorName,
      from = props.from,
      travelerNames = props.travelerNames,
      displayStartDate = props.displayStartDate,
      displayEndDate = props.displayEndDate,
      category = props.category,
      bedType = props.bedType,
      confirmationNumber = props.confirmationNumber,
      specialRequests = props.specialRequests,
      transferArrangements = props.transferArrangements,
      arrivalDetails = props.arrivalDetails,
      departureDetails = props.departureDetails,
      insideCircle = props.insideCircle,
      iata = props.iata;


  return _react2.default.createElement(
    'div',
    { className: _styles2.default.vipLetter },
    _react2.default.createElement(
      'p',
      null,
      'Hello ',
      primaryContactDisplayName,
      ','
    ),
    _react2.default.createElement(
      'p',
      null,
      'I would like to inform you of a ',
      amenityProgram,
      ' client of ours that will be staying with you soon at ',
      vendorName,
      '. I hope you can make a note of the following items for them, and I know they will be in good hands once they arrive!'
    ),
    _react2.default.createElement(
      'p',
      null,
      'The guest details are listed below. Please do not hesitate to contact us if you need any further information.'
    ),
    _react2.default.createElement(
      'p',
      null,
      'Many thanks!',
      _react2.default.createElement('br', null),
      from
    ),
    _react2.default.createElement(
      'p',
      null,
      travelerNames,
      _react2.default.createElement('br', null),
      displayStartDate,
      ' to ',
      displayEndDate,
      ' in a ',
      category,
      ' ',
      bedType,
      _react2.default.createElement('br', null),
      'Confirmation #',
      confirmationNumber
    ),
    _react2.default.createElement(
      'ul',
      null,
      _react2.default.createElement(
        'li',
        null,
        'Thank you for extending any',
        amenityProgram === 'VIP' ? '' : ' ' + amenityProgram + ' and',
        ' VIP services wherever possible to help the guests enjoy their stay'
      ),
      _react2.default.createElement(
        'li',
        null,
        'We appreciate any upgrades that may be applied'
      ),
      specialRequests.map(function (request, index) {
        return _react2.default.createElement(
          'li',
          { key: index },
          request
        );
      }),
      _react2.default.createElement(
        'li',
        null,
        transferArrangements,
        arrivalDetails || departureDetails ? _react2.default.createElement(
          'ul',
          null,
          arrivalDetails === '' ? null : _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              'Arriving:'
            ),
            ' ',
            arrivalDetails
          ),
          departureDetails === '' ? null : _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'b',
              null,
              'Departing:'
            ),
            ' ',
            departureDetails
          )
        ) : null
      ),
      _react2.default.createElement(
        'li',
        null,
        'Please sign any welcome notes from "',
        insideCircle ? 'David' : 'Team',
        ' Ourisman".'
      ),
      _react2.default.createElement(
        'li',
        null,
        'For your reference, our IATA is #',
        iata
      )
    )
  );
};

VIPLetter.propTypes = {
  primaryContactDisplayName: _propTypes2.default.string.isRequired,
  amenityProgram: _propTypes2.default.string.isRequired,
  vendorName: _propTypes2.default.string.isRequired,
  from: _propTypes2.default.string.isRequired,
  travelerNames: _propTypes2.default.arrayOf(_propTypes2.default.object).isRequired,
  displayStartDate: _propTypes2.default.string.isRequired,
  displayEndDate: _propTypes2.default.string.isRequired,
  category: _propTypes2.default.string.isRequired,
  bedType: _propTypes2.default.string.isRequired,
  confirmationNumber: _propTypes2.default.string.isRequired,
  specialRequests: _propTypes2.default.arrayOf(_propTypes2.default.string).isRequired,
  transferArrangements: _propTypes2.default.string.isRequired,
  arrivalDetails: _propTypes2.default.string.isRequired,
  departureDetails: _propTypes2.default.string.isRequired,
  insideCircle: _propTypes2.default.bool.isRequired,
  iata: _propTypes2.default.string.isRequired
};

exports.default = VIPLetter;

/***/ }),

/***/ "zLtr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keymirror = __webpack_require__("vMAF");

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  Auth: (0, _keymirror2.default)({
    setAuthData: null,
    logout: null,
    login: null
  }),
  RateQuote: (0, _keymirror2.default)({
    updateDateRange: null,
    updateDateString: null,
    toggleDatePicker: null,
    updateString: null
  }),
  Responsive: (0, _keymirror2.default)({
    updateWindowWidth: null,
    updateWindowHeight: null
  }),
  Inquiry: (0, _keymirror2.default)({
    toggleNewTraveler: null,
    addTraveler: null,
    moveTraveler: null,
    removeTraveler: null,
    removeSegment: null,
    updateField: null,
    addSegment: null,
    resetInquiryForm: null
  }),
  Trips: (0, _keymirror2.default)({
    setValue: null
  })
};

/***/ }),

/***/ "zPxQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactApollo = __webpack_require__("3zLD");

var _network = __webpack_require__("Zg14");

var _network2 = _interopRequireDefault(_network);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NODE_ENV = "production";

var graphqlURL = NODE_ENV === "development" ? _network2.default : "";

var networkInterface = (0, _reactApollo.createNetworkInterface)({
  uri: graphqlURL + "/graphql/"
});

networkInterface.use([{
  applyMiddleware: function applyMiddleware(req, next) {
    if (!req.options.headers) {
      req.options.headers = {};
    }

    var token = localStorage.getItem("PPJWT");
    req.options.headers.authorization = "Bearer " + token;
    next();
  }
}]);

var client = new _reactApollo.ApolloClient({ networkInterface: networkInterface });

exports.default = client;

/***/ })

},[0]);


// WEBPACK FOOTER //
// main-f1327a997947a2bf2eb8.js